"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2621],{

/***/ 5553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var React = __webpack_require__(91987);
var ui = __webpack_require__(49864);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Page404 = ({ src }) => {
  const [countdown, setCountdown] = React.useState(10);
  const interval = React.useRef(null);
  React.useEffect(() => {
    interval.current = setInterval(() => {
      setCountdown((countdown2) => countdown2 - 1);
    }, 1e3);
    return () => clearInterval(interval.current);
  }, []);
  React.useEffect(() => {
    if (countdown === 0) {
      clearInterval(interval.current);
      window.location.href = "/";
    }
  }, [countdown]);
  return /* @__PURE__ */ jsxRuntime.jsxs(WrapperPage, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(ui.Image, {
        src
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(StyledText, {
        children: [
          "Trang kh\xF4ng t\u1ED3n t\u1EA1i. B\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c \u0111\u01B0a v\u1EC1 trang ch\u1EE7 sau ",
          countdown,
          "s"
        ]
      })
    ]
  });
};
Page404.displayName = "404";
const WrapperPage = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70vh;
`;
const StyledText = styled__default["default"].div`
  color: #848788;
  font-weight: 400;
`;

exports.Page404 = Page404;


/***/ }),

/***/ 15444:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AccordionContext = React.createContext({
  activeKey: null,
  setActiveKey: null
});
const AccordionProvider = (_a) => {
  var _b = _a, {
    children
  } = _b, rest = __objRest(_b, [
    "children"
  ]);
  const [activeKey, setActiveKey] = React.useState();
  return /* @__PURE__ */ jsxRuntime.jsx(AccordionContext.Provider, {
    value: __spreadProps(__spreadValues({}, rest), { activeKey, setActiveKey }),
    children
  });
};

exports.AccordionContext = AccordionContext;
exports.AccordionProvider = AccordionProvider;


/***/ }),

/***/ 62160:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var context = __webpack_require__(15444);
var utils = __webpack_require__(24603);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Accordion = (_a) => {
  var _b = _a, {
    children,
    icon
  } = _b, rest = __objRest(_b, [
    "children",
    "icon"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({}, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsx(context.AccordionProvider, {
      icon,
      children
    })
  }));
};
Accordion.displayName = "Accordion";
const Wrapper = styled__default["default"].div(
  ({ commonStyle, itemStyle, titleStyle, duration }) => {
    const animationDuration = typeof duration === "number" ? `transition: all ${duration}s;` : "";
    return `
    ${coreRenderer.getStyle(commonStyle)}
    display: flex;
    flex-direction: column;

    .accordion {
      &__item {
        ${coreRenderer.getStyle(itemStyle)}
      }
      &__title {
        h1, h2, h3, h4, h5, h6 {
          ${coreRenderer.getStyle(titleStyle)}
        }
      }
      &__header,
      &__content  {
        ${animationDuration}
      }
    }
  `;
  },
  utils.getAccordionItemChildrenCss
);

exports.Accordion = Accordion;


/***/ }),

/***/ 22735:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AccordionContent = React__default["default"].forwardRef((_a, ref) => {
  var _b = _a, rest = __objRest(_b, ["contentRef"]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
    ref
  }, rest), {
    className: "accordion__content"
  }));
});
AccordionContent.displayName = "AccordionContent";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
`
);

exports.AccordionContent = AccordionContent;


/***/ }),

/***/ 62906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var context = __webpack_require__(15444);
var utils = __webpack_require__(24603);
var ui$1 = __webpack_require__(80768);
var ui = __webpack_require__(81171);
var fonts = __webpack_require__(74367);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AccordionItem = React__default["default"].forwardRef((_a, ref) => {
  var _b = _a, { children, customLabel, title, itemKey, icon } = _b, rest = __objRest(_b, ["children", "customLabel", "title", "itemKey", "icon"]);
  const {
    icon: defaultIcon,
    activeKey,
    setActiveKey
  } = React.useContext(context.AccordionContext);
  const isActive = activeKey === itemKey;
  const _a2 = {
    name: isActive ? (icon == null ? void 0 : icon.activeName) || (defaultIcon == null ? void 0 : defaultIcon.activeName) : (icon == null ? void 0 : icon.name) || (defaultIcon == null ? void 0 : defaultIcon.name),
    size: (icon == null ? void 0 : icon.size) || (defaultIcon == null ? void 0 : defaultIcon.size),
    color: (icon == null ? void 0 : icon.color) || (defaultIcon == null ? void 0 : defaultIcon.color),
    align: (icon == null ? void 0 : icon.align) || (defaultIcon == null ? void 0 : defaultIcon.align)
  }, { align = coreRenderer.Alignment.right } = _a2, restIconProps = __objRest(_a2, ["align"]);
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({
    ref
  }, rest), {
    className: `accordion__item ${isActive ? "active" : "collapsed"}`,
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs("div", {
        ref,
        onClick: () => {
          if (isActive) {
            setActiveKey(null);
          } else {
            setActiveKey(itemKey);
          }
        },
        className: `accordion__header ${align}`,
        children: [
          customLabel ? React__default["default"].cloneElement(customLabel, {
            className: "accordion__title"
          }) : /* @__PURE__ */ jsxRuntime.jsx(ui.Heading, {
            text: title,
            className: "accordion__title"
          }),
          /* @__PURE__ */ jsxRuntime.jsx(ui$1.PbIcon, __spreadValues({}, restIconProps))
        ]
      }),
      children
    ]
  }));
});
AccordionItem.displayName = "AccordionItem";
const Wrapper = styled__default["default"].div(
  (_c) => {
    var _d = _c, { commonStyle, iconAlign, titleStyle } = _d, rest = __objRest(_d, ["commonStyle", "iconAlign", "titleStyle"]);
    return `
    &.accordion__item {
      ${coreRenderer.getStyle(commonStyle)}
      ${utils.getAccordionItemChildrenCss(rest)}
    }

    .accordion {
      &__header {
        display: flex;
        align-items: center;
        cursor: pointer;

        &.left {
          flex-direction: row-reverse;
          justify-content: flex-end;
        }
        &.right {
          flex-direction: row;
          justify-content: space-between;
        }
      }

      &__title {
        h1, h2, h3, h4, h5, p {
          ${coreRenderer.getStyle(titleStyle)}
          ${fonts.getCommonTextCss()}
        }
      }

      &__content {
        display: flex;
        flex-direction: column;
      }
    }

    &.collapsed .accordion__content {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      height: 0;
      opacity: 0;
      pointer-events: none;
    }

    &.active .accordion__content {
      opacity: 1;
    }
  `;
  }
);

exports.AccordionItem = AccordionItem;


/***/ }),

/***/ 24603:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);

const getAccordionItemChildrenCss = ({
  headerStyle,
  contentStyle,
  contentAlign
}) => {
  const getHorizontalAlign = () => {
    if (!contentAlign)
      return "";
    let alignStyle = "stretch";
    if (contentAlign === coreRenderer.Alignment.center)
      alignStyle = "center";
    if (contentAlign === coreRenderer.Alignment.right)
      alignStyle = "flex-end";
    return `align-items: ${alignStyle};`;
  };
  return `
  .accordion {
    &__header {
      ${coreRenderer.getStyle(headerStyle)}
    }

    &__content {
      ${coreRenderer.getStyle(contentStyle)}
      ${getHorizontalAlign()}
    }
  }
`;
};

exports.getAccordionItemChildrenCss = getAccordionItemChildrenCss;


/***/ }),

/***/ 25175:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const DEFAULT_ARTICLE_HEADER = {
  commonStyle: {
    maxWidth: 1232,
    color: "#333",
    fontSize: 34
  }
};

exports.DEFAULT_ARTICLE_HEADER = DEFAULT_ARTICLE_HEADER;


/***/ }),

/***/ 42413:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var dayjs = __webpack_require__(72139);
var constants = __webpack_require__(25175);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var dayjs__default = /*#__PURE__*/_interopDefaultLegacy(dayjs);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ArticleHeader = (props) => {
  const { globalData = {} } = coreRenderer.useStore();
  const { page } = globalData || {};
  const { articleInfo } = page || {};
  const { authorName, publishedAt } = articleInfo || {};
  const fontSize = props.commonStyle.fontSize;
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({}, props), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Title, {
        fontSize,
        children: page == null ? void 0 : page.name
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(Meta, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx("div", {
            children: authorName
          }),
          /* @__PURE__ */ jsxRuntime.jsx("span", {
            children: dayjs__default["default"].unix(publishedAt).format("DD/MM/YYYY")
          })
        ]
      })
    ]
  }));
};
ArticleHeader.displayName = "ArticleHeader";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  margin: 0 auto;
  padding-left: 15px;
  padding-top: 40px;
  padding-bottom: 40px;
  padding-right: 15px;
  ${coreRenderer.getStyle(commonStyle)}`
);
const Title = styled__default["default"].h1(
  ({ fontSize = constants.DEFAULT_ARTICLE_HEADER.commonStyle.fontSize }) => `${coreRenderer.getStyle({ fontSize })}`
);
const Meta = styled__default["default"].div`
  display: flex;
  font-size: 14px;
  color: '#4B4B4B';
  margin-top: 12px;

  & > span {
    /* dot */
    &:before {
      content: '•';
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
      font-size: 18px;
    }

    vertical-align: middle;
    margin: -2px 5px 0;
  }
`;

exports.ArticleHeader = ArticleHeader;


/***/ }),

/***/ 30270:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var dayjs = __webpack_require__(72139);
var coreRenderer = __webpack_require__(12060);
var constants = __webpack_require__(14886);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var dayjs__default = /*#__PURE__*/_interopDefaultLegacy(dayjs);

const ArticleCard = ({ article, layout = "list" }) => {
  const { device } = coreRenderer.useStore();
  const isMobile = device === "mobile";
  if (!article)
    return null;
  const { name, description, extraInfo, articleInfo, canonical } = article || {};
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    layout: isMobile ? "grid" : layout,
    href: canonical,
    target: "_blank",
    rel: "noreferrer",
    children: [
      /* @__PURE__ */ jsxRuntime.jsx("div", {
        children: /* @__PURE__ */ jsxRuntime.jsx(Thumbnail, {
          layout,
          children: /* @__PURE__ */ jsxRuntime.jsx(ThumbnailContent, {
            children: /* @__PURE__ */ jsxRuntime.jsx("img", {
              src: (extraInfo == null ? void 0 : extraInfo.metaImage) || constants.DEFAULT_ARTICLE_THUMBNAIL,
              width: "100%",
              height: "100%",
              style: {
                objectFit: "cover"
              },
              alt: name
            })
          })
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsxs("div", {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Title, {
            children: name
          }),
          /* @__PURE__ */ jsxRuntime.jsx(Description, {
            children: description
          }),
          /* @__PURE__ */ jsxRuntime.jsx(AuthorName, {
            children: articleInfo == null ? void 0 : articleInfo.authorName
          }),
          /* @__PURE__ */ jsxRuntime.jsx(PublishedAt, {
            children: dayjs__default["default"].unix(articleInfo == null ? void 0 : articleInfo.publishedAt).format("DD/MM/YYYY")
          })
        ]
      })
    ]
  });
};
const Wrapper = styled__default["default"].a(
  ({ layout }) => layout === "grid" ? `
    display: flex;
    flex-direction: column;
    gap: 16px;
    ` : `
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    `
);
const Title = styled__default["default"].div`
  font-weight: bold;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 1em;
  line-height: 1.5;
`;
const Description = styled__default["default"].div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  margin-bottom: 0.5em;
  line-height: 1.5;
`;
const Thumbnail = styled__default["default"].div(
  ({ layout }) => `
position: relative;
padding-bottom: 67%;
overflow: hidden;
border-radius: 8px;
`
);
const AuthorName = styled__default["default"].div`
  margin-bottom: 0.5em;
`;
const PublishedAt = styled__default["default"].div`
  margin-bottom: 0.5em;
`;
const ThumbnailContent = styled__default["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

exports.ArticleCard = ArticleCard;


/***/ }),

/***/ 87341:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const EmptyIcon = () => /* @__PURE__ */ jsxRuntime.jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "106",
  height: "100",
  viewBox: "0 0 106 100",
  fill: "none",
  style: { paddingLeft: "1em" },
  children: [
    /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M44.6033 99.4921C69.237 99.4921 89.2066 95.7607 89.2066 91.1579C89.2066 86.555 69.237 82.8237 44.6033 82.8237C19.9696 82.8237 0 86.555 0 91.1579C0 95.7607 19.9696 99.4921 44.6033 99.4921Z",
      fill: "#F5F5F7",
      fillOpacity: "0.8"
    }),
    /* @__PURE__ */ jsxRuntime.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M80.2856 66.6737L64.5455 47.3019C63.7902 46.3901 62.6863 45.8381 61.5238 45.8381H27.6817C26.5198 45.8381 25.4159 46.3901 24.6606 47.3019L8.92114 66.6737V76.7941H80.2863V66.6737H80.2856Z",
      fill: "#AEB8C2"
    }),
    /* @__PURE__ */ jsxRuntime.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.2566 20.8355H66.9493C67.6473 20.8355 68.3166 21.1128 68.8102 21.6063C69.3037 22.0998 69.5809 22.7692 69.5809 23.4671V84.8776C69.5809 85.5755 69.3037 86.2449 68.8102 86.7384C68.3166 87.2319 67.6473 87.5092 66.9493 87.5092H22.2566C21.5586 87.5092 20.8893 87.2319 20.3958 86.7384C19.9023 86.2449 19.625 85.5755 19.625 84.8776V23.4671C19.625 22.7692 19.9023 22.0998 20.3958 21.6063C20.8893 21.1128 21.5586 20.8355 22.2566 20.8355V20.8355Z",
      fill: "#F5F5F7"
    }),
    /* @__PURE__ */ jsxRuntime.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.0777 27.3835H61.1283C61.4773 27.3835 61.812 27.5222 62.0587 27.7689C62.3055 28.0157 62.4441 28.3504 62.4441 28.6993V45.1184C62.4441 45.4674 62.3055 45.8021 62.0587 46.0488C61.812 46.2956 61.4773 46.4342 61.1283 46.4342H28.0777C27.7287 46.4342 27.394 46.2956 27.1472 46.0488C26.9005 45.8021 26.7619 45.4674 26.7619 45.1184V28.6993C26.7619 28.3504 26.9005 28.0157 27.1472 27.7689C27.394 27.5222 27.7287 27.3835 28.0777 27.3835ZM28.25 53.577H60.9559C61.3506 53.577 61.7291 53.7338 62.0082 54.0128C62.2873 54.2919 62.4441 54.6704 62.4441 55.0651C62.4441 55.4598 62.2873 55.8383 62.0082 56.1174C61.7291 56.3965 61.3506 56.5533 60.9559 56.5533H28.25C27.8553 56.5533 27.4768 56.3965 27.1977 56.1174C26.9186 55.8383 26.7619 55.4598 26.7619 55.0651C26.7619 54.6704 26.9186 54.2919 27.1977 54.0128C27.4768 53.7338 27.8553 53.577 28.25 53.577ZM28.25 61.3158H60.9559C61.3507 61.3158 61.7293 61.4726 62.0085 61.7518C62.2876 62.0309 62.4444 62.4095 62.4444 62.8043C62.4444 63.199 62.2876 63.5776 62.0085 63.8568C61.7293 64.1359 61.3507 64.2928 60.9559 64.2928H28.25C27.8552 64.2928 27.4766 64.1359 27.1975 63.8568C26.9184 63.5776 26.7615 63.199 26.7615 62.8043C26.7615 62.4095 26.9184 62.0309 27.1975 61.7518C27.4766 61.4726 27.8552 61.3158 28.25 61.3158ZM80.1402 89.9355C79.6303 91.9559 77.8395 93.4618 75.7092 93.4618H13.4967C11.3665 93.4618 9.57567 91.9553 9.06646 89.9355C8.96934 89.5505 8.92029 89.1549 8.92041 88.7579V66.6743H26.2349C28.1474 66.6743 29.6888 68.2849 29.6888 70.2401V70.2664C29.6888 72.221 31.248 73.7993 33.1605 73.7993H56.0454C57.9579 73.7993 59.5171 72.2066 59.5171 70.2513V70.2434C59.5171 68.2881 61.0586 66.6737 62.9711 66.6737H80.2855V88.7585C80.2855 89.1645 80.2349 89.5585 80.1402 89.9355Z",
      fill: "#DCE0E6"
    }),
    /* @__PURE__ */ jsxRuntime.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M82.3164 21.9026L77.823 23.6461C77.7075 23.6909 77.5818 23.7023 77.4602 23.6789C77.3385 23.6555 77.226 23.5982 77.1355 23.5137C77.045 23.4292 76.9802 23.3208 76.9485 23.2011C76.9168 23.0813 76.9196 22.9551 76.9565 22.8368L78.2309 18.7533C76.5276 16.8164 75.5276 14.4546 75.5276 11.9059C75.5276 5.33026 82.1842 0 90.396 0C98.6059 0 105.263 5.33026 105.263 11.9059C105.263 18.4816 98.6065 23.8118 90.3954 23.8118C87.4164 23.8118 84.6427 23.1105 82.3164 21.9026Z",
      fill: "#DCE0E6"
    }),
    /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M96.2528 14.0559C97.2879 14.0559 98.1271 13.2268 98.1271 12.204C98.1271 11.1811 97.2879 10.352 96.2528 10.352C95.2176 10.352 94.3784 11.1811 94.3784 12.204C94.3784 13.2268 95.2176 14.0559 96.2528 14.0559Z",
      fill: "white"
    }),
    /* @__PURE__ */ jsxRuntime.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M86.4132 13.8243H82.6646L84.5711 10.5836L86.4132 13.8243ZM88.756 10.5836H92.0356V13.8243H88.756V10.5836Z",
      fill: "white"
    })
  ]
});
const ArticleEmpty = () => {
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsxs("div", {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx("div", {
          children: /* @__PURE__ */ jsxRuntime.jsx(EmptyIcon, {})
        }),
        /* @__PURE__ */ jsxRuntime.jsx("div", {
          style: { marginTop: "1em" },
          children: "Ch\u01B0a c\xF3 b\xE0i vi\u1EBFt n\xE0o"
        })
      ]
    })
  });
};
const Wrapper = styled__default["default"].div`
  height: 400px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 14px;
`;

exports.ArticleEmpty = ArticleEmpty;


/***/ }),

/***/ 81337:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ArticleLayout = ({ layout, children, gridConfig, listConfig }) => {
  const { device } = coreRenderer.useStore();
  const isMobile = device === "mobile";
  if (layout === "list" || isMobile) {
    return /* @__PURE__ */ jsxRuntime.jsx(ListWrapper, __spreadProps(__spreadValues({}, listConfig), {
      children
    }));
  }
  return /* @__PURE__ */ jsxRuntime.jsx(GridWrapper, __spreadProps(__spreadValues({}, gridConfig), {
    children
  }));
};
const GridWrapper = styled__default["default"].div(
  ({ column = 4, gutter = 16 }) => `
display: grid;
grid-template-columns: repeat(${column}, minmax(0,1fr));
grid-gap: ${gutter}px;
grid-auto-rows: 1fr;
grid-auto-flow: dense;
`
);
const ListWrapper = styled__default["default"].div(
  ({ gutter = 16 }) => `
display: grid;
grid-template-columns: 1fr;
grid-gap: ${gutter}px;
grid-auto-rows: 1fr;
grid-auto-flow: dense;
`
);

exports.ArticleLayout = ArticleLayout;


/***/ }),

/***/ 14886:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const DEFAULT_ARTICLE_LIST = {
  layout: "grid",
  categoryIds: [],
  gridConfig: {
    row: 2,
    column: 4,
    gutter: 16
  },
  listConfig: {
    row: 10,
    gutter: 16
  },
  showLoadMore: true,
  commonStyle: { color: "#000000", backgroundColor: "#ffffff" }
};
const DEFAULT_ARTICLE_THUMBNAIL = "https://lh3.googleusercontent.com/nAocrNg5Uz_6OlemCdHXyNfPK9uxJpBhADfy_xEc4QiZT7ihSAC_8X_wkht7FGoOxRWfT0IFtkaVxF6mKajLbLbueDZmdlg=rw-w500";

exports.DEFAULT_ARTICLE_LIST = DEFAULT_ARTICLE_LIST;
exports.DEFAULT_ARTICLE_THUMBNAIL = DEFAULT_ARTICLE_THUMBNAIL;


/***/ }),

/***/ 96366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const useArticles = (props) => {
  const { websiteId, categoryIds, layout, gridConfig, listConfig } = props;
  const [articles, setArticles] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const { env } = coreRenderer.useStore();
  const [loading, setLoading] = React.useState(true);
  const [pagination, setPagination] = React.useState();
  const pageSize = layout === "grid" ? gridConfig.row * gridConfig.column : listConfig.row;
  const hasMore = (pagination == null ? void 0 : pagination.total) > currentPage * pageSize;
  const reset = () => {
    setArticles([]);
    setCurrentPage(1);
    setPagination(void 0);
  };
  const fetchArticles = () => {
    const API = new coreRenderer.Api(`${coreRenderer.publicBffUrl[env]}/v1/pages`);
    setLoading(true);
    API.get("/", {
      params: __spreadProps(__spreadValues({
        websiteId
      }, categoryIds.length && { categoryIds }), {
        page: currentPage,
        pageSize,
        isArticle: true
      })
    }).then((res) => {
      var _a, _b, _c, _d;
      const pages = (_b = (_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) == null ? void 0 : _b.pages;
      const currentPagination = (_d = (_c = res == null ? void 0 : res.data) == null ? void 0 : _c.data) == null ? void 0 : _d.pagination;
      if (currentPage === 1) {
        setArticles(pages);
      } else {
        setArticles((prev) => [...prev, ...pages]);
      }
      setPagination(currentPagination);
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setLoading(false);
    });
  };
  const loadMore = () => {
    setCurrentPage((prev) => prev + 1);
  };
  React.useEffect(() => {
    if (!!websiteId) {
      reset();
      fetchArticles();
    }
  }, [
    websiteId,
    categoryIds,
    listConfig.row,
    gridConfig.column,
    gridConfig.row
  ]);
  React.useEffect(() => {
    fetchArticles();
  }, [currentPage]);
  return { articles, loading, loadMore, hasMore };
};

exports.useArticles = useArticles;


/***/ }),

/***/ 48081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var useArticles = __webpack_require__(96366);
var ArticleEmpty = __webpack_require__(87341);
var ArticleLayout = __webpack_require__(81337);
var ArticleCard = __webpack_require__(30270);
var ui = __webpack_require__(61349);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ArticleList = (props) => {
  const _a = props, {
    categoryIds = [],
    layout,
    gridConfig,
    listConfig,
    showLoadMore,
    commonStyle,
    isEditingMode
  } = _a, rest = __objRest(_a, [
    "categoryIds",
    "layout",
    "gridConfig",
    "listConfig",
    "showLoadMore",
    "commonStyle",
    "isEditingMode"
  ]);
  const { globalData = {} } = coreRenderer.useStore();
  const { websiteId } = globalData || {};
  const {
    articles = [],
    loading,
    hasMore,
    loadMore
  } = useArticles.useArticles({
    websiteId,
    categoryIds,
    layout,
    listConfig,
    gridConfig
  });
  const isEmpty = articles.length === 0;
  if (!loading && isEmpty) {
    return /* @__PURE__ */ jsxRuntime.jsx(ArticleEmpty.ArticleEmpty, {});
  }
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({
    commonStyle,
    isEditingMode
  }, rest), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(ArticleLayout.ArticleLayout, __spreadProps(__spreadValues({}, props), {
        children: articles.map((article) => /* @__PURE__ */ jsxRuntime.jsx(ArticleCard.ArticleCard, {
          article,
          layout
        }, article.canonical))
      })),
      loading && /* @__PURE__ */ jsxRuntime.jsx(LoadingWrapper, {
        children: "\u0110ang t\u1EA3i b\xE0i vi\u1EBFt ..."
      }),
      showLoadMore && !loading && !isEmpty && /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: hasMore ? /* @__PURE__ */ jsxRuntime.jsx(ui.ButtonV2, {
          text: "Xem th\xEAm",
          onClick: loadMore,
          buttonStyle: {
            background: "white",
            hover: {
              color: "#777777"
            },
            border: {
              borderStyle: "solid",
              borderWidth: 1,
              borderColor: "#d9d9d9",
              borderRadius: 4
            },
            padding: { bottom: 8, top: 8, left: 16, right: 16 },
            margin: { top: 16, bottom: 16 }
          },
          commonStyle: { justifyContent: "center" }
        }) : /* @__PURE__ */ jsxRuntime.jsx(ArticleListFooter, {
          children: "Kh\xF4ng c\xF2n b\xE0i vi\u1EBFt n\xE0o"
        })
      })
    ]
  }));
};
ArticleList.displayName = "ArticleList";
const ArticleListFooter = styled__default["default"].div`
  text-align: center;
  margin: 2em 0;
  color: gray;
`;
const Wrapper = styled__default["default"].div(
  ({ commonStyle, isEditingMode }) => `
  ${isEditingMode ? "pointer-events: none;" : ""}
  ${coreRenderer.getStyle(commonStyle)}
  a{
    color: ${commonStyle.color};
  }
`
);
const LoadingWrapper = styled__default["default"].div`
  height: 400px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 14px;
`;

exports.ArticleList = ArticleList;


/***/ }),

/***/ 61349:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var getIconComponent = __webpack_require__(35010);
var SpinningInner = __webpack_require__(70411);
var Ripple = __webpack_require__(2078);
var index = __webpack_require__(43866);
var fonts = __webpack_require__(74367);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ButtonV2 = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, {
      commonStyle,
      text,
      iconConfig,
      isEditingMode = false,
      onClick,
      className,
      disabled,
      buttonStyle,
      customText,
      event,
      loading
    } = _a, rest = __objRest(_a, [
      "commonStyle",
      "text",
      "iconConfig",
      "isEditingMode",
      "onClick",
      "className",
      "disabled",
      "buttonStyle",
      "customText",
      "event",
      "loading"
    ]);
    const IconComponent = getIconComponent.getIconCompoment(iconConfig == null ? void 0 : iconConfig.icon);
    const hasPrefix = (iconConfig == null ? void 0 : iconConfig.show) && (iconConfig == null ? void 0 : iconConfig.position) === "left" && !!IconComponent;
    const hasSuffix = (iconConfig == null ? void 0 : iconConfig.show) && (iconConfig == null ? void 0 : iconConfig.position) === "right" && !!IconComponent;
    const isDisableBtn = disabled || loading;
    const btn = /* @__PURE__ */ jsxRuntime.jsxs(StyledButton, __spreadProps(__spreadValues({
      ref,
      disabled: isDisableBtn,
      buttonStyle,
      onClick: (e) => {
        if (typeof onClick === "function" && !isDisableBtn && !isEditingMode) {
          e.preventDefault();
          onClick();
        }
      }
    }, rest), {
      children: [
        loading && /* @__PURE__ */ jsxRuntime.jsx("span", {
          children: /* @__PURE__ */ jsxRuntime.jsx(SpinningInner.StyledSpinningInner, {
            size: 10,
            transform: 5,
            time: 0.6
          })
        }),
        hasPrefix && !loading && IconComponent,
        /* @__PURE__ */ jsxRuntime.jsx("span", {
          style: __spreadValues(__spreadValues({}, (hasPrefix || loading) && !!text && {
            marginLeft: iconConfig == null ? void 0 : iconConfig.spacing
          }), !!hasSuffix && !!text && {
            marginRight: iconConfig == null ? void 0 : iconConfig.spacing
          }),
          children: customText ? customText : /* @__PURE__ */ jsxRuntime.jsx("span", {
            dangerouslySetInnerHTML: { __html: text }
          })
        }),
        hasSuffix && IconComponent,
        !disabled && !customText && /* @__PURE__ */ jsxRuntime.jsx(Ripple.Ripple, {})
      ]
    }));
    if (isEditingMode) {
      return /* @__PURE__ */ jsxRuntime.jsx(ButtonWrapper, {
        commonStyle,
        className,
        children: btn
      });
    }
    return /* @__PURE__ */ jsxRuntime.jsx(ButtonWrapper, {
      commonStyle,
      className,
      children: /* @__PURE__ */ jsxRuntime.jsx(index.Link, __spreadProps(__spreadValues({}, event), {
        children: btn
      }))
    });
  }
);
const StyledButton = styled__default["default"].button(
  ({ buttonStyle }) => `
    ${fonts.getCommonTextCss()}
    position: relative;
    border: none;
    align-items: center;
    text-decoration: none;
    display: flex;
    cursor: pointer;
    justify-content: center;
    font-size: 14px;
    line-height: 16px;
    background: transparent;
    > span {
      font-size: inherit;
      line-height: inherit;
    }
    &[disabled] {
      color: #00000040;
      border-color: #d9d9d9;
      background: #f5f5f5;
      text-shadow: none;
      box-shadow: none;
      cursor: not-allowed;
    }
    ${coreRenderer.getStyle(buttonStyle)}
`
);
const ButtonWrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  display: flex;
  width: 100%;
  position: relative;
  ${coreRenderer.getStyle(commonStyle)}
`
);
ButtonV2.displayName = "ButtonV2";

exports.ButtonV2 = ButtonV2;
exports.ButtonWrapper = ButtonWrapper;


/***/ }),

/***/ 67610:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var clsx = __webpack_require__(77084);
var React = __webpack_require__(91987);
var utils = __webpack_require__(582);
var Col = __webpack_require__(97089);
var grid = __webpack_require__(74178);
var index = __webpack_require__(43866);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ColContent = styled__default["default"].div(
  ({
    commonStyle,
    verticalAlignment
  }) => `
  ${coreRenderer.getStyle(commonStyle, { lazyBgImage: true })}
  display: flex;
  flex-direction: column;
  justify-content: ${grid.MAPPING_VERTICAL_ALIGNMENT_FLEX[verticalAlignment] || grid.MAPPING_VERTICAL_ALIGNMENT_FLEX.top}
`
);
const PbCol = React__default["default"].forwardRef(
  (props, ref) => {
    var _b, _c;
    const _a = props, { commonStyle, verticalAlignment, children, event } = _a, rest = __objRest(_a, ["commonStyle", "verticalAlignment", "children", "event"]);
    const colRef = React.useRef();
    const { style: animationStyle, animationClassName } = coreRenderer.useAnimation(
      commonStyle == null ? void 0 : commonStyle.animation,
      colRef
    );
    const entry = coreRenderer.useIntersectionObserver(colRef, { freezeOnceVisible: true });
    return /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BreakpointWidthProvider, {
      sWidth: {
        value: utils.parseFlexPercent((_b = rest == null ? void 0 : rest.xs) == null ? void 0 : _b.flex),
        unit: "%"
      },
      mWidth: {
        value: utils.parseFlexPercent((_c = rest == null ? void 0 : rest.md) == null ? void 0 : _c.flex),
        unit: "%"
      },
      children: /* @__PURE__ */ jsxRuntime.jsxs(Col.Col, __spreadProps(__spreadValues({
        ref
      }, rest), {
        children: [
          (commonStyle == null ? void 0 : commonStyle.backgroundVideo) && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BackgroundVideo, __spreadValues({}, commonStyle.backgroundVideo)),
          /* @__PURE__ */ jsxRuntime.jsx(index.Link, __spreadProps(__spreadValues({}, event), {
            children: /* @__PURE__ */ jsxRuntime.jsx(ColContent, {
              ref: colRef,
              commonStyle,
              verticalAlignment,
              style: animationStyle,
              className: clsx__default["default"](
                {
                  [coreRenderer.BG_LAZY_CLASS_NAME]: true,
                  [coreRenderer.BG_VISIBLE_LAZY_CLASS_NAME]: entry == null ? void 0 : entry.isIntersecting
                },
                animationClassName
              ),
              children
            })
          }))
        ]
      }))
    });
  }
);
PbCol.displayName = Col.Col.displayName;

exports.PbCol = PbCol;


/***/ }),

/***/ 582:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(91987);
var Col = __webpack_require__(97089);

const useDragging = () => {
  const [isDragging, setIsDragging] = React.useState(false);
  const [pos, setPos] = React.useState(0);
  const [newPos, setNewPos] = React.useState(0);
  const ref = React.useRef(null);
  const current = ref == null ? void 0 : ref.current;
  const onMouseMove = (e) => {
    if (!isDragging)
      return;
    setNewPos(e.x - (current == null ? void 0 : current.offsetWidth) / 2);
    e.stopPropagation();
    e.preventDefault();
  };
  const onMouseUp = (e) => {
    document.querySelector("iframe").style.pointerEvents = "auto";
    setIsDragging(false);
    e.stopPropagation();
    e.preventDefault();
  };
  const onMouseDown = (e) => {
    document.querySelector("iframe").style.pointerEvents = "none";
    if (e.button !== 0)
      return;
    setIsDragging(true);
    setPos(e.x - (current == null ? void 0 : current.offsetWidth) / 2);
    setNewPos(e.x - (current == null ? void 0 : current.offsetWidth) / 2);
    e.stopPropagation();
    e.preventDefault();
  };
  React.useEffect(() => {
    current == null ? void 0 : current.addEventListener("mousedown", onMouseDown);
    return () => {
      current == null ? void 0 : current.removeEventListener("mousedown", onMouseDown);
    };
  }, [current]);
  React.useEffect(() => {
    if (isDragging) {
      document.addEventListener("mouseup", onMouseUp);
      document.addEventListener("mousemove", onMouseMove);
    } else {
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("mousemove", onMouseMove);
    }
    return () => {
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("mousemove", onMouseMove);
    };
  }, [isDragging]);
  return { ref, pos, newPos, isDragging };
};
const MIN_PERCENTAGE_COL_WIDTH = 8;
const getStepPercent = (pos, newPos, colWidth, colFlex, siblingFlex) => {
  let step = Col.floorPercentage(Math.abs(newPos - pos) / (colWidth / colFlex));
  if (newPos < pos) {
    if (colFlex - step < MIN_PERCENTAGE_COL_WIDTH)
      step = colFlex - MIN_PERCENTAGE_COL_WIDTH;
    step = -step;
  } else {
    if (siblingFlex - step < MIN_PERCENTAGE_COL_WIDTH)
      step = siblingFlex - MIN_PERCENTAGE_COL_WIDTH;
  }
  return step;
};
const parseFlex = (flex) => {
  return parseFloat(flex == null ? void 0 : flex.replace("%", ""));
};
const getRemainingPercent = (percents) => {
  const remainingPercent = Col.floorPercentage(
    percents.reduce((flex, percent) => {
      return flex -= parseFlex(percent) || 0;
    }, 100)
  );
  return remainingPercent;
};
const getColWidthProps = (md) => {
  return {
    md: {
      flex: Col.percentage(md, 12)
    },
    xs: {
      flex: "100%"
    }
  };
};
const parseFlexPercent = (value) => {
  try {
    if (typeof value !== "string")
      return 100;
    const flex = value.replace("%", "");
    if (isNaN(+flex))
      return 100;
    return +flex;
  } catch (e) {
    console.warn(e);
    return 100;
  }
};

exports.MIN_PERCENTAGE_COL_WIDTH = MIN_PERCENTAGE_COL_WIDTH;
exports.getColWidthProps = getColWidthProps;
exports.getRemainingPercent = getRemainingPercent;
exports.getStepPercent = getStepPercent;
exports.parseFlex = parseFlex;
exports.parseFlexPercent = parseFlexPercent;
exports.useDragging = useDragging;


/***/ }),

/***/ 7644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var type = __webpack_require__(15906);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const BubbleItem = ({ item, position }) => {
  var _a, _b, _c;
  if (!item)
    return null;
  const getPropsLink = (href) => {
    if (!href)
      return;
    const phoneNumber = href.replace(/-|\.|\s/g, "");
    if (coreRenderer.PATTERN_VALIDATION.phone.test(phoneNumber))
      return {
        href: `tel:${phoneNumber}`,
        target: "_self"
      };
    return {
      href,
      target: "_blank"
    };
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    position,
    children: [
      (item == null ? void 0 : item.icon) && /* @__PURE__ */ jsxRuntime.jsx("a", __spreadProps(__spreadValues({}, getPropsLink(item.href)), {
        rel: "noreferrer",
        children: /* @__PURE__ */ jsxRuntime.jsx("img", __spreadValues({
          src: (_a = item.icon) == null ? void 0 : _a.src,
          alt: item.title,
          height: item.size
        }, ((_b = item.icon) == null ? void 0 : _b.src) && {
          srcSet: coreRenderer.buildSrcsetDPR((_c = item.icon) == null ? void 0 : _c.src, item.size)
        }))
      })),
      /* @__PURE__ */ jsxRuntime.jsx(Label, {
        children: item == null ? void 0 : item.title
      })
    ]
  });
};
const getFlexDirection = (position) => {
  switch (position) {
    case type.ContactBubblePosition.BOTTOM_LEFT:
    case type.ContactBubblePosition.CENTER_LEFT:
      return "row";
    case type.ContactBubblePosition.BOTTOM_RIGHT:
    case type.ContactBubblePosition.CENTER_RIGHT:
      return "row-reverse";
    default:
      return "row";
  }
};
const Wrapper = styled__default["default"].div(
  ({ position }) => `
a:hover ~ p {
  display: block;
}

display: flex;
align-items: center;
flex-direction: row-reverse;
gap: 0.8em;
flex-direction: ${getFlexDirection(position)};
`
);
const Label = styled__default["default"].p`
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  position: relative;
  display: none;
  padding: 6px 10px;
`;

exports.BubbleItem = BubbleItem;


/***/ }),

/***/ 60660:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var BubbleItem = __webpack_require__(7644);
var FlashingBubbleItems = __webpack_require__(40777);
var type = __webpack_require__(15906);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Bubbles = ({ items, layout, position }) => {
  const filterItems = items.filter((item) => {
    var _a;
    return !!((_a = item == null ? void 0 : item.icon) == null ? void 0 : _a.src);
  });
  switch (layout) {
    case type.ContactBubbleLayout.VERTICAL:
      return /* @__PURE__ */ jsxRuntime.jsx(VerticalBubbles, {
        children: filterItems.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx(BubbleItem.BubbleItem, {
          item,
          position
        }, index))
      });
    case type.ContactBubbleLayout.FLASH:
      return /* @__PURE__ */ jsxRuntime.jsx(FlashingBubbleItems.FlashingBubbleItems, {
        items: filterItems,
        position
      });
    default:
      return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {});
  }
};
const VerticalBubbles = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  gap: 1em;
`;

exports.Bubbles = Bubbles;


/***/ }),

/***/ 40777:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var BubbleItem = __webpack_require__(7644);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const FlashingBubbleItems = ({ items, position }) => {
  const [index, setIndex] = React__default["default"].useState(0);
  const item = items[index];
  React.useEffect(() => {
    const interval = setInterval(() => {
      setIndex((index + 1) % items.length);
    }, 1e3);
    return () => clearInterval(interval);
  }, [index, items.length]);
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /* @__PURE__ */ jsxRuntime.jsx(BubbleItem.BubbleItem, {
      item,
      position
    })
  });
};

exports.FlashingBubbleItems = FlashingBubbleItems;


/***/ }),

/***/ 15906:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var ContactBubbleLayout = /* @__PURE__ */ ((ContactBubbleLayout2) => {
  ContactBubbleLayout2["VERTICAL"] = "VERTICAL";
  ContactBubbleLayout2["FLASH"] = "FLASH";
  return ContactBubbleLayout2;
})(ContactBubbleLayout || {});
var ContactBubblePosition = /* @__PURE__ */ ((ContactBubblePosition2) => {
  ContactBubblePosition2["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
  ContactBubblePosition2["BOTTOM_LEFT"] = "BOTTOM_LEFT";
  ContactBubblePosition2["CENTER_RIGHT"] = "CENTER_RIGHT";
  ContactBubblePosition2["CENTER_LEFT"] = "CENTER_LEFT";
  return ContactBubblePosition2;
})(ContactBubblePosition || {});

exports.ContactBubbleLayout = ContactBubbleLayout;
exports.ContactBubblePosition = ContactBubblePosition;


/***/ }),

/***/ 24190:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var type = __webpack_require__(15906);
var Bubbles = __webpack_require__(60660);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ContactBubble = (props) => {
  const { device } = coreRenderer.useStore();
  const { enable } = props;
  if (!enable)
    return null;
  const {
    items = [],
    layout = type.ContactBubbleLayout.VERTICAL,
    position = type.ContactBubblePosition.BOTTOM_RIGHT,
    gap
  } = (device === "desktop" ? props == null ? void 0 : props.desktop : props == null ? void 0 : props.mobile) || {};
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    position,
    gap,
    children: /* @__PURE__ */ jsxRuntime.jsx(Bubbles.Bubbles, {
      items,
      layout,
      position
    })
  });
};
ContactBubble.displayName = "ContactBubble";
const getStyleByPosition = (position, gap) => {
  switch (position) {
    case type.ContactBubblePosition.BOTTOM_RIGHT:
      return `
bottom: ${(gap == null ? void 0 : gap.vertical) || 0}px;
right: ${(gap == null ? void 0 : gap.horizontal) || 0}px;
`;
    case type.ContactBubblePosition.BOTTOM_LEFT:
      return `
bottom: ${(gap == null ? void 0 : gap.vertical) || 0}px;
left: ${(gap == null ? void 0 : gap.horizontal) || 0}px;
`;
    case type.ContactBubblePosition.CENTER_LEFT:
      return `
top: 50%;
left: ${(gap == null ? void 0 : gap.horizontal) || 0}px;
transform: translateY(-50%);
`;
    case type.ContactBubblePosition.CENTER_RIGHT:
      return `
top: 50%;
right: ${(gap == null ? void 0 : gap.horizontal) || 0}px;
transform: translateY(-50%);
`;
    default:
      return "";
  }
};
const Wrapper = styled__default["default"].div(
  ({ position, gap }) => `
position: fixed;
z-index: 9999;
${getStyleByPosition(position, gap)}
`
);

exports.ContactBubble = ContactBubble;


/***/ }),

/***/ 68882:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var clsx = __webpack_require__(77084);
var Container = __webpack_require__(88006);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledContainer = styled__default["default"](Container.Container)(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle, { lazyBgImage: true })}
`
);
const PbContainer = React__default["default"].forwardRef(
  (props, passRef) => {
    const _a = props, { commonStyle, children, className } = _a, rest = __objRest(_a, ["commonStyle", "children", "className"]);
    const containerRef = React.useRef();
    const ref = passRef || containerRef;
    const entry = coreRenderer.useIntersectionObserver(ref, {
      freezeOnceVisible: true
    });
    const { style: animationStyle, animationClassName } = coreRenderer.useAnimation(
      commonStyle == null ? void 0 : commonStyle.animation,
      containerRef
    );
    return /* @__PURE__ */ jsxRuntime.jsx(StyledContainer, __spreadProps(__spreadValues({
      ref,
      commonStyle,
      className: clsx__default["default"](
        className,
        {
          [coreRenderer.BG_LAZY_CLASS_NAME]: true,
          [coreRenderer.BG_VISIBLE_LAZY_CLASS_NAME]: entry == null ? void 0 : entry.isIntersecting
        },
        animationClassName
      )
    }, rest), {
      style: animationStyle,
      children
    }));
  }
);
PbContainer.displayName = Container.Container.displayName;

exports.PbContainer = PbContainer;


/***/ }),

/***/ 11970:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var utils = __webpack_require__(89475);
var Slider = __webpack_require__(85468);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ContentSlider = (props) => {
  return /* @__PURE__ */ jsxRuntime.jsx(Slider.DSSlider, __spreadProps(__spreadValues({}, utils.convertOptionSliderV2ToV1(props)), {
    children: props.children
  }));
};
ContentSlider.displayName = "ContentSlider";

exports.ContentSlider = ContentSlider;


/***/ }),

/***/ 49051:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ContentSliderItem = React__default["default"].forwardRef(({ children, commonStyle }, ref) => {
  return /* @__PURE__ */ jsxRuntime.jsx(StyledDiv, {
    commonStyle,
    ref,
    children
  });
});
const StyledDiv = styled__default["default"].div(
  ({ commonStyle }) => `
    ${coreRenderer.getStyle(commonStyle)}
  `
);
ContentSliderItem.displayName = "ContentSliderItem";

exports.ContentSliderItem = ContentSliderItem;


/***/ }),

/***/ 95648:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var addPaddingNumber = __webpack_require__(14437);
var grid = __webpack_require__(74178);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getISODateBackward = (dateString) => {
  if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/.test(dateString)) {
    const day = parseInt(dateString.substring(0, 2));
    const month = parseInt(dateString.substring(3, 5));
    const year = parseInt(dateString.substring(6, 10));
    const hour = parseInt(dateString.substring(11, 13));
    const minute = parseInt(dateString.substring(14, 16));
    return new Date(year, month - 1, day, hour, minute).toISOString();
  }
  return dateString;
};
const Countdown = ({
  countdownType: _countdownType = "due",
  due,
  showDays = true,
  showHours = true,
  showMinutes = true,
  showSeconds = true,
  showLabel = false,
  labelDays,
  labelHours,
  labelMinutes,
  labelSeconds,
  countdownStyle,
  commonStyle,
  splitTimeUnit
}) => {
  const {
    elementGap,
    labelGap,
    digitStyle,
    labelStyle,
    timeUnitStyle,
    layout,
    labelPosition,
    align
  } = countdownStyle || {};
  const finalDue = getISODateBackward(due);
  const dueDate = new Date(finalDue);
  const [duration, setDuration] = React.useState(
    coreRenderer.calculateTimeDelta(new Date(), dueDate)
  );
  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setDuration(coreRenderer.calculateTimeDelta(new Date(), dueDate));
    }, 1e3);
    return () => {
      clearInterval(intervalId);
    };
  }, [finalDue]);
  if (dueDate.toString() === "Invalid Date")
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    align,
    children: /* @__PURE__ */ jsxRuntime.jsxs(TimeWrapper, {
      commonStyle: __spreadProps(__spreadValues({}, commonStyle), { gap: elementGap }),
      children: [
        showDays && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(TimeUnit, {
              layout,
              labelPosition,
              labelGap,
              timeUnitStyle,
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(Digit, {
                  digitStyle,
                  children: addPaddingNumber.addPaddingNumber(duration.days)
                }),
                showLabel && /* @__PURE__ */ jsxRuntime.jsx(Label, {
                  labelStyle,
                  children: labelDays
                })
              ]
            }),
            !!splitTimeUnit && splitTimeUnit
          ]
        }),
        showHours && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(TimeUnit, {
              layout,
              labelPosition,
              labelGap,
              timeUnitStyle,
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(Digit, {
                  digitStyle,
                  children: addPaddingNumber.addPaddingNumber(duration.hours)
                }),
                showLabel && /* @__PURE__ */ jsxRuntime.jsx(Label, {
                  labelStyle,
                  children: labelHours
                })
              ]
            }),
            !!splitTimeUnit && splitTimeUnit
          ]
        }),
        showMinutes && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(TimeUnit, {
              layout,
              labelPosition,
              labelGap,
              timeUnitStyle,
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(Digit, {
                  digitStyle,
                  children: addPaddingNumber.addPaddingNumber(duration.minutes)
                }),
                showLabel && /* @__PURE__ */ jsxRuntime.jsx(Label, {
                  labelStyle,
                  children: labelMinutes
                })
              ]
            }),
            !!splitTimeUnit && splitTimeUnit
          ]
        }),
        showSeconds && /* @__PURE__ */ jsxRuntime.jsxs(TimeUnit, {
          layout,
          labelPosition,
          labelGap,
          timeUnitStyle,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(Digit, {
              digitStyle,
              children: addPaddingNumber.addPaddingNumber(duration.seconds)
            }),
            showLabel && /* @__PURE__ */ jsxRuntime.jsx(Label, {
              labelStyle,
              children: labelSeconds
            })
          ]
        })
      ]
    })
  });
};
const Wrapper = styled__default["default"].div(
  ({ align }) => `
  display: flex;
  justify-content: ${grid.MAPPING_VERTICAL_ALIGNMENT_FLEX[align]};
`
);
const TimeWrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)};
  display: flex;
`
);
const Digit = styled__default["default"].div(
  ({ digitStyle }) => `
  ${coreRenderer.getStyle(digitStyle)}
  @media only screen and (max-width: 480px){
    font-size: min(${digitStyle == null ? void 0 : digitStyle.fontSize}px, 30px);
  }
`
);
const Label = styled__default["default"].div(
  ({ labelStyle }) => `
  ${coreRenderer.getStyle(labelStyle)}
  @media only screen and (max-width: 480px){
    font-size: min(${labelStyle == null ? void 0 : labelStyle.fontSize}px, 30px);
  }
`
);
const TimeUnit = styled__default["default"].div(
  ({ layout, labelPosition, labelGap, timeUnitStyle }) => `
  ${coreRenderer.getStyle(timeUnitStyle)}
  display: flex;
  ${labelGap ? `gap: ${labelGap}px;` : ""}
  ${layout === "horizontal" ? `align-items: ${labelPosition};` : `flex-direction: column;`};
`
);
Countdown.displayName = "Countdown";

exports.Countdown = Countdown;
exports.getISODateBackward = getISODateBackward;


/***/ }),

/***/ 45388:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var DividerStyleEnum = /* @__PURE__ */ ((DividerStyleEnum2) => {
  DividerStyleEnum2["solid"] = "solid";
  DividerStyleEnum2["double"] = "double";
  DividerStyleEnum2["dotted"] = "dotted";
  DividerStyleEnum2["dashed"] = "dashed";
  return DividerStyleEnum2;
})(DividerStyleEnum || {});
var DividerTypeEnum = /* @__PURE__ */ ((DividerTypeEnum2) => {
  DividerTypeEnum2["text"] = "text";
  DividerTypeEnum2["icon"] = "icon";
  return DividerTypeEnum2;
})(DividerTypeEnum || {});

exports.DividerStyleEnum = DividerStyleEnum;
exports.DividerTypeEnum = DividerTypeEnum;


/***/ }),

/***/ 49730:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);
var coreRenderer = __webpack_require__(12060);
var type = __webpack_require__(45388);
var Divider = __webpack_require__(59603);
var getSizeWithUnit = __webpack_require__(80808);
var fonts = __webpack_require__(74367);
var getPropsIcon = __webpack_require__(26321);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PbDivider = (_a) => {
  var _b = _a, {
    commonStyle,
    gap,
    weight,
    style,
    align,
    type: type$1,
    textConfig,
    iconConfig,
    customText
  } = _b, rest = __objRest(_b, [
    "commonStyle",
    "gap",
    "weight",
    "style",
    "align",
    "type",
    "textConfig",
    "iconConfig",
    "customText"
  ]);
  const _a2 = commonStyle || {}, { width, color } = _a2, restCommonStyle = __objRest(_a2, ["width", "color"]);
  const renderText = () => {
    if (customText)
      return customText;
    return /* @__PURE__ */ jsxRuntime.jsx("span", {
      dangerouslySetInnerHTML: { __html: textConfig == null ? void 0 : textConfig.text }
    });
  };
  const renderDivider = () => {
    var _a3, _b2, _c;
    if (!type$1)
      return /* @__PURE__ */ jsxRuntime.jsx(Divider.Divider, {
        width: coreRenderer.unitParse(width),
        height: getSizeWithUnit.getSizeWithUnit(weight),
        color,
        dividerStyle: style,
        align,
        gap: getSizeWithUnit.getSizeWithUnit(gap)
      });
    return /* @__PURE__ */ jsxRuntime.jsxs(Divider.Divider, __spreadProps(__spreadValues({}, rest), {
      width: coreRenderer.unitParse(width),
      height: getSizeWithUnit.getSizeWithUnit(weight),
      color,
      dividerStyle: style,
      align,
      gap: getSizeWithUnit.getSizeWithUnit(gap),
      alignContent: type$1 === type.DividerTypeEnum.text ? textConfig == null ? void 0 : textConfig.align : iconConfig == null ? void 0 : iconConfig.align,
      spacingContent: type$1 === type.DividerTypeEnum.text ? getSizeWithUnit.getSizeWithUnit(textConfig == null ? void 0 : textConfig.spacing) : getSizeWithUnit.getSizeWithUnit(iconConfig == null ? void 0 : iconConfig.spacing),
      children: [
        type$1 === type.DividerTypeEnum.text && renderText(),
        type$1 === type.DividerTypeEnum.icon && /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, __spreadValues({}, __spreadValues({
          name: (_a3 = iconConfig == null ? void 0 : iconConfig.icon) == null ? void 0 : _a3.name
        }, getPropsIcon.getPropsIcon({
          color: (_b2 = iconConfig.icon) == null ? void 0 : _b2.color,
          size: (_c = iconConfig.icon) == null ? void 0 : _c.size
        }))))
      ]
    }));
  };
  return /* @__PURE__ */ jsxRuntime.jsx(StyledDivider, __spreadProps(__spreadValues({}, rest), {
    commonStyle: restCommonStyle,
    children: renderDivider()
  }));
};
const StyledDivider = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
  ${fonts.getCommonTextCss()}
`
);
PbDivider.displayName = "Divider";

exports.PbDivider = PbDivider;


/***/ }),

/***/ 71209:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var reactHookForm = __webpack_require__(67884);
var ui = __webpack_require__(61349);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ExamScore = ({
  textColor = "#000",
  boldColor = "#000",
  buttonColor = "#7367F0",
  buttonTextColor = "#fff",
  tableBorderColor = "#000"
}) => {
  var _a;
  const [loading, setLoading] = React.useState(false);
  const [score, setScore] = React.useState(null);
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError
  } = reactHookForm.useForm();
  const { env = "dev" } = coreRenderer.useStore();
  const API = new coreRenderer.Api(coreRenderer.publicBffUrl[env]);
  const onSubmit = async ({ id }) => {
    var _a2, _b;
    setLoading(true);
    try {
      const res = await API.get("/v1/exam-score?id=" + id);
      if (res.data) {
        const data = (_a2 = res == null ? void 0 : res.data) == null ? void 0 : _a2.data;
        if ((_b = data == null ? void 0 : data.student) == null ? void 0 : _b.sbd) {
          setScore(data.student);
        } else {
          setError("id", {
            type: "manual",
            message: "S\u1ED1 b\xE1o danh kh\xF4ng h\u1EE3p l\u1EC7"
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };
  const discountByAverage = (average) => {
    if (average >= 9)
      return 3e6;
    if (average >= 8)
      return 18e5;
    if (average >= 7)
      return 17e5;
    if (average >= 6)
      return 16e5;
    if (average >= 5)
      return 15e5;
    return 14e5;
  };
  const renderScore = (score2) => {
    const { toan, van, ngoaiNgu, lichSu, diaLy, gdcd, vatLy, hoaHoc, sinhHoc } = score2;
    const subjects = [
      { name: "To\xE1n", score: toan },
      { name: "Ng\u1EEF v\u0103n", score: van },
      { name: "Ngo\u1EA1i ng\u1EEF", score: ngoaiNgu },
      { name: "L\u1ECBch s\u1EED", score: lichSu },
      { name: "\u0110\u1ECBa l\xFD", score: diaLy },
      { name: "GDCD", score: gdcd },
      { name: "V\u1EADt l\xFD", score: vatLy },
      { name: "H\xF3a h\u1ECDc", score: hoaHoc },
      { name: "Sinh h\u1ECDc", score: sinhHoc }
    ];
    const total = subjects.reduce(
      (acc, subject) => acc + Number(subject.score || 0),
      0
    );
    const count = subjects.filter((subject) => subject.score).length || 6;
    const average = Math.round(total * 10 / count) / 10;
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsxs("div", {
          style: { marginBottom: "1em" },
          children: [
            "\u0110i\u1EC3m trung b\xECnh m\xF4n c\u1EE7a b\u1EA1n:",
            " ",
            /* @__PURE__ */ jsxRuntime.jsxs("strong", {
              style: { fontSize: "1.2em", color: boldColor },
              children: [
                " ",
                average.toFixed(1)
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx(StyledUl, {
          borderColor: tableBorderColor,
          children: subjects.map((subject, index) => {
            if (!subject.score)
              return null;
            return /* @__PURE__ */ jsxRuntime.jsxs("li", {
              children: [
                subject.name,
                ":",
                /* @__PURE__ */ jsxRuntime.jsx("br", {}),
                subject.score
              ]
            }, index);
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsxs("div", {
          children: [
            "Khuy\u1EBFn m\xE3i gi\u1EA3m th\xEAm c\u1EE7a b\u1EA1n:",
            " ",
            /* @__PURE__ */ jsxRuntime.jsxs("strong", {
              style: { fontSize: "1.2em", color: boldColor },
              children: [
                discountByAverage(average).toLocaleString().replace(/,/g, "."),
                "\u0111"
              ]
            })
          ]
        })
      ]
    });
  };
  return /* @__PURE__ */ jsxRuntime.jsx("div", {
    style: { color: textColor },
    children: score ? renderScore(score) : /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(Label, {
          children: "Nh\u1EADp s\u1ED1 b\xE1o danh"
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(StyledForm, {
          onSubmit: handleSubmit(onSubmit),
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs("div", {
              style: { width: "100%" },
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(StyledInput, __spreadValues({
                  placeholder: "Nh\u1EADp s\u1ED1 b\xE1o danh c\u1EE7a b\u1EA1n"
                }, register("id", {
                  required: "Vui l\xF2ng nh\u1EADp s\u1ED1 b\xE1o danh",
                  pattern: {
                    value: /^\d{8}$/,
                    message: "S\u1ED1 b\xE1o danh ph\u1EA3i c\xF3 8 ch\u1EEF s\u1ED1"
                  }
                }))),
                errors.id && /* @__PURE__ */ jsxRuntime.jsx(Warning, {
                  children: /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
                    children: (_a = errors.id) == null ? void 0 : _a.message
                  })
                })
              ]
            }),
            /* @__PURE__ */ jsxRuntime.jsx("div", {
              children: /* @__PURE__ */ jsxRuntime.jsx(ui.ButtonV2, {
                text: "Ki\u1EC3m tra",
                loading,
                style: {
                  color: buttonTextColor,
                  backgroundColor: buttonColor,
                  borderRadius: 6,
                  padding: "4px 15px"
                },
                commonStyle: {
                  width: 150,
                  height: 38
                }
              })
            })
          ]
        })
      ]
    })
  });
};
ExamScore.displayName = "ExamScore";
const Label = styled__default["default"].div`
  margin-bottom: 1em;
`;
const Warning = styled__default["default"].div`
  color: red;
  margin-top: 0.5em;
`;
const StyledForm = styled__default["default"].form`
  display: flex;
  gap: 1em;
  width: 100%;
`;
const StyledInput = styled__default["default"].input`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  background-color: white;

  &:focus {
    border-color: #007bff;
    background-color: #fff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`;
const StyledUl = styled__default["default"].ul(
  ({ borderColor = "#000" }) => `
list-style: none;
width: 100%;
display: grid !important;
grid-auto-rows: minmax(min-content, max-content);
grid-template-columns: repeat(6, minmax(0, 1fr));
border: 1px solid ${borderColor};
font-size: 14px;
margin-bottom: 1em;

li {
  padding: 0.5em;
  border: 1px solid ${borderColor};
}
`
);

exports.ExamScore = ExamScore;


/***/ }),

/***/ 3323:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CheckboxGroup = (props) => {
  const _a = props, {
    commonStyle,
    inputStyle,
    labelStyle,
    optionStyle,
    register,
    name,
    id,
    options = []
  } = _a, rest = __objRest(_a, [
    "commonStyle",
    "inputStyle",
    "labelStyle",
    "optionStyle",
    "register",
    "name",
    "id",
    "options"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle,
    id,
    children: options.map((el) => /* @__PURE__ */ jsxRuntime.jsxs(StyledLabelWrapper, {
      style: { display: "flex", alignItems: "center" },
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(StyledInput, __spreadProps(__spreadValues({
          inputStyle,
          value: el.value
        }, register ? register(name, rest) : __spreadValues({ name }, rest)), {
          type: "checkbox"
        })),
        /* @__PURE__ */ jsxRuntime.jsx(StyledLabel, {
          labelStyle: optionStyle,
          children: el.label
        })
      ]
    }, el.value))
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const StyledLabel = styled__default["default"].div(
  ({ labelStyle }) => `
  margin-left: 0.25rem;
  vertical-align: middle;
  width: -webkit-fill-available;
  ${coreRenderer.getStyle(labelStyle)}
`
);
const StyledLabelWrapper = styled__default["default"].label`
  vertical-align: middle;
  margin-bottom: 0;
`;
const StyledInput = styled__default["default"].input(
  ({ inputStyle }) => `
  ${coreRenderer.getStyle(inputStyle)}
`
);

exports.CheckboxGroup = CheckboxGroup;


/***/ }),

/***/ 13682:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InputText = (props) => {
  const _a = props, {
    commonStyle,
    inputStyle,
    placeholder,
    register,
    name,
    id,
    type = "text"
  } = _a, rest = __objRest(_a, [
    "commonStyle",
    "inputStyle",
    "placeholder",
    "register",
    "name",
    "id",
    "type"
  ]);
  const getPattern = (type2) => {
    if (type2 === "email")
      return coreRenderer.PATTERN_VALIDATION.email;
    if (type2 === "tel")
      return coreRenderer.PATTERN_VALIDATION.phone;
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle,
    id,
    children: /* @__PURE__ */ jsxRuntime.jsx(StyledInput, __spreadValues({
      inputStyle,
      placeholder,
      type
    }, register ? register(name, __spreadValues({ pattern: getPattern(type) }, rest)) : __spreadValues({ name }, rest)))
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const StyledInput = styled__default["default"].input(
  ({ inputStyle }) => `
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 100%;
    color: rgba(0, 0, 0, 0.85);
    height: 100%;
    padding: 0 0.5rem;
    &:focus,
    &-focused {
      outline: 0;
    }
    &::-moz-placeholder {
      opacity: 1;
    }

    &::placeholder {
      color: #999;
    }

    &:placeholder-shown {
      text-overflow: ellipsis;
    }
    border-style: solid;
    border-color: rgb(238, 238, 238);
    border-width: 1px;
  ${coreRenderer.getStyle(inputStyle)}
`
);

exports.InputText = InputText;


/***/ }),

/***/ 25552:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { defaultImage, checkedInputGroupImageBkg } = coreRenderer.mappingAssets;
const InputGroupImage = (props) => {
  const _a = props, {
    commonStyle,
    inputStyle,
    optionStyle,
    register,
    name,
    id,
    options = [],
    imageConfig,
    inputType
  } = _a, rest = __objRest(_a, [
    "commonStyle",
    "inputStyle",
    "optionStyle",
    "register",
    "name",
    "id",
    "options",
    "imageConfig",
    "inputType"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    inputType,
    imageConfig,
    commonStyle,
    id,
    children: options.map((item) => {
      var _a2, _b, _c, _d;
      const { image } = item;
      const width = ((_a2 = image == null ? void 0 : image.googleImageParams) == null ? void 0 : _a2.percent) ? Math.round(
        ((_b = image.googleImageParams) == null ? void 0 : _b.width) * ((_c = image.googleImageParams) == null ? void 0 : _c.percent) / 100
      ) : (_d = image == null ? void 0 : image.googleImageParams) == null ? void 0 : _d.width;
      const newSrc = coreRenderer.getImageUrlFromGoogleUserContent(image == null ? void 0 : image.src, {
        format: "webp",
        width
      });
      return /* @__PURE__ */ jsxRuntime.jsxs("label", {
        className: "form-item",
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(StyledInput, __spreadProps(__spreadValues({
            inputStyle,
            value: item.value
          }, register ? register(name, rest) : __spreadValues({ name }, rest)), {
            type: inputType
          })),
          /* @__PURE__ */ jsxRuntime.jsxs("div", {
            className: "form-item__label",
            children: [
              /* @__PURE__ */ jsxRuntime.jsx("div", {
                className: "form-item__label__img",
                children: /* @__PURE__ */ jsxRuntime.jsx("img", __spreadValues({
                  src: newSrc || defaultImage,
                  loading: "lazy",
                  alt: "form selection"
                }, newSrc && {
                  srcSet: coreRenderer.buildSrcsetDPR(newSrc, width)
                }))
              }),
              /* @__PURE__ */ jsxRuntime.jsx(StyledLabel, {
                labelStyle: optionStyle,
                imageWidth: imageConfig == null ? void 0 : imageConfig.width,
                className: "form-item__label__text",
                children: item.label
              })
            ]
          })
        ]
      });
    })
  });
};
const Wrapper = styled__default["default"].div(
  ({
    commonStyle,
    imageConfig,
    inputType
  }) => {
    const imageWidth = (imageConfig == null ? void 0 : imageConfig.width) || 60;
    let imageRadius = (imageConfig == null ? void 0 : imageConfig.radius) !== void 0 ? imageConfig.radius : 8;
    imageRadius = imageRadius > imageWidth / 2 ? imageWidth / 2 : imageRadius;
    return `
    margin-top: 4px;
    display: flex;
    flex-wrap: wrap;
    ${coreRenderer.getStyle(commonStyle)}

    .form-item {
      width: ${imageWidth}px;
      cursor: pointer;
      display: flex;
      align-items: flex-start;
    }
    .form-item__label {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    [type='${inputType}'] {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;
    }
  
    .form-item__label__img {
      border-radius: ${imageRadius}px;
      width: ${imageWidth}px;
      height: ${imageWidth}px;
      position: relative;
      background-size: ${(imageConfig == null ? void 0 : imageConfig.backgroundSize) || "contain"};
      background-position: center;
      background-repeat: no-repeat;
    }

    .form-item__label__img img{
      width: inherit;
      height: inherit;
      border-radius: inherit;
      object-fit: cover;
    }
  
    [type='${inputType}']:checked + .form-item__label > .form-item__label__img {
      &::after {
        position: absolute;
        content: ' ';
        width: 24px;
        height: 24px;
        background-image: url(${checkedInputGroupImageBkg});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        top: calc(-12px + 0.2939 * ${imageRadius}px);
        right: calc(-12px + 0.2939 * ${imageRadius}px);
      }
      outline: 2px solid #5ba1e3;
    }
  `;
  }
);
const StyledLabel = styled__default["default"].div(
  ({
    labelStyle,
    imageWidth = 100
  }) => `
  text-align: center;
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  max-width: ${imageWidth}px;
  ${coreRenderer.getStyle(labelStyle)}
`
);
const StyledInput = styled__default["default"].input(
  ({ inputStyle }) => `
  ${coreRenderer.getStyle(inputStyle)}
`
);

exports.InputGroupImage = InputGroupImage;


/***/ }),

/***/ 72885:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var Cascader = __webpack_require__(3346);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LocationSelect = (props) => {
  const _a = props, {
    commonStyle,
    inputStyle,
    setValue,
    register,
    name,
    trigger,
    wrapperRef
  } = _a, rest = __objRest(_a, [
    "commonStyle",
    "inputStyle",
    "setValue",
    "register",
    "name",
    "trigger",
    "wrapperRef"
  ]);
  const [options, setOptions] = React.useState([]);
  const { device } = coreRenderer.useStore();
  const [currentProvince, setCurrentProvince] = React.useState();
  const [currentDistrict, setCurrentDistrict] = React.useState();
  const [currentWard, setCurrentWard] = React.useState();
  const [location, setLocation] = React.useState();
  const onChange = (_value, selectedOptions) => {
    setLocation(
      selectedOptions.reverse().map((o) => o.label).join(", ")
    );
  };
  const renderDesktop = () => /* @__PURE__ */ jsxRuntime.jsx(Cascader, {
    options,
    onChange,
    expandIcon: /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
      name: "ForwardOutlined"
    }),
    getPopupContainer: () => wrapperRef.current,
    children: /* @__PURE__ */ jsxRuntime.jsx(StyledInput, __spreadProps(__spreadValues({
      inputStyle,
      value: location
    }, register ? register(name, __spreadValues({}, rest)) : __spreadValues({ name }, rest)), {
      autoComplete: "off",
      readOnly: true
    }))
  });
  const renderMobile = () => {
    var _a2, _b;
    return /* @__PURE__ */ jsxRuntime.jsxs("div", {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx("input", __spreadProps(__spreadValues({}, register ? register(name, { required: rest.required }) : {}), {
          style: { display: "none" }
        })),
        /* @__PURE__ */ jsxRuntime.jsxs(StyledSelect, {
          inputStyle,
          placeholder: "Ch\u1ECDn t\u1EC9nh/ th\xE0nh",
          onChange: (e) => {
            setCurrentProvince(
              options.find((option) => option.value == e.target.value)
            );
            setCurrentDistrict(null);
            setCurrentWard(null);
          },
          children: [
            /* @__PURE__ */ jsxRuntime.jsx("option", {
              children: "Ch\u1ECDn t\u1EC9nh/ th\xE0nh ph\u1ED1"
            }),
            options.map((option) => /* @__PURE__ */ jsxRuntime.jsx("option", {
              value: option.value,
              children: option.label
            }, option.value))
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(StyledSelect, {
          inputStyle,
          onChange: (e) => {
            setCurrentDistrict(
              currentProvince.children.find(
                (option) => option.value == e.target.value
              )
            );
            setCurrentWard(null);
          },
          children: [
            /* @__PURE__ */ jsxRuntime.jsx("option", {
              children: "Ch\u1ECDn qu\u1EADn/ huy\u1EC7n"
            }),
            (_a2 = currentProvince == null ? void 0 : currentProvince.children) == null ? void 0 : _a2.map((option) => /* @__PURE__ */ jsxRuntime.jsx("option", {
              value: option.value,
              children: option.label
            }, option.value))
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(StyledSelect, {
          inputStyle,
          placeholder: "Ch\u1ECDn x\xE3/ ph\u01B0\u1EDDng",
          onChange: (e) => setCurrentWard(
            currentDistrict.children.find(
              (option) => option.value == e.target.value
            )
          ),
          children: [
            /* @__PURE__ */ jsxRuntime.jsx("option", {
              children: "Ch\u1ECDn x\xE3/ ph\u01B0\u1EDDng"
            }),
            (_b = currentDistrict == null ? void 0 : currentDistrict.children) == null ? void 0 : _b.map((option) => /* @__PURE__ */ jsxRuntime.jsx("option", {
              value: option.value,
              children: option.label
            }, option.value))
          ]
        })
      ]
    });
  };
  React.useEffect(() => {
    if (currentProvince && currentDistrict && currentWard) {
      const newLocation = [currentWard, currentDistrict, currentProvince].map((o) => o.label).join(", ");
      setValue(name, newLocation);
      setLocation(newLocation);
      trigger(name);
    } else {
      setValue(name, null);
    }
  }, [currentProvince, currentDistrict, currentWard]);
  React.useEffect(() => {
    const scriptTag = document.createElement("script");
    scriptTag.src = "https://landingbuilder-cdn.tekoapis.com/location/1.0.1/location.vi.min.js";
    scriptTag.addEventListener("load", () => {
      setOptions(window.TempiLocation["VN"]);
    });
    document.body.appendChild(scriptTag);
  }, []);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle,
    children: device === "mobile" ? renderMobile() : renderDesktop()
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
    width:100%;
    ${coreRenderer.getStyle(commonStyle)}
    height: unset!important;
  `
);
const StyledInput = styled__default["default"].input(
  ({ inputStyle }) => `
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 100%;
    height: 32px;
    color: rgba(0, 0, 0, 0.85);
    padding: 0 0.5rem;
    &:focus,
    &-focused {
      outline: 0;
    }
    &::-moz-placeholder {
      opacity: 1;
    }

    &::placeholder {
      color: #999;
    }

    &:placeholder-shown {
      text-overflow: ellipsis;
    }
    border-style: solid;
    border-color: rgb(238, 238, 238);
    border-width: 1px;
  ${coreRenderer.getStyle(inputStyle)}
`
);
const StyledSelect = styled__default["default"].select(
  ({ inputStyle }) => `
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 100%;
    color: rgba(0, 0, 0, 0.85);
    height: 32px;
    padding: 0 0.5rem;
    &:focus,
    &-focused {
      outline: 0;
    }
    &::-moz-placeholder {
      opacity: 1;
    }

    &::placeholder {
      color: #999;
    }

    &:placeholder-shown {
      text-overflow: ellipsis;
    }
    border-style: solid;
    border-color: rgb(238, 238, 238);
    border-width: 1px;
    margin-bottom: 8px;
  ${coreRenderer.getStyle(inputStyle)}
`
);

exports.LocationSelect = LocationSelect;


/***/ }),

/***/ 85991:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const RadioGroup = (props) => {
  const _a = props, {
    commonStyle,
    inputStyle,
    labelStyle,
    optionStyle,
    register,
    name,
    id,
    options = []
  } = _a, rest = __objRest(_a, [
    "commonStyle",
    "inputStyle",
    "labelStyle",
    "optionStyle",
    "register",
    "name",
    "id",
    "options"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle,
    id,
    children: options.map((el) => /* @__PURE__ */ jsxRuntime.jsxs(StyledLabelWrapper, {
      style: { display: "flex", alignItems: "center" },
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(StyledInput, __spreadProps(__spreadValues({
          inputStyle,
          value: el.value
        }, register ? register(name, rest) : __spreadValues({ name }, rest)), {
          type: "radio"
        })),
        /* @__PURE__ */ jsxRuntime.jsx(StyledLabel, {
          labelStyle: optionStyle,
          children: el.label
        })
      ]
    }, el.value))
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const StyledLabel = styled__default["default"].div(
  ({ labelStyle }) => `
  vertical-align: middle;
  margin-left: 0.25rem;
  width: -webkit-fill-available;
  ${coreRenderer.getStyle(labelStyle)}
  `
);
const StyledLabelWrapper = styled__default["default"].label`
  vertical-align: middle;
  margin-bottom: 0;
`;
const StyledInput = styled__default["default"].input(
  ({ inputStyle }) => `
  ${coreRenderer.getStyle(inputStyle)}
`
);

exports.RadioGroup = RadioGroup;


/***/ }),

/***/ 74372:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SelectBox = (props) => {
  const _a = props, {
    commonStyle,
    inputStyle,
    placeholder,
    register,
    name,
    id,
    multiple,
    options = []
  } = _a, rest = __objRest(_a, [
    "commonStyle",
    "inputStyle",
    "placeholder",
    "register",
    "name",
    "id",
    "multiple",
    "options"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle,
    id,
    children: /* @__PURE__ */ jsxRuntime.jsxs(StyledSelect, __spreadProps(__spreadValues({
      inputStyle,
      multiple,
      name
    }, register ? register(name, rest) : __spreadValues({ name }, rest)), {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx("option", {
          style: { color: "#999" },
          value: "",
          disabled: multiple,
          selected: !multiple,
          children: placeholder || ""
        }),
        options.map((el) => /* @__PURE__ */ jsxRuntime.jsx("option", {
          value: el.value,
          children: el.label
        }, el.value))
      ]
    }))
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const StyledSelect = styled__default["default"].select(
  ({ inputStyle }) => `
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 100%;
    color: rgba(0, 0, 0, 0.85);
    height: 100%;
    padding: 0 0.5rem;
    &:focus,
    &-focused {
      outline: 0;
    }
    &::-moz-placeholder {
      opacity: 1;
    }

    &::placeholder {
      color: #999;
    }

    &:placeholder-shown {
      text-overflow: ellipsis;
    }
    border-style: solid;
    border-color: rgb(238, 238, 238);
    border-width: 1px;
  ${coreRenderer.getStyle(inputStyle)}
`
);

exports.SelectBox = SelectBox;


/***/ }),

/***/ 83849:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InputTextarea = (props) => {
  const _a = props, { commonStyle, inputStyle, placeholder, register, name, id } = _a, rest = __objRest(_a, ["commonStyle", "inputStyle", "placeholder", "register", "name", "id"]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle,
    id,
    children: /* @__PURE__ */ jsxRuntime.jsx(StyledInput, __spreadValues({
      inputStyle,
      placeholder
    }, register ? register(name, rest) : __spreadValues({ name }, rest)))
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const StyledInput = styled__default["default"].textarea(
  ({ inputStyle }) => `
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 100%;
    color: rgba(0, 0, 0, 0.85);
    height: 100%;
    padding: 0 0.5rem;
    &:focus,
    &-focused {
      outline: 0;
    }
    &::-moz-placeholder {
      opacity: 1;
    }

    &::placeholder {
      color: #999;
    }

    &:placeholder-shown {
      text-overflow: ellipsis;
    }
    border-style: solid;
    border-color: rgb(238, 238, 238);
    border-width: 1px;
  ${coreRenderer.getStyle(inputStyle)}
`
);

exports.InputTextarea = InputTextarea;


/***/ }),

/***/ 36017:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAX_FILE_BYTE_SIZE = 10485760;
const MAX_FILE_MB_SIZE = Math.round(MAX_FILE_BYTE_SIZE / (1024 * 1024));
const UploadFile = (props) => {
  var _b, _c;
  const _a = props, {
    commonStyle,
    inputStyle,
    register,
    name,
    id,
    setValue,
    errorStyle
  } = _a, rest = __objRest(_a, [
    "commonStyle",
    "inputStyle",
    "register",
    "name",
    "id",
    "setValue",
    "errorStyle"
  ]);
  const { env = "local" } = coreRenderer.useStore();
  const [isUploading, setUploading] = React.useState(false);
  const [error, setError] = React.useState("");
  const ref = React.useRef(null);
  const handleChange = async (event) => {
    var _a2, _b2;
    setError("");
    const selectedFile = event.target.files[0];
    if (selectedFile.size > MAX_FILE_BYTE_SIZE) {
      setError(
        `Dung l\u01B0\u1EE3ng t\u1EC7p kh\xF4ng \u0111\u01B0\u1EE3c v\u01B0\u1EE3t qu\xE1 ${MAX_FILE_MB_SIZE}MB. Vui l\xF2ng ch\u1ECDn l\u1EA1i`
      );
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFile);
    const isImage = !!((_a2 = selectedFile == null ? void 0 : selectedFile.type) == null ? void 0 : _a2.match("image"));
    formData.append("type", isImage ? "image" : "doc");
    setUploading(true);
    const API = new coreRenderer.Api(coreRenderer.publicBffUrl[env]);
    try {
      const res = await API.post("/v1/upload", formData);
      register(name).onChange(event);
      const url = (_b2 = res == null ? void 0 : res.data) == null ? void 0 : _b2.url;
      setValue(name, url);
    } catch (error2) {
      setError("\u0110\xE3 x\u1EA3y ra l\u1ED7i khi upload file. Vui l\xF2ng th\u1EED l\u1EA1i.");
    } finally {
      setUploading(false);
    }
  };
  const preventSubmit = () => !isUploading;
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    commonStyle,
    id,
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs("div", {
        children: [
          /* @__PURE__ */ jsxRuntime.jsxs(StyledButton, {
            disabled: isUploading,
            onClick: (e) => {
              var _a2;
              e.preventDefault();
              (_a2 = ref == null ? void 0 : ref.current) == null ? void 0 : _a2.click();
            },
            children: [
              /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                name: "UploadOutlined",
                style: { marginRight: "0.25em", fontSize: "16px" }
              }),
              isUploading ? "\u0110ang t\u1EA3i l\xEAn" : `Ch\u1ECDn t\u1EC7p tin (t\u1ED1i \u0111a ${MAX_FILE_MB_SIZE}MB)`
            ]
          }),
          ((_b = ref == null ? void 0 : ref.current) == null ? void 0 : _b.files.length) > 0 ? `(${(_c = ref == null ? void 0 : ref.current) == null ? void 0 : _c.files[0].name})` : ""
        ]
      }),
      error && /* @__PURE__ */ jsxRuntime.jsx(ErrorMessage, {
        errorStyle,
        children: error
      }),
      /* @__PURE__ */ jsxRuntime.jsx("input", __spreadProps(__spreadValues({}, register ? register(name, __spreadProps(__spreadValues({}, rest), { validate: { preventSubmit } })) : __spreadValues({ name }, rest)), {
        ref,
        onChange: handleChange,
        type: "file",
        accept: ".jpg, .jpeg, .png, .gif, .docx, .docs, .doc, .xls, .xlsx, .zip, .pdf",
        style: { display: "none" }
      }))
    ]
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
    margin-bottom: 0.5em;
    height: unset!important;
  `
);
const StyledButton = styled__default["default"].button`
  border-radius: 4px;
  margin-right: 4px;
  padding: 0.5em 0.75em;
`;
const ErrorMessage = styled__default["default"].span(
  ({ errorStyle }) => `
  color: rgb(255, 77, 79);
  font-size: 0.9em;
  ${coreRenderer.getStyle(errorStyle)}
`
);

exports.UploadFile = UploadFile;


/***/ }),

/***/ 4039:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var type = __webpack_require__(64133);
var utils = __webpack_require__(31748);
var get = __webpack_require__(47248);
var queryStringToObject = __webpack_require__(39217);
var getPartialDateTimeTimeZone7 = __webpack_require__(81700);
var transformValueGGSheet = __webpack_require__(73416);
var form = __webpack_require__(11340);
var isUrlValid = __webpack_require__(58983);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var get__default = /*#__PURE__*/_interopDefaultLegacy(get);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const api = new coreRenderer.Api("");
const useForm = ({
  wrapperRef,
  response
}) => {
  const [loading, setLoading] = React.useState(false);
  const { env } = coreRenderer.useStore();
  const popupContentTemplates = React.useRef({});
  const handleCallAPI = async (submit, oldValues, inputs) => {
    const { type: submitType, config } = submit;
    let newValues = __spreadValues({}, oldValues);
    if (config == null ? void 0 : config.autoPassParams) {
      newValues = __spreadValues(__spreadValues({}, queryStringToObject.queryStringToObject(window.location.search)), newValues);
    }
    if (submitType === "api") {
      const values = transformValues(newValues, inputs);
      const apiConfig = config;
      let headers;
      try {
        headers = JSON.parse((apiConfig == null ? void 0 : apiConfig.headers) || "{}");
      } catch (error) {
        headers = {};
      }
      if (["PATCH", "POST"].includes(apiConfig == null ? void 0 : apiConfig.method)) {
        const contentType = headers["Content-Type"] || (apiConfig == null ? void 0 : apiConfig.contentType) || type.ContentType.urlEncoded;
        return api.post(apiConfig == null ? void 0 : apiConfig.url, utils.formatData(contentType, values), {
          headers: __spreadValues(__spreadValues({}, !/^multipart\//.test(contentType) && {
            "Content-Type": contentType
          }), headers)
        }).catch((err) => {
          console.error(err);
          return Promise.reject(err);
        });
      }
      if ((apiConfig == null ? void 0 : apiConfig.method) === "GET") {
        return api.get(apiConfig == null ? void 0 : apiConfig.url, { params: values, headers }).catch((err) => {
          console.error(err);
          return Promise.reject(err);
        });
      }
    }
    if (submitType === "googleSheet") {
      const values = transformValueGGSheet.transformValuesGGSheet(newValues, inputs);
      const ggSheetConfig = config;
      if (!ggSheetConfig.valid || ggSheetConfig.formAccountId <= 0) {
        const err = "M\u1ED9t k\u1EBFt n\u1ED1i Google Sheet ch\u01B0a s\u1EB5n s\xE0ng, ki\u1EC3m tra l\u1EA1i!";
        console.error(err);
        return Promise.reject(err);
      }
      const date = new Date();
      const { year, month, day, hour, minute, second } = getPartialDateTimeTimeZone7.getPartialDateTimeTimeZone7(date);
      const dateString = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      const objSubmitTime = (ggSheetConfig == null ? void 0 : ggSheetConfig.submitTime) ? [
        {
          name: "Th\u1EDDi gian g\u1EEDi",
          type: "string",
          value: dateString
        }
      ] : [];
      return form.formUtils.insertDataToGoogleSheetV2(
        ggSheetConfig,
        [...objSubmitTime, ...values],
        `${coreRenderer.publicBffUrl[env]}/v1/submit-form`
      );
    }
  };
  const handleOpenPopup = (popupId, apiResponse, templateContent) => {
    if (!popupId || !templateContent)
      return;
    const popupEle = wrapperRef.current.ownerDocument.querySelector(
      `[data-uniq-id="${popupId}"]`
    );
    const popupContent = popupEle == null ? void 0 : popupEle.querySelector(".popup-content");
    popupContent.querySelectorAll("p, h1, h2, h3, h4, h5, h6").forEach((el, index) => {
      const data = apiResponse == null ? void 0 : apiResponse.data;
      const searchRegExp = /{{([\w,.]*)}}/g;
      el.innerHTML = templateContent[index].replaceAll(searchRegExp, (i) => {
        return get__default["default"](data, i.replace(/{{/, "").replace(/}}/, ""));
      });
    });
    popupEle == null ? void 0 : popupEle.click();
  };
  const handleSuccess = (apiResponse) => {
    if (!!(response == null ? void 0 : response.successPage) && isUrlValid.isUrlValid(response.successPage))
      window.location.href = response == null ? void 0 : response.successPage;
    if (!!(response == null ? void 0 : response.success))
      handleOpenPopup(
        response.success,
        apiResponse,
        getTemplatePopupContent(response.success)
      );
  };
  const handleFailed = (apiResponse) => {
    if (!!(response == null ? void 0 : response.failedPage) && isUrlValid.isUrlValid(response.failedPage))
      window.location.href = response == null ? void 0 : response.failedPage;
    if (!!(response == null ? void 0 : response.failed))
      handleOpenPopup(
        response.failed,
        apiResponse,
        getTemplatePopupContent(response.failed)
      );
  };
  const handleCustomResponse = (apiResponse) => {
    var _a;
    if (!((_a = response == null ? void 0 : response.custom) == null ? void 0 : _a.length))
      return;
    response.custom.forEach((item) => {
      var _a2, _b, _c;
      if (((_b = (_a2 = get__default["default"](apiResponse == null ? void 0 : apiResponse.data, item.key)) == null ? void 0 : _a2.toString) == null ? void 0 : _b.call(_a2)) === ((_c = item.value) == null ? void 0 : _c.toString())) {
        handleOpenPopup(
          item.popup,
          apiResponse,
          getTemplatePopupContent(item.popup)
        );
        return;
      }
    });
  };
  const getTemplatePopupContent = (popupId) => {
    if (!popupContentTemplates.current[popupId]) {
      const popupEle = wrapperRef.current.ownerDocument.querySelector(
        `[data-uniq-id="${popupId}"]`
      );
      if (popupEle) {
        const list = [
          ...popupEle.querySelectorAll(
            ".popup-content p, h1, h2, h3, h4, h5, h6"
          )
        ].map((el) => el.innerHTML);
        popupContentTemplates.current[popupId] = list;
      }
    }
    return popupContentTemplates.current[popupId];
  };
  const handleMultiSubmit = async (submits, newValues, inputs, mainConnection) => {
    let allSubmits = [...submits];
    const mainSubmit = allSubmits == null ? void 0 : allSubmits[mainConnection];
    setLoading(true);
    try {
      if (!mainSubmit) {
        await Promise.all(
          submits.map((submit) => handleCallAPI(submit, newValues, inputs))
        );
      } else {
        allSubmits.splice(mainConnection, 0);
        allSubmits = [mainSubmit, ...allSubmits];
        await Promise.all(
          allSubmits.map(async (submit, index) => {
            if (index === 0)
              return handleCallAPI(submit, newValues, inputs);
            return handleCallAPI(submit, newValues, inputs).catch(() => {
            });
          })
        ).then(([result]) => {
          if ((response == null ? void 0 : response.responseType) === "default") {
            handleSuccess(result);
          }
          if ((response == null ? void 0 : response.responseType) === "custom") {
            handleCustomResponse(result);
          }
        }).catch((err) => {
          if ((response == null ? void 0 : response.responseType) === "default") {
            handleFailed({ data: (err == null ? void 0 : err.response) || {} });
          }
          if ((response == null ? void 0 : response.responseType) === "custom") {
            handleCustomResponse({ data: (err == null ? void 0 : err.response) || {} });
          }
        });
      }
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitFormData = async (configStorage, values, inputs) => {
    var _b;
    try {
      setLoading(true);
      const _a = queryStringToObject.queryStringToObject(window.location.search) || {}, {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_term,
        utm_content
      } = _a, rest = __objRest(_a, [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_term",
        "utm_content"
      ]);
      const newValues = __spreadValues(__spreadValues({
        utm_source,
        utm_medium,
        utm_campaign,
        utm_term,
        utm_content
      }, (configStorage == null ? void 0 : configStorage.autoPassParams) && rest), values);
      const date = new Date();
      const { year, month, day, hour, minute, second } = getPartialDateTimeTimeZone7.getPartialDateTimeTimeZone7(date);
      const dateString = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      let valuesSubmit = transformValueGGSheet.transformValuesGGSheet(newValues, inputs);
      valuesSubmit = [
        ...valuesSubmit,
        {
          name: "Th\u1EDDi gian g\u1EEDi",
          type: "string",
          value: dateString
        },
        {
          name: "url_page",
          type: "string",
          value: (_b = window == null ? void 0 : window.location) == null ? void 0 : _b.href
        }
      ];
      await form.formUtils.submitFormData(
        configStorage == null ? void 0 : configStorage.formConfigId,
        valuesSubmit,
        `${coreRenderer.publicBffUrl[env]}/v1/submit-form`
      ).then((result) => {
        if ((response == null ? void 0 : response.responseType) === "default") {
          handleSuccess(result);
        }
        if ((response == null ? void 0 : response.responseType) === "custom") {
          handleCustomResponse(result);
        }
      }).catch((err) => {
        if ((response == null ? void 0 : response.responseType) === "default") {
          handleFailed({ data: (err == null ? void 0 : err.response) || {} });
        }
        if ((response == null ? void 0 : response.responseType) === "custom") {
          handleCustomResponse({ data: (err == null ? void 0 : err.response) || {} });
        }
      });
    } finally {
      setLoading(false);
    }
  };
  const transformValues = (values, inputs) => {
    const dateFields = inputs.filter((el) => el.type === "date").map((el) => el.name);
    const timeFields = inputs.filter((el) => el.type === "time").map((el) => el.name);
    const dateTimeFields = inputs.filter((el) => el.type === "datetime-local").map((el) => el.name);
    return Object.entries(values).map(([k, v]) => {
      if (dateFields.includes(k) && !!v) {
        const { year, month, day } = getPartialDateTimeTimeZone7.getPartialDateTimeTimeZone7(
          new Date(v)
        );
        return [k, `${day}-${month}-${year}`];
      }
      if (timeFields.includes(k) && !!v) {
        const { hour, minute, second } = getPartialDateTimeTimeZone7.getPartialDateTimeTimeZone7(
          new Date(v)
        );
        return [k, `${hour}:${minute}:${second}`];
      }
      if (dateTimeFields.includes(k) && !!v) {
        const { year, month, day, hour, minute, second } = getPartialDateTimeTimeZone7.getPartialDateTimeTimeZone7(new Date(v));
        return [k, `${day}-${month}-${year} ${hour}:${minute}:${second}`];
      }
      return [k, v];
    }).reduce((acc, curr) => __spreadProps(__spreadValues({}, acc), { [curr[0]]: curr[1] }), {});
  };
  return {
    handleMultiSubmit,
    loading,
    handleSubmitFormData
  };
};

exports.useForm = useForm;


/***/ }),

/***/ 64133:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var ContentType = /* @__PURE__ */ ((ContentType2) => {
  ContentType2["json"] = "application/json";
  ContentType2["formData"] = "multipart/form-data";
  ContentType2["urlEncoded"] = "application/x-www-form-urlencoded";
  return ContentType2;
})(ContentType || {});

exports.ContentType = ContentType;


/***/ }),

/***/ 62575:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var clsx = __webpack_require__(77084);
var React = __webpack_require__(91987);
var ReCAPTCHA = __webpack_require__(60243);
var reactGoogleRecaptchaV3 = __webpack_require__(64922);
var reactHookForm = __webpack_require__(67884);
var hooks = __webpack_require__(4039);
var Input = __webpack_require__(13682);
var Textarea = __webpack_require__(83849);
var SelectBox = __webpack_require__(74372);
var RadioGroup = __webpack_require__(85991);
var CheckboxGroup = __webpack_require__(3323);
var InputGroupImage = __webpack_require__(25552);
var UploadFile = __webpack_require__(36017);
var LocationSelect = __webpack_require__(72885);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ReCAPTCHA__default = /*#__PURE__*/_interopDefaultLegacy(ReCAPTCHA);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getErrorMessage = (type) => {
  let error = "";
  if (type === "required")
    error = "\u0110\xE2y l\xE0 th\xF4ng tin b\u1EAFt bu\u1ED9c";
  if (type === "pattern")
    error = "Vui l\xF2ng nh\u1EADp \u0111\xFAng \u0111\u1ECBnh d\u1EA1ng";
  return error;
};
const InnerFormV4 = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, {
      commonStyle,
      children,
      isEditingMode = false,
      submits = [],
      hiddenFields = [],
      inputs,
      formStyle,
      inputStyle,
      optionStyle,
      labelStyle,
      errorStyle,
      showLabel,
      mainConnection,
      response,
      captcha,
      event,
      configStorage,
      onFinish,
      customLoading
    } = _a, rest = __objRest(_a, [
      "commonStyle",
      "children",
      "isEditingMode",
      "submits",
      "hiddenFields",
      "inputs",
      "formStyle",
      "inputStyle",
      "optionStyle",
      "labelStyle",
      "errorStyle",
      "showLabel",
      "mainConnection",
      "response",
      "captcha",
      "event",
      "configStorage",
      "onFinish",
      "customLoading"
    ]);
    const {
      handleSubmit,
      register,
      formState: { errors, isSubmitting },
      reset,
      setValue,
      trigger
    } = reactHookForm.useForm();
    const wrapperRef = React.useRef();
    const { handleMultiSubmit, loading, handleSubmitFormData } = hooks.useForm({
      wrapperRef,
      response
    });
    const recaptchaRef = React.useRef();
    const { executeRecaptcha } = reactGoogleRecaptchaV3.useGoogleReCaptcha();
    const formCaptchaKey = (captcha == null ? void 0 : captcha.requestKey) || "g-captcha-response";
    const captchaCheckboxV2 = (captcha == null ? void 0 : captcha.version) === "checkboxv2" && !!(captcha == null ? void 0 : captcha.siteKey);
    const captchaInvisibleV2 = (captcha == null ? void 0 : captcha.version) === "invisiblev2" && !!(captcha == null ? void 0 : captcha.siteKey);
    const captchaInvisibleV3 = (captcha == null ? void 0 : captcha.version) === "invisiblev3" && !!(captcha == null ? void 0 : captcha.siteKey);
    const [inc, setInc] = React.useState(0);
    const {
      trackingEventName,
      conversionGGAdsId,
      conversionGGAdsLabel,
      scriptCustom,
      conversionValue
    } = event || {};
    React.useEffect(() => {
      if (!isEditingMode && captchaCheckboxV2) {
        register(formCaptchaKey, {
          required: true
        });
      }
    }, [inc]);
    const onSubmit = async (values, e) => {
      e.preventDefault();
      if (isEditingMode || isSubmitting)
        return false;
      trackEventForm();
      const newValues = __spreadValues({}, values);
      try {
        if (captchaCheckboxV2) {
          if (!captcha.requestKey)
            delete newValues[formCaptchaKey];
        }
        if (captchaInvisibleV2) {
          const token = await recaptchaRef.current.executeAsync();
          if (captcha == null ? void 0 : captcha.requestKey) {
            newValues[captcha.requestKey] = token;
          }
        }
        if (captchaInvisibleV3) {
          const token = await executeRecaptcha((captcha == null ? void 0 : captcha.action) || void 0);
          if (captcha == null ? void 0 : captcha.requestKey) {
            newValues[captcha.requestKey] = token;
          }
        }
      } catch (e2) {
        alert("X\xE1c minh danh t\xEDnh kh\xF4ng th\xE0nh c\xF4ng");
        return;
      }
      try {
        if (typeof onFinish !== "function") {
          if (!!(configStorage == null ? void 0 : configStorage.formConfigId)) {
            await handleSubmitFormData(configStorage, newValues, inputs);
          } else {
            await handleMultiSubmit(submits, newValues, inputs, mainConnection);
          }
        } else {
          await onFinish(values);
        }
      } finally {
        if (captchaCheckboxV2 || captchaInvisibleV2)
          recaptchaRef.current.reset();
        reset();
        setInc((i) => i + 1);
      }
    };
    const renderCaptchaCheckboxV2 = () => {
      var _a2;
      const error = errors[formCaptchaKey];
      return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: captchaCheckboxV2 && /* @__PURE__ */ jsxRuntime.jsxs("div", {
          style: { width: (_a2 = captcha == null ? void 0 : captcha.commonStyle) == null ? void 0 : _a2.width },
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(ReCAPTCHA__default["default"], {
              ref: recaptchaRef,
              sitekey: captcha.siteKey,
              onChange: (token) => setValue(formCaptchaKey, token, { shouldValidate: true }),
              onExpired: () => setValue(formCaptchaKey, "", { shouldValidate: true }),
              onErrored: () => setValue(formCaptchaKey, "", { shouldValidate: true })
            }),
            error && /* @__PURE__ */ jsxRuntime.jsx(ErrorMessage, {
              errorStyle,
              children: getErrorMessage(error.type)
            })
          ]
        })
      });
    };
    const renderCaptchaInvisible = () => {
      if (captchaInvisibleV2) {
        return /* @__PURE__ */ jsxRuntime.jsx(ReCAPTCHA__default["default"], {
          ref: recaptchaRef,
          sitekey: captcha.siteKey,
          size: "invisible"
        });
      }
      return null;
    };
    const trackEventForm = () => {
      var _a2, _b, _c, _d, _e;
      if (trackingEventName) {
        (_a2 = window == null ? void 0 : window.gtag) == null ? void 0 : _a2.call(window, "event", trackingEventName);
        !!conversionValue && ((_b = window == null ? void 0 : window.fbq) == null ? void 0 : _b.call(window, "track", trackingEventName, {
          value: conversionValue,
          currency: "VND"
        }));
        !conversionValue && ((_c = window == null ? void 0 : window.fbq) == null ? void 0 : _c.call(window, "track", trackingEventName));
        (_d = window == null ? void 0 : window.track) == null ? void 0 : _d.call(window, "customEvent", trackingEventName);
      }
      if (conversionGGAdsId && conversionGGAdsLabel) {
        (_e = window == null ? void 0 : window.gtag) == null ? void 0 : _e.call(window, "event", "conversion", {
          send_to: `AW-${conversionGGAdsId}/${conversionGGAdsLabel}`
        });
      }
      runStringFunc(scriptCustom);
    };
    const runStringFunc = (script) => {
      if (script == null ? void 0 : script.trim()) {
        try {
          const excuteScript = new Function(coreRenderer.unescapeString(script));
          excuteScript();
        } catch (err) {
          console.error(err);
        }
      }
    };
    return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      ref: wrapperRef,
      commonStyle,
      children: [
        /* @__PURE__ */ jsxRuntime.jsxs(Form, __spreadProps(__spreadValues({
          formStyle,
          ref,
          onSubmit: handleSubmit(onSubmit)
        }, rest), {
          children: [
            (inputs || []).map((input) => {
              const commonStyle2 = __spreadValues({}, input.commonStyle || {});
              const width = commonStyle2 == null ? void 0 : commonStyle2.width;
              const error = errors[input == null ? void 0 : input.name];
              commonStyle2 == null ? true : delete commonStyle2.width;
              const renderedLabel = /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
                children: showLabel && /* @__PURE__ */ jsxRuntime.jsx(StyledLabel, {
                  labelStyle,
                  className: clsx__default["default"]({ required: input.required }),
                  children: (input == null ? void 0 : input.label) || ""
                })
              });
              const renderedError = /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
                children: error && /* @__PURE__ */ jsxRuntime.jsx(ErrorMessage, {
                  errorStyle,
                  children: getErrorMessage(error.type)
                })
              });
              if ([
                "text",
                "tel",
                "email",
                "number",
                "date",
                "time",
                "datetime-local",
                "address"
              ].includes(input.type))
                return /* @__PURE__ */ jsxRuntime.jsxs("div", {
                  style: { width },
                  children: [
                    renderedLabel,
                    /* @__PURE__ */ jsxRuntime.jsx(Input.InputText, __spreadProps(__spreadValues({
                      type: input.type,
                      register: !isEditingMode && !!input.name && register
                    }, input), {
                      commonStyle: commonStyle2,
                      inputStyle: __spreadValues(__spreadValues({}, inputStyle || {}), input.inputStyle || {})
                    })),
                    renderedError
                  ]
                }, input.name);
              if (input.type === "textarea")
                return /* @__PURE__ */ jsxRuntime.jsxs("div", {
                  style: { width },
                  children: [
                    renderedLabel,
                    /* @__PURE__ */ jsxRuntime.jsx(Textarea.InputTextarea, __spreadProps(__spreadValues({
                      register: !isEditingMode && !!input.name && register
                    }, input), {
                      commonStyle: commonStyle2,
                      inputStyle: __spreadValues(__spreadValues({}, inputStyle || {}), input.inputStyle || {})
                    })),
                    renderedError
                  ]
                }, input.name);
              if (input.type === "select-box")
                return /* @__PURE__ */ jsxRuntime.jsxs("div", {
                  style: { width },
                  children: [
                    renderedLabel,
                    /* @__PURE__ */ jsxRuntime.jsx(SelectBox.SelectBox, __spreadProps(__spreadValues({
                      register: !isEditingMode && !!input.name && register
                    }, input), {
                      commonStyle: commonStyle2,
                      inputStyle: __spreadValues(__spreadValues({}, inputStyle || {}), input.inputStyle || {})
                    })),
                    renderedError
                  ]
                }, input.name);
              if (input.type === "radio-group")
                return /* @__PURE__ */ jsxRuntime.jsxs("div", {
                  style: { width },
                  children: [
                    renderedLabel,
                    /* @__PURE__ */ jsxRuntime.jsx(RadioGroup.RadioGroup, __spreadProps(__spreadValues({
                      register: !isEditingMode && !!input.name && register
                    }, input), {
                      commonStyle: commonStyle2,
                      labelStyle,
                      optionStyle: __spreadValues(__spreadValues({}, optionStyle || {}), input.optionStyle || {}),
                      inputStyle: __spreadValues(__spreadValues({}, inputStyle || {}), input.inputStyle || {})
                    })),
                    renderedError
                  ]
                }, input.name);
              if (input.type === "checkbox-group")
                return /* @__PURE__ */ jsxRuntime.jsxs("div", {
                  style: { width },
                  children: [
                    renderedLabel,
                    /* @__PURE__ */ jsxRuntime.jsx(CheckboxGroup.CheckboxGroup, __spreadProps(__spreadValues({
                      register: !isEditingMode && !!input.name && register
                    }, input), {
                      commonStyle: commonStyle2,
                      labelStyle,
                      optionStyle: __spreadValues(__spreadValues({}, optionStyle || {}), input.optionStyle || {}),
                      inputStyle: __spreadValues(__spreadValues({}, inputStyle || {}), input.inputStyle || {})
                    })),
                    renderedError
                  ]
                }, input.name);
              if (input.type === "checkbox-group-image")
                return /* @__PURE__ */ jsxRuntime.jsxs("div", {
                  style: { width },
                  children: [
                    renderedLabel,
                    /* @__PURE__ */ jsxRuntime.jsx(InputGroupImage.InputGroupImage, __spreadProps(__spreadValues({
                      inputType: "checkbox",
                      register: !isEditingMode && !!input.name && register
                    }, input), {
                      commonStyle: commonStyle2,
                      labelStyle,
                      optionStyle: __spreadValues(__spreadValues({}, optionStyle || {}), input.optionStyle || {}),
                      inputStyle: __spreadValues(__spreadValues({}, inputStyle || {}), input.inputStyle || {})
                    })),
                    renderedError
                  ]
                }, input.name);
              if (input.type === "radio-group-image")
                return /* @__PURE__ */ jsxRuntime.jsxs("div", {
                  style: { width },
                  children: [
                    renderedLabel,
                    /* @__PURE__ */ jsxRuntime.jsx(InputGroupImage.InputGroupImage, __spreadProps(__spreadValues({
                      inputType: "radio",
                      register: !isEditingMode && !!input.name && register
                    }, input), {
                      commonStyle: commonStyle2,
                      labelStyle,
                      optionStyle: __spreadValues(__spreadValues({}, optionStyle || {}), input.optionStyle || {}),
                      inputStyle: __spreadValues(__spreadValues({}, inputStyle || {}), input.inputStyle || {})
                    })),
                    renderedError
                  ]
                }, input.name);
              if (input.type === "file")
                return /* @__PURE__ */ jsxRuntime.jsxs("div", {
                  style: { width },
                  children: [
                    renderedLabel,
                    /* @__PURE__ */ jsxRuntime.jsx(UploadFile.UploadFile, __spreadProps(__spreadValues({
                      type: input.type,
                      register: !isEditingMode && !!input.name && register
                    }, input), {
                      commonStyle: commonStyle2,
                      inputStyle: __spreadValues(__spreadValues({}, inputStyle || {}), input.inputStyle || {}),
                      setValue,
                      errorStyle
                    })),
                    renderedError
                  ]
                }, input.name);
              if (input.type === "location")
                return /* @__PURE__ */ jsxRuntime.jsxs("div", {
                  style: { width },
                  children: [
                    renderedLabel,
                    /* @__PURE__ */ jsxRuntime.jsx(LocationSelect.LocationSelect, __spreadProps(__spreadValues({
                      register: !isEditingMode && !!input.name && register
                    }, input), {
                      commonStyle: commonStyle2,
                      inputStyle: __spreadValues(__spreadValues({}, inputStyle || {}), input.inputStyle || {}),
                      setValue,
                      trigger,
                      wrapperRef
                    })),
                    renderedError
                  ]
                }, input.name);
              return null;
            }),
            renderCaptchaCheckboxV2(),
            renderCaptchaInvisible(),
            !!hiddenFields.length && hiddenFields.map((field) => {
              if (!field.name)
                return null;
              return /* @__PURE__ */ jsxRuntime.jsx("input", __spreadProps(__spreadValues({
                type: "hidden"
              }, register(field.name)), {
                value: field.value
              }), field.name);
            }),
            React__default["default"].Children.map(
              children,
              (child, index) => {
                if (index === 0)
                  return React__default["default"].cloneElement(child, {
                    loading: loading || customLoading
                  });
              }
            )
          ]
        })),
        React__default["default"].Children.map(
          children,
          (child, index) => {
            if (index !== 0)
              return React__default["default"].cloneElement(child);
          }
        )
      ]
    });
  }
);
const FormV4 = React__default["default"].forwardRef(
  (props, ref) => {
    const { captcha } = props;
    const captchav3 = (captcha == null ? void 0 : captcha.siteKey) && (captcha == null ? void 0 : captcha.version) === "invisiblev3";
    if (captchav3) {
      return /* @__PURE__ */ jsxRuntime.jsx(reactGoogleRecaptchaV3.GoogleReCaptchaProvider, {
        reCaptchaKey: captcha.siteKey,
        children: /* @__PURE__ */ jsxRuntime.jsx(InnerFormV4, __spreadValues({
          ref
        }, props))
      });
    }
    return /* @__PURE__ */ jsxRuntime.jsx(InnerFormV4, __spreadValues({
      ref
    }, props));
  }
);
const ErrorMessage = styled__default["default"].span(
  ({ errorStyle }) => `
  color: rgb(255, 77, 79);
  font-size: 0.9em;
  ${coreRenderer.getStyle(errorStyle)}
`
);
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  display: flex;
  width: 100%;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const Form = styled__default["default"].form(
  ({ formStyle }) => `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  ${coreRenderer.getStyle(formStyle)}
`
);
const StyledLabel = styled__default["default"].label(
  ({ labelStyle }) => `
  position: relative;
  margin-bottom: 4px;
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  &.required {
    &:before {
      display: inline-block;
      margin-right: 4px;
      color: #ff4d4f;
      font-size: 14px;
      font-family: SimSun, sans-serif;
      line-height: 1;
      content: '*';
    }
  }
  ${coreRenderer.getStyle(labelStyle)}
`
);
FormV4.displayName = "FormV4";

exports.FormV4 = FormV4;
exports.InnerFormV4 = InnerFormV4;


/***/ }),

/***/ 31748:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var type = __webpack_require__(64133);

const formatData = (contentType, values) => {
  let data = values || {};
  if (contentType === type.ContentType.formData) {
    data = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      data.append(key, value);
    });
  } else if (contentType === type.ContentType.urlEncoded) {
    const body = [];
    Object.entries(values).forEach(([key, value]) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(
        value
      );
      body.push(`${encodedKey}=${encodedValue}`);
    });
    data = body.join("&");
  }
  return data;
};

exports.formatData = formatData;


/***/ }),

/***/ 4674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Grid = styled__default["default"].div(
  ({ columnCount, gap }) => `
    display: grid;
    grid-template-columns: repeat(${columnCount}, 1fr);
    grid-gap: ${gap}px;
  `
);
const Block = styled__default["default"].div`
  position: relative;
  padding-top: 100%;
  overflow: hidden;
`;
const ImageWrapper = styled__default["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
`;

exports.Block = Block;
exports.Grid = Grid;
exports.ImageWrapper = ImageWrapper;


/***/ }),

/***/ 33781:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Masonry = styled__default["default"].div(
  ({ columnCount, gap }) => `
    display: grid;
    grid-template-columns: repeat(${columnCount}, auto);
    grid-column-gap: ${gap}px;
    height: calc(100% + ${gap}px);
    margin-bottom: ${-gap}px;
  `
);
const MasonryImageWrapper = styled__default["default"].div(
  ({ gap }) => `
  margin-bottom: ${gap}px;
  display: flex;
  `
);

exports.Masonry = Masonry;
exports.MasonryImageWrapper = MasonryImageWrapper;


/***/ }),

/***/ 20024:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var MasonryGallery = __webpack_require__(33781);
var GridGallery = __webpack_require__(4674);
var ui = __webpack_require__(49864);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DEFAULT_COLUMN_COUNT = 4;
const MAX_COLUMN_COUNT = 16;
const getColumnCount = (n) => {
  if (!Number.isInteger(n) || n < 1) {
    return DEFAULT_COLUMN_COUNT;
  }
  if (n > 16) {
    return MAX_COLUMN_COUNT;
  }
  return n;
};
const Gallery = (props) => {
  const { device } = coreRenderer.useStore();
  const _a = coreRenderer.getPropsByDevice(props, device), {
    columnCount: columnCountProp = DEFAULT_COLUMN_COUNT,
    gap = 20,
    layout = "masonry",
    images = [],
    zoomPreview
  } = _a, rest = __objRest(_a, [
    "columnCount",
    "gap",
    "layout",
    "images",
    "zoomPreview"
  ]);
  const columnCount = getColumnCount(columnCountProp);
  const { displayItems } = coreRenderer.useTimeVisibility(images, props == null ? void 0 : props.isEditor);
  const renderGallery = () => {
    switch (layout) {
      case "grid":
      default:
        return /* @__PURE__ */ jsxRuntime.jsx(GridGallery.Grid, {
          columnCount,
          gap,
          children: displayItems.map((image, index) => /* @__PURE__ */ jsxRuntime.jsx(GridGallery.Block, {
            children: /* @__PURE__ */ jsxRuntime.jsx(GridGallery.ImageWrapper, {
              children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BreakpointWidthProvider, {
                sWidth: { value: 100 / columnCount, unit: "%" },
                mWidth: { value: 100 / columnCount, unit: "%" },
                children: /* @__PURE__ */ jsxRuntime.jsx(ui.Image, __spreadProps(__spreadValues({}, image), {
                  zoomPreview,
                  commonStyle: {
                    display: "block"
                  }
                }))
              })
            })
          }, index))
        });
      case "masonry":
        const masonryImages = getMasonryImages(displayItems, columnCount);
        return /* @__PURE__ */ jsxRuntime.jsx(MasonryGallery.Masonry, {
          columnCount,
          gap,
          children: masonryImages.map((column, index) => /* @__PURE__ */ jsxRuntime.jsx("div", {
            children: column.map((image, row) => /* @__PURE__ */ jsxRuntime.jsx(MasonryGallery.MasonryImageWrapper, {
              gap,
              children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BreakpointWidthProvider, {
                sWidth: { value: 100 / columnCount, unit: "%" },
                mWidth: { value: 100 / columnCount, unit: "%" },
                children: /* @__PURE__ */ jsxRuntime.jsx(ui.Image, __spreadProps(__spreadValues({}, image), {
                  zoomPreview,
                  commonStyle: {
                    display: "block"
                  }
                }))
              })
            }, row))
          }, index))
        });
    }
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({}, rest), {
    isEditor: props == null ? void 0 : props.isEditor,
    children: renderGallery()
  }));
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle, isEditor }) => `${coreRenderer.getStyle(commonStyle)}
  ${isEditor ? "pointer-events: none;" : ""}
  `
);
const getMasonryImages = (images, columnCount) => {
  const arr = Array.from(Array(columnCount), () => []);
  for (let i = 0; i < images.length; i++) {
    arr[i % columnCount][Math.floor(i / columnCount)] = images[i];
  }
  return arr;
};
Gallery.displayName = "Gallery";

exports.Gallery = Gallery;


/***/ }),

/***/ 62435:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);

const MOBILE_WIDTH = 767;
const defaultMenu = [
  {
    id: "5eBqBWoa",
    name: "Trang ch\u1EE7",
    target: "SELF",
    isHidden: false,
    linkType: "PAGE",
    page: {
      id: 455,
      isHomepage: true,
      slug: null
    }
  },
  {
    id: "iCScxX63",
    name: "Blog",
    target: "BLANK",
    linkType: "PAGE",
    page: {
      id: 456,
      isHomepage: false,
      slug: "add-page-test"
    }
  },
  {
    id: "LvTwfsZx",
    name: "About",
    target: "BLANK",
    isHidden: true,
    linkType: "PAGE",
    page: {
      id: 458,
      slug: "test-122312",
      isHomepage: false
    }
  },
  {
    id: "7DWki3lv",
    name: "Services",
    target: "SELF",
    isHidden: false,
    linkType: "PAGE",
    page: {
      id: 419,
      slug: "test-add-page-3",
      isHomepage: false
    }
  },
  {
    id: "LebWjo9l",
    name: "Child1",
    linkType: "PAGE",
    parentId: "7DWki3lv",
    page: {
      id: 459,
      slug: "test-12123",
      isHomepage: false
    }
  },
  {
    id: "moar1sju",
    name: "Contact",
    target: "SELF",
    linkType: "PAGE",
    page: {
      id: 460,
      slug: "test-123123123",
      isHomepage: false
    }
  },
  {
    id: "aVtmfMh_",
    href: "https://vnshop.vn/thung-48-bich-sua-tuoi-tiet-trung-khong-duong-dalatmilk-220ml--s210201486?sku=210201486",
    name: "Child2",
    target: "BLANK",
    linkType: "LINK",
    nofollow: true,
    parentId: "moar1sju"
  },
  {
    id: "IOm6L3zm",
    href: "https://vnshop.vn/thung-48-bich-sua-tuoi-tiet-trung-khong-duong-dalatmilk-220ml--s210201486?sku=210201486",
    name: "Child3",
    target: "BLANK",
    linkType: "LINK",
    nofollow: true,
    parentId: "moar1sju"
  },
  {
    id: "Nuklf8V1",
    name: "Gallery",
    target: "SELF",
    linkType: "PAGE",
    page: {
      id: 454,
      slug: "test-qiwueqw-queqwe",
      isHomepage: false
    }
  },
  {
    id: "iR183_D0",
    href: "https://vnshop.vn/thung-48-bich-sua-tuoi-tiet-trung-khong-duong-dalatmilk-220ml--s210201486?sku=210201486",
    name: "Child4",
    target: "BLANK",
    isHidden: true,
    linkType: "LINK",
    nofollow: true,
    parentId: "Nuklf8V1"
  },
  {
    id: "1hr5sQFD",
    href: "https://vnshop.vn/thung-48-bich-sua-tuoi-tiet-trung-khong-duong-dalatmilk-220ml--s210201486?sku=210201486",
    name: "Child5",
    target: "BLANK",
    linkType: "LINK",
    nofollow: true,
    parentId: "Nuklf8V1"
  },
  {
    id: "vx6PjNLA",
    name: "Lorem Ipsum",
    target: "SELF",
    isHidden: false,
    linkType: "PAGE",
    page: {
      id: 448,
      slug: "test-add-2",
      isHomepage: false
    }
  }
];
const DEFAULT_MENU = defaultMenu;
const DEFAULT_GLOBAL_HEADER = {
  stickyTop: true,
  menuConfig: {
    commonStyle: {
      columnGap: 32
    },
    align: coreRenderer.Alignment.right
  },
  logoConfig: {
    show: true,
    src: "https://tempi.vn/static/media/logo.2cc45380.png",
    align: coreRenderer.Alignment.left,
    commonStyle: {
      width: 100
    },
    spacingWithMenu: 32
  },
  menuItemConfig: {
    commonStyle: {
      color: "#000000",
      hover: {
        color: "#008cff"
      }
    }
  },
  commonStyle: {
    backgroundColor: "#ffffff",
    padding: {
      top: 30,
      right: 16,
      bottom: 30,
      left: 16
    }
  }
};

exports.DEFAULT_GLOBAL_HEADER = DEFAULT_GLOBAL_HEADER;
exports.DEFAULT_MENU = DEFAULT_MENU;
exports.MOBILE_WIDTH = MOBILE_WIDTH;
exports.defaultMenu = defaultMenu;


/***/ }),

/***/ 32147:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var clsx = __webpack_require__(77084);
var React = __webpack_require__(91987);
var hooks = __webpack_require__(3597);
var utils = __webpack_require__(38057);
var type = __webpack_require__(86450);
var Header = __webpack_require__(97702);
var Content = __webpack_require__(44032);
var Logo = __webpack_require__(62821);
var ToggleButton = __webpack_require__(15912);
var NavigationBar = __webpack_require__(23701);
var Menu = __webpack_require__(22902);
var Item = __webpack_require__(64697);
var DropdownItem = __webpack_require__(27689);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const GlobalHeader = (props) => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const {
    commonStyle,
    logoConfig,
    menuConfig,
    menu = [],
    isEditingMode,
    stickyTop
  } = props || {};
  const grid = utils.calculateGrid(props);
  const menuOpenClassName = clsx__default["default"]({ open: mobileMenuOpen });
  const tree = utils.flattenToTreeMax2Level(
    (menu || []).filter((el) => !el.isHidden)
  );
  const { headerRef, headerHeight } = hooks.useHeaderPosition(
    stickyTop ? type.PositionHeader.STICKY : type.PositionHeader.NORMAL
  );
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      var _a, _b;
      if (!((_b = (_a = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _a.contains) == null ? void 0 : _b.call(_a, event.target))) {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [headerRef]);
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Header.Header, {
        commonStyle,
        ref: headerRef,
        grid,
        headerHeight,
        children: /* @__PURE__ */ jsxRuntime.jsxs(Content.Content, {
          grid,
          commonStyle,
          children: [
            (logoConfig == null ? void 0 : logoConfig.show) && /* @__PURE__ */ jsxRuntime.jsx(Logo.Logo, __spreadProps(__spreadValues({}, !isEditingMode ? { href: "/" } : {}), {
              grid,
              children: /* @__PURE__ */ jsxRuntime.jsx(Logo.LogoImg, {
                alt: logoConfig == null ? void 0 : logoConfig.alt,
                src: coreRenderer.getImageUrlFromGoogleUserContent(
                  logoConfig == null ? void 0 : logoConfig.src,
                  logoConfig == null ? void 0 : logoConfig.googleImageParams
                ),
                grid,
                loading: "lazy"
              })
            })),
            /* @__PURE__ */ jsxRuntime.jsx(ToggleButton.ToggleButton, {
              className: menuOpenClassName,
              grid,
              onClick: () => setMobileMenuOpen(!mobileMenuOpen)
            }),
            /* @__PURE__ */ jsxRuntime.jsx(NavigationBar.Navbar, {
              grid,
              children: /* @__PURE__ */ jsxRuntime.jsx(Menu.Menu, {
                className: menuOpenClassName,
                grid,
                children: tree.map((item) => {
                  var _a;
                  return /* @__PURE__ */ jsxRuntime.jsx(Item.Item, {
                    children: ((_a = item == null ? void 0 : item.children) == null ? void 0 : _a.length) > 0 ? /* @__PURE__ */ jsxRuntime.jsx(DropdownItem.DropdownItem, {
                      item,
                      grid,
                      alignMenu: menuConfig == null ? void 0 : menuConfig.align,
                      isEditingMode,
                      backgroundColor: commonStyle.backgroundColor || "white"
                    }) : /* @__PURE__ */ jsxRuntime.jsx(Item.ItemLabel, {
                      children: /* @__PURE__ */ jsxRuntime.jsx(Item.ItemContentWrapper, {
                        alignMenu: menuConfig == null ? void 0 : menuConfig.align,
                        children: /* @__PURE__ */ jsxRuntime.jsxs(Item.ItemContent, __spreadProps(__spreadValues(__spreadProps(__spreadValues({
                          alignMenu: menuConfig == null ? void 0 : menuConfig.align
                        }, !isEditingMode ? {
                          href: utils.getUrlOfMenuItem(item)
                        } : {}), {
                          grid,
                          target: utils.getTargetUrl(item.target)
                        }), (item == null ? void 0 : item.linkType) === "LINK" && item.nofollow ? { rel: "nofollow" } : {}), {
                          children: [
                            (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx(Item.ItemIcon, {
                              src: item.iconUrl,
                              loading: "lazy"
                            }),
                            item == null ? void 0 : item.name
                          ]
                        }))
                      })
                    })
                  }, item.id);
                })
              })
            })
          ]
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsx("div", {
        className: "placeholder"
      })
    ]
  });
};

exports.GlobalHeader = GlobalHeader;


/***/ }),

/***/ 44032:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var constants = __webpack_require__(62435);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Content = styled__default["default"].div(
  ({ grid, commonStyle }) => {
    const {
      gridArea,
      navigationGridTemplateColumns,
      width,
      mobileNavigationGridTemplateColumns
    } = grid;
    return `
    position: relative;
    display: grid;
    grid-area: ${gridArea};
    grid-template-columns: ${navigationGridTemplateColumns};
    align-items: center;
    width: 100%;
    max-width: ${width || 1240}px;
    margin: 0 auto;
    
    ${coreRenderer.getStyle({ padding: commonStyle.padding })};
  
    @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
      grid-template-columns: ${mobileNavigationGridTemplateColumns};
    }
  `;
  }
);

exports.Content = Content;


/***/ }),

/***/ 27689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var constants = __webpack_require__(62435);
var utils = __webpack_require__(38057);
var Item = __webpack_require__(64697);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DropdownItem = ({ item, grid, alignMenu, isEditingMode, backgroundColor }) => {
  var _a;
  const id = `dropdown-${item.id}`;
  const { menuColor } = grid;
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /* @__PURE__ */ jsxRuntime.jsxs(StyledLabel, {
      htmlFor: id,
      children: [
        /* @__PURE__ */ jsxRuntime.jsx("input", {
          type: "checkbox",
          id,
          value: ""
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(Item.ItemContentWrapper, {
          alignMenu,
          hoverColor: grid.menuHoverColor,
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(Item.ItemContent, __spreadProps(__spreadValues(__spreadValues({
              grid,
              alignMenu,
              target: utils.getTargetUrl(item.target)
            }, !isEditingMode ? {
              href: utils.getUrlOfMenuItem(item)
            } : {}), (item == null ? void 0 : item.linkType) === "LINK" && item.nofollow ? { rel: "nofollow" } : {}), {
              children: [
                (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx(Item.ItemIcon, {
                  src: item.iconUrl,
                  loading: "lazy"
                }),
                item == null ? void 0 : item.name
              ]
            })),
            /* @__PURE__ */ jsxRuntime.jsx(DropdownIcon, {
              alignMenu,
              color: menuColor
            })
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx(SubMenu, {
          className: "sub-menu",
          grid,
          children: /* @__PURE__ */ jsxRuntime.jsx(SubMenuContent, {
            grid,
            backgroundColor,
            children: (_a = item == null ? void 0 : item.children) == null ? void 0 : _a.map((child, i) => /* @__PURE__ */ jsxRuntime.jsx(Item.Item, {
              children: /* @__PURE__ */ jsxRuntime.jsx(Item.ItemLabel, {
                children: /* @__PURE__ */ jsxRuntime.jsx(Item.ItemContentWrapper, {
                  alignMenu,
                  children: /* @__PURE__ */ jsxRuntime.jsxs(Item.ItemContent, __spreadProps(__spreadValues(__spreadValues({
                    grid: __spreadProps(__spreadValues({}, grid), { menuItemSpacing: null }),
                    alignMenu,
                    target: utils.getTargetUrl(item.target)
                  }, !isEditingMode ? {
                    href: utils.getUrlOfMenuItem(child)
                  } : {}), (child == null ? void 0 : child.linkType) === "LINK" && child.nofollow && { rel: "nofollow" }), {
                    children: [
                      (child == null ? void 0 : child.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx(Item.ItemIcon, {
                        src: child.iconUrl,
                        loading: "lazy"
                      }),
                      child == null ? void 0 : child.name
                    ]
                  }))
                })
              })
            }, i))
          })
        })
      ]
    })
  });
};
const StyledLabel = styled__default["default"](Item.ItemLabel)`
  cursor: pointer;

  input {
    display: none;
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
  }

  svg {
    transition: transform 0.3s;
  }

  @media screen and (min-width: ${constants.MOBILE_WIDTH}px) {
    &:hover {
      .sub-menu {
        display: block;

        ul {
          max-height: 400px;
          overflow-y: auto;
        }
      }
      svg {
        transform: rotate(180deg);
      }
    }
  }

  @media screen and (max-width: ${constants.MOBILE_WIDTH}px) {
    input[type='checkbox']:checked ~ {
      .sub-menu {
        display: block;
      }

      div {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }
`;
const DropdownIcon = ({ alignMenu, color }) => {
  let gridColumn;
  let gridRow;
  switch (alignMenu) {
    case coreRenderer.Alignment.left:
      gridColumn = "2/3";
      break;
    case coreRenderer.Alignment.center:
      gridColumn = "3/4";
      break;
    case coreRenderer.Alignment.right:
      gridRow = "1";
      gridColumn = "2/3";
      break;
  }
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "10",
    height: "7",
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-v-b930357f": "",
    style: { margin: "0 0.2rem", gridColumn, gridRow, color },
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M5 6.5L0.669873 0.5L9.33013 0.500001L5 6.5Z",
      fill: "currentColor",
      "data-v-b930357f": ""
    })
  });
};
const SubMenu = styled__default["default"].div(
  ({ grid }) => `
  position: absolute;
  z-index: 1;
  display: none;
  padding-top: 10px;
  padding-right: 16px;
  padding-bottom: 48px;
  margin-left: ${grid.menuItemSpacing}px;

  @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
    position: unset;
    padding: 8px 0;
  }
`
);
const SubMenuContent = styled__default["default"].ul(
  ({ grid, backgroundColor }) => `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 16px 24px;
  gap: 10px;
  list-style: none;
  border-radius: 5px;
  box-shadow: 0 2px 10px #0000001a;
  animation: expand-5b652f62 0.2s cubic-bezier(0.45, 0, 0.1, 1);
  background-color: ${backgroundColor};


  @media screen and (max-width: ${constants.MOBILE_WIDTH}px) {
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    align-items: ${grid.navigationJustifySelf};
  }
`
);

exports.DropdownItem = DropdownItem;


/***/ }),

/***/ 97702:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Header = styled__default["default"].header(({ commonStyle, headerHeight }) => {
  const _a = commonStyle, rest = __objRest(_a, ["padding"]);
  return `
    display: grid;
    grid-area: 1/1/-1/-1;
    grid-template-rows: 100%;
    grid-template-columns: 100%;
    width: 100%;
    transition: box-shadow 0.15s linear;
  
    &.sticky {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 100;
    }
    ${headerHeight ? `
    &.sticky + .placeholder{
      padding-bottom: ${headerHeight}px;
    }
    ` : ""}
    
    ${coreRenderer.getStyle(rest)}
  `;
});

exports.Header = Header;


/***/ }),

/***/ 64697:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var constants = __webpack_require__(62435);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Item = styled__default["default"].li`
  user-select: none;
`;
const ItemLabel = styled__default["default"].label`
  display: block;
`;
const ItemContentWrapper = styled__default["default"].div(
  ({ alignMenu, hoverColor }) => `
  display: flex;
  align-items: center;
  text-align: left;
  @media screen and (max-width: ${constants.MOBILE_WIDTH}px) {
    grid-template-columns: 
      ${alignMenu === coreRenderer.Alignment.left ? "auto 1fr auto" : ""}
      ${alignMenu === coreRenderer.Alignment.center ? "1fr auto 1fr" : ""}
      ${alignMenu === coreRenderer.Alignment.right ? "1fr auto" : ""}
    ;
    display: grid;
  }

  ${hoverColor ? `a:hover ~ svg{
    color: ${hoverColor} !important;
  }` : ""}
`
);
const ItemContent = styled__default["default"].a(({ grid, alignMenu }) => {
  const {
    menuItemSpacing,
    menuColor,
    menuHoverColor,
    mobileNavigationTextAlign
  } = grid || {};
  return `
  position: relative;
  align-self: center;
  margin: 0 0 0 ${menuItemSpacing}px;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  color: ${menuColor};

  &:hover {
    text-decoration: underline;
    text-underline-offset: 7px;
    color: ${menuHoverColor};
  }

  @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
    margin: 0;
    text-align: ${mobileNavigationTextAlign};

    grid-column: 
    ${alignMenu === coreRenderer.Alignment.left ? "1/2" : ""}
    ${alignMenu === coreRenderer.Alignment.center ? "2/3" : ""}
    ${alignMenu === coreRenderer.Alignment.right ? "3/4" : ""}
  }
`;
});
const ItemIcon = styled__default["default"].img`
  width: 20px;
  height: 20px;
  margin-right: 0.4em;
`;

exports.Item = Item;
exports.ItemContent = ItemContent;
exports.ItemContentWrapper = ItemContentWrapper;
exports.ItemIcon = ItemIcon;
exports.ItemLabel = ItemLabel;


/***/ }),

/***/ 62821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Logo = styled__default["default"].a(({ grid }) => {
  const {
    logoGridRow,
    logoGridColumn,
    logoJustifySelf,
    logoSpacing,
    logoWidth
  } = grid;
  return `
    display: inline-flex;
    grid-row: ${logoGridRow};
    grid-column: ${logoGridColumn};
    align-self: center;
    justify-self: ${logoJustifySelf};
    margin: ${logoSpacing};
    width: ${logoWidth}px;
  `;
});
const LogoImg = styled__default["default"].img(({ grid }) => {
  const { logoImageObjectPosition } = grid;
  return `
    width: 100%;
    height: 100%;
  
    vertical-align: middle;
    object-fit: contain;
    object-position: ${logoImageObjectPosition};
  `;
});

exports.Logo = Logo;
exports.LogoImg = LogoImg;


/***/ }),

/***/ 22902:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);
var constants = __webpack_require__(62435);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Menu = styled__default["default"].ul(({ grid }) => {
  const {
    navigationTextAlign,
    mobileMenuItemSpacing,
    mobileNavigationJustifySelf,
    paddingRight,
    mobileNavigationTextAlign,
    backgroundOverlayOpacity,
    mobileBackground
  } = grid;
  return `
    padding-left: unset;
    display: inline-flex;
    flex-flow: row wrap;
    row-gap: 16px;
    align-items: center;
    height: 100%;
    text-align: ${navigationTextAlign};
    list-style: none;
  
    @media screen and (max-width: ${constants.MOBILE_WIDTH}px) {
      position: absolute;
      top: 100%;
      right: 0;
      left: 0;
      z-index: 1;
      display: grid;
      grid-gap: ${mobileMenuItemSpacing || 16}px 0;
      justify-self: ${mobileNavigationJustifySelf};
      width: auto;
      height: 0;
      max-height: 450px;
      padding: ${mobileMenuItemSpacing || 16}px ${mobileMenuItemSpacing || 16}px ${mobileMenuItemSpacing || 16}px ${paddingRight}px;
      margin: 0;
      overflow-y: auto;
      text-align: ${mobileNavigationTextAlign};
      pointer-events: none;
      background-size: cover;
      box-shadow: 0 6px 14px -14px #0000001a;
      opacity: 0;
      transform: translateY(-1em);
      transition-timing-function: cubic-bezier(.45,0,.1,1);
      transition-duration: .2s;
      transition-property: opacity,transform;
      background: linear-gradient(rgba(0,0,0,${backgroundOverlayOpacity}),rgba(0,0,0,${backgroundOverlayOpacity})),${mobileBackground} no-repeat top;
  
      &.open {
        height: auto;
        pointer-events: auto;
        opacity: 1;
        transform: translate(0);
        transition-timing-function: cubic-bezier(.45,0,.1,1);
        transition-duration: .2s;
        transition-property: opacity,transform;
      }
    };
  `;
});

exports.Menu = Menu;


/***/ }),

/***/ 23701:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);
var constants = __webpack_require__(62435);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Navbar = styled__default["default"].nav(({ grid }) => {
  const {
    linksGridRow,
    linksGridColumn,
    navigationJustifySelf,
    menuItemSpacing
  } = grid;
  return `
    grid-row: ${linksGridRow};
    grid-column: ${linksGridColumn};
    justify-self: ${navigationJustifySelf};
    height: 100%;
    margin-left: ${-1 * menuItemSpacing}px;
  
    @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
      grid-row: unset;
      grid-column: unset;
    };
  `;
});

exports.Navbar = Navbar;


/***/ }),

/***/ 15912:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var constants = __webpack_require__(62435);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Toggle = styled__default["default"].button(({ grid }) => {
  const {
    linksGridRow,
    linksGridColumn,
    navigationJustifySelf,
    navigationTextAlign,
    menuColor
  } = grid;
  const mobileLinksGridRow = linksGridRow;
  const mobileLinksGridColumn = linksGridColumn;
  const mobileNavigationJustifySelf = navigationJustifySelf;
  const mobileNavigationTextAlign = navigationTextAlign;
  return `
  
    display: none;
    grid-row: ${linksGridRow};
    grid-column: ${linksGridColumn};
    justify-self: ${navigationJustifySelf};
    text-align: ${navigationTextAlign}; 
  
    width: 24px;
    height: 18px;
    cursor: pointer;
    background-color: transparent;
    transition: all .4s ease-in-out .1s;
    transform: rotate(0);
  
    border: none;
    outline: none;
    box-shadow: none;
    
    &:focus{
      outline: none;
    }
  
    span{
      position: absolute;
      display: block;
      width: 100%;
      height: 2px;
      background: ${menuColor || "#7367f0"};
      border-radius: 2px;
      transition: all .25s ease-in-out .1s;
      transform: rotate(0);
      transform-origin: left center;
    }
  
    span:nth-of-type(1){
      top: 0;
    } 
    span:nth-of-type(2){
      top: 8px;
    } 
    span:nth-of-type(3){
      top: 16px;
    } 
  
    &.open {
      span:nth-of-type(1){
        top: -1px;
        transform: rotate(45deg);
      } 
      span:nth-of-type(2){
        width: 0%;
        opacity: 0;
      } 
      span:nth-of-type(3){
        transform: rotate(-45deg);
      } 
    }
    
    @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
        display: block;
        grid-row: ${mobileLinksGridRow};
        grid-column: ${mobileLinksGridColumn};
        justify-self: ${mobileNavigationJustifySelf};
        text-align: ${mobileNavigationTextAlign};
    }
    `;
});
const ToggleButton = (props) => {
  return /* @__PURE__ */ jsxRuntime.jsxs(Toggle, __spreadProps(__spreadValues({}, props), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx("span", {}),
      /* @__PURE__ */ jsxRuntime.jsx("span", {}),
      /* @__PURE__ */ jsxRuntime.jsx("span", {})
    ]
  }));
};

exports.ToggleButton = ToggleButton;


/***/ }),

/***/ 38057:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const calculateGrid = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const padding = "30px 16px 30px 16px";
  const width = 1240;
  const menuPosition = (_a = props == null ? void 0 : props.menuConfig) == null ? void 0 : _a.align;
  const { paddingTop, paddingRight, paddingBottom, paddingLeft } = splitPaddingString(padding);
  const logoShow = (_b = props == null ? void 0 : props.logoConfig) == null ? void 0 : _b.show;
  const logoWidth = (_d = (_c = props == null ? void 0 : props.logoConfig) == null ? void 0 : _c.commonStyle) == null ? void 0 : _d.width;
  const spaceBetweenMenu = (_e = props == null ? void 0 : props.logoConfig) == null ? void 0 : _e.spacingWithMenu;
  const logoPosition = (_f = props == null ? void 0 : props.logoConfig) == null ? void 0 : _f.align;
  const gridArea = "1/1/-1/-1";
  const backgroundOverlayOpacity = 0;
  const menuItemSpacing = (_h = (_g = props == null ? void 0 : props.menuConfig) == null ? void 0 : _g.commonStyle) == null ? void 0 : _h.columnGap;
  const backgroundColor = (_i = props == null ? void 0 : props.commonStyle) == null ? void 0 : _i.backgroundColor;
  const menuColor = (_k = (_j = props == null ? void 0 : props.menuItemConfig) == null ? void 0 : _j.commonStyle) == null ? void 0 : _k.color;
  const menuHoverColor = (_n = (_m = (_l = props == null ? void 0 : props.menuItemConfig) == null ? void 0 : _l.commonStyle) == null ? void 0 : _m.hover) == null ? void 0 : _n.color;
  const mobilePaddingTop = 24;
  const mobilePadding = "24px 16px 24px 16px";
  const mobilePaddingRight = 16;
  const mobilePaddingBottom = 24;
  const mobilePaddingLeft = 16;
  const mobileLogoWidth = 70;
  const mobileMenuItemSpacing = 20;
  const mobileLogoGridRow = "1/2";
  const mobileLogoGridColumn = "1/2";
  const mobileLogoJustifySelf = "flex-start";
  const mobileLogoImageObjectPosition = "left center";
  const mobileLinksGridRow = "1/2";
  const mobileLinksGridColumn = "2/3";
  const mobileLogoSpacing = `0 ${spaceBetweenMenu}px 0 0`;
  const mobileDropdownBackgroundColor = "#dcdcdc";
  const mobileBackground = backgroundColor;
  let navigationGridTemplateColumns;
  let mobileNavigationGridTemplateColumns;
  navigationGridTemplateColumns = getNavigationGridTemplateColumns(
    logoPosition,
    menuPosition,
    logoWidth,
    spaceBetweenMenu,
    void 0
  );
  mobileNavigationGridTemplateColumns = getNavigationGridTemplateColumns(
    logoPosition,
    menuPosition,
    logoWidth,
    spaceBetweenMenu,
    "mobile",
    mobileLogoWidth
  );
  if (!logoShow) {
    navigationGridTemplateColumns = "1fr";
    mobileNavigationGridTemplateColumns = "1fr";
  }
  const logoGridColumn = getLogoGridColumn(logoPosition, menuPosition);
  let logoGridRow = "1/2";
  let logoSpacing = `0 ${spaceBetweenMenu}px 0 0`;
  let logoJustifySelf;
  switch (logoPosition) {
    case "left":
      logoJustifySelf = "flex-start";
      logoSpacing = `0 ${spaceBetweenMenu}px 0 0`;
      break;
    case "center":
      logoJustifySelf = "center";
      if (menuPosition === "center") {
        logoSpacing = `0 0 ${spaceBetweenMenu}px 0`;
        logoGridRow = "0/2";
      } else {
        logoSpacing = `0 ${spaceBetweenMenu}px`;
      }
      break;
    case "right":
      logoJustifySelf = "flex-end";
      logoSpacing = `0 0 0 ${spaceBetweenMenu}px`;
      break;
  }
  const logoImageObjectPosition = `${logoPosition} center`;
  let linksGridRow = "1/2";
  let linksGridColumn = "2/3";
  let navigationJustifySelf = "flex-end";
  const navigationTextAlign = menuPosition || "right";
  const mobileNavigationTextAlign = menuPosition || "right";
  let mobileNavigationJustifySelf = "flex-end";
  switch (menuPosition) {
    case "left":
      navigationJustifySelf = "flex-start";
      mobileNavigationJustifySelf = "flex-start";
      break;
    case "center":
      navigationJustifySelf = "center";
      mobileNavigationJustifySelf = "center";
      break;
    case "right":
      navigationJustifySelf = "flex-end";
      mobileNavigationJustifySelf = "flex-end";
      break;
  }
  linksGridColumn = getLinksGridColumn(logoPosition, menuPosition);
  if (logoPosition === "center" && menuPosition === "center") {
    linksGridRow = "2/2";
  }
  if (!logoShow) {
    linksGridColumn = "1/2";
  }
  return {
    gridArea,
    navigationGridTemplateColumns,
    padding,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
    width,
    logoGridRow,
    logoGridColumn,
    logoJustifySelf,
    logoSpacing,
    logoWidth,
    logoImageObjectPosition,
    linksGridRow,
    linksGridColumn,
    navigationJustifySelf,
    menuItemSpacing,
    navigationTextAlign,
    menuColor,
    menuHoverColor,
    mobilePadding,
    mobilePaddingTop,
    mobilePaddingRight,
    mobilePaddingBottom,
    mobilePaddingLeft,
    mobileLogoWidth,
    mobileMenuItemSpacing,
    mobileNavigationGridTemplateColumns,
    mobileLogoGridRow,
    mobileLogoGridColumn,
    mobileLogoJustifySelf,
    mobileLogoImageObjectPosition,
    mobileLinksGridRow,
    mobileLinksGridColumn,
    mobileLogoSpacing,
    mobileNavigationTextAlign,
    mobileNavigationJustifySelf,
    mobileDropdownBackgroundColor,
    mobileBackground,
    backgroundOverlayOpacity
  };
};
const splitPaddingString = (paddingString) => {
  const paddingValues = paddingString.split(" ");
  const result = {};
  if (paddingValues[0]) {
    result.paddingTop = parseInt(paddingValues[0].replace("px", ""));
  }
  if (paddingValues[1]) {
    result.paddingRight = parseInt(paddingValues[1].replace("px", ""));
  }
  if (paddingValues[2]) {
    result.paddingBottom = parseInt(paddingValues[2].replace("px", ""));
  }
  if (paddingValues[3]) {
    result.paddingLeft = parseInt(paddingValues[3].replace("px", ""));
  }
  return result;
};
const getNavigationGridTemplateColumns = (logoPosition, menuPosition, logoWidth, spaceBetweenMenu, device, mobileLogoWidth) => {
  const logoWidthWithSpace = (device === "desktop" ? logoWidth : mobileLogoWidth || logoWidth) + spaceBetweenMenu;
  const logoWidthWithSpaceAuto = `minmax(${logoWidthWithSpace}px, auto)`;
  switch (logoPosition) {
    case coreRenderer.Alignment.left:
      switch (menuPosition) {
        case coreRenderer.Alignment.left:
          return `${logoWidthWithSpaceAuto} 1fr`;
        case coreRenderer.Alignment.center:
          return `minmax(${logoWidthWithSpace}px, 1fr) auto 1fr`;
        case coreRenderer.Alignment.right:
          return `${logoWidthWithSpaceAuto} 1fr`;
      }
    case coreRenderer.Alignment.center:
      switch (menuPosition) {
        case coreRenderer.Alignment.left:
          return `1fr ${logoWidthWithSpaceAuto} 1fr`;
        case coreRenderer.Alignment.center:
          return `1fr minmax(${logoWidth}px, auto) 1fr`;
        case coreRenderer.Alignment.right:
          return `1fr ${logoWidthWithSpaceAuto} 1fr`;
      }
    case coreRenderer.Alignment.right:
      switch (menuPosition) {
        case coreRenderer.Alignment.left:
          return `1fr ${logoWidthWithSpaceAuto}`;
        case coreRenderer.Alignment.center:
          return `1fr auto minmax(${logoWidthWithSpace}px, 1fr)`;
        case coreRenderer.Alignment.right:
          return `1fr ${logoWidthWithSpaceAuto}`;
      }
  }
};
const getLinksGridColumn = (logoPosition, menuPosition) => {
  switch (logoPosition) {
    case coreRenderer.Alignment.left:
      return "2/3";
    case coreRenderer.Alignment.center:
      switch (menuPosition) {
        case coreRenderer.Alignment.left:
          return `1/2`;
        case coreRenderer.Alignment.center:
          return `1/4`;
        case coreRenderer.Alignment.right:
          return `3/4`;
      }
    case coreRenderer.Alignment.right:
      switch (menuPosition) {
        case coreRenderer.Alignment.left:
        case coreRenderer.Alignment.right:
          return `1/2`;
        case coreRenderer.Alignment.center:
          return `2/3`;
      }
  }
};
const getLogoGridColumn = (logoPosition, menuPosition) => {
  switch (logoPosition) {
    case coreRenderer.Alignment.left:
      return "1/2";
    case coreRenderer.Alignment.center:
      return "2/3";
    case coreRenderer.Alignment.right:
      switch (menuPosition) {
        case coreRenderer.Alignment.left:
        case coreRenderer.Alignment.right:
          return `2/3`;
        case coreRenderer.Alignment.center:
          return `3/4`;
      }
  }
};
const flattenToTreeMax2Level = (originMenu) => {
  const level1 = originMenu.filter((el) => !el.parentId);
  return level1.map((item) => {
    const children = originMenu.filter((m) => m.parentId === item.id);
    return __spreadProps(__spreadValues({}, item), {
      children
    });
  });
};
const getUrlOfMenuItem = (item) => {
  var _a, _b;
  if ((item == null ? void 0 : item.linkType) === "LINK")
    return item.href;
  if ((_a = item == null ? void 0 : item.page) == null ? void 0 : _a.isHomepage)
    return "/";
  return (_b = item == null ? void 0 : item.page) == null ? void 0 : _b.slug;
};
const getTargetUrl = (target) => {
  if (target === "BLANK")
    return "_blank";
  return "_self";
};

exports.calculateGrid = calculateGrid;
exports.flattenToTreeMax2Level = flattenToTreeMax2Level;
exports.getTargetUrl = getTargetUrl;
exports.getUrlOfMenuItem = getUrlOfMenuItem;
exports.splitPaddingString = splitPaddingString;


/***/ }),

/***/ 72436:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var BLOCK_TYPES = /* @__PURE__ */ ((BLOCK_TYPES2) => {
  BLOCK_TYPES2["HEADER"] = "HEADER";
  BLOCK_TYPES2["FOOTER"] = "FOOTER";
  return BLOCK_TYPES2;
})(BLOCK_TYPES || {});
const GLOBAL_BLOCK_TAG = "globalblock";

exports.BLOCK_TYPES = BLOCK_TYPES;
exports.GLOBAL_BLOCK_TAG = GLOBAL_BLOCK_TAG;


/***/ }),

/***/ 96985:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var type = __webpack_require__(72436);
var GlobalHeader = __webpack_require__(32147);
var ui = __webpack_require__(69447);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const GlobalBlock = (props) => {
  const { device } = coreRenderer.useStore();
  const newProps = coreRenderer.getPropsByDevice(props, device);
  const _a = newProps, { blockId, blockType, content } = _a, rest = __objRest(_a, ["blockId", "blockType", "content"]);
  if (blockType === type.BLOCK_TYPES.HEADER) {
    return /* @__PURE__ */ jsxRuntime.jsx(GlobalHeader.GlobalHeader, __spreadValues({}, rest));
  }
  return /* @__PURE__ */ jsxRuntime.jsx(ui.PbSection, __spreadProps(__spreadValues({}, rest), {
    children: props.children
  }));
};
GlobalBlock.displayName = "GlobalBlock";

exports.GlobalBlock = GlobalBlock;


/***/ }),

/***/ 63137:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(91987);

const HeaderContext = React.createContext({});

exports.HeaderContext = HeaderContext;


/***/ }),

/***/ 3597:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var type = __webpack_require__(86450);

const useHeaderPosition = (positionType) => {
  const headerRef = React.useRef(null);
  const [headerHeight, setHeaderHeight] = React.useState(110);
  const [direction, setDirection] = React.useState("");
  let oldScrollY = 0;
  const updateOldScrollY = coreRenderer.debounce((newValue) => oldScrollY = newValue, 100);
  const handleSticky = (stickyPosition) => {
    var _a, _b;
    if (window.pageYOffset >= stickyPosition) {
      (_a = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _a.classList.add("sticky");
    } else {
      (_b = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _b.classList.remove("sticky");
    }
  };
  const controlDirection = (stickyPosition) => {
    var _a, _b;
    if (window.pageYOffset >= stickyPosition) {
      (_a = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _a.classList.add("sticky");
      if ((window == null ? void 0 : window.scrollY) > oldScrollY) {
        setDirection("scrolldown");
      } else {
        setDirection("scrollup");
      }
      updateOldScrollY(window == null ? void 0 : window.scrollY);
    } else {
      (_b = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _b.classList.remove("sticky");
    }
  };
  React.useEffect(() => {
    var _a, _b;
    setHeaderHeight((_b = (_a = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _a.getClientRects()[0]) == null ? void 0 : _b.height);
  }, []);
  React.useEffect(() => {
    var _a;
    const headerPosition = (_a = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _a.offsetTop;
    const dynamicEvent = () => controlDirection(headerPosition);
    const stickyEvent = () => handleSticky(headerPosition);
    switch (positionType) {
      case type.PositionHeader.DYNAMIC:
        window == null ? void 0 : window.addEventListener("scroll", dynamicEvent);
        break;
      case type.PositionHeader.STICKY:
        window == null ? void 0 : window.addEventListener("scroll", stickyEvent);
        break;
    }
    return () => {
      window == null ? void 0 : window.removeEventListener("scroll", dynamicEvent);
      window == null ? void 0 : window.removeEventListener("scroll", stickyEvent);
    };
  }, [positionType]);
  return {
    headerRef,
    headerHeight,
    direction
  };
};

exports.useHeaderPosition = useHeaderPosition;


/***/ }),

/***/ 86450:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var PositionHeader = /* @__PURE__ */ ((PositionHeader2) => {
  PositionHeader2["NORMAL"] = "normal";
  PositionHeader2["STICKY"] = "sticky";
  PositionHeader2["DYNAMIC"] = "dynamic";
  return PositionHeader2;
})(PositionHeader || {});
var MenuItemType = /* @__PURE__ */ ((MenuItemType2) => {
  MenuItemType2["button"] = "button";
  MenuItemType2["link"] = "link";
  return MenuItemType2;
})(MenuItemType || {});

exports.MenuItemType = MenuItemType;
exports.PositionHeader = PositionHeader;


/***/ }),

/***/ 54501:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var context = __webpack_require__(63137);
var hooks = __webpack_require__(3597);
var type = __webpack_require__(86450);
var grid = __webpack_require__(74178);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Header = (_a) => {
  var _b = _a, {
    children,
    isMobile,
    toggle,
    positionType
  } = _b, rest = __objRest(_b, [
    "children",
    "isMobile",
    "toggle",
    "positionType"
  ]);
  const _a2 = rest, { commonStyle } = _a2, others = __objRest(_a2, ["commonStyle"]);
  const _b2 = commonStyle, { maxWidth } = _b2, restStyle = __objRest(_b2, ["maxWidth"]);
  const { headerRef, headerHeight, direction } = hooks.useHeaderPosition(positionType);
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
        ref: headerRef,
        isMobile,
        commonStyle: restStyle,
        positionType,
        direction,
        headerHeight
      }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx(ContentRow, {
          style: { maxWidth },
          children: /* @__PURE__ */ jsxRuntime.jsx(context.HeaderContext.Provider, {
            value: { toggle, isMobile },
            children
          })
        })
      })),
      /* @__PURE__ */ jsxRuntime.jsx("div", {
        className: "placeholder"
      })
    ]
  });
};
Header.displayName = "Header";
const mobileCss = ({
  commonStyle: { maxHeight, height, minHeight }
}) => `
  max-width: 100%;

  .logo {
    max-width: 50%;
  }

  .menu {
    &-desktop {
      display: none !important;
    }

    &-col {
      flex-direction: column;
      row-gap: 8px;
    }

    &-item {
      &.button {
        justify-content: center;
      }
    }
  }

  .toggle-button {
    ${coreRenderer.getStyle({ maxHeight, height, minHeight })}
  }
`;
const desktopCss = ({ alignment }) => `
  .menu {
    &-desktop {
      flex: 1;
    }

    &-col {
      &.left {
        justify-content: ${grid.MAPPING_ALIGNMENT_FLEX[alignment]};
      }
    }
  }

  .dropdown-menu,
  .toggle-button {
    display: none !important;
  }
`;
const Wrapper = styled__default["default"].div((props) => {
  const { isMobile, commonStyle, positionType, direction, headerHeight } = props;
  return [
    `
      ${coreRenderer.getStyle(commonStyle)}
      display: flex;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
      z-index: 100;
      transition: opacity .5s;
      ${positionType === type.PositionHeader.DYNAMIC ? direction === "scrolldown" ? "opacity: 0;" : "opacity: 1;" : ""}
      
      
      &.sticky {
        position: fixed;
        top: 0;
        width: 100%;
      }
      
      &.sticky + .placeholder{
        padding-bottom: ${headerHeight}px;
      }
    `,
    isMobile && mobileCss,
    isMobile === false && desktopCss,
    isMobile === void 0 && `
        @media (max-width: 767px) {
          ${mobileCss(props)}
        }
        @media (min-width: 767px) {
          ${desktopCss(props)}
        }
      `
  ];
});
const ContentRow = styled__default["default"].div`
  background: inherit;
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: 16px;
`;

exports.Header = Header;


/***/ }),

/***/ 51195:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var React = __webpack_require__(91987);
var ui = __webpack_require__(49864);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Logo = React__default["default"].forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
      ref,
      className: "logo",
      children: /* @__PURE__ */ jsxRuntime.jsx(ui.Image, __spreadValues({
        autoOptimize: true
      }, props))
    });
  }
);
Logo.displayName = "Logo";
const Wrapper = styled__default["default"].div`
  max-width: 33%;
`;

exports.Logo = Logo;


/***/ }),

/***/ 39353:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const DesktopMenu = (props) => {
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadValues({
    className: "menu-desktop"
  }, props));
};
const Wrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 24px;
`;

exports.DesktopMenu = DesktopMenu;


/***/ }),

/***/ 30655:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var context = __webpack_require__(63137);
var DesktopMenu = __webpack_require__(39353);
var MobileMenu = __webpack_require__(24373);

const Menu = ({ children }) => {
  const { isMobile } = React.useContext(context.HeaderContext);
  if (isMobile !== void 0) {
    if (isMobile) {
      return /* @__PURE__ */ jsxRuntime.jsx(MobileMenu.MobileMenu, {
        children
      });
    }
    return /* @__PURE__ */ jsxRuntime.jsx(DesktopMenu.DesktopMenu, {
      children
    });
  }
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(MobileMenu.MobileMenu, {
        children
      }),
      /* @__PURE__ */ jsxRuntime.jsx(DesktopMenu.DesktopMenu, {
        children
      })
    ]
  });
};
Menu.displayName = "Menu";

exports.Menu = Menu;


/***/ }),

/***/ 24373:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);
var React = __webpack_require__(91987);
var context = __webpack_require__(63137);
var getPropsIcon = __webpack_require__(26321);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const MobileMenu = ({ children }) => {
  const { toggle } = React.useContext(context.HeaderContext);
  const [visibleMenu, setVisibleMenu] = React.useState(false);
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(ToggleButton, {
        className: "toggle-button",
        onClick: () => setVisibleMenu(!visibleMenu),
        children: visibleMenu ? /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, __spreadValues({
          name: "CloseOutlined"
        }, getPropsIcon.getPropsIcon(toggle == null ? void 0 : toggle.icon))) : /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, __spreadValues({
          name: "MenuOutlined"
        }, getPropsIcon.getPropsIcon(toggle == null ? void 0 : toggle.icon)))
      }),
      /* @__PURE__ */ jsxRuntime.jsx(DropdownMenu, {
        className: `dropdown-menu ${visibleMenu ? "show" : ""}`,
        children
      })
    ]
  });
};
const ToggleButton = styled__default["default"].div`
  margin-left: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0 8px;
`;
const DropdownMenu = styled__default["default"].div`
  position: absolute;
  top: 80%;
  left: 0;
  right: 0;
  z-index: 100;

  display: flex;
  flex-direction: column;
  align-content: center;
  row-gap: 8px;

  height: auto;
  padding: 16px;
  overflow-y: auto;

  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease-in-out;

  background: inherit;
  box-shadow: 0 10px 16px rgba(10, 10, 10, 0.1);

  &.show {
    top: 100%;
    opacity: 1;
    visibility: visible;
  }
`;

exports.MobileMenu = MobileMenu;


/***/ }),

/***/ 22945:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var React = __webpack_require__(91987);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MenuCol = React__default["default"].forwardRef(
  (_a, ref) => {
    var _b = _a, { type = "right" } = _b, rest = __objRest(_b, ["type"]);
    if (type === "left") {
      return /* @__PURE__ */ jsxRuntime.jsx(LeftMenuCol, __spreadProps(__spreadValues({
        ref
      }, rest), {
        className: "menu-col left"
      }));
    }
    return /* @__PURE__ */ jsxRuntime.jsx(RightMenuCol, __spreadProps(__spreadValues({
      ref
    }, rest), {
      className: "menu-col right"
    }));
  }
);
MenuCol.displayName = "menuCol";
const menuColCss = `
  display: flex;
  align-items: center;
  column-gap: 24px;
  row-gap: 16px;
`;
const RightMenuCol = styled__default["default"].div(
  menuColCss,
  `
    justify-content: flex-end;
  `
);
const LeftMenuCol = styled__default["default"].div(
  menuColCss,
  `
  flex: 1;
`
);

exports.MenuCol = MenuCol;


/***/ }),

/***/ 7286:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var type = __webpack_require__(86450);
var ui = __webpack_require__(81171);
var ui$1 = __webpack_require__(61349);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MenuItem = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, { itemData, type: type$1, children } = _a, rest = __objRest(_a, ["itemData", "type", "children"]);
    if (children)
      return children;
    if (type$1 === type.MenuItemType.link) {
      return /* @__PURE__ */ jsxRuntime.jsx("div", {
        ref,
        children: /* @__PURE__ */ jsxRuntime.jsx(ui.Heading, __spreadValues(__spreadValues({}, itemData), rest))
      });
    }
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      ref,
      children: /* @__PURE__ */ jsxRuntime.jsx(ui$1.ButtonV2, __spreadProps(__spreadValues(__spreadValues({
        ref
      }, itemData), rest), {
        className: "menu-item button"
      }))
    });
  }
);
MenuItem.displayName = "MenuItem";

exports.MenuItem = MenuItem;


/***/ }),

/***/ 81171:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var styled = __webpack_require__(21483);
var index = __webpack_require__(43866);
var fonts = __webpack_require__(74367);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Heading = (_a) => {
  var _b = _a, {
    text,
    enabled,
    link,
    children
  } = _b, rest = __objRest(_b, [
    "text",
    "enabled",
    "link",
    "children"
  ]);
  const { text: formattedText } = coreRenderer.useInjectDynamicLinks(text);
  const renderHeading = () => {
    if (children)
      return /* @__PURE__ */ jsxRuntime.jsx(StyledHeading, __spreadProps(__spreadValues({}, rest), {
        children
      }));
    return /* @__PURE__ */ jsxRuntime.jsx(StyledHeading, __spreadProps(__spreadValues({}, rest), {
      dangerouslySetInnerHTML: {
        __html: formattedText
      }
    }));
  };
  const heading = renderHeading();
  if (!enabled)
    return /* @__PURE__ */ jsxRuntime.jsx(index.Link, __spreadProps(__spreadValues({}, link), {
      children: heading
    }));
  return heading;
};
const StyledHeading = styled__default["default"].div(
  ({ commonStyle }) => `
    ${coreRenderer.getStyle(commonStyle)}
    ${fonts.getCommonTextCss(true)}
  `,
  `a {
    color: inherit;
  }`
);
Heading.displayName = "Heading";

exports.Heading = Heading;
exports.StyledHeading = StyledHeading;


/***/ }),

/***/ 53590:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const HtmlCode = (_a) => {
  var _b = _a, { htmlCode, commonStyle } = _b, rest = __objRest(_b, ["htmlCode", "commonStyle"]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
    commonStyle
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsx("div", {
      dangerouslySetInnerHTML: {
        __html: htmlCode
      }
    })
  }));
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
`
);
HtmlCode.displayName = "HtmlCode";

exports.HtmlCode = HtmlCode;


/***/ }),

/***/ 80768:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var styled = __webpack_require__(21483);
var getIconComponent = __webpack_require__(35010);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PbIcon = (props) => {
  const _a = props, { commonStyle } = _a, rest = __objRest(_a, ["commonStyle"]);
  const IconComponent = getIconComponent.getIconCompoment(rest);
  return /* @__PURE__ */ jsxRuntime.jsx(IconWrapper, __spreadProps(__spreadValues({
    commonStyle
  }, rest), {
    children: IconComponent
  }));
};
const IconWrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)};
  > svg {
    display: inline-block;
  }
`
);
PbIcon.displayName = "Icon";

exports.PbIcon = PbIcon;


/***/ }),

/***/ 49864:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ImageWrapper = styled__default["default"].div(
  ({ alignment }) => `
  text-align: ${alignment};
`
);
const Image = (props) => {
  return /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues({}, props));
};
Image.displayName = "Image";

exports.Image = Image;
exports.ImageWrapper = ImageWrapper;


/***/ }),

/***/ 70045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(91987);

const ListItemContext = React.createContext({});

exports.ListItemContext = ListItemContext;


/***/ }),

/***/ 97863:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var fonts = __webpack_require__(74367);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledContent = styled__default["default"].div(
  ({ commonStyle }) => `
    ${coreRenderer.getStyle(commonStyle)}
    ${fonts.getCommonTextCss(true)}
  `
);
const ListItemContentV2 = React__default["default"].forwardRef((props, ref) => {
  const _a = props, { text, children } = _a, rest = __objRest(_a, ["text", "children"]);
  if (!!children) {
    return /* @__PURE__ */ jsxRuntime.jsx(StyledContent, __spreadProps(__spreadValues({
      ref
    }, rest), {
      children
    }));
  }
  return /* @__PURE__ */ jsxRuntime.jsx(StyledContent, __spreadProps(__spreadValues({
    ref
  }, rest), {
    dangerouslySetInnerHTML: { __html: text }
  }));
});
ListItemContentV2.displayName = "ListItemContentV2";

exports.ListItemContentV2 = ListItemContentV2;
exports.StyledContent = StyledContent;


/***/ }),

/***/ 68248:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var index = __webpack_require__(5502);
var context = __webpack_require__(70045);
var getIconComponent = __webpack_require__(35010);
var index$1 = __webpack_require__(43866);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const StyledIcon = styled__default["default"].div(
  ({ commonStyle, iconStyle }) => `
  display: flex;
  ${coreRenderer.getStyle(iconStyle)}
  ${coreRenderer.getStyle(commonStyle)}
`
);
const ListItemIconV2 = React__default["default"].forwardRef((props, ref) => {
  const { commonStyle, event, icon, position } = props;
  const { iconConfig, iconStyle } = React.useContext(context.ListItemContext);
  const GlobalIcon = getIconComponent.getIconCompoment(iconConfig == null ? void 0 : iconConfig.icon);
  const IconComponent = getIconComponent.getIconCompoment(icon);
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      position === index.Position.behind && /* @__PURE__ */ jsxRuntime.jsx("div", {
        style: { width: iconConfig.spacing }
      }),
      /* @__PURE__ */ jsxRuntime.jsx(StyledIcon, {
        ref,
        commonStyle,
        iconStyle,
        children: /* @__PURE__ */ jsxRuntime.jsx(index$1.Link, __spreadProps(__spreadValues({}, event), {
          children: IconComponent || GlobalIcon
        }))
      }),
      position === index.Position.front && /* @__PURE__ */ jsxRuntime.jsx("div", {
        style: { width: iconConfig.spacing }
      })
    ]
  });
});
ListItemIconV2.displayName = "ListItemIconV2";

exports.ListItemIconV2 = ListItemIconV2;


/***/ }),

/***/ 46530:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var context = __webpack_require__(70045);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListItemV2 = React__default["default"].forwardRef(
  (_a, ref) => {
    var _b = _a, { children, commonStyle } = _b, rest = __objRest(_b, ["children", "commonStyle"]);
    const { iconConfig, iconStyle } = rest;
    return /* @__PURE__ */ jsxRuntime.jsx(context.ListItemContext.Provider, {
      value: {
        iconConfig,
        iconStyle
      },
      children: /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
        ref,
        commonStyle
      }, rest), {
        children
      }))
    });
  }
);
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
    display: flex;
    ${coreRenderer.getStyle(commonStyle)}
`
);
ListItemV2.displayName = "ListItemV2";

exports.ListItemV2 = ListItemV2;


/***/ }),

/***/ 35751:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var ERROR_CODES = /* @__PURE__ */ ((ERROR_CODES2) => {
  ERROR_CODES2[ERROR_CODES2["OUT_OF_TURN"] = 400018] = "OUT_OF_TURN";
  ERROR_CODES2[ERROR_CODES2["OUT_OF_PRIZE"] = 400020] = "OUT_OF_PRIZE";
  return ERROR_CODES2;
})(ERROR_CODES || {});
const DEFAULT_LUCKY_DRAW_V2 = {
  id: null,
  backgroundColors: [
    "#ff7491",
    "#2ff3cf",
    "#2bb5fe",
    "#f5ea3a",
    "#bfeefc",
    "#ec4c4c",
    "#019ade",
    "#00cc6b",
    "#cc33ff",
    "#90e228",
    "#7e4bff",
    "#ffc502"
  ],
  prizeAngle: 90,
  spinDuration: 1,
  textColors: ["white"],
  canvasConfig: {
    innerRadius: 0,
    fontSize: 17,
    radiusLineColor: "#eeeeee",
    radiusLineWidth: 0,
    perpendicularPrize: true,
    textDistance: 60,
    border: {
      innerBorderColor: "#ffffff",
      innerBorderWidth: 0,
      outerBorderColor: "#ffffff",
      outerBorderWidth: -10,
      image: {
        src: "https://lh3.googleusercontent.com/SVu3oUkfvSqHso_2nPT7ZV-tbkcXohRGK73XK-0RAieqjpVzvahMB_sNerbsD9z-RU9YgVEQz8OvJDPC2FX2xz-u5tK8Vpcw"
      }
    }
  },
  spinTrigger: {
    text: "Spin",
    buttonStyle: {
      backgroundColor: "#ff4646",
      borderColor: "#328ed9",
      borderWidth: 6,
      color: "#ffffff",
      fontSize: "1.5em",
      fontWeight: "bold",
      hover: {
        zoom: 105
      }
    },
    image: {
      src: "https://lh3.googleusercontent.com/r5nZppsbH9EsI9GdyNqXFH19lto88WhhL2XL1Juexc9sElHTLXUWx-8HkHwMwsoe6rpVe3R3m2gR6fC10yMJ7s8U4mBgaW4"
    },
    imageStyle: {
      hover: {
        zoom: 110
      }
    }
  },
  roulette: {
    rotate: 90,
    color: "#328ed9",
    size: 40
  }
};
const DEFAULT_POPUP_PRIZE_V2 = (popupName) => ({
  ".dp27jtsb": {
    id: ".dp27jtsb",
    elementId: "7PhZ7Orijk",
    parentId: "ROOT",
    tag: "popupv1",
    resolvedName: "PopupEditorV1",
    style: {
      width: 400,
      backgroundColor: "#fff",
      padding: {
        left: 24,
        right: 24,
        bottom: 24,
        top: 0
      },
      borderRadius: 24,
      borderColor: "#ff5722ff"
    },
    isActive: false,
    isCanvas: true,
    customAttributes: {
      popupv1: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        maskClosable: true,
        maskStyle: {
          backgroundColor: "rgba(0, 0, 0, 0.1)"
        },
        position: "default",
        name: popupName,
        showCloseIcon: true
      }
    },
    children: [
      ".wmmjc6p0",
      ".t3o9bcjz",
      ".xl9nmif2",
      ".ishc5gft",
      ".likgxefm",
      ".ar9360ca"
    ]
  },
  ".wmmjc6p0": {
    id: ".wmmjc6p0",
    parentId: ".dp27jtsb",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  ".t3o9bcjz": {
    id: ".t3o9bcjz",
    parentId: ".dp27jtsb",
    tag: "image",
    resolvedName: "ImageEditor",
    style: {
      width: 60,
      widthUnit: "%",
      height: 100,
      heightUnit: "%"
    },
    isActive: false,
    isCanvas: false,
    customAttributes: {
      image: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        src: "https://lh3.googleusercontent.com/TCygQ0UckARy2xGqh3lBAcEJLpEbCRdjqvk4OnuOm5FVWchbXgFNFI_WgOoparnjX0xkQ_fK5W3qNHQVEXY3Xliqm62CADPUfA",
        googleImageParams: {
          percent: 100,
          width: 1088
        }
      }
    },
    children: []
  },
  ".xl9nmif2": {
    id: ".xl9nmif2",
    parentId: ".dp27jtsb",
    tag: "image",
    resolvedName: "ImageEditor",
    style: {
      width: 75,
      widthUnit: "%",
      height: 100,
      heightUnit: "%"
    },
    isActive: false,
    isCanvas: false,
    customAttributes: {
      image: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        src: "https://lh3.googleusercontent.com/dMzPbBXMFw4WUKWqtdw0wxFvRxXuoVQwsJH6iQg4nx-CDzLynOTPao3qLnT7926_UDIOrzdhdKx41DuTMf1luoMIAuyQ3UuyTQ",
        googleImageParams: {
          percent: 100,
          width: 1053
        }
      }
    },
    children: []
  },
  ".ishc5gft": {
    id: ".ishc5gft",
    parentId: ".dp27jtsb",
    tag: "heading",
    resolvedName: "HeadingEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      heading: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        text: '<h2 style="text-align: center; font-family: Quicksand"><strong><span style="font-size: 24px; color: rgb(27, 29, 41); background-color: rgb(255, 255, 255); font-weight: 700; text-transform: none">{{name}}</span></strong></h2>'
      }
    },
    children: []
  },
  ".likgxefm": {
    id: ".likgxefm",
    parentId: ".dp27jtsb",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  ".ar9360ca": {
    id: ".ar9360ca",
    parentId: ".dp27jtsb",
    tag: "heading",
    resolvedName: "HeadingEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      heading: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        text: '<h6 style="text-align: center; font-size: 16px; font-family: Quicksand"><strong><span style="color: rgb(67, 70, 87); font-weight: 400">Ch\xFAc m\u1EEBng b\u1EA1n \u0111\xE3 nh\u1EADn \u0111\u01B0\u1EE3c ph\u1EA7n qu\xE0 {{name}}!</span></strong></h6>'
      }
    },
    children: []
  },
  "83EW4j2go1": {
    id: "83EW4j2go1",
    parentId: "ROOT",
    tag: "section",
    resolvedName: "RowEditor",
    style: {
      padding: {
        top: 8,
        bottom: 8,
        left: 16,
        right: 16
      },
      maxWidth: 1232,
      margin: {
        bottom: 1e3
      }
    },
    isActive: false,
    isCanvas: true,
    customAttributes: {
      section: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        gutter: [0, 0],
        widthType: "fixed"
      }
    },
    children: ["tvXFs-v-ux"]
  },
  "tvXFs-v-ux": {
    id: "tvXFs-v-ux",
    parentId: "83EW4j2go1",
    tag: "col",
    resolvedName: "ColEditor",
    style: {
      padding: {
        left: 15,
        top: 5,
        bottom: 5,
        right: 15
      }
    },
    isActive: false,
    isCanvas: true,
    customAttributes: {
      col: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        md: {
          flex: "100%"
        },
        xs: {
          flex: "100%"
        }
      }
    },
    children: []
  }
});
const DEFAULT_POPUP_OUT_OF_MOVE_V2 = (popupName) => ({
  ".xgukw6ne": {
    id: ".xgukw6ne",
    elementId: "7PhZ7Orijk",
    parentId: "ROOT",
    tag: "popupv1",
    resolvedName: "PopupEditorV1",
    style: {
      width: 400,
      height: 200,
      backgroundColor: "#fff",
      padding: {
        left: 24,
        right: 24,
        bottom: 24,
        top: 0
      },
      borderRadius: 24,
      borderColor: "#ff5722ff"
    },
    isActive: false,
    isCanvas: true,
    customAttributes: {
      popupv1: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        maskClosable: true,
        maskStyle: {
          backgroundColor: "rgba(0, 0, 0, 0.1)"
        },
        position: "default",
        name: popupName,
        showCloseIcon: true
      }
    },
    children: [
      ".k85i8qdw",
      ".g7ef9s9p",
      ".lvhq4cof",
      ".1gmmca8b",
      ".gqixp832",
      ".vrduzqmv"
    ]
  },
  ".k85i8qdw": {
    id: ".k85i8qdw",
    parentId: ".xgukw6ne",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  ".g7ef9s9p": {
    id: ".g7ef9s9p",
    parentId: ".xgukw6ne",
    tag: "image",
    resolvedName: "ImageEditor",
    style: {
      width: 60,
      widthUnit: "%",
      height: 100,
      heightUnit: "%",
      margin: {
        top: 0,
        bottom: 0,
        right: 0,
        left: 0
      }
    },
    isActive: false,
    isCanvas: false,
    customAttributes: {
      image: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        src: "https://lh3.googleusercontent.com/B8UCNG5G1RPLbQ4ytQDyUIKOAIEgZKtDSKhlQloAcQB7Xak1Xfv6wnPWfXmdVuNb6w9Zn8krUlixTa_F3z7HOUnyiT6e3fZL",
        googleImageParams: {
          percent: 100,
          width: 1088
        }
      }
    },
    children: []
  },
  ".lvhq4cof": {
    id: ".lvhq4cof",
    parentId: ".xgukw6ne",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  ".1gmmca8b": {
    id: ".1gmmca8b",
    parentId: ".xgukw6ne",
    tag: "heading",
    resolvedName: "HeadingEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      heading: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        text: '<h2 style="text-align: center; font-family: Quicksand"><strong><span style="font-size: 24px; color: rgb(27, 29, 41); background-color: rgb(255, 255, 255); font-weight: 700; text-transform: none">B\u1EA1n \u0111\xE3 h\u1EBFt l\u01B0\u1EE3t quay!</span></strong></h2>'
      }
    },
    children: []
  },
  ".gqixp832": {
    id: ".gqixp832",
    parentId: ".xgukw6ne",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  ".vrduzqmv": {
    id: ".vrduzqmv",
    parentId: ".xgukw6ne",
    tag: "heading",
    resolvedName: "HeadingEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      heading: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        text: '<h6 style="text-align: center; font-size: 16px; font-family: Quicksand"><strong><span style="color: rgb(67, 70, 87); font-weight: 400">Vui l\xF2ng th\u1EED l\u1EA1i sau nh\xE9</span></strong></h6>'
      }
    },
    children: []
  }
});
const DEFAULT_POPUP_OUT_OF_PRIZE_V2 = (popupName) => ({
  BraTGniUhP: {
    id: "BraTGniUhP",
    parentId: "7PhZ7Orijk",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  hZJ3PSQWs3: {
    id: "hZJ3PSQWs3",
    parentId: "7PhZ7Orijk",
    tag: "image",
    resolvedName: "ImageEditor",
    style: {
      width: 60,
      widthUnit: "%",
      height: 100,
      heightUnit: "%",
      margin: {
        top: 0,
        bottom: 0,
        right: 0,
        left: 0
      }
    },
    isActive: false,
    isCanvas: false,
    customAttributes: {
      image: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        src: "https://lh3.googleusercontent.com/B8UCNG5G1RPLbQ4ytQDyUIKOAIEgZKtDSKhlQloAcQB7Xak1Xfv6wnPWfXmdVuNb6w9Zn8krUlixTa_F3z7HOUnyiT6e3fZL",
        googleImageParams: {
          percent: 100,
          width: 1088
        }
      }
    },
    children: []
  },
  ".wuwrv13b": {
    id: ".wuwrv13b",
    parentId: "7PhZ7Orijk",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  UeMBzuDA2c: {
    id: "UeMBzuDA2c",
    parentId: "7PhZ7Orijk",
    tag: "heading",
    resolvedName: "HeadingEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      heading: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        text: '<h2 style="text-align: center; font-family: Quicksand"><strong><span style="font-size: 24px; color: rgb(27, 29, 41); background-color: rgb(255, 255, 255); font-weight: 700; text-transform: none">R\u1EA5t ti\u1EBFc, qu\xE0 \u0111\xE3 h\u1EBFt!</span></strong></h2>'
      }
    },
    children: []
  },
  ".cyapx8b1": {
    id: ".cyapx8b1",
    parentId: "7PhZ7Orijk",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  ".vt2iwmb0": {
    id: ".vt2iwmb0",
    parentId: "7PhZ7Orijk",
    tag: "heading",
    resolvedName: "HeadingEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      heading: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        text: '<h6 style="text-align: center; font-size: 16px; font-family: Quicksand"><strong><span style="color: rgb(67, 70, 87); font-weight: 400">Vui l\xF2ng th\u1EED l\u1EA1i sau nh\xE9</span></strong></h6>'
      }
    },
    children: []
  },
  "7PhZ7Orijk": {
    id: "7PhZ7Orijk",
    elementId: "7PhZ7Orijk",
    parentId: "ROOT",
    tag: "popupv1",
    resolvedName: "PopupEditorV1",
    style: {
      width: 400,
      height: 200,
      backgroundColor: "#fff",
      padding: {
        left: 24,
        right: 24,
        bottom: 24,
        top: 0
      },
      borderRadius: 24,
      borderColor: "#ff5722ff"
    },
    isActive: false,
    isCanvas: true,
    customAttributes: {
      popupv1: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        maskClosable: true,
        maskStyle: {
          backgroundColor: "rgba(0, 0, 0, 0.1)"
        },
        position: "default",
        name: popupName,
        showCloseIcon: true
      }
    },
    children: [
      "BraTGniUhP",
      "hZJ3PSQWs3",
      ".wuwrv13b",
      "UeMBzuDA2c",
      ".cyapx8b1",
      ".vt2iwmb0"
    ]
  }
});

exports.DEFAULT_LUCKY_DRAW_V2 = DEFAULT_LUCKY_DRAW_V2;
exports.DEFAULT_POPUP_OUT_OF_MOVE_V2 = DEFAULT_POPUP_OUT_OF_MOVE_V2;
exports.DEFAULT_POPUP_OUT_OF_PRIZE_V2 = DEFAULT_POPUP_OUT_OF_PRIZE_V2;
exports.DEFAULT_POPUP_PRIZE_V2 = DEFAULT_POPUP_PRIZE_V2;
exports.ERROR_CODES = ERROR_CODES;


/***/ }),

/***/ 51030:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const PercentageWarning = ({
  totalPercentage = 100
}) => {
  if (totalPercentage === 100)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Content, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "InforOutlined",
          style: { fontSize: 40 }
        }),
        /* @__PURE__ */ jsxRuntime.jsx("div", {
          children: "T\u1ED5ng x\xE1c xu\u1EA5t r\u01A1i qu\xE0 ph\u1EA3i b\u1EB1ng 100%."
        }),
        /* @__PURE__ */ jsxRuntime.jsxs("div", {
          children: [
            "T\u1ED5ng x\xE1c xu\u1EA5t hi\u1EC7n t\u1EA1i: ",
            totalPercentage,
            "%"
          ]
        })
      ]
    })
  });
};
const Wrapper = styled__default["default"].div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  place-items: center;
`;
const Content = styled__default["default"].div`
  color: #e6983a;
  width: 304px;
  background-color: #fffbf5;
  text-align: center;
  border-radius: 8px;
  padding: 8px 12px;
`;

exports.PercentageWarning = PercentageWarning;


/***/ }),

/***/ 54686:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { rouletteImage } = coreRenderer.mappingAssets;
const Roulette = ({
  image,
  prizeAngle = 90,
  rotate = 90
}) => {
  const _a = image || {}, { src, googleImageParams } = _a, restImage = __objRest(_a, ["src", "googleImageParams"]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    prizeAngle,
    children: /* @__PURE__ */ jsxRuntime.jsx(RouletteImage, __spreadProps(__spreadValues({
      rotate
    }, restImage), {
      src: coreRenderer.getImageUrlFromGoogleUserContent(src, googleImageParams) || rouletteImage,
      loading: "lazy"
    }))
  });
};
const RouletteImage = styled__default["default"].img(({ rotate }) => {
  return `
    position: absolute;
    right: 0;
    top: calc(50%);
    width: 12%;
    transform: translateY(-50%) rotate(${rotate}deg);
    `;
});
const Wrapper = styled__default["default"].div(
  ({ prizeAngle }) => `
  width: 100%;
  height: 100%;
  transform: rotate(${360 - prizeAngle}deg)
`
);

exports.Roulette = Roulette;


/***/ }),

/***/ 99154:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const SpinBorder = ({ image }) => {
  const { src, googleImageParams } = image || {};
  if (!src)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(StyledBorderImage, __spreadProps(__spreadValues({
    alt: ""
  }, image), {
    src: coreRenderer.getImageUrlFromGoogleUserContent(src, googleImageParams),
    loading: "lazy"
  }));
};
const StyledBorderImage = styled__default["default"].img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

exports.SpinBorder = SpinBorder;


/***/ }),

/***/ 34855:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var styledComponents = __webpack_require__(90305);
var SpinningInner = __webpack_require__(70411);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { spinTriggerImage: spinTrigger } = coreRenderer.mappingAssets;
const SpinTrigger = ({
  disabled = false,
  height = 80,
  width = 80,
  imageStyle,
  image,
  loading,
  onStartSpinning
}) => {
  const _a = image || {}, { src, googleImageParams } = _a, restImage = __objRest(_a, ["src", "googleImageParams"]);
  if (disabled)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: loading ? /* @__PURE__ */ jsxRuntime.jsx(SpinTriggerWrapper, {
      width: 60,
      height: 60,
      children: /* @__PURE__ */ jsxRuntime.jsx(SpinningInner.StyledSpinningInner, {
        size: 60,
        transform: 30,
        color: "white"
      })
    }) : /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: /* @__PURE__ */ jsxRuntime.jsx(SpinTriggerWrapper, {
        width,
        height,
        children: /* @__PURE__ */ jsxRuntime.jsx(SpinImg, __spreadProps(__spreadValues({}, restImage), {
          src: coreRenderer.getImageUrlFromGoogleUserContent(src, googleImageParams) || spinTrigger,
          onClick: onStartSpinning,
          imageStyle,
          alt: ""
        }))
      })
    })
  });
};
const SpinTriggerWrapper = styled__default["default"].div(
  ({ width, height }) => `
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: ${width}px;
height: ${height}px;
max-width: 25%;
max-height: 25%;
`
);
const SpinImg = styled__default["default"](styledComponents.NonDraggableImage)(
  ({ imageStyle }) => `
cursor: pointer;
transition: 0.3s all;
width: 100%;

${coreRenderer.getStyle(imageStyle)}
`
);

exports.SpinTrigger = SpinTrigger;


/***/ }),

/***/ 75291:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var strings = __webpack_require__(64311);
var utils = __webpack_require__(10661);
var WheelCanvas = __webpack_require__(84976);
var Roulette = __webpack_require__(54686);
var SpinBorder = __webpack_require__(99154);
var SpinTrigger = __webpack_require__(34855);
var styles = __webpack_require__(97178);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const STARTED_SPINNING = "started-spinning";
const START_SPINNING_TIME = 2600;
const CONTINUE_SPINNING_TIME = 750;
const STOP_SPINNING_TIME = 8e3;
const Wheel = ({
  mustStartSpinning,
  prizeNumber,
  items = [],
  onStartSpinning = () => null,
  onStopSpinning = () => null,
  backgroundColors = strings.DEFAULT_BACKGROUND_COLORS,
  textColors = strings.DEFAULT_TEXT_COLORS,
  spinDuration = strings.DEFAULT_SPIN_DURATION,
  prizeAngle = strings.DEFAULT_PRIZE_ANGLE,
  spinTrigger,
  roulette,
  canvasConfig,
  loading = false
}) => {
  var _a;
  const [wheelData, setWheelData] = React.useState([...items]);
  const [startRotationDegrees, setStartRotationDegrees] = React.useState(0);
  const [finalRotationDegrees, setFinalRotationDegrees] = React.useState(0);
  const [hasStartedSpinning, setHasStartedSpinning] = React.useState(false);
  const [hasStoppedSpinning, setHasStoppedSpinning] = React.useState(false);
  const [isCurrentlySpinning, setIsCurrentlySpinning] = React.useState(false);
  const [isDataUpdated, setIsDataUpdated] = React.useState(false);
  const [classKey] = React.useState(utils.makeClassKey(5));
  const normalizedSpinDuration = Math.max(0.01, spinDuration);
  const startSpinningTime = START_SPINNING_TIME * normalizedSpinDuration;
  const continueSpinningTime = CONTINUE_SPINNING_TIME * normalizedSpinDuration;
  const stopSpinningTime = STOP_SPINNING_TIME * normalizedSpinDuration;
  const totalSpinningTime = startSpinningTime + continueSpinningTime + stopSpinningTime;
  const mustStopSpinning = React.useRef(false);
  React.useEffect(() => {
    var _a2, _b;
    const dataLength = items.length;
    const wheelDataAux = [{ name: "" }];
    for (let i = 0; i < dataLength; i++) {
      wheelDataAux[i] = __spreadProps(__spreadValues({}, items[i]), {
        style: {
          backgroundColor: ((_a2 = items[i].style) == null ? void 0 : _a2.backgroundColor) || backgroundColors[i % backgroundColors.length],
          textColor: ((_b = items[i].style) == null ? void 0 : _b.textColor) || textColors[i % textColors.length]
        }
      });
    }
    setWheelData([...wheelDataAux]);
    setIsDataUpdated(true);
  }, [items, backgroundColors, textColors]);
  React.useEffect(() => {
    if (mustStartSpinning && !isCurrentlySpinning) {
      setIsCurrentlySpinning(true);
      startSpinning();
      const finalRotationDegreesCalculated = utils.getRotationDegrees(
        prizeNumber,
        items.length,
        prizeAngle
      );
      setFinalRotationDegrees(finalRotationDegreesCalculated);
    }
  }, [mustStartSpinning]);
  React.useEffect(() => {
    if (hasStoppedSpinning) {
      setIsCurrentlySpinning(false);
      setStartRotationDegrees(finalRotationDegrees);
    }
  }, [hasStoppedSpinning]);
  const startSpinning = () => {
    setHasStartedSpinning(true);
    setHasStoppedSpinning(false);
    mustStopSpinning.current = true;
    setTimeout(() => {
      if (mustStopSpinning.current) {
        mustStopSpinning.current = false;
        setHasStartedSpinning(false);
        setHasStoppedSpinning(true);
        onStopSpinning();
      }
    }, totalSpinningTime);
  };
  const getRouletteClass = () => {
    if (hasStartedSpinning) {
      return STARTED_SPINNING;
    }
    return "";
  };
  if (!isDataUpdated) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntime.jsxs(styles.RouletteContainer, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(styles.RotationContainer, {
        className: getRouletteClass(),
        startSpinningTime,
        continueSpinningTime,
        stopSpinningTime,
        startRotationDegrees,
        finalRotationDegrees,
        classKey,
        children: /* @__PURE__ */ jsxRuntime.jsx(WheelCanvas, __spreadValues({
          width: "900",
          height: "900",
          items: wheelData
        }, canvasConfig))
      }),
      /* @__PURE__ */ jsxRuntime.jsx(SpinBorder.SpinBorder, {
        image: (_a = canvasConfig == null ? void 0 : canvasConfig.border) == null ? void 0 : _a.image
      }),
      /* @__PURE__ */ jsxRuntime.jsx(Roulette.Roulette, __spreadValues({
        prizeAngle
      }, roulette)),
      /* @__PURE__ */ jsxRuntime.jsx(SpinTrigger.SpinTrigger, __spreadProps(__spreadValues({
        onStartSpinning
      }, spinTrigger), {
        loading
      }))
    ]
  });
};

exports.Wheel = Wheel;


/***/ }),

/***/ 97178:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);
var styledComponents = __webpack_require__(90305);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const RouletteContainer = styled__default["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: inline-block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  flex-shrink: 0;
`;
const RotationContainer = styled__default["default"].div(
  ({
    startSpinningTime,
    startRotationDegrees,
    continueSpinningTime,
    stopSpinningTime,
    finalRotationDegrees,
    classKey
  }) => `
  position: absolute;
  width: 100%;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(${startRotationDegrees}deg);
  pointer-events: none;
  border-radius: 50%;
  overflow: hidden;

  &.started-spinning {
    animation: spin-${classKey} ${startSpinningTime / 1e3}s
        cubic-bezier(0.71, -0.29, 0.96, 0.9) 0s 1 normal forwards running,
      continueSpin-${classKey}
        ${continueSpinningTime / 1e3}s
        linear ${startSpinningTime / 1e3}s 1
        normal forwards running,
      stopSpin-${classKey} ${stopSpinningTime / 1e3}s
        cubic-bezier(0, 0, 0.35, 1.02)
        ${(startSpinningTime + continueSpinningTime) / 1e3}s
        1 normal forwards running;
  }

  @keyframes spin-${classKey} {
    from {
      transform: rotate(${startRotationDegrees}deg);
    }
    to {
      transform: rotate(${startRotationDegrees + 360}deg);
    }
  }
  @keyframes continueSpin-${classKey} {
    from {
      transform: rotate(${startRotationDegrees}deg);
    }
    to {
      transform: rotate(${startRotationDegrees + 360}deg);
    }
  }
  @keyframes stopSpin-${classKey} {
    from {
      transform: rotate(${startRotationDegrees}deg);
    }
    to {
      transform: rotate(
        ${1440 + finalRotationDegrees}deg
      );
    }
  }
`
);
styled__default["default"](styledComponents.NonDraggableImage)`
  position: absolute;
  z-index: 5;
  width: 17%;
  right: 6px;
  top: 15px;
`;

exports.RotationContainer = RotationContainer;
exports.RouletteContainer = RouletteContainer;


/***/ }),

/***/ 84976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var utils = __webpack_require__(10661);
var styles = __webpack_require__(17769);

const getImage = async (url) => new Promise(function(resolve) {
  const img = new Image();
  img.onload = function() {
    resolve(img);
  };
  img.src = url;
});
const drawWheel = async (canvasRef, items, config) => {
  var _a, _b, _c, _d;
  const QUANTITY = items.length;
  let {
    innerRadius,
    radiusLineColor,
    radiusLineWidth,
    fontSize,
    perpendicularPrize,
    textDistance,
    background
  } = config;
  fontSize *= 2;
  const canvas = canvasRef.current;
  if (canvas == null ? void 0 : canvas.getContext("2d")) {
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, 500, 500);
    ctx.strokeStyle = "transparent";
    ctx.lineWidth = 0;
    const arc = Math.PI / (QUANTITY / 2);
    const startAngle = 0;
    const outsideRadius = canvas.width / 2 - 10;
    const clampedTextDistance = utils.clamp(0, 100, textDistance);
    const textRadius = outsideRadius * clampedTextDistance / 100;
    const clampedInsideRadius = utils.clamp(0, 100, innerRadius);
    const insideRadius = outsideRadius * clampedInsideRadius / 100;
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const DEFAULT_PRIZE_IMAGE_WIDTH = 150;
    ctx.font = `bold ${fontSize}px Helvetica, Arial`;
    ctx.beginPath();
    ctx.arc(centerX, centerY, canvas.width / 2 - 32, 0, 360, false);
    ctx.fillStyle = "#ff6666";
    ctx.fill();
    if ((_a = background == null ? void 0 : background.image) == null ? void 0 : _a.src) {
      const bgImage = await getImage(
        coreRenderer.getImageUrlFromGoogleUserContent(
          background.image.src,
          background.image.googleImageParams
        )
      );
      const isRotate = (background == null ? void 0 : background.rotate) !== null;
      const size = utils.calculateImageSize(
        bgImage.width,
        bgImage.height,
        null,
        canvas.width
      );
      ctx.translate(centerX, centerY);
      if (isRotate) {
        ctx.rotate(background.rotate * Math.PI / 180);
      }
      ctx.drawImage(
        bgImage,
        -size.width / 2,
        -size.height / 2,
        size.width,
        size.height
      );
      if (isRotate) {
        ctx.rotate(-(background.rotate * Math.PI) / 180);
      }
      ctx.translate(-centerX, -centerY);
    }
    const isImageBackground = !!((_b = background == null ? void 0 : background.image) == null ? void 0 : _b.src);
    for (let i = 0; i < items.length; i++) {
      const angle = startAngle + i * arc;
      const { style } = items[i];
      ctx.fillStyle = style && style.backgroundColor;
      if (!isImageBackground) {
        ctx.beginPath();
        ctx.arc(centerX, centerY, outsideRadius, angle, angle + arc, false);
        ctx.arc(centerX, centerY, insideRadius, angle + arc, angle, true);
        ctx.stroke();
        ctx.fill();
      }
      ctx.save();
      if (!isImageBackground) {
        ctx.strokeStyle = radiusLineWidth <= 0 ? "transparent" : radiusLineColor;
        ctx.lineWidth = radiusLineWidth;
        for (let j = 0; j < items.length; j++) {
          const radiusAngle = startAngle + j * arc;
          ctx.beginPath();
          ctx.moveTo(
            centerX + (insideRadius + 1) * Math.cos(radiusAngle),
            centerY + (insideRadius + 1) * Math.sin(radiusAngle)
          );
          ctx.lineTo(
            centerX + (outsideRadius - 1) * Math.cos(radiusAngle),
            centerY + (outsideRadius - 1) * Math.sin(radiusAngle)
          );
          ctx.closePath();
          ctx.stroke();
        }
      }
      ctx.fillStyle = style && style.textColor;
      ctx.translate(
        centerX + Math.cos(angle + arc / 2) * textRadius,
        centerY + Math.sin(angle + arc / 2) * textRadius
      );
      const text = items[i].name;
      const imgSrc = (_c = items[i].image) == null ? void 0 : _c.src;
      const imgWidth = (_d = items[i].image) == null ? void 0 : _d.width;
      const textRotationAngle = perpendicularPrize ? angle + arc / 2 + Math.PI / 2 : angle + arc / 2;
      ctx.rotate(textRotationAngle);
      if (imgSrc) {
        const img = new Image();
        img.src = imgSrc;
        img.onload = function() {
          const { width, height } = utils.calculateImageSize(
            img.width,
            img.height,
            imgWidth,
            DEFAULT_PRIZE_IMAGE_WIDTH
          );
          const x = centerX + Math.cos(angle + arc / 2) * textRadius;
          const y = centerY + Math.sin(angle + arc / 2) * textRadius;
          ctx.translate(x, y);
          ctx.rotate(textRotationAngle);
          ctx.drawImage(img, -width / 2, -height / 2, width, height);
          ctx.rotate(-textRotationAngle);
          ctx.translate(-x, -y);
        };
      } else {
        ctx.fillText(text, -ctx.measureText(text).width / 2, fontSize / 2.7);
      }
      ctx.restore();
    }
  }
};
const redraw = (canvasRef, items, config) => {
  const canvas = canvasRef.current;
  if (canvas == null ? void 0 : canvas.getContext("2d")) {
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawWheel(canvasRef, items, config);
  }
};
const WheelCanvas = (props) => {
  const canvasRef = React.createRef();
  const {
    items,
    width,
    height,
    fontSize,
    innerRadius,
    perpendicularPrize,
    radiusLineColor,
    radiusLineWidth,
    textDistance,
    background,
    border
  } = props;
  React.useEffect(() => {
    drawWheel(canvasRef, items, props);
  }, [
    items,
    fontSize,
    border,
    innerRadius,
    perpendicularPrize,
    radiusLineColor,
    radiusLineWidth,
    textDistance,
    width,
    height
  ]);
  React.useEffect(() => {
    redraw(canvasRef, items, props);
  }, [background, items]);
  return /* @__PURE__ */ jsxRuntime.jsx(styles.WheelCanvasStyle, {
    ref: canvasRef,
    width,
    height
  });
};
var WheelCanvas$1 = WheelCanvas;

module.exports = WheelCanvas$1;


/***/ }),

/***/ 17769:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const WheelCanvasStyle = styled__default["default"].canvas`
  width: 98%;
  height: 98%;
`;

exports.WheelCanvasStyle = WheelCanvasStyle;


/***/ }),

/***/ 90305:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const NonDraggableImage = styled__default["default"].img`
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
`;

exports.NonDraggableImage = NonDraggableImage;


/***/ }),

/***/ 64311:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const DEFAULT_BACKGROUND_COLORS = ["darkgrey", "lightgrey"];
const DEFAULT_TEXT_COLORS = ["black"];
const DEFAULT_SPIN_DURATION = 1;
const DEFAULT_PRIZE_ANGLE = 90;

exports.DEFAULT_BACKGROUND_COLORS = DEFAULT_BACKGROUND_COLORS;
exports.DEFAULT_PRIZE_ANGLE = DEFAULT_PRIZE_ANGLE;
exports.DEFAULT_SPIN_DURATION = DEFAULT_SPIN_DURATION;
exports.DEFAULT_TEXT_COLORS = DEFAULT_TEXT_COLORS;


/***/ }),

/***/ 10661:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const getRotationDegrees = (prizeNumber, numberOfPrizes, prizeAngle) => {
  const degreesPerPrize = 360 / numberOfPrizes;
  const initialRotation = prizeAngle + degreesPerPrize / 2;
  const randomDifference = (-1 + Math.random() * 2) * degreesPerPrize * 0.35;
  const prizeRotation = degreesPerPrize * (numberOfPrizes - prizeNumber) - initialRotation + randomDifference;
  return numberOfPrizes - prizeNumber > numberOfPrizes / 2 ? -360 + prizeRotation : prizeRotation;
};
const clamp = (min, max, val) => Math.min(Math.max(min, +val), max);
const calculateImageSize = (width, height, newWidth, defaultWidth) => {
  if (!width || !height)
    return;
  const ratio = width / height;
  const calcWidth = newWidth || defaultWidth;
  const calcHeight = calcWidth / ratio;
  return { width: calcWidth, height: calcHeight };
};
const makeClassKey = (length) => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

exports.calculateImageSize = calculateImageSize;
exports.clamp = clamp;
exports.getRotationDegrees = getRotationDegrees;
exports.makeClassKey = makeClassKey;


/***/ }),

/***/ 1642:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);
var get = __webpack_require__(47248);
var React = __webpack_require__(91987);
var constants = __webpack_require__(35751);
var getPartialDateTimeTimeZone7 = __webpack_require__(81700);
var queryStringToObject = __webpack_require__(39217);
var form = __webpack_require__(11340);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var get__default = /*#__PURE__*/_interopDefaultLegacy(get);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const useLuckyDraw = (id, configs) => {
  var _a;
  const { triggerUpdate, popupResponse, configStorage, wrapperRef } = configs;
  const [loading, setLoading] = React.useState(true);
  const [userInfo, setUserInfo] = React.useState();
  const [wheel, setWheel] = React.useState();
  const [mustSpin, setMustSpin] = React.useState(false);
  const [turnCount, setTurnCount] = React.useState();
  const [prizeNumber, setPrizeNumber] = React.useState();
  const [isShowForm, setIsShowForm] = React.useState(false);
  const [listContentHtml, setListContentHtml] = React.useState();
  const [spinResponse, setSpinResponse] = React.useState();
  const { env } = coreRenderer.useStore();
  const { condition, items, totalPercentage = 100 } = wheel || {};
  const formFields = (_a = condition == null ? void 0 : condition.form) == null ? void 0 : _a.fields;
  const API = new coreRenderer.Api(`${coreRenderer.publicBffUrl[env]}/v1/lucky-draw`);
  const handleSpin = async (userInfo2) => {
    var _a2, _b;
    setUserInfo(userInfo2);
    setLoading(true);
    setIsShowForm(false);
    let response;
    await API.post("/spin", { wheelId: id, userInfo: userInfo2 }).then((res) => {
      response = res.data;
      setSpinResponse(response.data);
    }).catch((error) => {
      var _a3, _b2;
      if (parseInt((_a3 = error == null ? void 0 : error.response) == null ? void 0 : _a3.code) === constants.ERROR_CODES.OUT_OF_TURN) {
        showPopup(popupResponse == null ? void 0 : popupResponse.outOfTurn);
        setTurnCount(0);
        return;
      }
      if (parseInt((_b2 = error == null ? void 0 : error.response) == null ? void 0 : _b2.code) === constants.ERROR_CODES.OUT_OF_PRIZE) {
        showPopup(popupResponse == null ? void 0 : popupResponse.outOfPrize);
        return;
      }
    });
    if (response == null ? void 0 : response.data) {
      const spinTurn = (_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.spinTurn;
      setTurnCount(spinTurn);
      const prizeId = (_b = response == null ? void 0 : response.data) == null ? void 0 : _b.itemId;
      const prizeIndex = items.findIndex((item) => item.id === prizeId);
      setPrizeNumber(prizeIndex);
      setMustSpin(true);
    }
    setLoading(false);
  };
  const handleSpinClick = () => {
    if (mustSpin) {
      return;
    } else {
      if (formFields) {
        if (!userInfo) {
          setIsShowForm(true);
        } else {
          handleSpin(userInfo);
        }
      } else {
        handleSpin(null);
      }
    }
  };
  const fetchLuckyDrawData = (wheelId) => {
    API.get(`/wheel/${wheelId}`).then((res) => res.data).then((wheelResponse) => setWheel(wheelResponse.data)).catch((err) => {
      console.error(err);
      return Promise.reject(err);
    }).finally(() => {
      setLoading(false);
    });
  };
  const handleStorageData = async (configStorage2) => {
    var _a2, _b;
    const prize = (_a2 = wheel == null ? void 0 : wheel.items) == null ? void 0 : _a2[prizeNumber];
    if (!prize || !(configStorage2 == null ? void 0 : configStorage2.formConfigId))
      return;
    const date = new Date();
    const { year, month, day, hour, minute, second } = getPartialDateTimeTimeZone7.getPartialDateTimeTimeZone7(date);
    const dateString = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    let newValues = __spreadProps(__spreadValues({}, userInfo || {}), {
      prizeName: prize.name,
      spinAt: dateString
    });
    if (configStorage2 == null ? void 0 : configStorage2.autoPassParams) {
      newValues = __spreadValues(__spreadValues({}, queryStringToObject.queryStringToObject(window.location.search)), newValues);
    }
    const valuesSubmit = [
      ...Object.entries(newValues).map(([k, v]) => {
        return {
          name: k,
          type: "string",
          value: v
        };
      }),
      {
        name: "url_page",
        type: "string",
        value: (_b = window == null ? void 0 : window.location) == null ? void 0 : _b.href
      }
    ];
    await form.formUtils.submitFormData(
      configStorage2 == null ? void 0 : configStorage2.formConfigId,
      valuesSubmit,
      `${coreRenderer.publicBffUrl[env]}/v1/submit-form`
    );
  };
  const handleStopSpin = async () => {
    setMustSpin(false);
    const { assignResult, isAssignSuccess } = spinResponse;
    if (isAssignSuccess) {
      if (popupResponse == null ? void 0 : popupResponse.prize) {
        showPrizePopup(items[prizeNumber]);
      }
    } else if (assignResult) {
      handleCustomResponse(assignResult);
    } else {
      if (popupResponse == null ? void 0 : popupResponse.prize) {
        showPrizePopup(items[prizeNumber]);
      }
    }
    await handleStorageData(configStorage);
  };
  const replaceRegex = (popupId, prize, str) => {
    if (!popupId || !str)
      return;
    const searchRegExp = /{{([\w,.]*)}}/g;
    const popupEle = wrapperRef.current.ownerDocument.querySelector(
      `[data-uniq-id="${popupId}"]`
    );
    popupEle.querySelectorAll(".popup-content p, h1, h2, h3, h4, h5, h6").forEach((el, index) => {
      el.innerHTML = str[index].replaceAll(searchRegExp, (i) => {
        return get__default["default"](prize, i.replace(/{{/, "").replace(/}}/, ""));
      });
    });
  };
  const replaceContentApi = (popupId, data) => {
    const popupEle = wrapperRef.current.ownerDocument.querySelector(
      `[data-uniq-id="${popupId}"]`
    );
    if (!popupId || !popupEle)
      return;
    popupEle.querySelectorAll(".popup-content p, h1, h2, h3, h4, h5, h6").forEach((el) => {
      const str = el.innerHTML;
      const searchRegExp = /{{([\w,.]*)}}/g;
      el.innerHTML = str.replaceAll(searchRegExp, (i) => {
        return get__default["default"](data, i.replace(/{{/, "").replace(/}}/, ""));
      });
    });
  };
  const showPopup = (popupId) => {
    var _a2;
    (_a2 = wrapperRef.current.ownerDocument.querySelector(
      `[data-uniq-id="${popupId}"]`
    )) == null ? void 0 : _a2.click();
  };
  const showPrizePopup = (prize) => {
    const popupId = popupResponse.prize;
    if (!popupId)
      return;
    replaceRegex(popupId, prize, listContentHtml);
    showPopup(popupId);
  };
  const handleCustomResponse = (apiResponse) => {
    var _a2;
    if (!((_a2 = popupResponse == null ? void 0 : popupResponse.custom) == null ? void 0 : _a2.length))
      return;
    popupResponse.custom.forEach((item) => {
      var _a3, _b, _c, _d;
      if (((_b = (_a3 = get__default["default"](apiResponse, item.key)) == null ? void 0 : _a3.toString) == null ? void 0 : _b.call(_a3)) === ((_c = item.value) == null ? void 0 : _c.toString())) {
        const popupId = item.popup;
        replaceContentApi(popupId, apiResponse);
        (_d = wrapperRef.current.ownerDocument.querySelector(
          `[data-uniq-id="${popupId}"]`
        )) == null ? void 0 : _d.click();
        return;
      }
    });
  };
  React.useEffect(() => {
    if (!!id) {
      fetchLuckyDrawData(id);
    }
  }, [id, triggerUpdate]);
  React.useEffect(() => {
    if (wrapperRef.current && (popupResponse == null ? void 0 : popupResponse.prize)) {
      const popupEle = wrapperRef.current.ownerDocument.querySelector(
        `[data-uniq-id="${popupResponse.prize}"]`
      );
      if (popupEle) {
        const list = [
          ...popupEle.querySelectorAll(
            ".popup-content p, h1, h2, h3, h4, h5, h6"
          )
        ].map((el) => el.innerHTML);
        setListContentHtml(list);
      }
    }
  }, [wrapperRef.current]);
  return {
    wheel,
    loading,
    mustSpin,
    turnCount,
    prizeNumber,
    isShowForm,
    totalPercentage,
    setLoading,
    setUserInfo,
    handleSpin,
    handleSpinClick,
    setMustSpin,
    setIsShowForm,
    handleStorageData,
    handleStopSpin
  };
};

exports.useLuckyDraw = useLuckyDraw;


/***/ }),

/***/ 65188:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var hooks = __webpack_require__(1642);
var Spin = __webpack_require__(48183);
var Wheel = __webpack_require__(75291);
var PercentageWarning = __webpack_require__(51030);
var ui = __webpack_require__(89666);
var ui$1 = __webpack_require__(62575);
var ui$2 = __webpack_require__(61349);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LuckyDrawV2 = (props) => {
  var _b;
  const _a = props, {
    id,
    commonStyle,
    dimension = 400,
    response,
    showTurn = false,
    isEditor = false,
    configStorage,
    triggerUpdate,
    alignment = "center",
    children
  } = _a, wheelConfig = __objRest(_a, [
    "id",
    "commonStyle",
    "dimension",
    "response",
    "showTurn",
    "isEditor",
    "configStorage",
    "triggerUpdate",
    "alignment",
    "children"
  ]);
  const ref = React.useRef();
  const {
    loading,
    wheel,
    totalPercentage,
    isShowForm,
    setIsShowForm,
    turnCount,
    handleSpin,
    mustSpin,
    prizeNumber,
    handleSpinClick,
    handleStopSpin
  } = hooks.useLuckyDraw(id, {
    triggerUpdate,
    popupResponse: response,
    configStorage,
    wrapperRef: ref
  });
  const { condition } = wheel || {};
  const formFields = (_b = condition == null ? void 0 : condition.form) == null ? void 0 : _b.fields;
  const getTypeField = (name, type) => {
    if (name === "phoneNumber")
      return "tel";
    if (name === "email")
      return "email";
    return type || "text";
  };
  if (!id)
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      style: {
        textAlign: "center",
        height: 400,
        display: "grid",
        placeItems: "center"
      },
      children: /* @__PURE__ */ jsxRuntime.jsx(Spin.Spin, {})
    });
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: (totalPercentage === 100 || isEditor) && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsxs("div", {
          style: {
            textAlign: alignment,
            padding: "1.2em",
            overflow: "hidden"
          },
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
              commonStyle,
              ref,
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(Wheel.Wheel, __spreadProps(__spreadValues(__spreadProps(__spreadValues({
                  items: (wheel == null ? void 0 : wheel.items) || [],
                  loading,
                  mustStartSpinning: mustSpin
                }, wheelConfig), {
                  prizeNumber
                }), !isEditor && { onStartSpinning: handleSpinClick }), {
                  onStopSpinning: handleStopSpin
                })),
                isEditor && /* @__PURE__ */ jsxRuntime.jsx(PercentageWarning.PercentageWarning, {
                  totalPercentage
                })
              ]
            }),
            showTurn && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
              children: [
                isEditor && /* @__PURE__ */ jsxRuntime.jsxs(TurnLabel, {
                  children: [
                    "B\u1EA1n c\xF2n ",
                    /* @__PURE__ */ jsxRuntime.jsx("strong", {
                      children: "***"
                    }),
                    " l\u01B0\u1EE3t quay!"
                  ]
                }),
                turnCount !== void 0 && turnCount !== -1 && /* @__PURE__ */ jsxRuntime.jsxs(TurnLabel, {
                  children: [
                    "B\u1EA1n c\xF2n ",
                    /* @__PURE__ */ jsxRuntime.jsx("strong", {
                      children: turnCount
                    }),
                    " l\u01B0\u1EE3t quay!"
                  ]
                })
              ]
            })
          ]
        }),
        formFields && /* @__PURE__ */ jsxRuntime.jsxs(ui.PopupV1, __spreadProps(__spreadValues({
          show: isShowForm,
          onFinishClose: () => setIsShowForm(false)
        }, {
          maskClosable: true,
          maskStyle: {
            backgroundColor: "rgba(0, 0, 0, 0.5)"
          },
          commonStyle: {
            borderRadius: 8,
            width: 400,
            height: 300,
            backgroundColor: "#fff",
            padding: {
              left: 24,
              right: 24,
              bottom: 24,
              top: 24
            }
          },
          position: "default"
        }), {
          children: [
            /* @__PURE__ */ jsxRuntime.jsx("div", {
              style: { marginBottom: 32, fontWeight: "bold" },
              children: "Vui l\xF2ng \u0111i\u1EC1n th\xF4ng tin \u0111\u1EC3 tham gia ch\u01B0\u01A1ng tr\xECnh"
            }),
            /* @__PURE__ */ jsxRuntime.jsx(ui$1.FormV4, {
              inputs: formFields == null ? void 0 : formFields.map(({ label, name, required, type }) => {
                return {
                  type: getTypeField(name, type),
                  label,
                  name,
                  required,
                  commonStyle: {
                    height: 40,
                    width: "100%",
                    marginBottom: 8
                  },
                  inputStyle: {
                    borderRadius: 8
                  },
                  placeholder: `Nh\u1EADp ${label.toLowerCase()}`
                };
              }),
              submits: [],
              hiddenFields: [],
              showLabel: true,
              onFinish: handleSpin,
              children: /* @__PURE__ */ jsxRuntime.jsx(ui$2.ButtonV2, {
                text: "Ho\xE0n t\u1EA5t",
                buttonStyle: {
                  backgroundColor: "#108143",
                  color: "rgba(255, 255, 255, 1)",
                  height: 40,
                  width: 120,
                  borderRadius: 999,
                  margin: {
                    top: 20,
                    left: "auto",
                    right: "auto"
                  }
                },
                loading,
                iconConfig: {
                  position: "right",
                  spacing: 8,
                  show: true,
                  icon: {
                    name: "CheckOutlined",
                    size: 18
                  }
                }
              })
            })
          ]
        })),
        children
      ]
    })
  });
};
LuckyDrawV2.displayName = "LuckyDrawV2";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  display: inline-block;
  position: relative;
  width: min(400px,100%);
  padding-bottom: min(400px,100%);
  user-select: none;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const TurnLabel = styled__default["default"].div`
  font-size: 1.2em;
  text-align: center;
  margin-top: 1em;
`;

exports.LuckyDrawV2 = LuckyDrawV2;


/***/ }),

/***/ 72457:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Map = React__default["default"].forwardRef((props, ref) => {
  const _a = props, { address, zoom, commonStyle, id } = _a, rest = __objRest(_a, ["address", "zoom", "commonStyle", "id"]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
    ref,
    id,
    commonStyle
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsx("iframe", {
      title: "map",
      width: "100%",
      height: "100%",
      frameBorder: 0,
      scrolling: "no",
      marginHeight: 0,
      marginWidth: 0,
      src: `https://maps.google.com/maps?q=${encodeURI(address || "")}&z=${zoom || 14}&ie=UTF8&iwloc=B&output=embed`
    })
  }));
});
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
    ${coreRenderer.getStyle(commonStyle)}`
);
Map.displayName = "Map";

exports.Map = Map;


/***/ }),

/***/ 21256:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var type = __webpack_require__(68935);
var utils = __webpack_require__(26461);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BarProgress = ({
  value,
  maxValue,
  numberElement,
  textBeforeElement,
  textAfterElement,
  style
}) => {
  const _a = style || {}, {
    numberPosition,
    duration = 0,
    delay = 0,
    foregroundColor
  } = _a, restStyle = __objRest(_a, [
    "numberPosition",
    "duration",
    "delay",
    "foregroundColor"
  ]);
  const barFillRef = React.useRef();
  React.useEffect(() => {
    let timer;
    if (value) {
      timer = setTimeout(async () => {
        if (barFillRef.current) {
          barFillRef.current.style.removeProperty("transition");
          barFillRef.current.style.width = `${utils.calculatePercent(
            value,
            maxValue
          )}%`;
        }
      }, delay * 1e3);
    }
    return () => {
      clearTimeout(timer);
      if (barFillRef.current) {
        barFillRef.current.style.transition = "none";
        barFillRef.current.style.width = "0%";
      }
    };
  }, [value, maxValue]);
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      textBeforeElement,
      numberPosition === type.NumberPosition.above && numberElement,
      /* @__PURE__ */ jsxRuntime.jsx(BarContainer, {
        commonStyle: __spreadValues({}, restStyle),
        children: /* @__PURE__ */ jsxRuntime.jsx(BarFill, {
          ref: barFillRef,
          commonStyle: { background: foregroundColor },
          duration,
          children: numberPosition === type.NumberPosition.inside && numberElement
        })
      }),
      numberPosition === type.NumberPosition.below && numberElement,
      textAfterElement
    ]
  });
};
const BarContainer = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}

  position: relative;
  width: 100%;
`
);
const BarFill = styled__default["default"].div(
  ({ commonStyle, duration }) => {
    return `
      ${coreRenderer.getStyle(commonStyle)}

      position: absolute;
      height: 100%;
      width: 0%;

      display: flex;
      align-items: center;

      overflow: hidden;
      transition: width ${duration}s linear;
    `;
  }
);

exports.BarProgress = BarProgress;


/***/ }),

/***/ 81207:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(91987);

const useFirstVisible = (element) => {
  const [isVisible, setState] = React.useState(false);
  const counter = React.useRef(0);
  React.useEffect(() => {
    if ((element == null ? void 0 : element.current) && !counter.current) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && !counter.current) {
          setState(entry.isIntersecting);
          observer.unobserve(element.current);
          counter.current++;
        }
      });
      observer.observe(element.current);
      return () => {
        if (element == null ? void 0 : element.current) {
          observer.unobserve(element.current);
        }
      };
    }
  }, [element]);
  return isVisible;
};

exports.useFirstVisible = useFirstVisible;


/***/ }),

/***/ 68935:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var NumberType = /* @__PURE__ */ ((NumberType2) => {
  NumberType2["standard"] = "standard";
  NumberType2["percent"] = "percent";
  return NumberType2;
})(NumberType || {});
var NumberCounterLayout = /* @__PURE__ */ ((NumberCounterLayout2) => {
  NumberCounterLayout2["number"] = "number";
  NumberCounterLayout2["bar"] = "bar";
  NumberCounterLayout2["circle"] = "circle";
  return NumberCounterLayout2;
})(NumberCounterLayout || {});
var NumberPosition = /* @__PURE__ */ ((NumberPosition2) => {
  NumberPosition2["above"] = "above";
  NumberPosition2["inside"] = "inside";
  NumberPosition2["below"] = "below";
  NumberPosition2["hidden"] = "hidden";
  return NumberPosition2;
})(NumberPosition || {});

exports.NumberCounterLayout = NumberCounterLayout;
exports.NumberPosition = NumberPosition;
exports.NumberType = NumberType;


/***/ }),

/***/ 81812:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var reactCircularProgressbar = __webpack_require__(13413);
var reactFrameComponent = __webpack_require__(90425);
var type = __webpack_require__(68935);
var utils = __webpack_require__(26461);
var useFirstVisible = __webpack_require__(81207);
var BarProgress = __webpack_require__(21256);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const START_NUMBER = 0;
const NumberCounter = (props) => {
  const {
    number,
    total,
    numberType,
    layout,
    barStyle,
    circleStyle,
    duration = 0,
    delay = 0,
    prefixNumber = "",
    suffixNumber = "",
    textBefore,
    textAfter,
    foregroundColor,
    backgroundColor,
    background
  } = props;
  const numberCounterRef = React.useRef();
  const isVisible = useFirstVisible.useFirstVisible(numberCounterRef);
  const positiveNumber = Math.abs(number || 0);
  const positiveTotal = Math.abs(total || 1);
  const maxValue = utils.getMaxValue(positiveNumber, positiveTotal, numberType);
  const [progress, setProgress] = React.useState(START_NUMBER);
  const { document: frameDocument } = reactFrameComponent.useFrame();
  coreRenderer.useInjectLinksToHTML(
    [
      {
        rel: "stylesheet",
        href: "https://cdn.jsdelivr.net/npm/react-circular-progressbar@2.0.4/dist/styles.css"
      }
    ],
    frameDocument
  );
  React.useEffect(() => {
    if (number && isVisible) {
      let intervalId;
      const timer = setTimeout(async () => {
        const intervalTime = Math.floor(duration / positiveNumber * 100) / 100;
        intervalId = setInterval(() => {
          setProgress((preValue) => {
            const newValue = preValue + 1;
            if (newValue < positiveNumber)
              return newValue;
            clearInterval(intervalId);
            clearTimeout(timer);
            return positiveNumber;
          });
        }, intervalTime * 1e3);
      }, delay * 1e3);
      return () => {
        clearInterval(intervalId);
        clearTimeout(timer);
        setProgress(START_NUMBER);
      };
    }
  }, [isVisible, layout, numberType, number, total, duration, delay]);
  const renderNumber = () => {
    const getNumber = () => {
      if (number === void 0)
        return;
      return number >= 0 ? progress : progress * -1;
    };
    const showedNumber = new Intl.NumberFormat("en-CA").format(getNumber());
    if (numberType === type.NumberType.standard) {
      return `${prefixNumber}${showedNumber}${suffixNumber}`;
    }
    return `${showedNumber}%`;
  };
  const numberElement = /* @__PURE__ */ jsxRuntime.jsx("div", {
    className: "number",
    children: renderNumber()
  });
  const textBeforeElement = textBefore && /* @__PURE__ */ jsxRuntime.jsx("div", {
    className: "text",
    children: textBefore
  });
  const textAfterElement = textAfter && /* @__PURE__ */ jsxRuntime.jsx("div", {
    className: "text",
    children: textAfter
  });
  const renderBarLayout = () => {
    const value = numberType === type.NumberType.percent && number < 0 ? 0 : positiveNumber;
    return /* @__PURE__ */ jsxRuntime.jsx(BarProgress.BarProgress, {
      value,
      maxValue,
      numberElement,
      textBeforeElement,
      textAfterElement,
      style: __spreadProps(__spreadValues({}, barStyle), {
        backgroundColor,
        foregroundColor,
        duration,
        delay,
        background
      })
    });
  };
  const renderCircleLayout = () => {
    const value = numberType === type.NumberType.percent && number < 0 ? 0 : progress;
    return /* @__PURE__ */ jsxRuntime.jsx(CircleContainer, {
      circleStyle,
      children: /* @__PURE__ */ jsxRuntime.jsx(reactCircularProgressbar.CircularProgressbarWithChildren, {
        value,
        maxValue,
        strokeWidth: circleStyle == null ? void 0 : circleStyle.strokeSize,
        styles: {
          path: {
            stroke: foregroundColor,
            transitionDuration: `${duration / positiveNumber}s`
          },
          trail: {
            stroke: backgroundColor || background
          }
        },
        children: /* @__PURE__ */ jsxRuntime.jsxs(CircleContent, {
          children: [
            textBeforeElement,
            numberElement,
            textAfterElement
          ]
        })
      })
    });
  };
  const renderContent = () => {
    if (layout === type.NumberCounterLayout.bar) {
      return renderBarLayout();
    }
    if (layout === type.NumberCounterLayout.circle) {
      return renderCircleLayout();
    }
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [
        textBeforeElement,
        numberElement,
        textAfterElement
      ]
    });
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
    ref: numberCounterRef
  }, props), {
    children: renderContent()
  }));
};
NumberCounter.displayName = "NumberCounter";
const CircleContainer = styled__default["default"].div(
  ({ circleStyle }) => `
    width: ${circleStyle == null ? void 0 : circleStyle.size}px;
    height: ${circleStyle == null ? void 0 : circleStyle.size}px;
    max-width: 100%;
    max-height: 100%;

    margin: auto;
  `
);
const CircleContent = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Wrapper = styled__default["default"].div((props) => {
  const { commonStyle, numberStyle, textStyle } = props;
  return `
    ${coreRenderer.getStyle(commonStyle)};
    overflow: hidden;

    .text {
      ${coreRenderer.getStyle(textStyle)};
    }

    .number {
      width: 100%;
      height: 100%;
      ${coreRenderer.getStyle(numberStyle)};
    }
  `;
});

exports.NumberCounter = NumberCounter;


/***/ }),

/***/ 26461:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var type = __webpack_require__(68935);

const getMaxValue = (value, total, type$1) => {
  let maxValue = total;
  if (type$1 === type.NumberType.percent) {
    maxValue = 100;
  }
  return Math.max(value, maxValue);
};
const calculatePercent = (value, maxValue) => {
  return Math.min(100, Math.round(value / maxValue * 1e4) / 1e4 * 100);
};

exports.calculatePercent = calculatePercent;
exports.getMaxValue = getMaxValue;


/***/ }),

/***/ 49322:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var HTMLFlipBook = __webpack_require__(47670);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var HTMLFlipBook__default = /*#__PURE__*/_interopDefaultLegacy(HTMLFlipBook);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PageFlip = (_a) => {
  var _b = _a, {
    commonStyle,
    id,
    images,
    align
  } = _b, rest = __objRest(_b, [
    "commonStyle",
    "id",
    "images",
    "align"
  ]);
  const pageFlipRef = React.useRef();
  const [pageFlipKey, setPageFlipKey] = React.useState(0);
  const DEFAULT_WIDTH = 596;
  const DEFAULT_HEIGHT = 842;
  React.useEffect(() => {
    setPageFlipKey((key) => key + 1);
  }, [
    rest.autoSize,
    rest.drawShadow,
    rest.flippingTime,
    rest.height,
    rest.width,
    rest.maxHeight,
    rest.maxWidth,
    rest.maxShadowOpacity,
    rest.mobileScrollSupport,
    rest.showCover,
    rest.size,
    rest.startZIndex,
    rest.usePortrait
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle,
    id,
    align,
    children: /* @__PURE__ */ jsxRuntime.jsx(HTMLFlipBook__default["default"], __spreadProps(__spreadValues({
      ref: pageFlipRef
    }, rest), {
      width: rest.width || DEFAULT_WIDTH,
      height: rest.height || DEFAULT_HEIGHT,
      children: images == null ? void 0 : images.map((image, index) => {
        const { src, googleImageParams } = image;
        return /* @__PURE__ */ jsxRuntime.jsx(Page, {
          src: coreRenderer.getImageUrlFromGoogleUserContent(src, __spreadValues({
            format: "webp"
          }, googleImageParams))
        }, index);
      })
    }), pageFlipKey)
  });
};
const transformAlign = (align) => {
  switch (align) {
    case coreRenderer.Alignment.center:
      return "margin: 0 auto;";
    case coreRenderer.Alignment.right:
      return `
        margin: 0 auto;
        margin-right: 0;
      `;
    default:
      return "";
  }
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle, align }) => `
  display: flex;
  width: 100%;
  max-width: 100% !important;
  max-width: fit-content;
  position: relative;
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
  ${transformAlign(align)}
`
);
const Page = styled__default["default"].div(
  ({ src }) => `
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${src});
`
);
PageFlip.displayName = "PageFlip";

exports.PageFlip = PageFlip;


/***/ }),

/***/ 89223:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var clsx = __webpack_require__(77084);
var React = __webpack_require__(91987);
var fonts = __webpack_require__(74367);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Paragraph = (_a) => {
  var _b = _a, {
    text,
    commonStyle,
    children
  } = _b, rest = __objRest(_b, [
    "text",
    "commonStyle",
    "children"
  ]);
  const ref = React.useRef(null);
  const { style: animationStyle, animationClassName } = coreRenderer.useAnimation(
    commonStyle == null ? void 0 : commonStyle.animation,
    ref
  );
  const { text: formattedText } = coreRenderer.useInjectDynamicLinks(text);
  const paragraphProps = __spreadProps(__spreadValues({}, rest), {
    ref,
    className: clsx__default["default"](rest.className, animationClassName),
    style: animationStyle,
    commonStyle
  });
  if (children) {
    return /* @__PURE__ */ jsxRuntime.jsx(StyledParagraph, __spreadProps(__spreadValues({}, paragraphProps), {
      children
    }));
  }
  return /* @__PURE__ */ jsxRuntime.jsx(StyledParagraph, __spreadProps(__spreadValues({}, paragraphProps), {
    dangerouslySetInnerHTML: {
      __html: formattedText
    }
  }));
};
const StyledParagraph = styled__default["default"].div(
  ({ commonStyle }) => `
    ${coreRenderer.getStyle(commonStyle)};
    ${fonts.getCommonTextCss(true)}
  `,
  `a {
    color: inherit;
  }`
);
Paragraph.displayName = "Paragraph";

exports.Paragraph = Paragraph;
exports.StyledParagraph = StyledParagraph;


/***/ }),

/***/ 89666:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);
var coreRenderer = __webpack_require__(12060);
var clsx = __webpack_require__(77084);
var React = __webpack_require__(91987);
var getPropsIcon = __webpack_require__(26321);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PopupV1 = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, {
      commonStyle,
      maskStyle,
      position,
      children,
      show,
      onFinishClose,
      displayOnVisitPage,
      delay,
      isEditorMode,
      displayOnScrollTo,
      displayOnExitPage,
      showCloseIcon,
      event,
      closeIcon,
      closeIconWrapperStyle,
      allowCloseOnEscPressed,
      zIndex,
      className
    } = _a, rest = __objRest(_a, [
      "commonStyle",
      "maskStyle",
      "position",
      "children",
      "show",
      "onFinishClose",
      "displayOnVisitPage",
      "delay",
      "isEditorMode",
      "displayOnScrollTo",
      "displayOnExitPage",
      "showCloseIcon",
      "event",
      "closeIcon",
      "closeIconWrapperStyle",
      "allowCloseOnEscPressed",
      "zIndex",
      "className"
    ]);
    const [showPopup, setShowPopup] = React.useState(false);
    const [displayOnScrolToFlag, setDisplayOnScrolToFlag] = React.useState(false);
    const [displayOnExitFlag, setDisplayOnExitFlag] = React.useState(false);
    const maskRef = React.useRef(null);
    const {
      trackingEventName,
      conversionGGAdsId,
      conversionGGAdsLabel,
      scriptCustom
    } = event || {};
    const handleOpenPopupOnExitPage = React.useCallback(() => {
      openPopup();
      setDisplayOnExitFlag(true);
    }, []);
    React.useEffect(() => {
      if (displayOnVisitPage && !isEditorMode) {
        setTimeout(() => openPopup(), delay * 1e3);
      }
    }, [displayOnVisitPage, delay, isEditorMode]);
    React.useEffect(() => {
      if (isEditorMode || !displayOnExitPage)
        return;
      if (!displayOnExitFlag) {
        document.body.addEventListener("mouseleave", handleOpenPopupOnExitPage);
      } else
        document.body.removeEventListener(
          "mouseleave",
          handleOpenPopupOnExitPage
        );
    }, [displayOnExitFlag]);
    const handleScrollTo = React.useCallback(() => {
      var _a2, _b;
      const element = document.getElementById(displayOnScrollTo);
      const rect = element == null ? void 0 : element.getBoundingClientRect();
      if (!showPopup && rect && rect.top >= 0 && rect.left >= 0 && rect.bottom <= ((window == null ? void 0 : window.innerHeight) || ((_a2 = document == null ? void 0 : document.documentElement) == null ? void 0 : _a2.clientHeight)) && rect.right <= ((window == null ? void 0 : window.innerWidth) || ((_b = document == null ? void 0 : document.documentElement) == null ? void 0 : _b.clientWidth))) {
        openPopup();
        setDisplayOnScrolToFlag(true);
      }
    }, []);
    React.useEffect(() => {
      if (!displayOnScrolToFlag) {
        document.addEventListener("scroll", handleScrollTo);
      } else {
        document.removeEventListener("scroll", handleScrollTo);
      }
      return () => {
        document.removeEventListener("scroll", handleScrollTo);
      };
    }, [displayOnScrolToFlag]);
    const openPopup = () => {
      setShowPopup(true);
      onTrackingEvent();
    };
    const onTrackingEvent = () => {
      var _a2, _b, _c, _d;
      if (trackingEventName) {
        (_a2 = window == null ? void 0 : window.gtag) == null ? void 0 : _a2.call(window, "event", trackingEventName);
        (_b = window == null ? void 0 : window.fbq) == null ? void 0 : _b.call(window, "trackCustom", trackingEventName);
        (_c = window == null ? void 0 : window.track) == null ? void 0 : _c.call(window, "customEvent", trackingEventName);
      }
      if (conversionGGAdsId && conversionGGAdsLabel) {
        (_d = window == null ? void 0 : window.gtag) == null ? void 0 : _d.call(window, "event", "conversion", {
          send_to: `AW-${conversionGGAdsId}/${conversionGGAdsLabel}`
        });
      }
      runStringFunc(scriptCustom);
    };
    const runStringFunc = (script) => {
      if (script == null ? void 0 : script.trim()) {
        try {
          const excuteScript = new Function(coreRenderer.unescapeString(script));
          excuteScript();
        } catch (err) {
          console.error(err);
        }
      }
    };
    const handleClosePopup = () => {
      setShowPopup(false);
      onFinishClose == null ? void 0 : onFinishClose();
    };
    React.useEffect(() => {
      setShowPopup(show);
    }, [show]);
    React.useEffect(() => {
      if (showPopup && allowCloseOnEscPressed && !isEditorMode) {
        const handleDocumentKeyDown = (e) => {
          if (e.keyCode === 27) {
            handleClosePopup();
          }
        };
        document.addEventListener("keydown", handleDocumentKeyDown);
        return () => {
          document.removeEventListener("keydown", handleDocumentKeyDown);
        };
      }
    }, [showPopup]);
    const calculateZIndex = isEditorMode ? 1e3 : zIndex || 1050;
    return /* @__PURE__ */ jsxRuntime.jsxs(Mask, {
      className: clsx__default["default"]([show || showPopup ? "show" : "hide", className]),
      ref: maskRef,
      style: { zIndex: calculateZIndex },
      position,
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(Backdrop, {
          maskStyle,
          onClick: () => {
            if (!showCloseIcon)
              handleClosePopup();
          }
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({
          onClick: () => {
            var _a2, _b, _c, _d;
            if (!showPopup)
              openPopup();
            if ((_b = (_a2 = maskRef.current) == null ? void 0 : _a2.classList) == null ? void 0 : _b.contains("hide-from-btn")) {
              handleClosePopup();
              (_d = (_c = maskRef.current) == null ? void 0 : _c.classList) == null ? void 0 : _d.remove("hide-from-btn");
            }
          },
          ref,
          position,
          commonStyle
        }, rest), {
          children: [
            showCloseIcon && /* @__PURE__ */ jsxRuntime.jsx(StyledIconClose, {
              style: closeIconWrapperStyle,
              onClick: handleClosePopup,
              children: /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, __spreadValues({
                name: "CloseOutlined"
              }, getPropsIcon.getPropsIcon({
                size: (closeIcon == null ? void 0 : closeIcon.size) || 18,
                color: closeIcon == null ? void 0 : closeIcon.color
              })))
            }),
            /* @__PURE__ */ jsxRuntime.jsx("div", {
              className: "popup-content",
              children
            })
          ]
        }))
      ]
    });
  }
);
const POPUP_CONTENT_STYLE_MAPPING = {
  topLeft: `vertical-align: top;
            top: 0;
            left: 0;
            right: unset !important;
            bottom:unset !important;`,
  topCenter: `vertical-align: top;
              top: 0;
              left: unset !important;
              right: unset !important;
              bottom: unset !important;`,
  topRight: `vertical-align: top;
            top: 0;
            left: unset !important;
            right: 0;
            bottom: unset !important;`,
  centerLeft: `vertical-align: middle;
              top: unset !important;
              left: 0;
              right: unset !important;
              bottom: unset !important;`,
  centerRight: `vertical-align: middle;
                top: unset !important;
                left: unset !important;
                right: 0;
                bottom: unset !important;`,
  bottomLeft: `vertical-align: bottom;
              top: unset !important;
              left: 0;
              right:unset !important;
              bottom: 0;`,
  bottomRight: `vertical-align: bottom;
                bottom: 0;
                right: 0;
                top: unset !important;;
                left: unset !important;`,
  bottomCenter: `vertical-align: bottom;
                top: unset !important;
                left: unset !important;
                right:unset !important;
                bottom: 0;`,
  center: `vertical-align: middle;`,
  default: `top: 100px;
            left: unset !important;
            right:unset !important;
            bottom: unset !important;
            vertical-align: top;`
};
const MASK_STYLE_MAPPING = {
  topLeft: "text-align: start;",
  topCenter: "text-align: center;",
  topRight: "text-align: end;",
  centerLeft: "text-align: start;",
  centerRight: "text-align: end;",
  bottomLeft: "text-align: start;",
  bottomRight: "text-align: end;",
  bottomCenter: "text-align: center;",
  center: "text-align: center",
  default: "text-align: center;"
};
const VERTICAL_MAPPING = {
  topLeft: "vertical-align: top;",
  topCenter: "vertical-align: top;",
  topRight: "vertical-align: top;",
  centerLeft: "vertical-align: middle;",
  centerRight: "vertical-align: middle;",
  bottomLeft: "vertical-align: bottom;",
  bottomRight: "vertical-align: bottom;",
  bottomCenter: "vertical-align: bottom;",
  center: "vertical-align: middle;",
  default: "vertical-align: top;"
};
const getStyleByPosition = (position, mappingData) => {
  switch (position) {
    case "default":
      return `
        ${mappingData["default"]}
      `;
    case "topLeft":
      return `
        ${mappingData["topLeft"]}
      `;
    case "topCenter":
      return `
        ${mappingData["topCenter"]}
      `;
    case "topRight":
      return `
        ${mappingData["topRight"]}
      `;
    case "centerLeft":
      return `
        ${mappingData["centerLeft"]}
      `;
    case "centerRight":
      return `
        ${mappingData["centerRight"]}
      `;
    case "bottomLeft":
      return `
            ${mappingData["bottomLeft"]}
        `;
    case "bottomCenter":
      return `
        ${mappingData["bottomCenter"]}
      `;
    case "bottomRight":
      return `
        ${mappingData["bottomRight"]}
      `;
    case "center":
      return `
        ${mappingData["center"]}
      `;
    default:
      return `
        ${mappingData["default"]}
      `;
  }
};
const Wrapper = styled__default["default"].div(
  ({
    commonStyle,
    position
  }) => {
    const _a = commonStyle || {}, { height } = _a, rest = __objRest(_a, ["height"]);
    return `
    position: relative !important;
    z-index: 1050;
    max-width: 100%;
    min-height: ${height || 400}px;
    height: max-content;
    text-align: start;
    display: inline-block;
    ${getStyleByPosition(position, POPUP_CONTENT_STYLE_MAPPING)}
    ${coreRenderer.getStyle(rest)}
  `;
  }
);
const Mask = styled__default["default"].div(({ position }) => {
  return `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  overflow: auto;
  ${getStyleByPosition(position, MASK_STYLE_MAPPING)}
  &.hide {
    display: none;
  }
  &::before {
    display: inline-block;
    width: 0;
    height: 100%;
    content: '';
    ${getStyleByPosition(position, VERTICAL_MAPPING)}
  }
  `;
});
const Backdrop = styled__default["default"].div(
  ({ maskStyle }) => `
 ${coreRenderer.getStyle(maskStyle)}
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1000;
`
);
const StyledIconClose = styled__default["default"].div`
  position: absolute;
  right: 10px;
  top: 8px;
  cursor: pointer;
  z-index: 1;
`;
PopupV1.displayName = "PopupV1";

exports.PopupV1 = PopupV1;


/***/ }),

/***/ 42263:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Wrapper = styled__default["default"].div`
  position: absolute;
  width: 0;
  height: 0;
`;
const PopupRoot = React.forwardRef(
  (props, ref) => {
    const { children } = props;
    return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
        ref,
        children
      })
    });
  }
);
PopupRoot.displayName = "PopupRoot";

exports.PopupRoot = PopupRoot;


/***/ }),

/***/ 28713:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var constants = __webpack_require__(29203);
var ui = __webpack_require__(89666);
var ui$1 = __webpack_require__(89223);
var ui$2 = __webpack_require__(62575);
var ui$3 = __webpack_require__(61349);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CheckoutPopup = ({
  open,
  setOpen,
  onFinish,
  loading
}) => {
  return /* @__PURE__ */ jsxRuntime.jsxs(ui.PopupV1, __spreadProps(__spreadValues({
    show: open,
    onFinishClose: () => !loading && setOpen(false)
  }, {
    maskClosable: true,
    showCloseIcon: true,
    closeIcon: {
      size: 24
    },
    closeIconWrapperStyle: {
      top: 16,
      right: 16
    },
    maskStyle: {
      backgroundColor: "rgba(0, 0, 0, 0.5)"
    },
    commonStyle: {
      borderRadius: 8,
      width: 334,
      backgroundColor: "#fff",
      padding: {
        left: 24,
        right: 24,
        bottom: 16,
        top: 16
      }
    },
    position: "default"
  }), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(ui$1.Paragraph, {
        text: "T\u1EA1o \u0111\u01A1n h\xE0ng",
        commonStyle: {
          fontSize: 16,
          lineHeight: "24px",
          fontWeight: "bold",
          margin: { bottom: 4 }
        }
      }),
      /* @__PURE__ */ jsxRuntime.jsx(ui$2.FormV4, {
        labelStyle: {
          margin: { top: 12 }
        },
        inputs: constants.inputsConfig,
        submits: [],
        hiddenFields: [],
        showLabel: true,
        onFinish,
        customLoading: loading,
        children: /* @__PURE__ */ jsxRuntime.jsx(ui$3.ButtonV2, {
          text: "T\u1EA1o \u0111\u01A1n",
          buttonStyle: {
            backgroundColor: "#7367F0",
            color: "rgba(255, 255, 255, 1)",
            height: 32,
            width: 83,
            borderRadius: 4
          },
          commonStyle: { justifyContent: "flex-end", margin: { top: 12 } }
        })
      })
    ]
  }));
};

exports.CheckoutPopup = CheckoutPopup;


/***/ }),

/***/ 44680:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var icons = __webpack_require__(94556);
var styled = __webpack_require__(21483);
var ui = __webpack_require__(89666);
var ui$1 = __webpack_require__(81171);
var ui$2 = __webpack_require__(89223);
var ui$3 = __webpack_require__(61349);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CheckoutSuccessPopup = ({
  open,
  setOpen
}) => {
  return /* @__PURE__ */ jsxRuntime.jsxs(ui.PopupV1, __spreadProps(__spreadValues({
    show: open,
    onFinishClose: () => setOpen(false)
  }, {
    maskClosable: true,
    maskStyle: {
      backgroundColor: "rgba(0, 0, 0, 0.5)"
    },
    commonStyle: {
      borderRadius: 8,
      width: 334,
      backgroundColor: "#fff",
      height: 200,
      padding: {
        left: 32,
        right: 32,
        bottom: 32,
        top: 32
      }
    },
    position: "default"
  }), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(StyledIcon, {
        children: /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "SuccessColored",
          style: { fontSize: 120 }
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsx(ui$1.Heading, {
        commonStyle: { margin: { top: 32 }, textAlign: "center" },
        text: "<h3>Th\xE0nh c\xF4ng!</h3>"
      }),
      /* @__PURE__ */ jsxRuntime.jsx(ui$2.Paragraph, {
        commonStyle: { margin: { top: 12 }, textAlign: "center" },
        text: "T\u1EA1o \u0111\u01A1n h\xE0ng th\xE0nh c\xF4ng"
      }),
      /* @__PURE__ */ jsxRuntime.jsx(ui$3.ButtonV2, __spreadProps(__spreadValues({}, {
        text: "<span>\u0110\xF3ng</span>",
        commonStyle: {
          margin: {
            top: 24
          }
        },
        buttonStyle: {
          backgroundColor: "#7367F0",
          color: "rgba(255, 255, 255, 1)",
          borderRadius: 4,
          height: 36,
          width: "100%"
        }
      }), {
        onClick: () => setOpen(false)
      }))
    ]
  }));
};
const StyledIcon = styled__default["default"].div`
  position: absolute;
  top: -60px;
  left: calc(50% - 60px);
`;

exports.CheckoutSuccessPopup = CheckoutSuccessPopup;


/***/ }),

/***/ 14874:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var clsx = __webpack_require__(77084);
var index = __webpack_require__(43866);
var ui = __webpack_require__(49864);
var ui$1 = __webpack_require__(89223);
var Rating = __webpack_require__(66507);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ProductCard = ({
  product,
  nameStyle,
  priceStyle,
  alignment,
  onClick,
  isEditingMode = false,
  currencyUnit,
  currencyAlignment
}) => {
  const hasClickEvent = typeof onClick === "function";
  const { name, discount, price, image, link, virtualSold, virtualRating } = product;
  const getPriceText = () => {
    const formattedPrice = coreRenderer.formatCurrencyVND(price, false);
    const unit = currencyUnit || "\u0111";
    if (currencyAlignment === "left")
      return `${unit}${formattedPrice}`;
    return `${formattedPrice} ${unit}`;
  };
  const handleClickProduct = () => {
    if (hasClickEvent)
      onClick(product);
  };
  const renderSold = () => {
    const sold = Intl.NumberFormat("en-US", {
      notation: "compact",
      maximumFractionDigits: 1
    }).format(virtualSold);
    return /* @__PURE__ */ jsxRuntime.jsx(Sold, {
      text: `\u0110\xE3 b\xE1n ${sold}`,
      fontSize: +priceStyle.fontSize - 1
    });
  };
  const renderCard = () => {
    return /* @__PURE__ */ jsxRuntime.jsxs(ProductCardContent, {
      className: clsx__default["default"]({ "allow-click": hasClickEvent }),
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(ProductVisualWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx("div", {
            style: { position: "relative", paddingBottom: "100%" },
            children: /* @__PURE__ */ jsxRuntime.jsx(StyledImage, __spreadValues({
              commonStyle: {
                objectFit: "contain",
                height: "100%",
                width: "100%"
              },
              autoOptimize: true
            }, image))
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(DetailCard, {
          className: clsx__default["default"]("detail-card", alignment),
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(ProductName, {
              className: "detail-card__name",
              text: name,
              commonStyle: nameStyle
            }),
            /* @__PURE__ */ jsxRuntime.jsxs(WrapperPrice, {
              className: "detail-card__price",
              children: [
                (!!price || price === 0) && /* @__PURE__ */ jsxRuntime.jsx(Price, {
                  text: getPriceText(),
                  commonStyle: priceStyle
                }),
                !!discount && /* @__PURE__ */ jsxRuntime.jsx(WrapperDiscount, {
                  children: /* @__PURE__ */ jsxRuntime.jsx(Discount, {
                    fontSize: +priceStyle.fontSize - 4,
                    children: `-${discount}%`
                  })
                })
              ]
            }),
            (virtualRating > 0 || virtualSold > 0) && /* @__PURE__ */ jsxRuntime.jsxs(WrapperExtra, {
              className: "detail-card__extra",
              children: [
                virtualRating > 0 && /* @__PURE__ */ jsxRuntime.jsx(Rating.Rating, {
                  style: { fontSize: priceStyle.fontSize || 14 },
                  value: virtualRating,
                  disabled: true
                }),
                virtualSold > 0 && renderSold()
              ]
            })
          ]
        })
      ]
    });
  };
  if (isEditingMode)
    return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
      children: renderCard()
    });
  if (hasClickEvent)
    return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
      onClick: handleClickProduct,
      children: renderCard()
    });
  return /* @__PURE__ */ jsxRuntime.jsx(index.Link, __spreadProps(__spreadValues({}, {
    eventType: "link",
    link: { openNewTab: true, nofollow: true, href: link }
  }), {
    children: /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
      children: renderCard()
    })
  }));
};
const Wrapper = styled__default["default"].div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: transparent;
`;
const ProductCardContent = styled__default["default"].div`
  position: relative;
  flex: 1 0 auto;

  &.allow-click {
    &:hover {
      cursor: pointer;
    }
  }
`;
const ProductVisualWrapper = styled__default["default"].div`
  position: relative;
  margin-bottom: 4px;
`;
const StyledImage = styled__default["default"](ui.Image)`
  display: inline-block;
  overflow: hidden;
  position: absolute;
  height: 100%;
  inset: 0;
`;
const DetailCard = styled__default["default"].div`
  min-height: 72px;
  &.detail-card.left {
    .detail-card__name {
      text-align: left;
    }
    .detail-card__price,
    .detail-card__extra {
      justify-content: flex-start;
    }
  }
  &.detail-card.center {
    .detail-card__name {
      text-align: center;
    }
    .detail-card__price,
    .detail-card__extra {
      justify-content: center;
    }
  }
  &.detail-card.right {
    .detail-card__name {
      text-align: right;
    }
    .detail-card__price,
    .detail-card__extra {
      justify-content: flex-end;
    }
  }
`;
const ProductName = styled__default["default"](ui$1.Paragraph)`
  font-size: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #000000;
  font-weight: 700;
  ${(props) => coreRenderer.getStyle(props == null ? void 0 : props.commonStyle)}
`;
const WrapperPrice = styled__default["default"].div`
  display: flex;
`;
const Price = styled__default["default"](ui$1.Paragraph)`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  ${(props) => coreRenderer.getStyle(props == null ? void 0 : props.commonStyle)}
`;
const WrapperDiscount = styled__default["default"].div`
  margin-left: 8px;
`;
const Discount = styled__default["default"].span(
  ({ fontSize = 10 }) => `
padding: 0 4px;
color: #ffffff;
background-color: #e40303;
font-size: ${fontSize}px;
line-height: 14px;
font-weight: 700;
border-radius: 2px;
`
);
const WrapperExtra = styled__default["default"].div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;
const Sold = styled__default["default"](ui$1.Paragraph)(
  ({ fontSize = 13 }) => `
font-weight: 400;
font-size: ${fontSize}px;
line-height: 22px;
`
);

exports.ProductCard = ProductCard;


/***/ }),

/***/ 74457:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var ProductCard = __webpack_require__(14874);
var Slider = __webpack_require__(85468);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarousel = (_a) => {
  var _b = _a, {
    items = [],
    carouselOptions,
    layout
  } = _b, rest = __objRest(_b, [
    "items",
    "carouselOptions",
    "layout"
  ]);
  const { device } = coreRenderer.useStore();
  const slidesPerView = device === "mobile" ? 2.5 : carouselOptions.slidesPerView;
  return /* @__PURE__ */ jsxRuntime.jsx(Slider.DSSlider, __spreadProps(__spreadValues({}, carouselOptions), {
    slidesPerView,
    slidesPerViewMobile: 2.5,
    allowTouchMove: !(rest == null ? void 0 : rest.isEditingMode),
    children: items.map((product, index) => /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BreakpointWidthProvider, {
      sWidth: { value: 100 / 2.5, unit: "%" },
      mWidth: {
        value: 100 / carouselOptions.slidesPerView || 5,
        unit: "%"
      },
      children: /* @__PURE__ */ jsxRuntime.jsx(ProductCard.ProductCard, __spreadValues({
        product
      }, rest))
    }, index))
  }));
};

exports.ProductCarousel = ProductCarousel;


/***/ }),

/***/ 85657:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var ProductCard = __webpack_require__(14874);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const GAP = 16;
const ProductGrid = (_a) => {
  var _b = _a, {
    items = [],
    gridOptions,
    layout
  } = _b, rest = __objRest(_b, [
    "items",
    "gridOptions",
    "layout"
  ]);
  const { device } = coreRenderer.useStore();
  const { columns = 5 } = gridOptions || {};
  const cols = device === "mobile" ? 2 : columns;
  return /* @__PURE__ */ jsxRuntime.jsx(WrapperGrid, {
    style: { gridTemplateColumns: `repeat(${cols}, 1fr)` },
    children: items.map((product, index) => /* @__PURE__ */ jsxRuntime.jsx("div", {
      children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BreakpointWidthProvider, {
        sWidth: { value: 100 / 2, unit: "%" },
        mWidth: { value: 100 / columns, unit: "%" },
        children: /* @__PURE__ */ jsxRuntime.jsx(ProductCard.ProductCard, __spreadValues({
          product
        }, rest))
      })
    }, index))
  });
};
const WrapperGrid = styled__default["default"].div`
  display: grid;
  align-self: stretch;
  gap: ${GAP}px;
`;

exports.ProductGrid = ProductGrid;


/***/ }),

/***/ 29203:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var type = __webpack_require__(343);

const DEFAULT_PRODUCT_LIST = {
  layout: "grid",
  currencyUnit: "\u0111",
  currencyAlignment: "right",
  gridOptions: {
    rows: 4,
    columns: 4
  },
  items: [
    {
      name: "S\u1EA3n ph\u1EA9m 1",
      price: 1e5,
      link: "https://tempi.vn",
      discount: 30,
      image: {
        src: "https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500"
      },
      virtualRating: 5
    },
    {
      name: "S\u1EA3n ph\u1EA9m 2",
      price: 1e5,
      discount: 30,
      image: {
        src: "https://lh3.googleusercontent.com/s30ROB2cqLL_G97fr4qG8VjryAdAREIOV2pUSjq9p0IjXy8V7Jy3hf-E1f-wtA9t69JIbg4xSyNR3ck_Jnfpn4bfZ6rSmJNg=rw-w500"
      },
      virtualRating: 5
    },
    {
      name: "S\u1EA3n ph\u1EA9m 3",
      price: 1e5,
      discount: 30,
      image: {
        src: "https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"
      },
      virtualRating: 5
    },
    {
      name: "S\u1EA3n ph\u1EA9m 4",
      price: 1e5,
      discount: 30,
      image: {
        src: "https://lh3.googleusercontent.com/xR9Sx8XT-vsY7F-2x4wnlGk7LXFLb2sCW1RoWtR7dTUmfrpqVvdO2F00Q8g51s7b1TYVZddlIIQXoUzRiv50Ao4k3TLQbvY=rw-w500"
      },
      virtualRating: 5
    }
  ],
  eventType: "link",
  alignment: "left",
  nameStyle: {
    color: "#000",
    fontSize: 16
  },
  priceStyle: {
    color: "#000",
    fontSize: 14
  }
};
const defaultGridOptions = {
  rows: 1,
  columns: 4
};
const defaultCarouselOptions = {
  type: type.SliderTypeEnum.product,
  slidesPerView: 5,
  slidesPerColumn: 1,
  navigation: true,
  navigationStyle: 1,
  autoplay: true,
  loop: false,
  spaceBetween: 16,
  speed: 3e3
};
const DATA_KEYS = {
  name: "T\xEAn kh\xE1ch h\xE0ng",
  phoneNumber: "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
  address: "\u0110\u1ECBa ch\u1EC9",
  note: "Th\xF4ng tin b\u1ED5 sung",
  productName: "T\xEAn s\u1EA3n ph\u1EA9m",
  price: "Gi\xE1 b\xE1n"
};
const inputsConfig = [
  {
    type: "text",
    name: DATA_KEYS.name,
    label: "T\xEAn",
    placeholder: "Nh\u1EADp h\u1ECD v\xE0 t\xEAn",
    required: true,
    commonStyle: {
      height: 32,
      width: "100%"
    },
    inputStyle: {
      borderRadius: 4
    }
  },
  {
    type: "tel",
    name: DATA_KEYS.phoneNumber,
    label: "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
    placeholder: "Nh\u1EADp s\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
    required: true,
    commonStyle: {
      height: 32,
      width: "100%"
    },
    inputStyle: {
      borderRadius: 4
    }
  },
  {
    type: "text",
    name: DATA_KEYS.address,
    label: "\u0110\u1ECBa ch\u1EC9",
    placeholder: "Nh\u1EADp \u0111\u1ECBa ch\u1EC9 nh\u1EADn h\xE0ng",
    required: true,
    commonStyle: {
      height: 32,
      width: "100%"
    },
    inputStyle: {
      borderRadius: 4
    }
  },
  {
    type: "textarea",
    name: DATA_KEYS.note,
    label: "Th\xF4ng tin b\u1ED5 sung",
    placeholder: "Th\xF4ng tin b\u1ED5 sung cho ng\u01B0\u1EDDi b\xE1n.\nVD: S\u1ED1 l\u01B0\u1EE3ng, k\xEDch th\u01B0\u1EDBc, giao gi\u1EDD h\xE0nh ch\xEDnh...",
    commonStyle: {
      width: "100%"
    },
    inputStyle: {
      borderRadius: 4,
      minHeight: 100
    }
  }
];

exports.DATA_KEYS = DATA_KEYS;
exports.DEFAULT_PRODUCT_LIST = DEFAULT_PRODUCT_LIST;
exports.defaultCarouselOptions = defaultCarouselOptions;
exports.defaultGridOptions = defaultGridOptions;
exports.inputsConfig = inputsConfig;


/***/ }),

/***/ 56516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(91987);
var coreRenderer = __webpack_require__(12060);
var constants = __webpack_require__(29203);
var queryStringToObject = __webpack_require__(39217);
var getPartialDateTimeTimeZone7 = __webpack_require__(81700);
var transformValueGGSheet = __webpack_require__(73416);
var form = __webpack_require__(11340);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useCheckout = (configStorage) => {
  const { env } = coreRenderer.useStore();
  const [selectedProduct, setSelectedProduct] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [doneCheckout, setDoneCheckout] = React.useState(false);
  const handleFinishCheckout = async (values) => {
    var _b;
    try {
      setLoading(true);
      const _a = queryStringToObject.queryStringToObject(window.location.search) || {}, {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_term,
        utm_content
      } = _a, rest = __objRest(_a, [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_term",
        "utm_content"
      ]);
      const newValues = __spreadValues(__spreadValues({
        utm_source,
        utm_medium,
        utm_campaign,
        utm_term,
        utm_content
      }, (configStorage == null ? void 0 : configStorage.autoPassParams) && rest), values);
      const date = new Date();
      const { year, month, day, hour, minute, second } = getPartialDateTimeTimeZone7.getPartialDateTimeTimeZone7(date);
      const dateString = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      let valuesSubmit = transformValueGGSheet.transformValuesGGSheet(newValues, constants.inputsConfig);
      valuesSubmit = [
        ...valuesSubmit,
        {
          name: "T\xEAn s\u1EA3n ph\u1EA9m",
          type: "string",
          value: selectedProduct == null ? void 0 : selectedProduct.name
        },
        {
          name: "Gi\xE1 b\xE1n",
          type: "number",
          value: selectedProduct == null ? void 0 : selectedProduct.price
        },
        {
          name: "Th\u1EDDi gian g\u1EEDi",
          type: "string",
          value: dateString
        },
        {
          name: "G\u1EEDi t\u1EEB URL",
          type: "string",
          value: (_b = window == null ? void 0 : window.location) == null ? void 0 : _b.href
        }
      ];
      await form.formUtils.submitFormData(
        configStorage == null ? void 0 : configStorage.formConfigId,
        valuesSubmit,
        `${coreRenderer.publicBffUrl[env]}/v1/submit-form`
      );
      setSelectedProduct(void 0);
      setDoneCheckout(true);
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    handleFinishCheckout,
    selectedProduct,
    setSelectedProduct,
    doneCheckout,
    setDoneCheckout
  };
};

exports.useCheckout = useCheckout;


/***/ }),

/***/ 68944:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var constants = __webpack_require__(29203);
var hooks = __webpack_require__(56516);
var CheckoutPopup = __webpack_require__(28713);
var CheckoutSuccessPopup = __webpack_require__(44680);
var ProductCarousel = __webpack_require__(74457);
var ProductGrid = __webpack_require__(85657);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TempiProductList = (_a) => {
  var _b = _a, {
    isEditingMode,
    configStorage
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "configStorage"
  ]);
  const {
    selectedProduct,
    setSelectedProduct,
    loading,
    doneCheckout,
    setDoneCheckout,
    handleFinishCheckout
  } = hooks.useCheckout(configStorage);
  const handleClickProduct = (restProps == null ? void 0 : restProps.eventType) === "showPopup" ? setSelectedProduct : void 0;
  const renderContent = () => {
    if ((restProps == null ? void 0 : restProps.layout) === "carousel")
      return /* @__PURE__ */ jsxRuntime.jsx(ProductCarousel.ProductCarousel, __spreadProps(__spreadValues({
        isEditingMode
      }, restProps), {
        carouselOptions: __spreadValues(__spreadValues({}, constants.defaultCarouselOptions), restProps == null ? void 0 : restProps.carouselOptions),
        onClick: handleClickProduct
      }));
    return /* @__PURE__ */ jsxRuntime.jsx(ProductGrid.ProductGrid, __spreadProps(__spreadValues({
      isEditingMode
    }, restProps), {
      gridOptions: __spreadValues(__spreadValues({}, constants.defaultGridOptions), restProps == null ? void 0 : restProps.gridOptions),
      onClick: handleClickProduct
    }));
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      renderContent(),
      /* @__PURE__ */ jsxRuntime.jsx(CheckoutPopup.CheckoutPopup, {
        open: !!selectedProduct,
        setOpen: () => setSelectedProduct(void 0),
        loading,
        onFinish: handleFinishCheckout
      }),
      /* @__PURE__ */ jsxRuntime.jsx(CheckoutSuccessPopup.CheckoutSuccessPopup, {
        open: doneCheckout,
        setOpen: () => setDoneCheckout(false)
      })
    ]
  });
};
TempiProductList.displayName = "TempiProductList";

exports.TempiProductList = TempiProductList;


/***/ }),

/***/ 57901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var qrcode_react = __webpack_require__(92295);
var React = __webpack_require__(91987);
var grid = __webpack_require__(74178);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const QRCode = ({
  value,
  qrCodeStyle,
  commonStyle,
  alignment = grid.MAPPING_VERTICAL_ALIGNMENT_FLEX.center,
  size = 160,
  bordered = true
}) => {
  const qrCodeProps = React.useMemo(() => {
    return {
      value,
      size,
      level: "M",
      bgColor: (qrCodeStyle == null ? void 0 : qrCodeStyle.backgroundColor) || "transparent",
      fgColor: qrCodeStyle == null ? void 0 : qrCodeStyle.color
    };
  }, [qrCodeStyle, size, value]);
  return /* @__PURE__ */ jsxRuntime.jsx(QRCodeWrapper, {
    align: alignment,
    children: /* @__PURE__ */ jsxRuntime.jsx(StyledQRCode, __spreadProps(__spreadValues({
      commonStyle
    }, { size, bordered, backgroundColor: qrCodeStyle == null ? void 0 : qrCodeStyle.backgroundColor }), {
      children: /* @__PURE__ */ jsxRuntime.jsx(qrcode_react.QRCodeCanvas, __spreadValues({}, qrCodeProps))
    }))
  });
};
QRCode.displayName = "QRCode";
const QRCodeWrapper = styled__default["default"].div(
  ({ align }) => `
  display: flex;
  justify-content: ${grid.MAPPING_ALIGNMENT_FLEX[align]};
`
);
const StyledQRCode = styled__default["default"].div(
  ({
    size,
    backgroundColor,
    bordered,
    commonStyle
  }) => `
  box-sizing: border-box;
  margin: 0;
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${backgroundColor ? backgroundColor : "#fff"};
  border-radius: 8px;
  ${bordered ? "border: 1px solid rgba(5, 5, 5, 0.06);" : ""}
  position: relative;
  width: ${size};
  height: ${size};
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)};
`
);

exports.QRCode = QRCode;


/***/ }),

/***/ 96453:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
    min-height: 100vh;
    overflow: hidden;
    
    ${(commonStyle == null ? void 0 : commonStyle.backgroundOverlay) ? "z-index: 0;" : ""}
    ${coreRenderer.getStyle(commonStyle)};
  `
);
const Root = (props) => {
  const { device } = coreRenderer.useStore();
  const newProps = coreRenderer.getPropsByDevice(props, device);
  const { children, commonStyle } = newProps;
  return /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BreakpointWidthProvider, {
    sWidth: { value: 100, unit: "%" },
    mWidth: { value: 100, unit: "%" },
    children: /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
      commonStyle,
      children
    })
  });
};
Root.displayName = "Root";

exports.Root = Root;


/***/ }),

/***/ 82398:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var clsx = __webpack_require__(77084);
var React = __webpack_require__(91987);
var Row = __webpack_require__(58624);
var grid = __webpack_require__(74178);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledPbRow = styled__default["default"](Row.Row)(
  ({
    verticalAlignment,
    commonStyle
  }) => `
  ${coreRenderer.getStyle(commonStyle, { lazyBgImage: true })}
  align-items: ${grid.MAPPING_VERTICAL_ALIGNMENT_FLEX[verticalAlignment] || grid.MAPPING_VERTICAL_ALIGNMENT_FLEX.top};
`
);
const PbRow = React__default["default"].forwardRef(
  (props, passRef) => {
    const _a = props, {
      commonStyle,
      children,
      verticalAlignment,
      gutter,
      className
    } = _a, rest = __objRest(_a, [
      "commonStyle",
      "children",
      "verticalAlignment",
      "gutter",
      "className"
    ]);
    const rowRef = React.useRef(null);
    const ref = passRef || rowRef;
    const entry = coreRenderer.useIntersectionObserver(ref, {
      freezeOnceVisible: true
    });
    const { style: animationStyle, animationClassName } = coreRenderer.useAnimation(
      commonStyle == null ? void 0 : commonStyle.animation,
      rowRef
    );
    return /* @__PURE__ */ jsxRuntime.jsxs(StyledPbRow, __spreadProps(__spreadValues({
      verticalAlignment,
      ref: (el) => {
        if (typeof passRef === "function") {
          passRef(el);
        } else if (passRef) {
          passRef.current = el;
        }
        rowRef.current = el;
      },
      commonStyle,
      style: animationStyle,
      gutter: gutter || [16, 16],
      className: clsx__default["default"](
        className,
        {
          [coreRenderer.BG_LAZY_CLASS_NAME]: true,
          [coreRenderer.BG_VISIBLE_LAZY_CLASS_NAME]: entry == null ? void 0 : entry.isIntersecting
        },
        animationClassName
      )
    }, rest), {
      children: [
        (commonStyle == null ? void 0 : commonStyle.backgroundVideo) && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BackgroundVideo, __spreadValues({}, commonStyle.backgroundVideo)),
        children
      ]
    }));
  }
);
PbRow.displayName = Row.Row.displayName;

exports.PbRow = PbRow;


/***/ }),

/***/ 69447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var index = __webpack_require__(5502);
var ui = __webpack_require__(68882);
var ui$1 = __webpack_require__(82398);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PbSection = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, {
      children,
      commonStyle,
      verticalAlignment,
      widthType,
      row,
      gutter
    } = _a, other = __objRest(_a, [
      "children",
      "commonStyle",
      "verticalAlignment",
      "widthType",
      "row",
      "gutter"
    ]);
    const { maxWidth } = commonStyle;
    let rowStyle = row == null ? void 0 : row.commonStyle;
    rowStyle = __spreadValues({ minHeight: "inherit", height: "100%" }, rowStyle);
    if (rowStyle == null ? void 0 : rowStyle.maxWidth) {
      rowStyle = __spreadValues({
        marginLeft: "auto !important",
        marginRight: "auto !important"
      }, rowStyle);
    }
    return /* @__PURE__ */ jsxRuntime.jsxs(ui.PbContainer, __spreadProps(__spreadValues({
      maxWidth,
      fluid: widthType === index.WidthTypeEnum.full,
      ref,
      commonStyle
    }, other), {
      children: [
        (commonStyle == null ? void 0 : commonStyle.backgroundVideo) && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BackgroundVideo, __spreadValues({}, commonStyle.backgroundVideo)),
        /* @__PURE__ */ jsxRuntime.jsx(ui$1.PbRow, {
          commonStyle: rowStyle,
          verticalAlignment,
          gutter,
          children
        })
      ]
    }));
  }
);
PbSection.displayName = "Section";

exports.PbSection = PbSection;


/***/ }),

/***/ 343:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var SliderTypeEnum = /* @__PURE__ */ ((SliderTypeEnum2) => {
  SliderTypeEnum2["image"] = "image";
  SliderTypeEnum2["product"] = "product";
  return SliderTypeEnum2;
})(SliderTypeEnum || {});

exports.SliderTypeEnum = SliderTypeEnum;


/***/ }),

/***/ 88494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var styled = __webpack_require__(21483);
var React = __webpack_require__(91987);
var Slider$1 = __webpack_require__(85468);
var ui = __webpack_require__(49864);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Slider = (props) => {
  const _a = props, { items, type, commonStyle, isEditingMode } = _a, sliderConfig = __objRest(_a, ["items", "type", "commonStyle", "isEditingMode"]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const wrapperStyleRef = React.useRef(__spreadValues({}, commonStyle));
  const handleChangeWrapperStyle = () => {
    const newWrapperStyle = __spreadValues({}, wrapperStyleRef.current);
    delete newWrapperStyle.height;
    delete newWrapperStyle.borderRadius;
    wrapperStyleRef.current = newWrapperStyle;
  };
  if ((sliderConfig == null ? void 0 : sliderConfig.slidesPerColumn) > 1 || (sliderConfig == null ? void 0 : sliderConfig.showThumbnail)) {
    handleChangeWrapperStyle();
  }
  const sliderPerRow = (sliderConfig == null ? void 0 : sliderConfig.slidesPerColumn) || 1;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle: wrapperStyleRef.current,
    children: /* @__PURE__ */ jsxRuntime.jsx(Slider$1.DSSlider, __spreadProps(__spreadValues(__spreadValues({
      commonStyle
    }, sliderConfig), !(sliderConfig == null ? void 0 : sliderConfig.showThumbnail) && {
      paginationStyle: 2,
      navigationStyle: 3
    }), {
      children: displayItems == null ? void 0 : displayItems.map((item, index) => {
        return /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BreakpointWidthProvider, {
          sWidth: { value: 100 / sliderPerRow, unit: "%" },
          mWidth: { value: 100 / sliderPerRow, unit: "%" },
          children: /* @__PURE__ */ jsxRuntime.jsx(ui.Image, __spreadValues({
            commonStyle: {
              objectFit: props.crop ? "cover" : "contain",
              height: commonStyle == null ? void 0 : commonStyle.height,
              width: "100%"
            },
            fetchPriority: index === 0 ? "high" : "auto"
          }, item))
        }, index);
      })
    }))
  });
};
Slider.displayName = "Slider";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)};
  overflow: hidden;
`
);

exports.Slider = Slider;


/***/ }),

/***/ 89475:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var type = __webpack_require__(343);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const convertOptionSliderV2ToV1 = (options) => {
  const _a = options, {
    items,
    gridCols,
    gridRows,
    arrows,
    arrowStyle,
    pagination,
    paginationStyle,
    autoplay,
    pauseOnHover,
    rewind,
    paginationColor
  } = _a, rest = __objRest(_a, [
    "items",
    "gridCols",
    "gridRows",
    "arrows",
    "arrowStyle",
    "pagination",
    "paginationStyle",
    "autoplay",
    "pauseOnHover",
    "rewind",
    "paginationColor"
  ]);
  const newValue = __spreadValues({
    type: type.SliderTypeEnum.product,
    items,
    slidesPerColumn: gridRows,
    slidesPerView: gridCols,
    navigation: arrows || !!arrowStyle,
    navigationStyle: arrowStyle,
    pagination: pagination || !!paginationStyle,
    paginationStyle,
    autoplay,
    loop: rewind,
    pauseOnMouseEnter: pauseOnHover,
    paginationColor,
    virtual: gridRows === 1
  }, rest);
  return Object.keys(newValue).filter((el) => newValue[el] !== void 0).reduce(
    (acc, curr) => __spreadProps(__spreadValues({}, acc), { [curr]: newValue[curr] }),
    {}
  );
};

exports.convertOptionSliderV2ToV1 = convertOptionSliderV2ToV1;


/***/ }),

/***/ 21424:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);
var coreRenderer = __webpack_require__(12060);
var index = __webpack_require__(43866);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const socialIconMapping = {
  facebook: {
    icon: "FacebookFilled",
    color: "#415993"
  },
  youtube: {
    icon: "YoutubeFilled",
    color: "#bd342b"
  },
  tiktok: {
    icon: "TiktokFilled",
    color: "#262626"
  },
  instagram: {
    icon: "InstagramFilled",
    color: "#d96357"
  },
  twitter: {
    icon: "TwitterFilled",
    color: "#1DA1F2"
  },
  github: {
    icon: "GithubFilled",
    color: "#000000"
  },
  zalo: { icon: "ZaloFilled", color: "#2d75f6" }
};
const SocialIcon = ({
  commonStyle,
  icons: icons$1,
  iconSize,
  iconStyle
}) => {
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle,
    children: icons$1.map((e, index$1) => {
      var _a, _b;
      if (!socialIconMapping[e.name])
        return;
      return /* @__PURE__ */ jsxRuntime.jsx(index.Link, __spreadProps(__spreadValues({}, e.link), {
        children: /* @__PURE__ */ jsxRuntime.jsx(IconWrapper, {
          iconStyle: __spreadProps(__spreadValues({}, iconStyle), {
            height: iconStyle.width,
            backgroundColor: (_a = socialIconMapping[e.name]) == null ? void 0 : _a.color
          }),
          children: /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
            name: (_b = socialIconMapping == null ? void 0 : socialIconMapping[e.name]) == null ? void 0 : _b.icon,
            style: { fontSize: iconSize || 25 }
          })
        })
      }), index$1);
    })
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)};
  display: flex;
`
);
const IconWrapper = styled__default["default"].div(
  ({ iconStyle }) => `
${coreRenderer.getStyle(iconStyle)};
display: flex;
align-items: center;
justify-content: center;
border-radius: 10%;
> span {
  color: white;
  line-height: 1; 
}
`
);
SocialIcon.displayName = "SocialIcon";

exports.SocialIcon = SocialIcon;


/***/ }),

/***/ 51986:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Spacer = ({ height = 0, commonStyle }) => /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
  height,
  commonStyle
});
const Wrapper = styled__default["default"].div(
  ({ height, commonStyle }) => `
  height: ${height}px;
  width: 100%;
  ${coreRenderer.getStyle(commonStyle)}
`
);
Spacer.displayName = "Spacer";

exports.Spacer = Spacer;


/***/ }),

/***/ 40521:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);
var React = __webpack_require__(91987);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Store = ({ store, mainColor }) => {
  const { name, address, phone, workHours, map } = store;
  const [showMap, setShowMap] = React.useState(false);
  return /* @__PURE__ */ jsxRuntime.jsxs(StoreWrapper, {
    mainColor,
    children: [
      /* @__PURE__ */ jsxRuntime.jsx("div", {
        className: "store-name",
        children: /* @__PURE__ */ jsxRuntime.jsx("b", {
          children: name
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsxs("div", {
        className: "store-details",
        children: [
          /* @__PURE__ */ jsxRuntime.jsxs("div", {
            className: "store-address",
            children: [
              /* @__PURE__ */ jsxRuntime.jsx("b", {
                children: "\u0110\u1ECBa ch\u1EC9: "
              }),
              address
            ]
          }),
          /* @__PURE__ */ jsxRuntime.jsxs("div", {
            className: "bottom-elements",
            children: [
              /* @__PURE__ */ jsxRuntime.jsxs("div", {
                className: "store-info",
                children: [
                  /* @__PURE__ */ jsxRuntime.jsxs("div", {
                    className: "store-phone",
                    children: [
                      /* @__PURE__ */ jsxRuntime.jsx("b", {
                        children: "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i: "
                      }),
                      /* @__PURE__ */ jsxRuntime.jsx("span", {
                        children: phone
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsxRuntime.jsxs("div", {
                    className: "store-working-hours",
                    children: [
                      /* @__PURE__ */ jsxRuntime.jsx("b", {
                        children: "Gi\u1EDD m\u1EDF c\u1EEDa: "
                      }),
                      /* @__PURE__ */ jsxRuntime.jsx("span", {
                        children: workHours
                      })
                    ]
                  })
                ]
              }),
              map && /* @__PURE__ */ jsxRuntime.jsxs("button", {
                onClick: () => setShowMap(!showMap),
                className: "map-toggle",
                children: [
                  "T\xECm \u0111\u01B0\u1EDDng",
                  " ",
                  showMap ? /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                    name: "ArrowDownTinyFilled"
                  }) : /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                    name: "ArrowUpTinyFilled"
                  })
                ]
              })
            ]
          })
        ]
      }),
      showMap && map && /* @__PURE__ */ jsxRuntime.jsx("div", {
        className: "store-map",
        children: map.startsWith("<iframe") ? /* @__PURE__ */ jsxRuntime.jsx("div", {
          dangerouslySetInnerHTML: {
            __html: map
          }
        }) : /* @__PURE__ */ jsxRuntime.jsx("iframe", {
          src: map,
          title: "map",
          allowFullScreen: true
        })
      })
    ]
  });
};
const StoreWrapper = styled__default["default"].div(
  ({ mainColor }) => `
  line-height: 2;
  padding: 0.8em 1.5em;
  background-color: white;
  border-bottom: 1px solid #eaeaea;

  &:hover{
    background: ${mainColor.slice(0, 7) + "10"};
  }


  .store-name{
    font-size: 1.4em;
    color: ${mainColor};
  }

  .store-details{
    position: relative;

    .bottom-elements{
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .store-info{
        display: inline-block;
        margin-right: auto;
        padding-bottom: 0.5em;
      }   

      .map-toggle{
        border: 1px solid ${mainColor};
        background-color: white;
      
        height: 40px;
        color: ${mainColor};
        line-height: 40px;
        display: block;
        padding: 0 15px;
        border-radius: 4px;
        outline-color: ${mainColor};

        svg{
          vertical-align: baseline;
        }
      }
    }
  }
  
  .store-map{
    margin-top: 1em;

    iframe{
      width: 100%;
      border: none;
      border-radius: 1em;
    }
  }
`
);

exports.Store = Store;


/***/ }),

/***/ 97424:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);

const useGetCitiesAndDistricts = () => {
  const [VN, setVN] = React.useState({});
  React.useEffect(() => {
    const getVNJsonFile = async () => {
      try {
        const response = await fetch(coreRenderer.mappingAssets.VN);
        const jsonResponse = await response.json();
        setVN(jsonResponse);
      } catch (e) {
        console.error(e);
      }
    };
    getVNJsonFile();
  }, []);
  const cities = VN["province"] || [];
  const districts = VN["district"] || [];
  return { cities, districts };
};

exports.useGetCitiesAndDistricts = useGetCitiesAndDistricts;


/***/ }),

/***/ 58783:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var hooks = __webpack_require__(97424);
var Store = __webpack_require__(40521);
var Row = __webpack_require__(58624);
var Col = __webpack_require__(97089);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const StoreList = ({
  stores,
  mainColor = "#2e7ac1",
  commonStyle,
  stickyTop,
  title
}) => {
  const [cityId, setCityId] = React.useState();
  const [districtId, setDistrictId] = React.useState();
  const [filteredStores, setFilteredStores] = React.useState(stores);
  const { cities: _cities, districts: _districts } = hooks.useGetCitiesAndDistricts();
  const cities = _cities.filter(
    (city) => !!stores.find((store) => store.cityId === city.idProvince)
  );
  const districts = _districts.filter(
    (district) => district.idProvince === cityId && !!stores.find((store) => store.districtId === district.idDistrict)
  );
  const handleChangeLocation = (_cityId, _districtId) => {
    if (_cityId) {
      setCityId(_cityId);
      setDistrictId(null);
    }
    if (_districtId) {
      setDistrictId(_districtId);
    }
  };
  React.useEffect(() => {
    if (!cityId || cityId === "0") {
      setFilteredStores(stores);
    } else if (cityId && (!districtId || districtId === "0")) {
      setFilteredStores(stores.filter((store) => store.cityId === cityId));
    } else
      setFilteredStores(
        stores.filter(
          (store) => store.cityId === cityId && store.districtId === districtId
        )
      );
  }, [cityId, districtId, stores]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    stickyTop,
    mainColor,
    commonStyle,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Row.Row, {
      gutter: [24, 16],
      children: [
        /* @__PURE__ */ jsxRuntime.jsxs(Col.Col, {
          md: 5,
          xs: 12,
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs("div", {
              className: "label",
              children: [
                "H\u1EC7 th\u1ED1ng ",
                stores.length,
                " c\u1EEDa h\xE0ng"
              ]
            }),
            /* @__PURE__ */ jsxRuntime.jsxs("div", {
              className: "select-location",
              children: [
                /* @__PURE__ */ jsxRuntime.jsx("h5", {
                  children: /* @__PURE__ */ jsxRuntime.jsx("b", {
                    children: title || "Ch\u1ECDn c\u1EEDa h\xE0ng theo t\u1EC9nh/th\xE0nh ph\u1ED1"
                  })
                }),
                /* @__PURE__ */ jsxRuntime.jsxs("select", {
                  onChange: (e) => handleChangeLocation(e.target.value),
                  children: [
                    /* @__PURE__ */ jsxRuntime.jsx("option", {
                      value: 0,
                      children: "Ch\u1ECDn t\u1EC9nh/ th\xE0nh ph\u1ED1"
                    }),
                    cities.map((city) => /* @__PURE__ */ jsxRuntime.jsx("option", {
                      value: city.idProvince,
                      children: city.name
                    }, city.idProvince))
                  ]
                }),
                /* @__PURE__ */ jsxRuntime.jsxs("select", {
                  onChange: (e) => handleChangeLocation(null, e.target.value),
                  children: [
                    /* @__PURE__ */ jsxRuntime.jsx("option", {
                      value: 0,
                      children: "Ch\u1ECDn qu\u1EADn/ huy\u1EC7n"
                    }),
                    districts.sort((a, b) => a.name < b.name ? -1 : 1).map((district) => /* @__PURE__ */ jsxRuntime.jsx("option", {
                      value: district.idDistrict,
                      children: district.name
                    }, district.idDistrict))
                  ]
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(Col.Col, {
          md: 7,
          xs: 12,
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs("div", {
              className: "label",
              children: [
                filteredStores.length,
                " k\u1EBFt qu\u1EA3"
              ]
            }),
            /* @__PURE__ */ jsxRuntime.jsx("div", {
              className: "store-list",
              children: filteredStores.length > 0 ? filteredStores.map((store, i) => /* @__PURE__ */ jsxRuntime.jsx(Store.Store, {
                store,
                mainColor
              }, i)) : /* @__PURE__ */ jsxRuntime.jsx(Empty, {
                mainColor,
                children: "Kh\xF4ng c\xF3 c\u1EEDa h\xE0ng"
              })
            })
          ]
        })
      ]
    })
  });
};
StoreList.displayName = "StoreList";
const Empty = styled__default["default"].div(
  ({ mainColor }) => `
  font-size: 1.8em;
  text-align: center;
  padding: 2em;
  color: ${mainColor};
  opacity: 0.85;

`
);
const Wrapper = styled__default["default"].div(
  ({ mainColor, commonStyle, stickyTop }) => `   
  ${coreRenderer.getStyle(commonStyle)}

  .label{
    font-size: 1em;
    margin-bottom: 0.5em;
  }

  .select-location{    
    padding: 0.8em 1.5em;
    background-color: ${mainColor};
    border-radius: 3px;
    font-size: 1.1em;
    position: sticky;
    top: ${stickyTop}px;
    
    h5 {
      color: white;
      margin-top: 0.5em;
      margin-bottom: 1em;
    }
  
    select{
      width: 100%;
      margin-bottom: 1em;
      border-radius: 4px;
      -webkit-appearance: none;
      padding: 0.5em 3.5em 0.5em 1em;

      background-color: white;
      background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);
      background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
      background-size: 5px 5px, 5px 5px, 1px 1.5em;
      background-repeat: no-repeat;      
    }
  }
  
  .store-list{
    border: 1px solid ${mainColor};
    border-radius: 5px;
    overflow: hidden;
  }
`
);

exports.StoreList = StoreList;


/***/ }),

/***/ 12770:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var TabItemHead = __webpack_require__(17617);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Tab = React.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      children,
      commonStyle,
      tabs = [],
      activeColor,
      textColor,
      type,
      alignment = "left"
    } = _b, rest = __objRest(_b, [
      "children",
      "commonStyle",
      "tabs",
      "activeColor",
      "textColor",
      "type",
      "alignment"
    ]);
    const numberOfChildren = tabs.length;
    const [activeTab, setActiveTab] = React.useState(0);
    const tabHeadRef = React.useRef();
    const tabHead = tabHeadRef == null ? void 0 : tabHeadRef.current;
    React.useEffect(() => {
      if (tabHead && tabHead.scroll) {
        const activeDom = tabHead.childNodes[activeTab];
        tabHead.scroll({
          left: activeDom.offsetLeft - (tabHead.offsetWidth - activeDom.offsetWidth) / 2,
          behavior: "smooth"
        });
      }
    }, [activeTab]);
    React.useEffect(() => {
      if (tabs.length - 1 < activeTab) {
        setActiveTab(Math.max(tabs.length - 1, 0));
      }
    }, [tabs]);
    return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({
      ref,
      commonStyle
    }, rest), {
      children: [
        !!tabs.length && /* @__PURE__ */ jsxRuntime.jsx(TabHeadWrapper, {
          ref: tabHeadRef,
          children: tabs.map((tab, index) => /* @__PURE__ */ jsxRuntime.jsx(TabItemHeadWrapper, {
            alignment,
            index,
            arrayLength: numberOfChildren,
            children: /* @__PURE__ */ jsxRuntime.jsx(TabItemHead.TabItemHead, __spreadProps(__spreadValues({
              id: `tab-${index}`,
              activeColor,
              textColor,
              isActive: index === activeTab,
              alignment,
              onClick: () => {
                setActiveTab(index);
              },
              type
            }, tab), {
              children: /* @__PURE__ */ jsxRuntime.jsx("span", {
                dangerouslySetInnerHTML: { __html: tab.title }
              })
            }))
          }, index))
        }),
        (children == null ? void 0 : children[activeTab]) || (children != null ? children : null)
      ]
    }));
  }
);
const TabHeadWrapper = styled__default["default"].div`
  display: flex;
  white-space: nowrap;
  overflow-x: scroll;
  gap: 8px;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
    width: 100%;
    position: relative;
    ${coreRenderer.getStyle(commonStyle)};
`
);
const getItemHeadAlignment = (alignment, index, arrayLength) => {
  switch (alignment) {
    case "center":
      if (index === 0)
        return "margin-left: auto;";
      else if (index === arrayLength - 1)
        return "margin-right: auto;";
      else
        return "";
    case "justify":
      return "margin: auto;";
    case "right":
      if (index === 0)
        return "margin-left: auto;";
      else
        return "";
    case "left":
      if (index === arrayLength - 1)
        return "margin-right: auto";
      else
        return "";
    default:
      return "";
  }
};
const TabItemHeadWrapper = styled__default["default"].div(
  ({
    alignment,
    index,
    arrayLength
  }) => `
  ${getItemHeadAlignment(alignment, index, arrayLength)}`
);
Tab.displayName = "Tab";

exports.Tab = Tab;
exports.TabHeadWrapper = TabHeadWrapper;


/***/ }),

/***/ 10348:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var React = __webpack_require__(91987);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TabItem = React.forwardRef(
  (_a, ref) => {
    var _b = _a, { children, onClick } = _b, rest = __objRest(_b, ["children", "onClick"]);
    return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
      ref,
      onClick
    }, rest), {
      children
    }));
  }
);
const Wrapper = styled__default["default"].div`
  padding: 8px;
  width: 100%;
  height: 100%;
`;
TabItem.displayName = "TabItem";

exports.TabItem = TabItem;


/***/ }),

/***/ 17617:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TabItemHead = (_a) => {
  var _b = _a, {
    type,
    children,
    isActive,
    activeColor = "#258DFF",
    textColor,
    alignment
  } = _b, rest = __objRest(_b, [
    "type",
    "children",
    "isActive",
    "activeColor",
    "textColor",
    "alignment"
  ]);
  switch (type) {
    case "line":
      return /* @__PURE__ */ jsxRuntime.jsx(TabHeadLine, __spreadProps(__spreadValues({
        alignment,
        className: isActive ? "active" : "",
        textColor,
        activeColor
      }, rest), {
        children
      }));
    case "card":
      return /* @__PURE__ */ jsxRuntime.jsx(TabHeadCard, __spreadProps(__spreadValues({
        alignment,
        className: isActive ? "active" : "",
        activeColor,
        textColor
      }, rest), {
        children
      }));
    case "rectangle":
      return /* @__PURE__ */ jsxRuntime.jsx(TabHeadRectangle, __spreadProps(__spreadValues({
        className: isActive ? "active" : "",
        activeColor,
        textColor
      }, rest), {
        children
      }));
    default:
      return /* @__PURE__ */ jsxRuntime.jsx(TabHeadButton, __spreadProps(__spreadValues({
        className: isActive ? "active" : "",
        activeColor,
        textColor
      }, rest), {
        children
      }));
  }
};
const baseCss = `
  transition: 0.2s;
  cursor: pointer;
  height: 32px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const TabHeadButton = styled__default["default"].div(
  ({ activeColor, textColor }) => `
border-radius: 999px;
background-color: transparent;
color: ${textColor || "inherit"};
${baseCss}
&.active {
  background: ${activeColor};
  color: #fff;
}
`
);
const TabHeadRectangle = styled__default["default"].div(
  ({ activeColor, textColor }) => `
border-radius: 0;
background-color: transparent;
color: ${textColor || "inherit"};
${baseCss}
&.active {
  background: ${activeColor};
  color: #fff;
}
`
);
const TabHeadLine = styled__default["default"].div(
  ({ activeColor, alignment, textColor }) => `
  ${baseCss}
  ${alignment === "justify" ? "width: 100% !important;" : ""}
  color: ${textColor || "inherit"};
  &::after {
    content: '';
    height: 2px;
    background-color: ${activeColor};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: all 0.3s ease;
  }
  &.active {
    position: relative;
    &::after {
      opacity: 1;
    }
  }
`
);
const TabHeadCard = styled__default["default"].div(
  ({ activeColor, alignment, textColor }) => `
  ${baseCss}
  ${alignment === "justify" ? "width: 100% !important;" : ""}
  color: ${textColor || "inherit"};
  &.active {
    color: ${activeColor};
  }
`
);
TabItemHead.displayName = "TabItemHead";

exports.TabHeadButton = TabHeadButton;
exports.TabHeadCard = TabHeadCard;
exports.TabHeadLine = TabHeadLine;
exports.TabHeadRectangle = TabHeadRectangle;
exports.TabItemHead = TabItemHead;


/***/ }),

/***/ 92163:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var fonts = __webpack_require__(74367);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Table = (_a) => {
  var _b = _a, { text, children } = _b, rest = __objRest(_b, ["text", "children"]);
  if (children) {
    return /* @__PURE__ */ jsxRuntime.jsx(StyledTable, __spreadProps(__spreadValues({}, rest), {
      children
    }));
  }
  return /* @__PURE__ */ jsxRuntime.jsx(StyledTable, __spreadProps(__spreadValues({}, rest), {
    dangerouslySetInnerHTML: { __html: text }
  }));
};
const StyledTable = styled__default["default"].div(
  ({
    commonStyle,
    color,
    backgroundColor,
    borderColor,
    headerBackgroundColor
  }) => `
    ${coreRenderer.getStyle(commonStyle)};
    ${fonts.getCommonTextCss()}
    overflow-x: auto;
    color: ${color || "inherit"};
    background-color: ${backgroundColor || "inherit"};

    table {
      border-collapse: collapse;
      margin: 0;
      overflow: hidden;
      table-layout: fixed;
      min-width: 100%;
    }
    table td, table th {
      border: 2px solid ${borderColor || "#ced4da"};
      box-sizing: border-box;
      min-width: 1em;
      padding: 3px 5px;
      position: relative;
      vertical-align: top;
    }
    table td > *, table th > * {
      margin-bottom: 0;
    }
    table th {
      background-color: ${headerBackgroundColor || "#f1f3f5"};
      font-weight: bold;
      text-align: left;
    }
    table .selectedCell:after {
      background: rgba(200, 200, 255, 0.4);
      content: "";
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      pointer-events: none;
      position: absolute;
      z-index: 2;
    }
    table .column-resize-handle {
      background-color: #adf;
      bottom: -2px;
      position: absolute;
      right: -2px;
      pointer-events: none;
      top: 0;
      width: 4px;
    }
    table p {
      margin: 0;
    }
    .tableWrapper {
      padding: 1rem 0;
      overflow-x: auto;
    }
    .resize-cursor {
      cursor: ew-resize;
      cursor: col-resize;
    }   
  `
);
Table.displayName = "Table";

exports.StyledTable = StyledTable;
exports.Table = Table;


/***/ }),

/***/ 91021:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const discoveryURIMap = {
  "test-1": "https://discovery.dev.tekoapis.net/api",
  dev: "https://discovery.dev.tekoapis.net/api",
  stag: "https://discovery.stag.tekoapis.net/api",
  production: "https://discovery.tekoapis.com/api"
};
const DEFAULT_PRODUCT_LIST = {
  limit: 10,
  type: "grid",
  itemSettings: {
    priceColor: "rgb(235, 31, 58)"
  },
  responsiveSettings: {
    desktop: {
      gap: 4,
      itemsPerRow: 5
    },
    mobile: {
      gap: 4,
      itemsPerRow: 2
    }
  },
  carouselSettings: {
    desktop: {
      paginationColor: "rgba(37, 141, 255, 1)",
      paginationPosition: "inside",
      gridRows: 1,
      gridCols: 5
    },
    mobile: {
      paginationColor: "rgba(37, 141, 255, 1)",
      paginationPosition: "inside",
      gridRows: 1,
      gridCols: 2.5
    }
  },
  button: {
    text: "Xem th\xEAm",
    buttonStyle: {
      backgroundColor: "rgba(37, 141, 255, 1)",
      color: "rgba(255, 255, 255, 1)",
      height: 32,
      width: 120,
      borderRadius: 999
    },
    iconConfig: {
      position: "left",
      spacing: 8,
      show: true,
      icon: {
        size: 24
      }
    },
    commonStyle: {
      justifyContent: "center"
    }
  }
};
const DEFAULT_PRODUCT_LIST_HEADING = {
  text: '<h4 style="text-align: center;">Danh s\xE1ch s\u1EA3n ph\u1EA9m</h4>'
};

exports.DEFAULT_PRODUCT_LIST = DEFAULT_PRODUCT_LIST;
exports.DEFAULT_PRODUCT_LIST_HEADING = DEFAULT_PRODUCT_LIST_HEADING;
exports.discoveryURIMap = discoveryURIMap;


/***/ }),

/***/ 2695:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);

const ProductListContext = React.createContext({ products: [], setProducts: () => {
} });
const ProductListProvider = ({
  children
}) => {
  const [products, setProducts] = React.useState([]);
  const [showBlock, setShowBlock] = React.useState(true);
  const _setProducts = React.useCallback(setProducts, []);
  const _setShowBlock = React.useCallback(setShowBlock, []);
  return /* @__PURE__ */ jsxRuntime.jsx(ProductListContext.Provider, {
    value: {
      products,
      setProducts: _setProducts,
      showBlock,
      setShowBlock: _setShowBlock
    },
    children
  });
};
function useProductList() {
  const context = React.useContext(ProductListContext);
  if (!context) {
    throw new Error(
      "useProductList must be inside a ProductListContext with a state value"
    );
  }
  return context;
}

exports.ProductListContext = ProductListContext;
exports.ProductListProvider = ProductListProvider;
exports.useProductList = useProductList;


/***/ }),

/***/ 42674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var ui = __webpack_require__(49864);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { noProductFoundImage } = coreRenderer.mappingAssets;
const NoProductsFound = (_a) => {
  var _b = _a, {
    text
  } = _b, props = __objRest(_b, [
    "text"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({}, props), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(ui.Image, {
        width: 200,
        src: noProductFoundImage
      }),
      !!text && /* @__PURE__ */ jsxRuntime.jsx(Text, {
        children: text
      })
    ]
  }));
};
const Wrapper = styled__default["default"].div`
  text-align: center;
  width: 100%;
  padding: 0.5rem 0;
`;
const Text = styled__default["default"].div`
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #82869e;
`;

exports.NoProductsFound = NoProductsFound;


/***/ }),

/***/ 6232:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var ProductPrice = __webpack_require__(49775);
var ui = __webpack_require__(89223);
var ui$1 = __webpack_require__(49864);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductItem = (_a) => {
  var _b = _a, {
    product,
    isEditorMode
  } = _b, rest = __objRest(_b, [
    "product",
    "isEditorMode"
  ]);
  const renderProduct = /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsxs(ProductCardContent, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(ProductVisualWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx("div", {
            style: { position: "relative", paddingBottom: "100%" },
            children: /* @__PURE__ */ jsxRuntime.jsx(StyledImage, {
              commonStyle: {
                objectFit: "contain",
                height: "100%",
                width: "100%"
              },
              src: product.imageUrl,
              width: 300,
              showPlaceholder: false
            })
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(ProductNameWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(ProductName, {
            text: product.name
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(ProductSaleInfo, {
          children: /* @__PURE__ */ jsxRuntime.jsx(ProductPrice.ProductPrice, {
            latestPrice: product.latestPrice,
            supplierRetailPrice: product.supplierRetailPrice,
            textColor: rest.priceColor
          })
        })
      ]
    })
  });
  if (product.url && !isEditorMode)
    return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: /* @__PURE__ */ jsxRuntime.jsx("a", {
        href: product.url,
        target: "_blank",
        children: renderProduct
      })
    });
  return renderProduct;
};
const Wrapper = styled__default["default"].div`
  position: relative;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  background-color: transparent;
`;
const ProductCardContent = styled__default["default"].div`
  position: relative;
  flex: 1 0 auto;
  margin-bottom: 8px;
`;
const ProductVisualWrapper = styled__default["default"].div`
  position: relative;
  margin-bottom: 4px;
`;
const ProductNameWrapper = styled__default["default"].div`
  height: 2rem;
`;
const ProductName = styled__default["default"](ui.Paragraph)`
  font-size: 12px;
  line-height: 16px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #434657;
  font-weight: 400;
`;
const ProductSaleInfo = styled__default["default"].div`
  position: relative;
  margin-top: 4px;
`;
const StyledImage = styled__default["default"](ui$1.Image)`
  display: inline-block;
  overflow: hidden;
  position: absolute;
  height: 100%;
  inset: 0;
`;

exports.ProductItem = ProductItem;


/***/ }),

/***/ 49775:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ProductPrice = ({
  supplierRetailPrice,
  latestPrice,
  textColor,
  align = "start"
}) => {
  const formattedRetailPrice = coreRenderer.formatCurrencyVND(supplierRetailPrice);
  const formattedLatestPrice = coreRenderer.formatCurrencyVND(latestPrice);
  const renderedLatestPrice = /* @__PURE__ */ jsxRuntime.jsx(StyledLatestPrice, {
    color: textColor,
    children: formattedLatestPrice
  });
  const renderedRetailPrice = /* @__PURE__ */ jsxRuntime.jsx(StyledRetailPrice, {
    children: formattedRetailPrice
  });
  return /* @__PURE__ */ jsxRuntime.jsxs(ProductPriceWrapper, {
    align,
    children: [
      renderedLatestPrice,
      /* @__PURE__ */ jsxRuntime.jsx(StyledDiscount, {
        children: supplierRetailPrice && supplierRetailPrice > latestPrice && renderedRetailPrice
      })
    ]
  });
};
const ProductPriceWrapper = styled__default["default"].div(
  ({ align }) => `
  display: flex;
  flex-direction: column;
  align-items: ${align};
`
);
const StyledLatestPrice = styled__default["default"].div(
  ({ color }) => `
  color: ${color || "rgb(235, 31, 58)"};
  font-weight: 700;
  text-decoration: unset;
  font-size: 15px;
  line-height: 24px;
`
);
const StyledRetailPrice = styled__default["default"].div`
  text-decoration: line-through;
  color: rgb(130, 134, 158);
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;
const StyledDiscount = styled__default["default"].div`
  display: flex;
  height: 1rem;
`;

exports.ProductPrice = ProductPrice;


/***/ }),

/***/ 83217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var context = __webpack_require__(2695);
var LazyComponent = __webpack_require__(30968);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductListInner = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, { isEditorMode = false } = _a, rest = __objRest(_a, ["isEditorMode"]);
    const { showBlock } = context.useProductList();
    if (!isEditorMode && !showBlock)
      return null;
    return /* @__PURE__ */ jsxRuntime.jsx(StyledProductList, __spreadValues({
      ref
    }, rest));
  }
);
const ProductList = React__default["default"].forwardRef(
  (props, ref) => {
    const WrapLazy = props.isEditorMode ? React__default["default"].Fragment : LazyComponent.LazyComponent;
    return /* @__PURE__ */ jsxRuntime.jsx(WrapLazy, {
      children: /* @__PURE__ */ jsxRuntime.jsx(context.ProductListProvider, {
        children: /* @__PURE__ */ jsxRuntime.jsx(ProductListInner, __spreadValues({
          ref
        }, props))
      })
    });
  }
);
const StyledProductList = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
`
);
ProductList.displayName = "TekoProductListV1";

exports.ProductList = ProductList;


/***/ }),

/***/ 18620:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var utils$1 = __webpack_require__(89475);
var context = __webpack_require__(2695);
var utils = __webpack_require__(34481);
var ui$2 = __webpack_require__(67610);
var NoProductsFound = __webpack_require__(42674);
var ProductItem = __webpack_require__(6232);
var Spin = __webpack_require__(48183);
var ui = __webpack_require__(61349);
var ui$1 = __webpack_require__(82398);
var Slider = __webpack_require__(85468);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ProductListContent = React__default["default"].forwardRef((props, ref) => {
  const {
    commonStyle,
    isEditorMode = false,
    editorTerminal,
    type,
    responsiveSettings,
    carouselSettings,
    limit,
    menuItemId,
    slug,
    itemSettings,
    button,
    actionButton
  } = props;
  const { terminalCode, terminalId, env } = coreRenderer.useStore();
  const terminal = isEditorMode ? typeof editorTerminal === "number" ? { id: editorTerminal } : { code: editorTerminal } : { code: terminalCode, id: terminalId };
  const hasTerminal = (terminal == null ? void 0 : terminal.code) || (terminal == null ? void 0 : terminal.id);
  const { products, setProducts, setShowBlock } = context.useProductList();
  const [hasNextPage, setHasNextPage] = React.useState(false);
  const [menuItem, setMenuItem] = React.useState();
  const [page, setPage] = React.useState(1);
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    const getProducts = async () => {
      if (hasTerminal && (menuItemId || slug) && actionButton) {
        try {
          setLoading(true);
          if (slug) {
            const { products: products2, hasNextPage: hasNextPage2 } = await utils.fetchProductsByCollection(
              env,
              {
                slug,
                terminal,
                size: limit
              }
            );
            setHasNextPage(hasNextPage2);
            setProducts(utils.cookProducts(products2));
            if (products2.length === 0) {
              setShowBlock(false);
            }
          } else {
            const { products: products2, hasNextPage: hasNextPage2, menuItem: menuItem2 } = await utils.fetchProducts(
              env,
              {
                menuItemId: +menuItemId,
                terminal,
                size: limit
              }
            );
            setHasNextPage(hasNextPage2);
            setProducts(utils.cookProducts(products2));
            setMenuItem(menuItem2);
            if (products2.length === 0) {
              setShowBlock(false);
            }
          }
        } finally {
          setLoading(false);
        }
      } else {
        setProducts([]);
        setShowBlock(false);
      }
    };
    setPage(1);
    getProducts();
  }, [menuItemId, limit, JSON.stringify(terminal), actionButton, slug]);
  React.useEffect(() => {
    const getNextProducts = async () => {
      if (hasTerminal && (menuItemId || slug) && actionButton) {
        try {
          setLoading(true);
          if (slug) {
            const { products: products2, hasNextPage: hasNextPage2 } = await utils.fetchProductsByCollection(
              env,
              {
                slug,
                terminal,
                size: limit,
                page
              }
            );
            setHasNextPage(hasNextPage2);
            setProducts((prev) => [...prev, ...utils.cookProducts(products2)]);
          } else {
            const { products: products2, hasNextPage: hasNextPage2 } = await utils.fetchProducts(
              env,
              {
                menuItemId: +menuItemId,
                terminal,
                size: limit,
                page
              },
              menuItem
            );
            setHasNextPage(hasNextPage2);
            setProducts((prev) => [...prev, ...utils.cookProducts(products2)]);
          }
        } finally {
          setLoading(false);
        }
      } else {
        setProducts([]);
        setShowBlock(false);
      }
    };
    if (page > 1) {
      getNextProducts();
    }
  }, [page]);
  const renderContent = () => {
    if (isEditorMode) {
      if (!hasTerminal || !(menuItemId || slug)) {
        return /* @__PURE__ */ jsxRuntime.jsx(NoProductsFound.NoProductsFound, {
          text: "Vui l\xF2ng ch\u1ECDn \u0111i\u1EC3m b\xE1n v\xE0 nh\u1EADp trang danh s\xE1ch s\u1EA3n ph\u1EA9m"
        });
      }
      if (hasTerminal && (menuItemId || slug) && (products == null ? void 0 : products.length) === 0) {
        return /* @__PURE__ */ jsxRuntime.jsx(NoProductsFound.NoProductsFound, {
          text: "Kh\xF4ng t\xECm th\u1EA5y s\u1EA3n ph\u1EA9m n\xE0o"
        });
      }
      return /* @__PURE__ */ jsxRuntime.jsx(StyledPbRow, {
        responsiveSettings,
        children: products.map((product, index) => /* @__PURE__ */ jsxRuntime.jsx(StyledPbCol, {
          responsiveSettings,
          children: /* @__PURE__ */ jsxRuntime.jsx(ProductItem.ProductItem, __spreadValues({
            product,
            isEditorMode
          }, itemSettings))
        }, index))
      });
    }
    return /* @__PURE__ */ jsxRuntime.jsx(StyledPbRow, {
      responsiveSettings,
      children: products.map((product, index) => /* @__PURE__ */ jsxRuntime.jsx(StyledPbCol, {
        responsiveSettings,
        children: /* @__PURE__ */ jsxRuntime.jsx(ProductItem.ProductItem, __spreadValues({
          product,
          isEditorMode
        }, itemSettings))
      }, index))
    });
  };
  const renderContentCarousel = () => {
    if (isEditorMode) {
      if (!hasTerminal || !(menuItemId || slug)) {
        return /* @__PURE__ */ jsxRuntime.jsx(NoProductsFound.NoProductsFound, {
          text: "Vui l\xF2ng ch\u1ECDn \u0111i\u1EC3m b\xE1n v\xE0 nh\u1EADp trang danh s\xE1ch s\u1EA3n ph\u1EA9m"
        });
      }
      if (hasTerminal && (menuItemId || slug) && (products == null ? void 0 : products.length) === 0) {
        return /* @__PURE__ */ jsxRuntime.jsx(NoProductsFound.NoProductsFound, {
          text: "Kh\xF4ng t\xECm th\u1EA5y s\u1EA3n ph\u1EA9m n\xE0o"
        });
      }
      if (props.isMobile) {
        return /* @__PURE__ */ jsxRuntime.jsx(Slider.DSSlider, __spreadProps(__spreadValues({}, utils$1.convertOptionSliderV2ToV1(carouselSettings.mobile)), {
          children: products.map((product, index) => /* @__PURE__ */ jsxRuntime.jsx(ProductItem.ProductItem, __spreadValues({
            product,
            isEditorMode
          }, itemSettings), index))
        }));
      } else {
        return /* @__PURE__ */ jsxRuntime.jsx(Slider.DSSlider, __spreadProps(__spreadValues({}, utils$1.convertOptionSliderV2ToV1(carouselSettings.desktop)), {
          children: products.map((product, index) => /* @__PURE__ */ jsxRuntime.jsx(ProductItem.ProductItem, __spreadValues({
            product,
            isEditorMode
          }, itemSettings), index))
        }));
      }
    }
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(StyledCarouselMobile, {
          children: /* @__PURE__ */ jsxRuntime.jsx(Slider.DSSlider, __spreadProps(__spreadValues({}, utils$1.convertOptionSliderV2ToV1(carouselSettings.mobile)), {
            children: (products || []).map((product, index) => /* @__PURE__ */ jsxRuntime.jsx(ProductItem.ProductItem, __spreadValues({
              product,
              isEditorMode
            }, itemSettings), index))
          }))
        }),
        /* @__PURE__ */ jsxRuntime.jsx(StyledCarouselDesktop, {
          children: /* @__PURE__ */ jsxRuntime.jsx(Slider.DSSlider, __spreadProps(__spreadValues({}, utils$1.convertOptionSliderV2ToV1(carouselSettings.desktop)), {
            children: (products || []).map((product, index) => /* @__PURE__ */ jsxRuntime.jsx(ProductItem.ProductItem, __spreadValues({
              product,
              isEditorMode
            }, itemSettings), index))
          }))
        })
      ]
    });
  };
  const showCTAButton = actionButton === "openSearch" || actionButton === "loadMore" && hasNextPage;
  const event = actionButton === "openSearch" && !!(menuItem || slug) ? {
    eventType: "link",
    link: {
      href: slug ? slug : utils.convertMenuItemConfigToUrl(menuItem),
      openNewTab: true,
      nofollow: false
    }
  } : void 0;
  const onClickBtn = actionButton === "loadMore" && !!(menuItem || slug) ? () => {
    setPage((prev) => prev + 1);
  } : void 0;
  if (type === "carousel")
    return /* @__PURE__ */ jsxRuntime.jsx(StyledProductListContent, {
      commonStyle,
      ref,
      children: /* @__PURE__ */ jsxRuntime.jsxs(Spin.Spin, {
        spinning: loading,
        style: { minHeight: 250 },
        children: [
          renderContentCarousel(),
          showCTAButton && /* @__PURE__ */ jsxRuntime.jsx(ui.ButtonV2, __spreadProps(__spreadValues({
            isEditingMode: isEditorMode
          }, button), {
            event,
            onClick: onClickBtn
          }))
        ]
      })
    });
  return /* @__PURE__ */ jsxRuntime.jsx(StyledProductListContent, {
    commonStyle,
    ref,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Spin.Spin, {
      spinning: loading,
      style: { minHeight: 250 },
      children: [
        renderContent(),
        showCTAButton && /* @__PURE__ */ jsxRuntime.jsx(ui.ButtonV2, __spreadProps(__spreadValues({
          isEditingMode: isEditorMode
        }, button), {
          event,
          onClick: onClickBtn
        }))
      ]
    })
  });
});
const mobileCssRow = ({ responsiveSettings }) => {
  var _a;
  const gap = ((_a = responsiveSettings == null ? void 0 : responsiveSettings.mobile) == null ? void 0 : _a.gap) || 4;
  return `
    gap: ${gap}px;
  `;
};
const desktopCssRow = ({ responsiveSettings }) => {
  var _a;
  const gap = ((_a = responsiveSettings == null ? void 0 : responsiveSettings.desktop) == null ? void 0 : _a.gap) || 4;
  return `
    gap: ${gap}px;
  `;
};
const StyledPbRow = styled__default["default"](ui$1.PbRow)((props) => {
  const { isMobile, commonStyle } = props;
  return [
    `
      ${coreRenderer.getStyle(commonStyle)}
      display: flex;
      flex-wrap: wrap;
      place-content: flex-start;
      min-height: 150px;
    `,
    isMobile && mobileCssRow,
    isMobile === false && desktopCssRow,
    isMobile === void 0 && `
        @media (max-width: 767px) {
          ${mobileCssRow(props)}
        }
        @media (min-width: 767px) {
          ${desktopCssRow(props)}
        }
      `
  ];
});
const mobileCssCol = ({ responsiveSettings }) => {
  var _a, _b;
  const gap = ((_a = responsiveSettings == null ? void 0 : responsiveSettings.mobile) == null ? void 0 : _a.gap) || 4;
  const itemsPerRow = ((_b = responsiveSettings == null ? void 0 : responsiveSettings.mobile) == null ? void 0 : _b.itemsPerRow) || 2;
  return `
    width: calc(${100 / itemsPerRow}% - ${gap}px);
  `;
};
const desktopCssCol = ({ responsiveSettings }) => {
  var _a, _b;
  const gap = ((_a = responsiveSettings == null ? void 0 : responsiveSettings.desktop) == null ? void 0 : _a.gap) || 4;
  const itemsPerRow = ((_b = responsiveSettings == null ? void 0 : responsiveSettings.desktop) == null ? void 0 : _b.itemsPerRow) || 5;
  return `
  width: calc(${100 / itemsPerRow}% - ${gap}px);
  `;
};
const StyledPbCol = styled__default["default"](ui$2.PbCol)(
  (props) => {
    const { isMobile } = props;
    return [
      isMobile && mobileCssCol,
      isMobile === false && desktopCssCol,
      isMobile === void 0 && `
        @media (max-width: 767px) {
          ${mobileCssCol(props)}
        }
        @media (min-width: 767px) {
          ${desktopCssCol(props)}
        }
      `
    ];
  }
);
const StyledCarouselMobile = styled__default["default"].div`
  @media (min-width: 767px) {
    display: none;
  }
`;
const StyledCarouselDesktop = styled__default["default"].div`
  @media (max-width: 767px) {
    display: none;
  }
`;
const StyledProductListContent = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
`
);
ProductListContent.displayName = "TekoProductListContentV1";

exports.ProductListContent = ProductListContent;


/***/ }),

/***/ 34481:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var constants = __webpack_require__(91021);
var coreRenderer = __webpack_require__(12060);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const transformPrice = (prices) => {
  var _a, _b, _c, _d;
  const latestPrice = (_a = prices == null ? void 0 : prices[0]) == null ? void 0 : _a.latestPrice;
  const supplierRetailPrice = (_b = prices == null ? void 0 : prices[0]) == null ? void 0 : _b.supplierRetailPrice;
  const discountPercent = (_c = prices == null ? void 0 : prices[0]) == null ? void 0 : _c.discountPercent;
  const discountAmount = (_d = prices == null ? void 0 : prices[0]) == null ? void 0 : _d.discountAmount;
  return {
    latestPrice: latestPrice && +latestPrice,
    discountAmount: discountAmount && +discountAmount,
    discountPercent,
    supplierRetailPrice: supplierRetailPrice && +supplierRetailPrice
  };
};
const getDefaultPromotions = (promotions) => {
  var _a;
  const couponProductPromotion = (_a = promotions.filter((promo) => {
    var _a2;
    const isTypeCoupon = promo.type === "coupon";
    const isApplyOnProduct = promo.applyOn === "product";
    const hasCoupon = !!((_a2 = promo == null ? void 0 : promo.condition) == null ? void 0 : _a2.coupon);
    return isTypeCoupon && isApplyOnProduct && hasCoupon;
  })) == null ? void 0 : _a[0];
  const defaultPromotions = promotions.filter((promo) => {
    const isTypeProduct = promo.type === "product";
    const isApplyOnProduct = promo.applyOn === "product";
    const isDefault = promo.isDefault;
    return isTypeProduct && isApplyOnProduct && isDefault;
  });
  return [...defaultPromotions, couponProductPromotion].filter(Boolean);
};
const getSelectionPromotions = (promotions) => {
  return promotions.filter((promo) => {
    const isTypeProduct = promo.type === "product";
    const isApplyOnProduct = promo.applyOn === "product";
    const isDefault = promo.isDefault;
    return isTypeProduct && isApplyOnProduct && !isDefault;
  });
};
const checkGift = (promotions) => {
  const appliedPromotion = [
    ...getDefaultPromotions(promotions),
    ...getSelectionPromotions(promotions)
  ];
  return appliedPromotion.some((el) => {
    var _a;
    return (((_a = el == null ? void 0 : el.benefit) == null ? void 0 : _a.gifts) || []).length;
  });
};
const transformProduct = (product) => {
  const { flashSales, prices, productInfo, promotions, totalAvailable } = product;
  const { canonical, name, sku, imageUrl } = productInfo;
  return __spreadProps(__spreadValues({
    totalAvailable
  }, transformPrice(prices)), {
    url: `/${canonical}`,
    name,
    sku,
    imageUrl,
    hasGift: checkGift(promotions),
    flashSale: flashSales == null ? void 0 : flashSales[0]
  });
};
const cookProducts = (products) => {
  return products.map((el) => transformProduct(el));
};
const convertMenuItemConfigToUrl = (menuItem) => {
  const configs = menuItem.configs || {};
  const sorting = menuItem.sorting || {};
  const urlObject = new URLSearchParams();
  Object.keys(sorting).forEach((k) => urlObject.append(k, sorting[k]));
  const _a = configs, { price, attributes } = _a, restConfig = __objRest(_a, ["price", "attributes"]);
  const { from, to } = price || {};
  if (from) {
    urlObject.set("price_gte", from.toString());
  }
  if (to) {
    urlObject.set("price_lte", to.toString());
  }
  (attributes || []).forEach((attr) => {
    urlObject.set(`attributes.${attr.code}`, attr.optionIds.join(","));
  });
  Object.keys(restConfig).forEach((k) => {
    const val = restConfig[k];
    if (Array.isArray(val) && val.length > 0) {
      urlObject.set(k, val.join(","));
    } else if (typeof val === "number" || typeof val === "string" || typeof val === "boolean") {
      urlObject.set(k, `${val}`);
    }
  });
  return `/search?${urlObject.toString()}`;
};
const transformSearchBody = (menuItem) => {
  const searchBody = {
    sorting: {
      order: "ORDER_BY_UNSPECIFIED",
      sort: "SORT_BY_UNSPECIFIED"
    },
    filter: {}
  };
  if (Object.keys((menuItem == null ? void 0 : menuItem.sorting) || {}).length) {
    searchBody.sorting = __spreadValues(__spreadValues({}, searchBody.sorting), menuItem.sorting);
  }
  if (Object.keys((menuItem == null ? void 0 : menuItem.configs) || {}).length) {
    const _a = menuItem.configs, {
      price,
      providerIds,
      sellerIds,
      attributes,
      hasPromotions
    } = _a, rest = __objRest(_a, [
      "price",
      "providerIds",
      "sellerIds",
      "attributes",
      "hasPromotions"
    ]);
    searchBody.filter = rest;
    if (providerIds == null ? void 0 : providerIds.length) {
      searchBody.filter.providerIds = providerIds.map((el) => el.toString());
    }
    if (sellerIds == null ? void 0 : sellerIds.length) {
      searchBody.filter.sellerIds = sellerIds.map((el) => el.toString());
    }
    if (attributes == null ? void 0 : attributes.length) {
      searchBody.filter.attributes = attributes.map((el) => ({
        code: el.code,
        optionIds: (el.optionIds || []).map((o) => o.toString())
      }));
    }
    if (price == null ? void 0 : price.from) {
      searchBody.filter.priceGte = price.from.toString();
    }
    if (price == null ? void 0 : price.to) {
      searchBody.filter.priceLte = price.to.toString();
    }
    if (hasPromotions) {
      searchBody.filter.hasPromotions = !!hasPromotions;
    }
  }
  return searchBody;
};
const fetchProducts = async (env, options, baseMenuItem) => {
  var _a, _b;
  const { menuItemId, terminal, locationCode, size = 10, page = 1 } = options;
  const hasTerminal = (terminal == null ? void 0 : terminal.code) || (terminal == null ? void 0 : terminal.id);
  const terminalCode = (terminal == null ? void 0 : terminal.code) || void 0;
  const terminalId = (terminal == null ? void 0 : terminal.id) || void 0;
  const discoveryURI = constants.discoveryURIMap[env];
  if (!discoveryURI) {
    throw "Please set discoveryURI!";
  }
  if (!menuItemId || !hasTerminal) {
    return;
  }
  const client = new coreRenderer.Api("");
  let menuItem = baseMenuItem;
  if (!menuItem) {
    menuItem = await client.get(`${discoveryURI}/v1/menu-item/${menuItemId}`).then((res2) => {
      var _a2;
      return (_a2 = res2.data) == null ? void 0 : _a2.result;
    });
  }
  if (!menuItem)
    return {
      products: []
    };
  const res = await client.post(`${discoveryURI}/v1/search`, __spreadProps(__spreadValues({}, transformSearchBody(menuItem)), {
    terminalCode,
    terminalId,
    location: locationCode,
    pagination: {
      pageNumber: page,
      itemsPerPage: size
    }
  }));
  const products = ((_a = res.data.result) == null ? void 0 : _a.products) || [];
  const totalPages = ((_b = res.data.pagination) == null ? void 0 : _b.totalPages) || 0;
  return {
    products,
    hasNextPage: totalPages > page,
    menuItem
  };
};
const fetchProductsByCollection = async (env, options) => {
  var _a, _b;
  const { slug, terminal, locationCode, size = 10, page = 1 } = options;
  const hasTerminal = (terminal == null ? void 0 : terminal.code) || (terminal == null ? void 0 : terminal.id);
  const terminalCode = (terminal == null ? void 0 : terminal.code) || void 0;
  const terminalId = (terminal == null ? void 0 : terminal.id) || void 0;
  const discoveryURI = constants.discoveryURIMap[env];
  if (!discoveryURI) {
    throw "Please set discoveryURI!";
  }
  if (!slug || !hasTerminal) {
    return;
  }
  const client = new coreRenderer.Api("");
  const res = await client.post(`${discoveryURI}/v1/search`, {
    slug,
    terminalCode,
    terminalId,
    location: locationCode,
    pagination: {
      pageNumber: page,
      itemsPerPage: size
    }
  });
  const products = ((_a = res.data.result) == null ? void 0 : _a.products) || [];
  const totalPages = ((_b = res.data.pagination) == null ? void 0 : _b.totalPages) || 0;
  return {
    products,
    hasNextPage: totalPages > page
  };
};

exports.convertMenuItemConfigToUrl = convertMenuItemConfigToUrl;
exports.cookProducts = cookProducts;
exports.fetchProducts = fetchProducts;
exports.fetchProductsByCollection = fetchProductsByCollection;
exports.transformSearchBody = transformSearchBody;


/***/ }),

/***/ 22195:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var ui = __webpack_require__(49864);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const TestimonialItem = ({
  image,
  imageStyle,
  content,
  contentStyle,
  title,
  titleStyle,
  name,
  nameStyle,
  width,
  alignment,
  layout,
  skin,
  bubbleStyle
}) => {
  const arrowAlign = layout === "imageInline" || layout === "imageAbove" ? alignment : imageStyle == null ? void 0 : imageStyle.alignment;
  return /* @__PURE__ */ jsxRuntime.jsxs(StyledItem, {
    width,
    layout,
    alignment,
    skin,
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(ContentWrapper, {
        skin,
        className: "testimonial__content",
        commonStyle: bubbleStyle,
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Content, {
            commonStyle: contentStyle,
            children: content
          }),
          /* @__PURE__ */ jsxRuntime.jsx(Arrow, {
            className: `arrow ${getArrowClassName(
              layout,
              arrowAlign || "center"
            )}`,
            imgWidth: imageStyle.width
          })
        ]
      }),
      /* @__PURE__ */ jsxRuntime.jsx("div", {
        className: "testimonial__image",
        children: /* @__PURE__ */ jsxRuntime.jsx(ui.Image, __spreadProps(__spreadValues({}, image), {
          commonStyle: __spreadProps(__spreadValues({}, imageStyle), {
            height: imageStyle.width,
            objectFit: "cover"
          }),
          alignment: imageStyle.alignment
        }))
      }),
      /* @__PURE__ */ jsxRuntime.jsxs("div", {
        className: "testimonial__footer",
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Name, {
            commonStyle: nameStyle,
            children: name
          }),
          /* @__PURE__ */ jsxRuntime.jsx(Title, {
            commonStyle: titleStyle,
            children: title
          })
        ]
      })
    ]
  });
};
const arrowWidth = 12;
const defaultLayoutCss = (layout) => {
  switch (layout) {
    case "imageAbove":
      return `display: grid;
            grid-template-rows: auto auto auto;
            grid-template-columns: 1fr;
            .testimonial {
              &__content {
                grid-row: 2/3;
              }
              &__image {
                grid-row: 1/2;
              }
              &__footer {
                grid-row: 3/4;
              }
            }`;
    case "imageStacked":
      return `display: grid;
            grid-template-rows: auto auto auto;
            grid-template-columns: 1fr;
            .testimonial {
              &__content {
                grid-row: 1/2;
              }
              &__image {
                grid-row: 2/3;
              }
              &__footer {
                grid-row: 3/4;
              }
            }`;
    case "imageInline":
      return `display: flex; 
            flex-wrap: wrap;
            align-items: center;`;
    case "imageRight":
      return `display: grid;
            grid-template-rows: auto 1fr;
            grid-template-columns: 1fr auto;
            .testimonial {
              &__content {
                grid-row: 1/2; 
                grid-column: 1/2;
              }
              &__image {
                grid-row: 1/3; 
                grid-column: 2/3;
              }
              &__footer {
                grid-row: 2/3; 
                grid-column: 1/2;
              }
            }`;
    case "imageLeft":
      return `display: grid;
            grid-template-rows: auto 1fr;
            grid-template-columns: auto 1fr;
            .testimonial {
              &__content {
                grid-row: 1/2;
                grid-column: 2/3;
              }
              &__image {
                grid-row: 1/3; 
                grid-column: 1/2;
              }
              &__footer {
                grid-row: 2/3; 
                grid-column: 2/3;
              }
            }`;
    default:
      return "";
  }
};
const bubbleLayoutCss = (layout) => {
  switch (layout) {
    case "imageAbove":
      return `display: flex; 
            align-items: center;
            flex-wrap: wrap;
            .testimonial {
              &__image {
                order: 1;
              }
              &__footer {
                order: 2;
              }
              &__content {
                order: 3;
              }
            }`;
    case "imageStacked":
      return `display: grid;
            grid-template-rows: auto auto auto;
            grid-template-columns: 1fr;
            .testimonial {
              &__content {
                grid-row: 1/2;
              }
              &__image {
                grid-row: 2/3;
              }
              &__footer {
                grid-row: 3/4;
              }
            }`;
    case "imageInline":
      return `display: flex; 
            flex-wrap: wrap;
            align-items: center;`;
    case "imageRight":
      return `display: grid;
            grid-template-rows: auto 1fr;
            grid-template-columns: 1fr auto;
            .testimonial {
              &__content {
                grid-row: 1/3; 
                grid-column: 1/2;
              }
              &__image {
                grid-row: 1/2; 
                grid-column: 2/3;
              }
              &__footer {
                grid-row: 2/3; 
                grid-column: 2/3;
              }
            }`;
    case "imageLeft":
      return `display: grid;
            grid-template-rows: auto 1fr;
            grid-template-columns: auto 1fr;
            .testimonial {
              &__content {
                grid-row: 1/3;
                grid-column: 2/3;
              }
              &__image {
                grid-row: 1/2; 
                grid-column: 1/2;
              }
              &__footer {
                grid-row: 2/3; 
                grid-column: 1/2;
              }
            }`;
    default:
      return "";
  }
};
const getArrowClassName = (layout, alignment) => {
  return `arrow-${layout.split(/(?=[A-Z])/).join("-").toLowerCase()}-${alignment}`;
};
const arrowPositionAttribute = (className) => {
  if (className.includes("inline") || className.includes("stacked"))
    return "bottom";
  if (className.includes("image-left"))
    return "left";
  if (className.includes("image-right"))
    return "right";
  if (className.includes("above"))
    return "top";
};
const gapCss = (layout) => {
  switch (layout) {
    case "imageAbove":
      return `.testimonial__content { margin-top: ${arrowWidth + 8}px; }`;
    case "imageStacked":
    case "imageInline":
      return `.testimonial__content { margin-bottom: ${arrowWidth + 8}px; }`;
    case "imageRight":
    case "imageLeft":
      return `column-gap: ${arrowWidth + 8}px;`;
    default:
      return "";
  }
};
const styledItemCss = (skin, layout) => {
  switch (skin) {
    case "bubble":
      return `${bubbleLayoutCss(layout)} 
              ${gapCss(layout)}`;
    case "default":
      return defaultLayoutCss(layout);
    default:
      return "";
  }
};
const contentWrapperCss = (skin, commonStyle) => {
  switch (skin) {
    case "bubble":
      return coreRenderer.getStyle(commonStyle);
    case "default":
      return ".arrow{ display: none; }";
    default:
      return "";
  }
};
const StyledItem = styled__default["default"].div(
  ({ width, layout, alignment, skin }) => `
      width: ${width || 100}%;
      justify-content: ${alignment === "left" ? "flex-start" : alignment === "right" ? "flex-end" : "center"};
      .image{
        padding: 12px;
      }
      ${styledItemCss(skin, layout)}
    `
);
const Content = styled__default["default"].div(
  ({ commonStyle }) => `
      ${coreRenderer.getStyle(commonStyle)}
    `
);
const Name = styled__default["default"].div(
  ({ commonStyle }) => `
      ${coreRenderer.getStyle(commonStyle)}
    `
);
const Title = styled__default["default"].div(
  ({ commonStyle }) => `
      ${coreRenderer.getStyle(commonStyle)}
    `
);
const ContentWrapper = styled__default["default"].div(
  ({ skin, commonStyle }) => `
  width: 100%;
  position: relative;
  ${contentWrapperCss(skin, commonStyle)}`
);
const Arrow = styled__default["default"].div(
  ({ imgWidth, className }) => `
    position: absolute;
    width: ${arrowWidth}px;
    height: ${arrowWidth}px;
    background: inherit;
    z-index: -1;
    transform: rotate(45deg);
    ${arrowPositionAttribute(className)}: -${arrowWidth / 2}px;
    &.arrow-image-inline-left, 
    &.arrow-image-stacked-left, 
    &.arrow-image-above-left {
      left: ${imgWidth / 2 - arrowWidth / 2}px;
    }
    &.arrow-image-inline-right,
    &.arrow-image-stacked-right, 
    &.arrow-image-above-right {
      right: ${imgWidth / 2 - arrowWidth / 2}px;
    }
    &.arrow-image-inline-center,
    &.arrow-image-stacked-center, 
    &.arrow-image-above-center {
      right: calc(50% - ${arrowWidth / 2}px);
    }
    ${className.includes("image-left") || className.includes("image-right") ? `top: ${imgWidth / 2 - arrowWidth / 2}px;` : ""}
  `
);

exports.Arrow = Arrow;
exports.Content = Content;
exports.ContentWrapper = ContentWrapper;
exports.Name = Name;
exports.StyledItem = StyledItem;
exports.TestimonialItem = TestimonialItem;
exports.Title = Title;
exports.getArrowClassName = getArrowClassName;


/***/ }),

/***/ 92022:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var TestimonialItem = __webpack_require__(22195);
var Slider = __webpack_require__(85468);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TestimonialCarousel = (_a) => {
  var _b = _a, {
    items,
    commonStyle,
    contentStyle,
    nameStyle,
    titleStyle,
    imageStyle,
    bubbleStyle,
    width,
    alignment = "center",
    layout,
    skin
  } = _b, sliderConfig = __objRest(_b, [
    "items",
    "commonStyle",
    "contentStyle",
    "nameStyle",
    "titleStyle",
    "imageStyle",
    "bubbleStyle",
    "width",
    "alignment",
    "layout",
    "skin"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(StyledTestimonialCarousel, {
    commonStyle,
    children: /* @__PURE__ */ jsxRuntime.jsx(Slider.DSSlider, __spreadProps(__spreadValues({}, sliderConfig), {
      children: items.map((testimonial, index) => /* @__PURE__ */ jsxRuntime.jsx(ItemWrapper, {
        alignment,
        children: /* @__PURE__ */ jsxRuntime.jsx(TestimonialItem.TestimonialItem, __spreadProps(__spreadValues({}, testimonial), {
          skin,
          contentStyle,
          titleStyle,
          nameStyle,
          imageStyle,
          bubbleStyle,
          width,
          alignment,
          layout
        }))
      }, index))
    }))
  });
};
const StyledTestimonialCarousel = styled__default["default"].div(
  ({ commonStyle }) => `
    ${coreRenderer.getStyle(commonStyle)}
  `
);
const ItemWrapper = styled__default["default"].div(
  ({ alignment }) => `
    display: flex;
    justify-content: ${alignment === "left" ? "flex-start" : alignment === "right" ? "flex-end" : "center"};
`
);
TestimonialCarousel.displayName = "TestimonialCarousel";

exports.TestimonialCarousel = TestimonialCarousel;


/***/ }),

/***/ 36852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const TestimonialV2Item = React__default["default"].forwardRef(({ children, commonStyle }, ref) => {
  return /* @__PURE__ */ jsxRuntime.jsx(StyledDiv, {
    commonStyle,
    ref,
    children
  });
});
const StyledDiv = styled__default["default"].div(
  ({ commonStyle }) => `
    ${coreRenderer.getStyle(commonStyle)}
  `
);
TestimonialV2Item.displayName = "TestimonialV2Item";

exports.TestimonialV2Item = TestimonialV2Item;


/***/ }),

/***/ 32588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var utils = __webpack_require__(89475);
var Slider = __webpack_require__(85468);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const TestimonialV2 = (props) => {
  const { children } = props;
  return /* @__PURE__ */ jsxRuntime.jsx(Slider.DSSlider, __spreadProps(__spreadValues({}, utils.convertOptionSliderV2ToV1(props)), {
    children
  }));
};
TestimonialV2.displayName = "TestimonialV2";

exports.TestimonialV2 = TestimonialV2;


/***/ }),

/***/ 43874:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var Ytb = __webpack_require__(15218);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Ytb__default = /*#__PURE__*/_interopDefaultLegacy(Ytb);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Video = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, {
      uploadSrc,
      src,
      isEditorMode = false,
      autoplay = false,
      loop = false
    } = _a, rest = __objRest(_a, [
      "uploadSrc",
      "src",
      "isEditorMode",
      "autoplay",
      "loop"
    ]);
    const uploadRender = /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: /* @__PURE__ */ jsxRuntime.jsx(StyledVideo, {
        controls: true,
        autoPlay: autoplay,
        loop,
        muted: true,
        src: uploadSrc
      })
    });
    let videoId;
    if (src) {
      videoId = coreRenderer.youtubeParser(src);
    }
    const youtubeRender = /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: /* @__PURE__ */ jsxRuntime.jsx(StyledYtb, {
        className: isEditorMode ? "editor-mode" : "",
        containerClassName: "container",
        videoId,
        opts: !isEditorMode ? {
          playerVars: {
            playlist: videoId,
            autoplay: autoplay ? 1 : 0,
            mute: autoplay ? 1 : 0,
            loop: loop ? 1 : 0
          }
        } : {}
      })
    });
    return /* @__PURE__ */ jsxRuntime.jsx(StyledWrapper, __spreadProps(__spreadValues({}, rest), {
      ref,
      children: /* @__PURE__ */ jsxRuntime.jsx(StyledRatio, {
        children: uploadSrc ? uploadRender : youtubeRender
      })
    }));
  }
);
const StyledWrapper = styled__default["default"].div(
  ({ commonStyle }) => `
    ${coreRenderer.getStyle(commonStyle)}
    width: 100%
  `
);
const StyledRatio = styled__default["default"].div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  .container {
    height: 100%;
  }
`;
const StyledYtb = styled__default["default"](Ytb__default["default"])`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &.editor-mode {
    pointer-events: none;
  }
`;
const StyledVideo = styled__default["default"].video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &.editor-mode {
    pointer-events: none;
  }
`;
Video.displayName = "Video";

exports.Video = Video;


/***/ }),

/***/ 36536:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);
var constants = __webpack_require__(32934);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ActionButton = styled__default["default"].div(({}) => {
  return `
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    grid-column: last-col / span 1;
    grid-row: span 2;
    padding-left: 16px;

    div {
      margin: 0px;
    }

    @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
      display: none;
    }
  `;
});
const ActionButtonMobile = styled__default["default"].div(
  ({ grid }) => {
    const { navigationTextAlign } = grid;
    let alignItems;
    switch (navigationTextAlign) {
      case "left":
        alignItems = "flex-start";
        break;
      case "right":
        alignItems = "flex-end";
        break;
      case "center":
        alignItems = "center";
        break;
    }
    return `
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
    @media screen and (min-width: ${constants.MOBILE_WIDTH}px){
      display: none;
    }

    div {
      // because buttonV2 has a wrapper flex, setting align-item in parent div has no value.
      justify-content: ${alignItems};
      margin: 0px;
    }
  `;
  }
);

exports.ActionButton = ActionButton;
exports.ActionButtonMobile = ActionButtonMobile;


/***/ }),

/***/ 94885:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var constants = __webpack_require__(32934);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Content = styled__default["default"].div(
  ({ grid, commonStyle }) => {
    const {
      gridArea,
      navigationGridTemplateColumns,
      width,
      mobileNavigationGridTemplateColumns
    } = grid;
    return `
    position: relative;
    display: grid;
    grid-area: ${gridArea};
    grid-template-columns: ${navigationGridTemplateColumns};
    align-items: center;
    width: 100%;
    max-width: ${width || 1240}px;
    margin: 0 auto;
    
    ${coreRenderer.getStyle({ padding: commonStyle.padding })};
  
    @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
      grid-template-columns: ${mobileNavigationGridTemplateColumns};
    }
  `;
  }
);

exports.Content = Content;


/***/ }),

/***/ 64328:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var constants = __webpack_require__(32934);
var Item = __webpack_require__(8907);
var coreRenderer = __webpack_require__(12060);
var menu = __webpack_require__(51004);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DropdownItem = ({ item, grid, alignMenu, isEditingMode, backgroundColor }) => {
  var _a;
  const id = `dropdown-${item.id}`;
  const { menuColor } = grid;
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /* @__PURE__ */ jsxRuntime.jsxs(StyledLabel, {
      htmlFor: id,
      children: [
        /* @__PURE__ */ jsxRuntime.jsx("input", {
          type: "checkbox",
          id,
          value: ""
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(Item.ItemContentWrapper, {
          alignMenu,
          hoverColor: grid.menuHoverColor,
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(Item.ItemContent, __spreadProps(__spreadValues({
              grid,
              alignMenu,
              target: menu.getTargetUrl(item.target),
              href: menu.getUrlOfMenuItem(item, isEditingMode)
            }, (item == null ? void 0 : item.linkType) === "LINK" && item.nofollow ? { rel: "nofollow" } : {}), {
              children: [
                (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx(Item.ItemIcon, {
                  src: item.iconUrl,
                  loading: "lazy"
                }),
                item == null ? void 0 : item.name
              ]
            })),
            /* @__PURE__ */ jsxRuntime.jsx(DropdownIcon, {
              alignMenu,
              color: menuColor
            })
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx(SubMenu, {
          className: "sub-menu",
          grid,
          children: /* @__PURE__ */ jsxRuntime.jsx(SubMenuContent, {
            grid,
            backgroundColor,
            children: (_a = item == null ? void 0 : item.children) == null ? void 0 : _a.map((child, i) => /* @__PURE__ */ jsxRuntime.jsx(Item.Item, {
              children: /* @__PURE__ */ jsxRuntime.jsx(Item.ItemLabel, {
                children: /* @__PURE__ */ jsxRuntime.jsx(Item.ItemContentWrapper, {
                  alignMenu,
                  hoverColor: grid == null ? void 0 : grid.menuHoverColor,
                  children: /* @__PURE__ */ jsxRuntime.jsxs(Item.ItemContent, __spreadProps(__spreadValues({
                    grid: __spreadProps(__spreadValues({}, grid), { menuItemSpacing: null }),
                    alignMenu,
                    target: menu.getTargetUrl(item.target),
                    href: menu.getUrlOfMenuItem(child, isEditingMode)
                  }, (child == null ? void 0 : child.linkType) === "LINK" && child.nofollow && { rel: "nofollow" }), {
                    children: [
                      (child == null ? void 0 : child.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx(Item.ItemIcon, {
                        src: child.iconUrl,
                        loading: "lazy"
                      }),
                      child == null ? void 0 : child.name
                    ]
                  }))
                })
              })
            }, i))
          })
        })
      ]
    })
  });
};
const StyledLabel = styled__default["default"](Item.ItemLabel)`
  cursor: pointer;

  input {
    display: none;
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
  }

  svg {
    transition: transform 0.3s;
  }

  @media screen and (min-width: ${constants.MOBILE_WIDTH}px) {
    &:hover {
      .sub-menu {
        display: block;

        ul {
          max-height: 400px;
          overflow-y: auto;
        }
      }
      svg {
        transform: rotate(180deg);
      }
    }
  }

  @media screen and (max-width: ${constants.MOBILE_WIDTH}px) {
    input[type='checkbox']:checked ~ {
      .sub-menu {
        display: block;
      }

      div {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }
`;
const DropdownIconWrapper = styled__default["default"].span`
  all: unset;
  display: flex;
  margin-left: 8px;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 3px;
  transition: border 0.3s;

  @media screen and (max-width: ${constants.MOBILE_WIDTH}px) {
    display: inline-block;
  }
`;
const DropdownIcon = ({ alignMenu, color }) => {
  let gridColumn;
  let gridRow;
  switch (alignMenu) {
    case coreRenderer.Alignment.left:
      gridColumn = "3/4";
      break;
    case coreRenderer.Alignment.center:
      gridColumn = "3/4";
      break;
    case coreRenderer.Alignment.right:
      gridRow = "1";
      gridColumn = "1/2";
      break;
  }
  return /* @__PURE__ */ jsxRuntime.jsx("div", {
    style: { gridColumn, gridRow, color },
    children: /* @__PURE__ */ jsxRuntime.jsx(DropdownIconWrapper, {
      children: /* @__PURE__ */ jsxRuntime.jsx("svg", {
        width: "10",
        height: "7",
        viewBox: "0 0 10 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-v-b930357f": "",
        children: /* @__PURE__ */ jsxRuntime.jsx("path", {
          d: "M5 6.5L0.669873 0.5L9.33013 0.500001L5 6.5Z",
          fill: "currentColor",
          "data-v-b930357f": ""
        })
      })
    })
  });
};
const SubMenu = styled__default["default"].div(
  ({ grid }) => `
  position: absolute;
  z-index: 1;
  display: none;
  padding-top: 10px;
  padding-right: 16px;
  padding-bottom: 48px;

  margin-left: ${grid.menuItemSpacing}px;

  @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
    position: unset;
    padding: 8px 0;
    margin-top: 8px;
    margin-bottom: 8px;
  }
`
);
const SubMenuContent = styled__default["default"].ul(
  ({ grid, backgroundColor }) => `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 16px 24px;
  gap: 10px;
  list-style: none;
  border-radius: 5px;
  box-shadow: 0 2px 10px #0000001a;
  animation: expand-5b652f62 0.2s cubic-bezier(0.45, 0, 0.1, 1);
  background-color: ${backgroundColor};


  @media screen and (max-width: ${constants.MOBILE_WIDTH}px) {
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    align-items: ${grid.navigationJustifySelf};
  }
`
);

exports.DropdownItem = DropdownItem;


/***/ }),

/***/ 55089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Header = styled__default["default"].header(({ commonStyle, headerHeight }) => {
  const _a = commonStyle, rest = __objRest(_a, ["padding"]);
  return `
    display: grid;
    grid-area: 1/1/-1/-1;
    grid-template-rows: 100%;
    grid-template-columns: 100%;
    width: 100%;
    transition: box-shadow 0.15s linear;
  
    &.sticky {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 100;
    }
    ${headerHeight ? `
    &.sticky + .placeholder{
      padding-bottom: ${headerHeight}px;
    }
    ` : ""}
    
    ${coreRenderer.getStyle(rest)}
  `;
});

exports.Header = Header;


/***/ }),

/***/ 8907:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var constants = __webpack_require__(32934);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Item = styled__default["default"].li`
  user-select: none;
`;
const ItemLabel = styled__default["default"].label`
  display: block;
`;
const ItemContentWrapper = styled__default["default"].div(
  ({ alignMenu, hoverColor }) => `
  display: flex;
  align-items: center;
  text-align: left;
  @media screen and (max-width: ${constants.MOBILE_WIDTH}px) {
    grid-template-columns: 
      ${alignMenu === coreRenderer.Alignment.left ? "auto 1fr auto" : ""}
      ${alignMenu === coreRenderer.Alignment.center ? "1fr auto 1fr" : ""}
      ${alignMenu === coreRenderer.Alignment.right ? "1fr auto" : ""}
    ;
    display: grid;
  }

  ${hoverColor ? `
    &:hover {
      color: ${hoverColor};
      
      svg {
        color: ${hoverColor} !important;
        }
    }` : ""}
`
);
const ItemContent = styled__default["default"].a(({ grid, alignMenu }) => {
  const {
    menuItemSpacing,
    menuColor,
    menuHoverColor,
    mobileNavigationTextAlign
  } = grid || {};
  return `
  position: relative;
  display: inline-flex;
  align-self: center;
  margin: 0 0 0 ${menuItemSpacing}px;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  color: ${menuColor};

  &:hover {
    text-decoration: underline;
    text-underline-offset: 7px;
    color: ${menuHoverColor};
  }

  @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
    margin: 0;
    text-align: ${mobileNavigationTextAlign};

    grid-column: 
    ${alignMenu === coreRenderer.Alignment.left ? "1/2" : ""}
    ${alignMenu === coreRenderer.Alignment.center ? "2/3" : ""}
    ${alignMenu === coreRenderer.Alignment.right ? "3/4" : ""}
  }
`;
});
const ItemIcon = styled__default["default"].img`
  width: 20px;
  height: 20px;
  margin-right: 0.4em;
`;

exports.Item = Item;
exports.ItemContent = ItemContent;
exports.ItemContentWrapper = ItemContentWrapper;
exports.ItemIcon = ItemIcon;
exports.ItemLabel = ItemLabel;


/***/ }),

/***/ 25202:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Logo = styled__default["default"].a(({ grid }) => {
  const {
    logoGridRow,
    logoGridColumn,
    logoJustifySelf,
    logoSpacing,
    logoWidth
  } = grid;
  return `
    display: inline-flex;
    grid-row: ${logoGridRow};
    grid-column: ${logoGridColumn};
    align-self: center;
    justify-self: ${logoJustifySelf};
    margin: ${logoSpacing};
    width: ${logoWidth}px;
  `;
});
const LogoImg = styled__default["default"].img(({ grid }) => {
  const { logoImageObjectPosition } = grid;
  return `
    width: 100%;
    height: 100%;
  
    vertical-align: middle;
    object-fit: contain;
    object-position: ${logoImageObjectPosition};
  `;
});

exports.Logo = Logo;
exports.LogoImg = LogoImg;


/***/ }),

/***/ 94195:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);
var constants = __webpack_require__(32934);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Menu = styled__default["default"].ul(({ grid }) => {
  const {
    navigationTextAlign,
    mobileMenuItemSpacing,
    mobileNavigationJustifySelf,
    paddingRight,
    mobileNavigationTextAlign,
    backgroundOverlayOpacity,
    mobileBackground = "#ffffff"
  } = grid;
  return `
    padding-left: unset;
    display: inline-flex;
    flex-flow: row wrap;
    row-gap: 16px;
    align-items: center;
    height: 100%;
    text-align: ${navigationTextAlign};
    list-style: none;
  
    @media screen and (max-width: ${constants.MOBILE_WIDTH}px) {
      position: absolute;
      top: 100%;
      right: 0;
      left: 0;
      z-index: 1;
      display: grid;
      grid-gap: ${mobileMenuItemSpacing || 16}px 0;
      justify-self: ${mobileNavigationJustifySelf};
      width: auto;
      height: 0;
      max-height: 450px;
      padding: ${mobileMenuItemSpacing || 16}px ${mobileMenuItemSpacing || 16}px ${mobileMenuItemSpacing || 16}px ${paddingRight}px;
      margin: 0;
      overflow-y: auto;
      text-align: ${mobileNavigationTextAlign};
      pointer-events: none;
      background-size: cover;
      box-shadow: 0 6px 14px -14px #0000001a;
      opacity: 0;
      transform: translateY(-1em);
      transition-timing-function: cubic-bezier(.45,0,.1,1);
      transition-duration: .2s;
      transition-property: opacity,transform;
      background: linear-gradient(rgba(0,0,0,${backgroundOverlayOpacity}),rgba(0,0,0,${backgroundOverlayOpacity})),${mobileBackground} no-repeat top;
  
      &.open {
        height: auto;
        pointer-events: auto;
        opacity: 1;
        transform: translate(0);
        transition-timing-function: cubic-bezier(.45,0,.1,1);
        transition-duration: .2s;
        transition-property: opacity,transform;
      }
    };
  `;
});

exports.Menu = Menu;


/***/ }),

/***/ 38780:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);
var constants = __webpack_require__(32934);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Navbar = styled__default["default"].nav(({ grid }) => {
  const {
    linksGridRow,
    linksGridColumn,
    navigationJustifySelf,
    menuItemSpacing
  } = grid;
  return `
    grid-row: ${linksGridRow};
    grid-column: ${linksGridColumn};
    justify-self: ${navigationJustifySelf};
    height: 100%;
    margin-left: ${-1 * menuItemSpacing}px;
  
    @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
      grid-row: unset;
      grid-column: unset;
    };
  `;
});

exports.Navbar = Navbar;


/***/ }),

/***/ 21520:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var constants = __webpack_require__(32934);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Toggle = styled__default["default"].button(({ grid }) => {
  const {
    linksGridRow,
    linksGridColumn,
    navigationJustifySelf,
    navigationTextAlign,
    menuColor
  } = grid;
  const mobileLinksGridRow = linksGridRow;
  const mobileLinksGridColumn = linksGridColumn;
  const mobileNavigationJustifySelf = navigationJustifySelf;
  const mobileNavigationTextAlign = navigationTextAlign;
  return `
  
    display: none;
    grid-row: ${linksGridRow};
    grid-column: ${linksGridColumn};
    justify-self: ${navigationJustifySelf};
    text-align: ${navigationTextAlign}; 
  
    width: 24px;
    height: 18px;
    cursor: pointer;
    background-color: transparent;
    transition: all .4s ease-in-out .1s;
    transform: rotate(0);
  
    border: none;
    outline: none;
    box-shadow: none;
    
    &:focus{
      outline: none;
    }
  
    span{
      position: absolute;
      display: block;
      width: 100%;
      height: 2px;
      background: ${menuColor || "#7367f0"};
      border-radius: 2px;
      transition: all .25s ease-in-out .1s;
      transform: rotate(0);
      transform-origin: left center;
    }
  
    span:nth-of-type(1){
      top: 0;
    } 
    span:nth-of-type(2){
      top: 8px;
    } 
    span:nth-of-type(3){
      top: 16px;
    } 
  
    &.open {
      span:nth-of-type(1){
        top: -1px;
        transform: rotate(45deg);
      } 
      span:nth-of-type(2){
        width: 0%;
        opacity: 0;
      } 
      span:nth-of-type(3){
        transform: rotate(-45deg);
      } 
    }
    
    @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
        display: block;
        grid-row: ${mobileLinksGridRow};
        grid-column: ${mobileLinksGridColumn};
        justify-self: ${mobileNavigationJustifySelf};
        text-align: ${mobileNavigationTextAlign};
    }
    `;
});
const ToggleButton = (props) => {
  return /* @__PURE__ */ jsxRuntime.jsxs(Toggle, __spreadProps(__spreadValues({}, props), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx("span", {}),
      /* @__PURE__ */ jsxRuntime.jsx("span", {}),
      /* @__PURE__ */ jsxRuntime.jsx("span", {})
    ]
  }));
};

exports.ToggleButton = ToggleButton;


/***/ }),

/***/ 32934:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const MOBILE_WIDTH = 767;
const DEFAULT_WEBSITE_HEADER_DESKTOP = {
  stickyTop: true,
  menuConfig: {
    commonStyle: {
      columnGap: 32
    },
    align: coreRenderer.Alignment.right
  },
  logoConfig: {
    show: true,
    src: "https://lh3.googleusercontent.com/bhg6FoxZPA5S6q50_Gmu6YgMt2GcKxpjsbnaRvvHUwSV9JSnAj83TpbJEHIJjgKnbNoZmM7Mnx0pBlUau5CG2yIOG5v7rGc",
    align: coreRenderer.Alignment.left,
    commonStyle: {
      width: 100
    },
    spacingWithMenu: 32
  },
  menuItemConfig: {
    commonStyle: {
      color: "#000000",
      hover: {
        color: "#008cff"
      }
    }
  },
  commonStyle: {
    backgroundColor: "#ffffff",
    padding: {
      top: 30,
      right: 16,
      bottom: 30,
      left: 16
    }
  }
};
const DEFAULT_WEBSITE_HEADER_MOBILE = {
  commonStyle: {
    padding: {
      top: 24,
      right: 16,
      bottom: 24,
      left: 16
    }
  }
};
const DEFAULT_WEBSITE_HEADER = {
  desktop: __spreadValues({}, DEFAULT_WEBSITE_HEADER_DESKTOP),
  mobile: __spreadValues({}, DEFAULT_WEBSITE_HEADER_MOBILE)
};
const DEFAULT_BUTTONS = [
  {
    text: "",
    buttonStyle: {
      backgroundColor: "#7367F0",
      color: "#ffffff",
      height: 40,
      width: 100,
      borderRadius: 16,
      borderStyle: "solid",
      borderWidth: 0
    }
  }
];

exports.DEFAULT_BUTTONS = DEFAULT_BUTTONS;
exports.DEFAULT_WEBSITE_HEADER = DEFAULT_WEBSITE_HEADER;
exports.DEFAULT_WEBSITE_HEADER_DESKTOP = DEFAULT_WEBSITE_HEADER_DESKTOP;
exports.DEFAULT_WEBSITE_HEADER_MOBILE = DEFAULT_WEBSITE_HEADER_MOBILE;
exports.MOBILE_WIDTH = MOBILE_WIDTH;


/***/ }),

/***/ 82026:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var clsx = __webpack_require__(77084);
var React = __webpack_require__(91987);
var hooks = __webpack_require__(3597);
var DropdownItem = __webpack_require__(64328);
var utils = __webpack_require__(5518);
var Header = __webpack_require__(55089);
var Content = __webpack_require__(94885);
var Logo = __webpack_require__(25202);
var ToggleButton = __webpack_require__(21520);
var NavigationBar = __webpack_require__(38780);
var Menu = __webpack_require__(94195);
var Item = __webpack_require__(8907);
var ActionButton = __webpack_require__(36536);
var type = __webpack_require__(86450);
var menu = __webpack_require__(51004);
var ui = __webpack_require__(61349);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const WebsiteHeader = (props) => {
  const { device, globalData } = coreRenderer.useStore();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const _a = props, { isEditingMode, menu: editorMenu } = _a, rest = __objRest(_a, ["isEditingMode", "menu"]);
  const propsByDevice = coreRenderer.getPropsByDevice(rest, device) || {};
  const menu$1 = isEditingMode ? editorMenu : (globalData == null ? void 0 : globalData.menu) || [];
  const {
    commonStyle,
    logoConfig,
    menuConfig,
    stickyTop,
    actionButtons: propsActionButtons
  } = propsByDevice;
  const actionButtons = propsActionButtons != null ? propsActionButtons : [];
  const grid = utils.calculateGrid(propsByDevice);
  const menuOpenClassName = clsx__default["default"]({ open: mobileMenuOpen });
  const tree = utils.flattenToTreeMax2Level(
    (menu$1 || []).filter((el) => !el.isHidden)
  );
  const { headerRef, headerHeight } = hooks.useHeaderPosition(
    stickyTop ? type.PositionHeader.STICKY : type.PositionHeader.NORMAL
  );
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      var _a2, _b;
      if (!((_b = (_a2 = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _a2.contains) == null ? void 0 : _b.call(_a2, event.target))) {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [headerRef]);
  const renderActionButtons = () => {
    return actionButtons.map((item) => {
      return /* @__PURE__ */ jsxRuntime.jsx(ui.ButtonV2, __spreadProps(__spreadValues({}, item), {
        isEditingMode
      }));
    });
  };
  const renderDesktopButtons = () => {
    if (!(actionButtons == null ? void 0 : actionButtons.length))
      return null;
    return /* @__PURE__ */ jsxRuntime.jsx(ActionButton.ActionButton, {
      grid,
      children: renderActionButtons()
    });
  };
  const renderMobileButtons = () => {
    if (!(actionButtons == null ? void 0 : actionButtons.length))
      return null;
    return /* @__PURE__ */ jsxRuntime.jsx(ActionButton.ActionButtonMobile, {
      grid,
      children: renderActionButtons()
    });
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Header.Header, {
        commonStyle,
        ref: headerRef,
        headerHeight,
        children: /* @__PURE__ */ jsxRuntime.jsxs(Content.Content, {
          grid,
          commonStyle,
          children: [
            (logoConfig == null ? void 0 : logoConfig.show) && /* @__PURE__ */ jsxRuntime.jsx(Logo.Logo, __spreadProps(__spreadValues({}, !isEditingMode ? { href: "/" } : {}), {
              grid,
              children: /* @__PURE__ */ jsxRuntime.jsx(Logo.LogoImg, {
                alt: logoConfig == null ? void 0 : logoConfig.alt,
                src: coreRenderer.getImageUrlFromGoogleUserContent(
                  logoConfig == null ? void 0 : logoConfig.src,
                  logoConfig == null ? void 0 : logoConfig.googleImageParams
                ),
                srcSet: coreRenderer.buildSrcsetDPR(logoConfig == null ? void 0 : logoConfig.src, grid.logoWidth),
                grid,
                loading: "lazy"
              })
            })),
            /* @__PURE__ */ jsxRuntime.jsx(ToggleButton.ToggleButton, {
              className: menuOpenClassName,
              grid,
              onClick: () => setMobileMenuOpen(!mobileMenuOpen)
            }),
            /* @__PURE__ */ jsxRuntime.jsx(NavigationBar.Navbar, {
              grid,
              children: /* @__PURE__ */ jsxRuntime.jsxs(Menu.Menu, {
                className: menuOpenClassName,
                grid,
                children: [
                  tree.map((item) => {
                    var _a2;
                    return /* @__PURE__ */ jsxRuntime.jsx(Item.Item, {
                      children: ((_a2 = item == null ? void 0 : item.children) == null ? void 0 : _a2.length) > 0 ? /* @__PURE__ */ jsxRuntime.jsx(DropdownItem.DropdownItem, {
                        item,
                        grid,
                        alignMenu: menuConfig == null ? void 0 : menuConfig.align,
                        isEditingMode,
                        backgroundColor: commonStyle.backgroundColor || "white"
                      }) : /* @__PURE__ */ jsxRuntime.jsx(Item.ItemLabel, {
                        children: /* @__PURE__ */ jsxRuntime.jsx(Item.ItemContentWrapper, {
                          alignMenu: menuConfig == null ? void 0 : menuConfig.align,
                          hoverColor: grid == null ? void 0 : grid.menuHoverColor,
                          children: /* @__PURE__ */ jsxRuntime.jsxs(Item.ItemContent, __spreadProps(__spreadValues({
                            alignMenu: menuConfig == null ? void 0 : menuConfig.align,
                            href: menu.getUrlOfMenuItem(item, isEditingMode),
                            grid,
                            target: menu.getTargetUrl(item.target)
                          }, (item == null ? void 0 : item.linkType) === "LINK" && item.nofollow ? { rel: "nofollow" } : {}), {
                            children: [
                              (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx(Item.ItemIcon, {
                                src: item.iconUrl,
                                loading: "lazy"
                              }),
                              item == null ? void 0 : item.name
                            ]
                          }))
                        })
                      })
                    }, item.id);
                  }),
                  renderMobileButtons()
                ]
              })
            }),
            renderDesktopButtons()
          ]
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsx("div", {
        className: "placeholder"
      })
    ]
  });
};
WebsiteHeader.displayName = "websiteheader";

exports.WebsiteHeader = WebsiteHeader;


/***/ }),

/***/ 5518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const calculateGrid = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const padding = "30px 16px 30px 16px";
  const width = 1240;
  const menuPosition = (_a = props == null ? void 0 : props.menuConfig) == null ? void 0 : _a.align;
  const { paddingTop, paddingRight, paddingBottom, paddingLeft } = splitPaddingString(padding);
  const logoShow = (_b = props == null ? void 0 : props.logoConfig) == null ? void 0 : _b.show;
  const logoWidth = (_d = (_c = props == null ? void 0 : props.logoConfig) == null ? void 0 : _c.commonStyle) == null ? void 0 : _d.width;
  const spaceBetweenMenu = (_e = props == null ? void 0 : props.logoConfig) == null ? void 0 : _e.spacingWithMenu;
  const logoPosition = (_f = props == null ? void 0 : props.logoConfig) == null ? void 0 : _f.align;
  const gridArea = "1/1/-1/-1";
  const backgroundOverlayOpacity = 0;
  const menuItemSpacing = (_h = (_g = props == null ? void 0 : props.menuConfig) == null ? void 0 : _g.commonStyle) == null ? void 0 : _h.columnGap;
  const backgroundColor = (_i = props == null ? void 0 : props.commonStyle) == null ? void 0 : _i.backgroundColor;
  const menuColor = (_k = (_j = props == null ? void 0 : props.menuItemConfig) == null ? void 0 : _j.commonStyle) == null ? void 0 : _k.color;
  const menuHoverColor = (_n = (_m = (_l = props == null ? void 0 : props.menuItemConfig) == null ? void 0 : _l.commonStyle) == null ? void 0 : _m.hover) == null ? void 0 : _n.color;
  const mobilePaddingTop = 24;
  const mobilePadding = "24px 16px 24px 16px";
  const mobilePaddingRight = 16;
  const mobilePaddingBottom = 24;
  const mobilePaddingLeft = 16;
  const mobileLogoWidth = 70;
  const mobileMenuItemSpacing = 20;
  const mobileLogoGridRow = "1/2";
  const mobileLogoGridColumn = "1/2";
  const mobileLogoJustifySelf = "flex-start";
  const mobileLogoImageObjectPosition = "left center";
  const mobileLinksGridRow = "1/2";
  const mobileLinksGridColumn = "2/3";
  const mobileLogoSpacing = `0 ${spaceBetweenMenu}px 0 0`;
  const mobileDropdownBackgroundColor = "#dcdcdc";
  const mobileBackground = backgroundColor;
  let navigationGridTemplateColumns;
  let mobileNavigationGridTemplateColumns;
  navigationGridTemplateColumns = getNavigationGridTemplateColumns(
    logoPosition,
    menuPosition,
    logoWidth,
    spaceBetweenMenu,
    void 0
  );
  mobileNavigationGridTemplateColumns = getNavigationGridTemplateColumns(
    logoPosition,
    menuPosition,
    logoWidth,
    spaceBetweenMenu,
    "mobile",
    mobileLogoWidth
  );
  if (!logoShow) {
    navigationGridTemplateColumns = "1fr";
    mobileNavigationGridTemplateColumns = "1fr";
  }
  const logoGridColumn = getLogoGridColumn(logoPosition, menuPosition);
  let logoGridRow = "1/2";
  let logoSpacing = `0 ${spaceBetweenMenu}px 0 0`;
  let logoJustifySelf;
  switch (logoPosition) {
    case "left":
      logoJustifySelf = "flex-start";
      logoSpacing = `0 ${spaceBetweenMenu}px 0 0`;
      break;
    case "center":
      logoJustifySelf = "center";
      if (menuPosition === "center") {
        logoSpacing = `0 0 ${spaceBetweenMenu}px 0`;
        logoGridRow = "0/2";
      } else {
        logoSpacing = `0 ${spaceBetweenMenu}px`;
      }
      break;
    case "right":
      logoJustifySelf = "flex-end";
      logoSpacing = `0 0 0 ${spaceBetweenMenu}px`;
      break;
  }
  const logoImageObjectPosition = `${logoPosition} center`;
  let linksGridRow = "1/2";
  let linksGridColumn = "2/3";
  let navigationJustifySelf = "flex-end";
  const navigationTextAlign = menuPosition || "right";
  const mobileNavigationTextAlign = menuPosition || "right";
  let mobileNavigationJustifySelf = "flex-end";
  switch (menuPosition) {
    case "left":
      navigationJustifySelf = "flex-start";
      mobileNavigationJustifySelf = "flex-start";
      break;
    case "center":
      navigationJustifySelf = "center";
      mobileNavigationJustifySelf = "center";
      break;
    case "right":
      navigationJustifySelf = "flex-end";
      mobileNavigationJustifySelf = "flex-end";
      break;
  }
  linksGridColumn = getLinksGridColumn(logoPosition, menuPosition);
  if (logoPosition === "center" && menuPosition === "center") {
    linksGridRow = "2/2";
  }
  if (!logoShow) {
    linksGridColumn = "1/2";
  }
  return {
    gridArea,
    navigationGridTemplateColumns,
    padding,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
    width,
    logoGridRow,
    logoGridColumn,
    logoJustifySelf,
    logoSpacing,
    logoWidth,
    logoImageObjectPosition,
    linksGridRow,
    linksGridColumn,
    navigationJustifySelf,
    menuItemSpacing,
    navigationTextAlign,
    menuColor,
    menuHoverColor,
    mobilePadding,
    mobilePaddingTop,
    mobilePaddingRight,
    mobilePaddingBottom,
    mobilePaddingLeft,
    mobileLogoWidth,
    mobileMenuItemSpacing,
    mobileNavigationGridTemplateColumns,
    mobileLogoGridRow,
    mobileLogoGridColumn,
    mobileLogoJustifySelf,
    mobileLogoImageObjectPosition,
    mobileLinksGridRow,
    mobileLinksGridColumn,
    mobileLogoSpacing,
    mobileNavigationTextAlign,
    mobileNavigationJustifySelf,
    mobileDropdownBackgroundColor,
    mobileBackground,
    backgroundOverlayOpacity
  };
};
const splitPaddingString = (paddingString) => {
  const paddingValues = paddingString.split(" ");
  const result = {};
  if (paddingValues[0]) {
    result.paddingTop = parseInt(paddingValues[0].replace("px", ""));
  }
  if (paddingValues[1]) {
    result.paddingRight = parseInt(paddingValues[1].replace("px", ""));
  }
  if (paddingValues[2]) {
    result.paddingBottom = parseInt(paddingValues[2].replace("px", ""));
  }
  if (paddingValues[3]) {
    result.paddingLeft = parseInt(paddingValues[3].replace("px", ""));
  }
  return result;
};
const getNavigationGridTemplateColumns = (logoPosition, menuPosition, logoWidth, spaceBetweenMenu, device, mobileLogoWidth) => {
  const logoWidthWithSpace = (device === "desktop" ? logoWidth : mobileLogoWidth || logoWidth) + spaceBetweenMenu;
  const logoWidthWithSpaceAuto = `minmax(${logoWidthWithSpace}px, auto)`;
  switch (logoPosition) {
    case coreRenderer.Alignment.left:
      switch (menuPosition) {
        case coreRenderer.Alignment.left:
          return `${logoWidthWithSpaceAuto} 1fr auto`;
        case coreRenderer.Alignment.center:
          return `minmax(${logoWidthWithSpace}px, 1fr) auto 1fr auto`;
        case coreRenderer.Alignment.right:
          return `${logoWidthWithSpaceAuto} 1fr auto`;
      }
    case coreRenderer.Alignment.center:
      switch (menuPosition) {
        case coreRenderer.Alignment.left:
          return `1fr ${logoWidthWithSpaceAuto} 1fr auto`;
        case coreRenderer.Alignment.center:
          return `1fr minmax(${logoWidth}px, auto) 1fr auto`;
        case coreRenderer.Alignment.right:
          return `1fr ${logoWidthWithSpaceAuto} 1fr auto`;
      }
    case coreRenderer.Alignment.right:
      switch (menuPosition) {
        case coreRenderer.Alignment.left:
          return `1fr ${logoWidthWithSpaceAuto} auto`;
        case coreRenderer.Alignment.center:
          return `1fr auto minmax(${logoWidthWithSpace}px, 1fr) auto`;
        case coreRenderer.Alignment.right:
          return `1fr ${logoWidthWithSpaceAuto} auto`;
      }
  }
};
const getLinksGridColumn = (logoPosition, menuPosition) => {
  switch (logoPosition) {
    case coreRenderer.Alignment.left:
      return "2/3";
    case coreRenderer.Alignment.center:
      switch (menuPosition) {
        case coreRenderer.Alignment.left:
          return `1/2`;
        case coreRenderer.Alignment.center:
          return `1/4`;
        case coreRenderer.Alignment.right:
          return `3/4`;
      }
    case coreRenderer.Alignment.right:
      switch (menuPosition) {
        case coreRenderer.Alignment.left:
        case coreRenderer.Alignment.right:
          return `1/2`;
        case coreRenderer.Alignment.center:
          return `2/3`;
      }
  }
};
const getLogoGridColumn = (logoPosition, menuPosition) => {
  switch (logoPosition) {
    case coreRenderer.Alignment.left:
      return "1/2";
    case coreRenderer.Alignment.center:
      return "2/3";
    case coreRenderer.Alignment.right:
      switch (menuPosition) {
        case coreRenderer.Alignment.left:
        case coreRenderer.Alignment.right:
          return `2/3`;
        case coreRenderer.Alignment.center:
          return `3/4`;
      }
  }
};
const flattenToTreeMax2Level = (originMenu) => {
  const level1 = originMenu.filter((el) => !el.parentId);
  return level1.map((item) => {
    const children = originMenu.filter((m) => m.parentId === item.id);
    return __spreadProps(__spreadValues({}, item), {
      children
    });
  });
};

exports.calculateGrid = calculateGrid;
exports.flattenToTreeMax2Level = flattenToTreeMax2Level;
exports.splitPaddingString = splitPaddingString;


/***/ }),

/***/ 82404:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const WebsiteFooter = ({ children }) => {
  var _a, _b;
  const { globalData } = coreRenderer.useStore();
  const re = new RegExp((_a = globalData == null ? void 0 : globalData.powerByConfig) == null ? void 0 : _a.regexTempiFreeDomain);
  const isFreeDomain = typeof window !== "undefined" && re.test(window.location.href);
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      children,
      isFreeDomain ? /* @__PURE__ */ jsxRuntime.jsxs(PowerBy, {
        children: [
          "Powered by",
          /* @__PURE__ */ jsxRuntime.jsxs(StyledLink, {
            href: (_b = globalData == null ? void 0 : globalData.powerByConfig) == null ? void 0 : _b.powerByDomain,
            target: "_blank",
            children: [
              " ",
              "Tempi"
            ]
          })
        ]
      }) : null
    ]
  });
};
const PowerBy = styled__default["default"].p`
  width: 100%;
  text-align: center;
  font-weight: 400;
  padding-bottom: 10px;
`;
const StyledLink = styled__default["default"].a`
  color: #7367f0;

  &:hover {
    color: #7367f0;
    opacity: 0.8;
    cursor: pointer;
  }
`;
WebsiteFooter.displayName = "WebsiteFooter";

exports.WebsiteFooter = WebsiteFooter;


/***/ }),

/***/ 1326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var coreRenderer = __webpack_require__(12060);
var Ytb = __webpack_require__(15218);
var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Ytb__default = /*#__PURE__*/_interopDefaultLegacy(Ytb);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Youtube = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, { link, isEditorMode = false, autoplay = false } = _a, rest = __objRest(_a, ["link", "isEditorMode", "autoplay"]);
    return /* @__PURE__ */ jsxRuntime.jsx(StyledWrapper, __spreadProps(__spreadValues({}, rest), {
      ref,
      children: /* @__PURE__ */ jsxRuntime.jsx(StyledRatio, {
        children: /* @__PURE__ */ jsxRuntime.jsx(StyledYtb, {
          className: isEditorMode ? "editor-mode" : "",
          containerClassName: "container",
          videoId: coreRenderer.youtubeParser(link),
          opts: !isEditorMode ? {
            playerVars: {
              autoplay: autoplay ? 1 : 0,
              mute: autoplay ? 1 : 0
            }
          } : {}
        })
      })
    }));
  }
);
const StyledWrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
  width: 100%
`
);
const StyledRatio = styled__default["default"].div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  .container {
    height: 100%;
  }
`;
const StyledYtb = styled__default["default"](Ytb__default["default"])`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &.editor-mode {
    pointer-events: none;
  }
`;
Youtube.displayName = "Youtube";

exports.Youtube = Youtube;


/***/ }),

/***/ 74367:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);
var capitalize = __webpack_require__(20951);
var getResponsiveAttrKey = __webpack_require__(97612);

const fontFamilyOptions = coreRenderer.pbFontFamily.map((ff) => ({
  label: ff,
  value: ff
}));
const fontWeightOptions = Object.entries(coreRenderer.pbFontWeight).reduce((acc, cur) => {
  var _a;
  return [...acc, { label: capitalize.capitalize(cur[0]), value: (_a = cur[1]) == null ? void 0 : _a.toString() }];
}, []);
const fontSizeOptions = [12, 14, 16, 18, 24, 32, 48, 64, 72].map(
  (ff) => ({
    label: ff,
    value: ff
  })
);
const textTransformOptions = [
  { label: "Capitalize", value: "capitalize" },
  { label: "Uppercase", value: "uppercase" },
  { label: "Lowercase", value: "lowercase" }
];
const textDecorationOptions = [
  { label: "Underline", value: "underline" },
  { label: "Overline", value: "overline" },
  { label: "Line Through", value: "line-through" }
];
const fontStyleOptions = [
  { label: "Normal", value: "normal" },
  { label: "Italic", value: "italic" },
  { label: "Oblique", value: "oblique" }
];
const fontVariantOptions = [
  { label: "Normal", value: "normal" },
  { label: "Small Caps", value: "small-caps" }
];
const TEXT_STYLE_KEY = {
  fontSize: "fontSize"
};
const RESPONSIVE_TEXT_STYLE_KEY = {
  fontSize: {
    desktop: getResponsiveAttrKey.getResponsiveAttrKey(TEXT_STYLE_KEY.fontSize, "desktop"),
    mobile: getResponsiveAttrKey.getResponsiveAttrKey(TEXT_STYLE_KEY.fontSize, "mobile")
  }
};
const getCommonTextCss = (allowResponsive) => {
  const { fontSize } = RESPONSIVE_TEXT_STYLE_KEY;
  return `
  *:not(.ProseMirror-trailingBreak):empty:after {
    content: "";
    display: inline-block;
  }

  ${allowResponsive ? `
  @media (min-width: 768px) {
    .fs-desktop {
      font-size: var(--${fontSize.desktop});
    }

    li {
      margin-left: var(--${fontSize.desktop}, 1rem);
    }
  }

  @media (max-width: 767px) {
    .fs-mobile {
      font-size: var(--${fontSize.mobile});
    }
    
    li {
      margin-left: var(--${fontSize.mobile}, 1rem);
    }
  }
    ` : `
      li {
        margin-left: 1rem;
      }
    `}
`;
};

exports.RESPONSIVE_TEXT_STYLE_KEY = RESPONSIVE_TEXT_STYLE_KEY;
exports.TEXT_STYLE_KEY = TEXT_STYLE_KEY;
exports.fontFamilyOptions = fontFamilyOptions;
exports.fontSizeOptions = fontSizeOptions;
exports.fontStyleOptions = fontStyleOptions;
exports.fontVariantOptions = fontVariantOptions;
exports.fontWeightOptions = fontWeightOptions;
exports.getCommonTextCss = getCommonTextCss;
exports.textDecorationOptions = textDecorationOptions;
exports.textTransformOptions = textTransformOptions;


/***/ }),

/***/ 74178:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);
var index = __webpack_require__(5502);

const BREAK_POINTS = {
  xs: "480px",
  sm: "576px",
  md: "768px",
  lg: "1024px",
  xl: "1440px",
  xxl: "1600px"
};
const GRID_COLUMNS = 12;
const MAPPING_VERTICAL_ALIGNMENT_FLEX = {
  [coreRenderer.VerticalAlignment.top]: "flex-start",
  [coreRenderer.VerticalAlignment.center]: "center",
  [coreRenderer.VerticalAlignment.bottom]: "flex-end"
};
const MAPPING_ALIGNMENT_FLEX = {
  [coreRenderer.Alignment.center]: "center",
  [coreRenderer.Alignment.left]: "flex-start",
  [coreRenderer.Alignment.right]: "flex-end",
  [coreRenderer.Alignment.justify]: "space-between"
};
const DEFAULT_WIDTH = 1232;
const DEFAULT_HEIGHT = 400;
const DEFAULT_GUTTER = [0, 0];
const WIDTH_TYPE_OPTIONS = [
  { label: "To\xE0n b\u1ED9 chi\u1EC1u r\u1ED9ng", value: index.WidthTypeEnum.full },
  { label: "T\xF9y ch\u1EC9nh", value: index.WidthTypeEnum.fixed }
];

exports.BREAK_POINTS = BREAK_POINTS;
exports.DEFAULT_GUTTER = DEFAULT_GUTTER;
exports.DEFAULT_HEIGHT = DEFAULT_HEIGHT;
exports.DEFAULT_WIDTH = DEFAULT_WIDTH;
exports.GRID_COLUMNS = GRID_COLUMNS;
exports.MAPPING_ALIGNMENT_FLEX = MAPPING_ALIGNMENT_FLEX;
exports.MAPPING_VERTICAL_ALIGNMENT_FLEX = MAPPING_VERTICAL_ALIGNMENT_FLEX;
exports.WIDTH_TYPE_OPTIONS = WIDTH_TYPE_OPTIONS;


/***/ }),

/***/ 3346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var Trigger = __webpack_require__(21484);
var warning = __webpack_require__(36544);
var KeyCode = __webpack_require__(44833);
var arrayTreeFilter = __webpack_require__(40314);
var utils = __webpack_require__(45263);
var Menus = __webpack_require__(30810);
var placements = __webpack_require__(12452);
var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Trigger__default = /*#__PURE__*/_interopDefaultLegacy(Trigger);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
var KeyCode__default = /*#__PURE__*/_interopDefaultLegacy(KeyCode);
var arrayTreeFilter__default = /*#__PURE__*/_interopDefaultLegacy(arrayTreeFilter);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
class Cascader extends React__namespace.Component {
  constructor(props) {
    super(props);
    this.setPopupVisible = (popupVisible) => {
      const { value } = this.state;
      if (!("popupVisible" in this.props)) {
        this.setState({ popupVisible });
      }
      if (popupVisible && !this.state.popupVisible) {
        this.setState({
          activeValue: value
        });
      }
      this.props.onPopupVisibleChange(popupVisible);
    };
    this.handleChange = (options, { visible }, e) => {
      if (e.type !== "keydown" || e.keyCode === KeyCode__default["default"].ENTER) {
        this.props.onChange(
          options.map((o) => o[this.getFieldName("value")]),
          options
        );
        this.setPopupVisible(visible);
      }
    };
    this.handlePopupVisibleChange = (popupVisible) => {
      this.setPopupVisible(popupVisible);
    };
    this.handleMenuSelect = (targetOption, menuIndex, e) => {
      const triggerNode = this.trigger.getRootDomNode();
      if (triggerNode && triggerNode.focus) {
        triggerNode.focus();
      }
      const { changeOnSelect, loadData, expandTrigger } = this.props;
      if (!targetOption || targetOption.disabled) {
        return;
      }
      let { activeValue } = this.state;
      activeValue = activeValue.slice(0, menuIndex + 1);
      activeValue[menuIndex] = targetOption[this.getFieldName("value")];
      const activeOptions = this.getActiveOptions(activeValue);
      if (targetOption.isLeaf === false && !targetOption[this.getFieldName("children")] && loadData) {
        if (changeOnSelect) {
          this.handleChange(activeOptions, { visible: true }, e);
        }
        this.setState({ activeValue });
        loadData(activeOptions);
        return;
      }
      const newState = {};
      if (!targetOption[this.getFieldName("children")] || !targetOption[this.getFieldName("children")].length) {
        this.handleChange(activeOptions, { visible: false }, e);
        newState.value = activeValue;
      } else if (changeOnSelect && (e.type === "click" || e.type === "keydown")) {
        if (expandTrigger === "hover") {
          this.handleChange(activeOptions, { visible: false }, e);
        } else {
          this.handleChange(activeOptions, { visible: true }, e);
        }
        newState.value = activeValue;
      }
      newState.activeValue = activeValue;
      if ("value" in this.props || e.type === "keydown" && e.keyCode !== KeyCode__default["default"].ENTER) {
        delete newState.value;
      }
      this.setState(newState);
    };
    this.handleItemDoubleClick = () => {
      const { changeOnSelect } = this.props;
      if (changeOnSelect) {
        this.setPopupVisible(false);
      }
    };
    this.handleKeyDown = (e) => {
      const { children } = this.props;
      if (children && children.props.onKeyDown) {
        children.props.onKeyDown(e);
        return;
      }
      const activeValue = [...this.state.activeValue];
      const currentLevel = activeValue.length - 1 < 0 ? 0 : activeValue.length - 1;
      const currentOptions = this.getCurrentLevelOptions();
      const currentIndex = currentOptions.map((o) => o[this.getFieldName("value")]).indexOf(activeValue[currentLevel]);
      if (e.keyCode !== KeyCode__default["default"].DOWN && e.keyCode !== KeyCode__default["default"].UP && e.keyCode !== KeyCode__default["default"].LEFT && e.keyCode !== KeyCode__default["default"].RIGHT && e.keyCode !== KeyCode__default["default"].ENTER && e.keyCode !== KeyCode__default["default"].SPACE && e.keyCode !== KeyCode__default["default"].BACKSPACE && e.keyCode !== KeyCode__default["default"].ESC && e.keyCode !== KeyCode__default["default"].TAB) {
        return;
      }
      if (!this.state.popupVisible && e.keyCode !== KeyCode__default["default"].BACKSPACE && e.keyCode !== KeyCode__default["default"].LEFT && e.keyCode !== KeyCode__default["default"].RIGHT && e.keyCode !== KeyCode__default["default"].ESC && e.keyCode !== KeyCode__default["default"].TAB) {
        this.setPopupVisible(true);
        if (this.props.onKeyDown) {
          this.props.onKeyDown(e);
        }
        return;
      }
      if (e.keyCode === KeyCode__default["default"].DOWN || e.keyCode === KeyCode__default["default"].UP) {
        e.preventDefault();
        let nextIndex = currentIndex;
        if (nextIndex !== -1) {
          if (e.keyCode === KeyCode__default["default"].DOWN) {
            nextIndex += 1;
            nextIndex = nextIndex >= currentOptions.length ? 0 : nextIndex;
          } else {
            nextIndex -= 1;
            nextIndex = nextIndex < 0 ? currentOptions.length - 1 : nextIndex;
          }
        } else {
          nextIndex = 0;
        }
        activeValue[currentLevel] = currentOptions[nextIndex][this.getFieldName("value")];
      } else if (e.keyCode === KeyCode__default["default"].LEFT || e.keyCode === KeyCode__default["default"].BACKSPACE) {
        e.preventDefault();
        activeValue.splice(activeValue.length - 1, 1);
      } else if (e.keyCode === KeyCode__default["default"].RIGHT) {
        e.preventDefault();
        if (currentOptions[currentIndex] && currentOptions[currentIndex][this.getFieldName("children")]) {
          activeValue.push(
            currentOptions[currentIndex][this.getFieldName("children")][0][this.getFieldName("value")]
          );
        }
      } else if (e.keyCode === KeyCode__default["default"].ESC || e.keyCode === KeyCode__default["default"].TAB) {
        this.setPopupVisible(false);
        if (this.props.onKeyDown) {
          this.props.onKeyDown(e);
        }
        return;
      }
      if (!activeValue || activeValue.length === 0) {
        this.setPopupVisible(false);
      }
      const activeOptions = this.getActiveOptions(activeValue);
      const targetOption = activeOptions[activeOptions.length - 1];
      this.handleMenuSelect(targetOption, activeOptions.length - 1, e);
      if (this.props.onKeyDown) {
        this.props.onKeyDown(e);
      }
    };
    this.saveTrigger = (node) => {
      this.trigger = node;
    };
    let initialValue = [];
    if ("value" in props) {
      initialValue = props.value || [];
    } else if ("defaultValue" in props) {
      initialValue = props.defaultValue || [];
    }
    warning__default["default"](
      !("filedNames" in props),
      "`filedNames` of Cascader is a typo usage and deprecated, please use `fieldNames` instead."
    );
    this.state = {
      popupVisible: props.popupVisible,
      activeValue: initialValue,
      value: initialValue,
      prevProps: props
    };
    this.defaultFieldNames = {
      label: "label",
      value: "value",
      children: "children"
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { prevProps = {} } = prevState;
    const newState = {
      prevProps: nextProps
    };
    if ("value" in nextProps && !utils.isEqualArrays(prevProps.value, nextProps.value)) {
      newState.value = nextProps.value || [];
      if (!("loadData" in nextProps)) {
        newState.activeValue = nextProps.value || [];
      }
    }
    if ("popupVisible" in nextProps) {
      newState.popupVisible = nextProps.popupVisible;
    }
    return newState;
  }
  getPopupDOMNode() {
    return this.trigger.getPopupDomNode();
  }
  getFieldName(name) {
    const { defaultFieldNames } = this;
    const { fieldNames, filedNames } = this.props;
    if ("filedNames" in this.props) {
      return filedNames[name] || defaultFieldNames[name];
    }
    return fieldNames[name] || defaultFieldNames[name];
  }
  getFieldNames() {
    const { fieldNames, filedNames } = this.props;
    if ("filedNames" in this.props) {
      return filedNames;
    }
    return fieldNames;
  }
  getCurrentLevelOptions() {
    const { options = [] } = this.props;
    const { activeValue = [] } = this.state;
    const result = arrayTreeFilter__default["default"](
      options,
      (o, level) => o[this.getFieldName("value")] === activeValue[level],
      { childrenKeyName: this.getFieldName("children") }
    );
    if (result[result.length - 2]) {
      return result[result.length - 2][this.getFieldName("children")];
    }
    return [...options].filter((o) => !o.disabled);
  }
  getActiveOptions(activeValue) {
    return arrayTreeFilter__default["default"](
      this.props.options || [],
      (o, level) => o[this.getFieldName("value")] === activeValue[level],
      { childrenKeyName: this.getFieldName("children") }
    );
  }
  render() {
    const _a = this.props, {
      prefixCls,
      transitionName,
      popupClassName,
      options = [],
      disabled,
      builtinPlacements,
      popupPlacement,
      children,
      dropdownRender
    } = _a, restProps = __objRest(_a, [
      "prefixCls",
      "transitionName",
      "popupClassName",
      "options",
      "disabled",
      "builtinPlacements",
      "popupPlacement",
      "children",
      "dropdownRender"
    ]);
    let menus = /* @__PURE__ */ jsxRuntime.jsx("div", {});
    let emptyMenuClassName = "";
    if (options && options.length > 0) {
      menus = /* @__PURE__ */ jsxRuntime.jsx(StyledMenus, __spreadProps(__spreadValues({}, this.props), {
        fieldNames: this.getFieldNames(),
        defaultFieldNames: this.defaultFieldNames,
        activeValue: this.state.activeValue,
        onSelect: this.handleMenuSelect,
        onItemDoubleClick: this.handleItemDoubleClick,
        visible: this.state.popupVisible
      }));
    } else {
      emptyMenuClassName = ` ${prefixCls}-menus-empty`;
    }
    let popupNode = menus;
    if (dropdownRender) {
      popupNode = dropdownRender(menus);
    }
    return /* @__PURE__ */ jsxRuntime.jsx(Trigger__default["default"], __spreadProps(__spreadValues({
      ref: this.saveTrigger
    }, restProps), {
      popupPlacement,
      builtinPlacements,
      popupTransitionName: transitionName,
      action: disabled ? [] : ["click"],
      popupVisible: disabled ? false : this.state.popupVisible,
      onPopupVisibleChange: this.handlePopupVisibleChange,
      prefixCls: `${prefixCls}-menus`,
      popupClassName: popupClassName + emptyMenuClassName,
      popup: popupNode,
      children: React__namespace.cloneElement(children, {
        onKeyDown: this.handleKeyDown,
        tabIndex: disabled ? void 0 : 0
      })
    }));
  }
}
Cascader.defaultProps = {
  onChange: () => {
  },
  onPopupVisibleChange: () => {
  },
  disabled: false,
  transitionName: "",
  prefixCls: "rc-cascader",
  popupClassName: "",
  popupPlacement: "bottomLeft",
  builtinPlacements: placements,
  expandTrigger: "click",
  fieldNames: { label: "label", value: "value", children: "children" },
  expandIcon: ">"
};
var Cascader$1 = Cascader;
const StyledMenus = styled__default["default"](Menus)`
  .rc-cascader {
    font-size: 12px;
  }
  .rc-cascader-menus {
    font-size: 12px;
    overflow: hidden;
    background: #fff;
    position: absolute;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);
    white-space: nowrap;
  }
  .rc-cascader-menus-hidden {
    display: none;
  }
  .rc-cascader-menus.slide-up-enter,
  .rc-cascader-menus.slide-up-appear {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    transform-origin: 0 0;
    opacity: 0;
    animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
    animation-play-state: paused;
  }
  .rc-cascader-menus.slide-up-leave {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    transform-origin: 0 0;
    opacity: 1;
    animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
    animation-play-state: paused;
  }
  .rc-cascader-menus.slide-up-enter.slide-up-enter-active.rc-cascader-menus-placement-bottomLeft,
  .rc-cascader-menus.slide-up-appear.slide-up-appear-active.rc-cascader-menus-placement-bottomLeft {
    animation-name: SlideUpIn;
    animation-play-state: running;
  }
  .rc-cascader-menus.slide-up-enter.slide-up-enter-active.rc-cascader-menus-placement-topLeft,
  .rc-cascader-menus.slide-up-appear.slide-up-appear-active.rc-cascader-menus-placement-topLeft {
    animation-name: SlideDownIn;
    animation-play-state: running;
  }
  .rc-cascader-menus.slide-up-leave.slide-up-leave-active.rc-cascader-menus-placement-bottomLeft {
    animation-name: SlideUpOut;
    animation-play-state: running;
  }
  .rc-cascader-menus.slide-up-leave.slide-up-leave-active.rc-cascader-menus-placement-topLeft {
    animation-name: SlideDownOut;
    animation-play-state: running;
  }
  .rc-cascader-menu {
    display: inline-block;
    width: 100px;
    height: 192px;
    list-style: none;
    margin: 0;
    padding: 0;
    border-right: 1px solid #e9e9e9;
    overflow: auto;
  }
  .rc-cascader-menu:last-child {
    border-right: 0;
  }
  .rc-cascader-menu-item {
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all 0.3s ease;
    position: relative;
  }
  .rc-cascader-menu-item:hover {
    background: tint(#2db7f5, 90%);
  }
  .rc-cascader-menu-item-disabled {
    cursor: not-allowed;
    color: #ccc;
  }
  .rc-cascader-menu-item-disabled:hover {
    background: transparent;
  }
  .rc-cascader-menu-item-loading:after {
    position: absolute;
    right: 12px;
    content: 'loading';
    color: #aaa;
    font-style: italic;
  }
  .rc-cascader-menu-item-active {
    background: tint(#2db7f5, 80%);
  }
  .rc-cascader-menu-item-active:hover {
    background: tint(#2db7f5, 80%);
  }
  .rc-cascader-menu-item-expand {
    position: relative;
  }
  .rc-cascader-menu-item-expand-icon {
    font-size: 12px;
    color: #999;
    position: absolute;
    right: 16px;
    line-height: 32px;
  }
  @keyframes SlideUpIn {
    0% {
      opacity: 0;
      transform-origin: 0% 0%;
      transform: scaleY(0.8);
    }
    100% {
      opacity: 1;
      transform-origin: 0% 0%;
      transform: scaleY(1);
    }
  }
  @keyframes SlideUpOut {
    0% {
      opacity: 1;
      transform-origin: 0% 0%;
      transform: scaleY(1);
    }
    100% {
      opacity: 0;
      transform-origin: 0% 0%;
      transform: scaleY(0.8);
    }
  }
  @keyframes SlideDownIn {
    0% {
      opacity: 0;
      transform-origin: 0% 100%;
      transform: scaleY(0.8);
    }
    100% {
      opacity: 1;
      transform-origin: 0% 100%;
      transform: scaleY(1);
    }
  }
  @keyframes SlideDownOut {
    0% {
      opacity: 1;
      transform-origin: 0% 100%;
      transform: scaleY(1);
    }
    100% {
      opacity: 0;
      transform-origin: 0% 100%;
      transform: scaleY(0.8);
    }
  }
`;

module.exports = Cascader$1;


/***/ }),

/***/ 30810:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var arrayTreeFilter = __webpack_require__(40314);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var arrayTreeFilter__default = /*#__PURE__*/_interopDefaultLegacy(arrayTreeFilter);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class Menus extends React__namespace.Component {
  constructor() {
    super(...arguments);
    this.menuItems = {};
    this.saveMenuItem = (index) => (node) => {
      this.menuItems[index] = node;
    };
  }
  componentDidMount() {
    this.scrollActiveItemToView();
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.scrollActiveItemToView();
    }
  }
  getFieldName(name) {
    const { fieldNames, defaultFieldNames } = this.props;
    return fieldNames[name] || defaultFieldNames[name];
  }
  getOption(option, menuIndex) {
    const { prefixCls, expandTrigger, expandIcon, loadingIcon } = this.props;
    const onSelect = this.props.onSelect.bind(this, option, menuIndex);
    const onItemDoubleClick = this.props.onItemDoubleClick.bind(
      this,
      option,
      menuIndex
    );
    let expandProps = {
      onClick: onSelect,
      onDoubleClick: onItemDoubleClick
    };
    let menuItemCls = `${prefixCls}-menu-item`;
    let expandIconNode = null;
    const hasChildren = option[this.getFieldName("children")] && option[this.getFieldName("children")].length > 0;
    if (hasChildren || option.isLeaf === false) {
      menuItemCls += ` ${prefixCls}-menu-item-expand`;
      if (!option.loading) {
        expandIconNode = /* @__PURE__ */ jsxRuntime.jsx("span", {
          className: `${prefixCls}-menu-item-expand-icon`,
          children: expandIcon
        });
      }
    }
    if (expandTrigger === "hover" && (hasChildren || option.isLeaf === false)) {
      expandProps = {
        onMouseEnter: this.delayOnSelect.bind(this, onSelect),
        onMouseLeave: this.delayOnSelect.bind(this),
        onClick: onSelect
      };
    }
    if (this.isActiveOption(option, menuIndex)) {
      menuItemCls += ` ${prefixCls}-menu-item-active`;
      expandProps.ref = this.saveMenuItem(menuIndex);
    }
    if (option.disabled) {
      menuItemCls += ` ${prefixCls}-menu-item-disabled`;
    }
    let loadingIconNode = null;
    if (option.loading) {
      menuItemCls += ` ${prefixCls}-menu-item-loading`;
      loadingIconNode = loadingIcon || null;
    }
    let title = "";
    if ("title" in option) {
      title = option.title;
    } else if (typeof option[this.getFieldName("label")] === "string") {
      title = option[this.getFieldName("label")];
    }
    return /* @__PURE__ */ jsxRuntime.jsxs("li", __spreadProps(__spreadValues({
      className: menuItemCls,
      title
    }, expandProps), {
      role: "menuitem",
      onMouseDown: (e) => e.preventDefault(),
      children: [
        option[this.getFieldName("label")],
        expandIconNode,
        loadingIconNode
      ]
    }), option[this.getFieldName("value")]);
  }
  getActiveOptions(values) {
    const { options } = this.props;
    const activeValue = values || this.props.activeValue;
    return arrayTreeFilter__default["default"](
      options,
      (o, level) => o[this.getFieldName("value")] === activeValue[level],
      { childrenKeyName: this.getFieldName("children") }
    );
  }
  getShowOptions() {
    const { options } = this.props;
    const result = this.getActiveOptions().map((activeOption) => activeOption[this.getFieldName("children")]).filter((activeOption) => !!activeOption);
    result.unshift(options);
    return result;
  }
  delayOnSelect(onSelect, ...args) {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
    if (typeof onSelect === "function") {
      this.delayTimer = window.setTimeout(() => {
        onSelect(args);
        this.delayTimer = null;
      }, 150);
    }
  }
  scrollActiveItemToView() {
    const optionsLength = this.getShowOptions().length;
    for (let i = 0; i < optionsLength; i++) {
      const itemComponent = this.menuItems[i];
      if (itemComponent && itemComponent.parentElement) {
        itemComponent.parentElement.scrollTop = itemComponent.offsetTop;
      }
    }
  }
  isActiveOption(option, menuIndex) {
    const { activeValue = [] } = this.props;
    return activeValue[menuIndex] === option[this.getFieldName("value")];
  }
  render() {
    const { prefixCls, dropdownMenuColumnStyle } = this.props;
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      children: this.getShowOptions().map((options, menuIndex) => /* @__PURE__ */ jsxRuntime.jsx("ul", {
        className: `${prefixCls}-menu`,
        style: dropdownMenuColumnStyle,
        children: options.map((option) => this.getOption(option, menuIndex))
      }, menuIndex))
    });
  }
}
Menus.defaultProps = {
  options: [],
  value: [],
  activeValue: [],
  onSelect() {
  },
  prefixCls: "rc-cascader-menus",
  visible: false,
  expandTrigger: "click"
};
var Menus$1 = Menus;

module.exports = Menus$1;


/***/ }),

/***/ 12452:
/***/ (function(module) {



const BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  }
};
var BUILT_IN_PLACEMENTS$1 = BUILT_IN_PLACEMENTS;

module.exports = BUILT_IN_PLACEMENTS$1;


/***/ }),

/***/ 45263:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

function isEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }
  if (!arrA || !arrB) {
    return false;
  }
  const len = arrA.length;
  if (arrB.length !== len) {
    return false;
  }
  for (let i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }
  return true;
}

exports.isEqualArrays = isEqualArrays;


/***/ }),

/***/ 88006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var coreRenderer = __webpack_require__(12060);
var styled = __webpack_require__(21483);
var grid = __webpack_require__(74178);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled__default["default"].div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${grid.BREAK_POINTS.xl}) {
    max-width: ${(props) => props.fluid ? "100%" : coreRenderer.unitParse(props.maxWidth)};
  }
`;
const Container = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
    return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
      maxWidth,
      fluid,
      ref
    }, others), {
      children
    }));
  }
);
Container.displayName = "Container";

exports.Container = Container;


/***/ }),

/***/ 59603:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var styled = __webpack_require__(21483);
var type = __webpack_require__(45388);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Divider = (_a) => {
  var _b = _a, {
    width = "100%",
    height = "1px",
    color = "black",
    dividerStyle = type.DividerStyleEnum.solid,
    align,
    gap,
    alignContent,
    spacingContent,
    children
  } = _b, rest = __objRest(_b, [
    "width",
    "height",
    "color",
    "dividerStyle",
    "align",
    "gap",
    "alignContent",
    "spacingContent",
    "children"
  ]);
  const renderSeparator = () => {
    if (!children) {
      return /* @__PURE__ */ jsxRuntime.jsx(WrapperSeparator, {
        width,
        weight: height,
        dividerStyle,
        color,
        align
      });
    }
    return /* @__PURE__ */ jsxRuntime.jsx(WrapperSeparatorText, {
      width,
      weight: height,
      dividerStyle,
      color,
      align,
      alignContent,
      spacingContent,
      children: /* @__PURE__ */ jsxRuntime.jsx("span", {
        children
      })
    });
  };
  return /* @__PURE__ */ jsxRuntime.jsx(WrapperDivider, __spreadProps(__spreadValues({}, rest), {
    gap,
    children: renderSeparator()
  }));
};
const WrapperDivider = styled__default["default"].div(
  ({ gap }) => `
  --divider-gap: ${coreRenderer.unitParse(gap) || "12px"};
  display: flex;
  padding-top: var(--divider-gap);
  padding-bottom: var(--divider-gap);
`
);
const transformAlign = (align) => {
  switch (align) {
    case coreRenderer.Alignment.center:
      return "margin: 0 auto;";
    case coreRenderer.Alignment.right:
      return `
        margin: 0 auto;
        margin-right: 0;
      `;
    default:
      return "";
  }
};
const transformAlignContent = (alignContent) => {
  const css = `{
    display: block;
    content: "";
    border-bottom: 0;
    flex-grow: 1;
    border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);
  }`;
  switch (alignContent) {
    case coreRenderer.Alignment.left:
      return `
          &:after ${css}
        `;
    case coreRenderer.Alignment.right:
      return `
          &:before ${css}
        `;
    default:
      return `
          &:after, &:before ${css}
        `;
  }
};
const WrapperSeparator = styled__default["default"].div(
  ({ width, weight, dividerStyle, color, align }) => `
  --divider-border-style: ${dividerStyle};
  --divider-color: ${color || "#000000"};
  --divider-border-width: ${weight || "1px"};
  display: flex;
  width: ${width ? width : "100%"};
  border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);
  ${transformAlign(align)}
`
);
const WrapperSeparatorText = styled__default["default"].div(
  ({
    width,
    weight,
    dividerStyle,
    color = "black",
    align,
    alignContent,
    spacingContent
  }) => `
  --divider-border-style: ${dividerStyle};
  --divider-color: ${color};
  --divider-border-width: ${weight || "1px"};
  --divider-content-spacing: ${spacingContent || "10px"};
  display: flex;
  align-items: center;
  width: ${width ? width : "100%"};
  ${transformAlign(align)}
  ${transformAlignContent(alignContent)}

  > span {
    margin: 0 var(--divider-content-spacing);
    margin-left: ${alignContent === "left" ? "0" : "var(--divider-content-spacing)"};
    margin-right: ${alignContent === "right" ? "0" : "var(--divider-content-spacing)"};
  }
`
);
Divider.displayName = "Divider";

exports.Divider = Divider;


/***/ }),

/***/ 85468:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var react = __webpack_require__(6968);
var helper = __webpack_require__(50916);
var SwiperCore = __webpack_require__(26438);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var SwiperCore__default = /*#__PURE__*/_interopDefaultLegacy(SwiperCore);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
SwiperCore__default["default"].use([SwiperCore.Navigation, SwiperCore.Pagination, SwiperCore.Thumbs, SwiperCore.Autoplay, SwiperCore.Virtual]);
const DSSlider = (_a) => {
  var _b = _a, {
    className,
    children,
    paginationStyle,
    navigationStyle,
    speed = 3e3,
    pauseOnMouseEnter = true,
    paginationColor,
    virtual,
    paginationPosition = "inside",
    commonStyle,
    slidesPerViewMobile,
    navigationColor
  } = _b, swiperProps = __objRest(_b, [
    "className",
    "children",
    "paginationStyle",
    "navigationStyle",
    "speed",
    "pauseOnMouseEnter",
    "paginationColor",
    "virtual",
    "paginationPosition",
    "commonStyle",
    "slidesPerViewMobile",
    "navigationColor"
  ]);
  const {
    slidesPerView,
    slidesPerColumn,
    pagination,
    autoplay,
    loop,
    showThumbnail,
    alignThumbnail
  } = swiperProps;
  const [swiperKey, setSwiperKey] = React.useState(0);
  let breakpoints;
  const [thumbsSwiper, setThumbsSwiper] = React.useState(null);
  const isMultipleRows = slidesPerColumn && slidesPerColumn > 1;
  if (pagination) {
    swiperProps.pagination = {
      clickable: true
    };
  }
  if (isMultipleRows)
    swiperProps.loop = false;
  if (autoplay) {
    swiperProps.autoplay = {
      delay: speed,
      disableOnInteraction: false,
      pauseOnMouseEnter
    };
  }
  if (slidesPerViewMobile) {
    breakpoints = {
      320: { slidesPerView: slidesPerViewMobile },
      640: { slidesPerView }
    };
  }
  React.useEffect(() => {
    setSwiperKey((key) => key + 1);
  }, [
    showThumbnail,
    autoplay,
    loop,
    speed,
    pauseOnMouseEnter,
    virtual,
    slidesPerColumn
  ]);
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    className,
    paginationStyle,
    navigationStyle,
    isMultipleRows,
    paginationColor,
    navigationColor,
    paginationPosition,
    commonStyle,
    slidesPerView,
    slidesPerColumn,
    itemsCount: React.Children.toArray(children).length,
    spaceBetween: swiperProps == null ? void 0 : swiperProps.spaceBetween,
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(react.Swiper, __spreadProps(__spreadValues({
        breakpoints
      }, swiperProps), {
        thumbs: {
          swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
        },
        virtual: virtual && slidesPerView ? {
          addSlidesBefore: slidesPerView
        } : false,
        resizeObserver: true,
        slidesPerColumnFill: "row",
        children: React.Children.map(children, (child, index) => /* @__PURE__ */ jsxRuntime.jsx(react.SwiperSlide, {
          virtualIndex: index,
          children: child
        }, `slide-${index}`))
      }), `swiper-${swiperKey}`),
      showThumbnail && /* @__PURE__ */ jsxRuntime.jsx(react.Swiper, {
        className: `swiper-thumbnail ${alignThumbnail ? `swiper-thumbnail__${alignThumbnail}` : ""}`,
        onSwiper: setThumbsSwiper,
        spaceBetween: 10,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        children: React.Children.map(children, (child, index) => /* @__PURE__ */ jsxRuntime.jsx(react.SwiperSlide, {
          virtualIndex: index,
          children: child
        }, `thumb-${index}`))
      })
    ]
  });
};
const Wrapper = styled__default["default"].div(
  ({
    isMultipleRows,
    paginationStyle,
    paginationColor,
    paginationPosition,
    navigationStyle,
    navigationColor,
    commonStyle,
    slidesPerView = 1,
    slidesPerColumn = 1,
    itemsCount,
    spaceBetween = 10
  }) => {
    var _a;
    const isServerless = typeof window === "undefined";
    let totalItemPerRow, serverWidthWrapper, serverWidthItem;
    if (isServerless) {
      totalItemPerRow = Math.ceil(itemsCount / slidesPerColumn);
      serverWidthWrapper = `${totalItemPerRow / slidesPerView * 100}%`;
      serverWidthItem = `calc(100% / ${totalItemPerRow} - ${spaceBetween * (totalItemPerRow - 1) / totalItemPerRow}px)`;
    }
    return `
    .swiper-container {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      list-style: none;
      padding: 0;
      ${paginationStyle && paginationPosition === "outside" ? "padding-bottom: 3em;" : ""}
    }
    .swiper-wrapper {
      position: relative;
      height: 100%;
      display: flex;
      transition-property: transform;
      box-sizing: content-box;
      flex-wrap: ${isMultipleRows ? "wrap" : "nowrap"};
      // Ch\u1EC9 c\xF3 t\xE1c d\u1EE5ng \u1EDF SSR, khi v\u1EC1 CSR th\u01B0 vi\u1EC7n swiper s\u1EBD t\u1EF1 \u0111\u1ED9ng override css n\xE0y b\u1EB1ng pixel
      ${isServerless ? `width: ${serverWidthWrapper}` : ""}
    }
    .swiper-slide {
      flex-shrink: 0;
      height: 100%;
      position: relative;
      border-radius: ${coreRenderer.unitParse(
      (_a = commonStyle == null ? void 0 : commonStyle.borderRadius) != null ? _a : 0,
      coreRenderer.UnitEnum.percent
    )};
      overflow: hidden;
      transition-property: transform;
      ${isMultipleRows ? `margin-top: 0px !important` : ""};
      // Ch\u1EC9 c\xF3 t\xE1c d\u1EE5ng \u1EDF SSR, khi v\u1EC1 CSR th\u01B0 vi\u1EC7n swiper s\u1EBD t\u1EF1 \u0111\u1ED9ng override css n\xE0y b\u1EB1ng pixel
      ${isServerless ? `width: ${serverWidthItem};
            margin-right: ${spaceBetween}px;` : ""}
    }
    &:hover {
      .swiper-button-next,
      .swiper-button-prev {
        opacity: 1;
        &.swiper-button-disabled {
          opacity: 0.35;
        }
      }
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-pagination-fraction {
      bottom: 0;
      left: 0;
      width: 100%;
    }
    .swiper-pagination-bullets {
      bottom: 10px;
      left: 0;
      width: 100%;
    }
    ${paginationStyle ? helper.renderPaginationStyle(paginationStyle, paginationColor) : ""}
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      top: 50%;
      z-index: 10;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      margin-top: -22px;
      opacity: 0;
      &.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
        pointer-events: auto;
      }
    }
    .swiper-thumbnail {
      padding-top: 10px;

      &.swiper-thumbnail__left {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }

      &.swiper-thumbnail__center {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &.swiper-thumbnail__right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .swiper-slide {
        width: 80px !important;
        height: 80px;
        cursor: pointer;

        img {
          width: 80px;
          height: 80px;
        }

        &.swiper-slide-thumb-active::after {
          background: transparent;
        }

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,.5);
        }
      }
    }
    ${coreRenderer.getStyle(commonStyle)}
    ${navigationStyle ? helper.renderSwipeButton(navigationStyle, navigationColor) : ""}
`;
  }
);

exports.DSSlider = DSSlider;


/***/ }),

/***/ 50916:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const renderPaginationStyle = (index, paginationColor) => {
  const styleArr = [
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: 0.75rem;
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: 0.75rem;
      width: 24px;
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #ddd;
      cursor: pointer;
      &:first-of-type {
        border-radius: 999px 0 0 999px;
      };
      &:last-of-type {
        border-radius: 0 999px 999px 0;
      }
    }
    .swiper-pagination-bullet-active {
      width: 24px;
      position: relative;
      &:after {
        content: "";
        border-radius: 999px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${paginationColor};
      }
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: 0.75rem;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      transform: translateY(2px);
    }`
  ];
  return index > 0 ? styleArr[index - 1] : null;
};
const renderSwipeButton = (index, color) => {
  const styleArr = [
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-right: 0.5rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-left: 1rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }`
  ];
  return index > 0 ? styleArr[index - 1] : null;
};

exports.renderPaginationStyle = renderPaginationStyle;
exports.renderSwipeButton = renderSwipeButton;


/***/ }),

/***/ 97089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var clsx = __webpack_require__(77084);
var RowContext = __webpack_require__(90208);
var react = __webpack_require__(75537);
var styled = __webpack_require__(21483);
var grid = __webpack_require__(74178);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function parseFlex(flex) {
  if (typeof flex === "number") {
    return `${flex} ${flex} auto`;
  }
  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return `0 0 ${flex}`;
  }
  return flex;
}
const sizes = ["xs", "sm", "md", "lg", "xl", "xxl"];
const Col = React__default["default"].forwardRef(
  (props, ref) => {
    const { gutter, wrap } = React__default["default"].useContext(RowContext);
    const _a = props, {
      span,
      order,
      offset,
      push,
      pull,
      className,
      children,
      flex,
      style
    } = _a, others = __objRest(_a, [
      "span",
      "order",
      "offset",
      "push",
      "pull",
      "className",
      "children",
      "flex",
      "style"
    ]);
    const prefixCls = "teko-col";
    let sizeClassObj = {};
    sizes.forEach((size) => {
      let sizeProps = {};
      const propSize = props[size];
      if (typeof propSize === "number") {
        sizeProps.span = propSize;
      } else if (typeof propSize === "object") {
        sizeProps = propSize || {};
      }
      sizeClassObj = __spreadProps(__spreadValues({}, sizeClassObj), {
        [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== void 0,
        [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
        [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
        [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
        [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0
      });
    });
    const classes = clsx__default["default"](
      prefixCls,
      {
        [`${prefixCls}-${span}`]: span !== void 0,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull
      },
      className,
      sizeClassObj
    );
    let mergedStyle = __spreadValues({}, style);
    if (gutter) {
      mergedStyle = __spreadValues(__spreadValues({}, gutter[0] && gutter[0] > 0 ? {
        paddingLeft: gutter[0] / 2,
        paddingRight: gutter[0] / 2
      } : {}), mergedStyle);
    }
    if (flex) {
      mergedStyle.flex = parseFlex(flex);
      if (flex === "auto" && wrap === false && !mergedStyle.minWidth) {
        mergedStyle.minWidth = 0;
      }
    }
    return /* @__PURE__ */ jsxRuntime.jsx(StyledCol, __spreadProps(__spreadValues({}, others), {
      style: mergedStyle,
      className: classes,
      ref,
      children
    }));
  }
);
Col.displayName = "Col";
const floorPercentage = (percent) => {
  return Math.floor(percent * 100) / 100;
};
const percentage = (x, y) => {
  return floorPercentage(x / y * 100) + "%";
};
const loopGridColumn = (_class = "") => {
  let _css = `
    &.teko-col${_class}-0 {
      display: none;
    }
    &.teko-col-push-0 {
      left: auto;
    }
    &.teko-col-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-push-0 {
      left: auto;
    }
    &.teko-col${_class}-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-offset-0 {
      margin-left: 0;
    }
    &.teko-col${_class}-order-0 {
      order: 0;
    }
  `;
  for (let i = 1; i <= 24; i++) {
    _css += `
      &.teko-col${_class}-${i} {
        display: block;
        flex: 0 0 ${percentage(i, grid.GRID_COLUMNS)};
        max-width: ${_class === "-lg" ? "84px" : ["-xl", "-xxl"].includes(_class) ? "104px" : percentage(i, grid.GRID_COLUMNS)};
      }
      &.teko-col${_class}-push-${i} {
        left: ${percentage(i, grid.GRID_COLUMNS)};
      }
      &.teko-col${_class}-pull-${i} {
        right: ${percentage(i, grid.GRID_COLUMNS)};
      }
      &.teko-col${_class}-offset-${i} {
        margin-left: ${percentage(i, grid.GRID_COLUMNS)};
      }
      &.teko-col${_class}-order-${i} {
        order: ${i};
      }
    `;
  }
  return _css;
};
const makeGrid = react.css`
  ${loopGridColumn()}
  ${loopGridColumn("-xs")}
  ${Object.keys(grid.BREAK_POINTS).map(
  (label) => label !== "xs" ? `
    @media (min-width: ${grid.BREAK_POINTS[label]}) {
      ${loopGridColumn(`-${label}`)}
    }
  ` : ""
).join("")}
`;
const flexStyle = (flex) => {
  if (!flex)
    return;
  return `
    flex: ${parseFlex(flex)};
    ${typeof flex === "string" ? `max-width: ${flex} !important;` : ""}
  `;
};
const makeFlexStyles = (props) => {
  var _a;
  return react.css`
    ${typeof props.xs === "object" && ((_a = props.xs) == null ? void 0 : _a.flex) !== void 0 ? flexStyle(props.xs.flex) : ""}
    ${Object.keys(grid.BREAK_POINTS).map(
    (label) => {
      var _a2, _b;
      return ((_a2 = props[label]) == null ? void 0 : _a2.flex) && label !== "xs" ? `
      @media (min-width: ${grid.BREAK_POINTS[label]}) {
        ${flexStyle((_b = props[label]) == null ? void 0 : _b.flex)};
      }
    ` : "";
    }
  ).join("")}
  `;
};
const StyledCol = styled__default["default"].div(
  `
  &.teko-col {
    position: relative;
    max-width: 100%;
    // Prevent columns from collapsing when empty
    min-height: 1px;
  }`,
  makeGrid,
  makeFlexStyles
);

exports.Col = Col;
exports.floorPercentage = floorPercentage;
exports.percentage = percentage;


/***/ }),

/***/ 58624:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var clsx = __webpack_require__(77084);
var RowContext = __webpack_require__(90208);
var util = __webpack_require__(39534);
var styled = __webpack_require__(21483);
var grid = __webpack_require__(74178);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Row = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, {
      justify,
      align,
      className,
      style,
      children,
      gutter = 0,
      wrap
    } = _a, others = __objRest(_a, [
      "justify",
      "align",
      "className",
      "style",
      "children",
      "gutter",
      "wrap"
    ]);
    const [screens, setScreens] = React__default["default"].useState({
      xs: true,
      sm: true,
      md: true,
      lg: true,
      xl: true,
      xxl: true
    });
    const gutterRef = React__default["default"].useRef(gutter);
    React__default["default"].useEffect(() => {
      const token = util["default"].subscribe((screen) => {
        const currentGutter = gutterRef.current || 0;
        if (!Array.isArray(currentGutter) && typeof currentGutter === "object" || Array.isArray(currentGutter) && (typeof currentGutter[0] === "object" || typeof currentGutter[1] === "object")) {
          setScreens(screen);
        }
      });
      return () => util["default"].unsubscribe(token);
    }, []);
    const getGutter = () => {
      const results = [0, 0];
      const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
      normalizedGutter.forEach((g, index) => {
        if (typeof g === "object") {
          for (let i = 0; i < util.responsiveArray.length; i++) {
            const breakpoint = util.responsiveArray[i];
            if (screens[breakpoint] && g[breakpoint] !== void 0) {
              results[index] = g[breakpoint];
              break;
            }
          }
        } else {
          results[index] = g || 0;
        }
      });
      return results;
    };
    const prefixCls = "teko-row";
    const gutters = getGutter();
    const classes = clsx__default["default"](
      prefixCls,
      {
        [`${prefixCls}-no-wrap`]: wrap === false,
        [`${prefixCls}-${justify}`]: justify,
        [`${prefixCls}-${align}`]: align
      },
      className
    );
    const rowStyle = __spreadValues(__spreadValues(__spreadValues({}, gutters[0] && gutters[0] > 0 ? {
      marginLeft: gutters[0] / -2,
      marginRight: gutters[0] / -2
    } : {}), gutters[1] && gutter[1] > 0 ? {
      rowGap: gutters[1]
    } : {}), style);
    return /* @__PURE__ */ jsxRuntime.jsx(RowContext.Provider, {
      value: { gutter: gutters, wrap },
      children: /* @__PURE__ */ jsxRuntime.jsx(StyledRow, __spreadProps(__spreadValues({}, others), {
        className: classes,
        style: rowStyle,
        ref,
        children
      }))
    });
  }
);
Row.displayName = "Row";
const StyledRow = styled__default["default"].div`
  &.teko-row {
    display: flex;
    flex-flow: row wrap;
  }
  @media (min-width: ${grid.BREAK_POINTS.lg}) {
    &.teko-row {
      justify-content: center;
    }
  }
  &.teko-row:before,
  &.teko-row:after {
    display: flex;
  }

  // No wrap of flex
  &.teko-row-no-wrap {
    flex-wrap: nowrap;
  }

  &.teko-row-start {
    justify-content: flex-start;
  }

  &.teko-row-center {
    justify-content: center;
  }

  &.teko-row-end {
    justify-content: flex-end;
  }

  &.teko-row-space-between {
    justify-content: space-between;
  }

  &.teko-row-space-around {
    justify-content: space-around;
  }

  &.teko-row-top {
    align-items: flex-start;
  }

  &.teko-row-middle {
    align-items: center;
  }

  &.teko-row-bottom {
    align-items: flex-end;
  }
`;

exports.Row = Row;


/***/ }),

/***/ 90208:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



var React = __webpack_require__(91987);

const RowContext = React.createContext({});
var RowContext$1 = RowContext;

module.exports = RowContext$1;


/***/ }),

/***/ 39534:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const responsiveArray = [
  "xxl",
  "xl",
  "lg",
  "md",
  "sm",
  "xs"
];
const responsiveMap = {
  xs: "(max-width: 575px)",
  sm: "(min-width: 576px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 1024px)",
  xl: "(min-width: 1440px)",
  xxl: "(min-width: 1600px)"
};
const subscribers = /* @__PURE__ */ new Map();
let subUid = -1;
let screens = {};
const responsiveObserve = {
  matchHandlers: {},
  dispatch(pointMap) {
    screens = pointMap;
    subscribers.forEach((func) => func(screens));
    return subscribers.size >= 1;
  },
  subscribe(func) {
    if (!subscribers.size)
      this.register();
    subUid += 1;
    subscribers.set(subUid, func);
    func(screens);
    return subUid;
  },
  unsubscribe(token) {
    subscribers.delete(token);
    if (!subscribers.size)
      this.unregister();
  },
  unregister() {
    Object.keys(responsiveMap).forEach((screen) => {
      const matchMediaQuery = responsiveMap[screen];
      const handler = this.matchHandlers[matchMediaQuery];
      handler == null ? void 0 : handler.mql.removeListener(handler == null ? void 0 : handler.listener);
    });
    subscribers.clear();
  },
  register() {
    Object.keys(responsiveMap).forEach((screen) => {
      const matchMediaQuery = responsiveMap[screen];
      const listener = ({ matches }) => {
        this.dispatch(__spreadProps(__spreadValues({}, screens), {
          [screen]: matches
        }));
      };
      const mql = window.matchMedia(matchMediaQuery);
      mql.addListener(listener);
      this.matchHandlers[matchMediaQuery] = {
        mql,
        listener
      };
      listener(mql);
    });
  }
};
var ResponsiveObserve = responsiveObserve;

exports["default"] = ResponsiveObserve;
exports.responsiveArray = responsiveArray;
exports.responsiveMap = responsiveMap;


/***/ }),

/***/ 30968:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const LazyComponent = ({
  children,
  debounce = 0
}) => {
  const ref = React__default["default"].useRef(null);
  const [hydrated, setHydrated] = React.useState(false);
  React__default["default"].useEffect(() => {
    if (!ref.current)
      return;
    const ob = new IntersectionObserver((entries, observer) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          setHydrated(true);
          observer.disconnect();
          return;
        }
      }
    });
    ob.observe(ref.current);
    function hydrate(deadline) {
      if (deadline.timeRemaining() > debounce) {
        setHydrated(true);
        ob.disconnect();
      } else {
        requestIdleCallback(hydrate);
      }
    }
    if (debounce > 0) {
      requestIdleCallback(hydrate);
    }
    return () => ob.disconnect();
  }, [debounce]);
  return /* @__PURE__ */ jsxRuntime.jsx("div", {
    ref,
    className: "lazy-component",
    children: hydrated ? children : /* @__PURE__ */ jsxRuntime.jsx("div", {
      className: "fake-body",
      style: { width: "100%", height: 200 }
    })
  });
};

exports.LazyComponent = LazyComponent;


/***/ }),

/***/ 69632:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);

const convertHref = (href, type) => {
  if (type === "email")
    return `mailto:${href}`;
  if (type === "phone")
    return `tel:${href}`;
  if (type === "internal")
    return `/${href}`;
  return href;
};
const LinkV1 = ({
  href,
  target,
  linkType,
  children,
  className,
  sectionMarginTop = 0
}) => {
  const ref = React.useRef();
  if (!href)
    return children;
  const scrollToElement = (elementId) => {
    const isInIframe = ref.current.ownerDocument !== document;
    let innerWindow = window;
    if (isInIframe) {
      const iframeElements = window.document.getElementsByTagName("iframe");
      for (const iframe of iframeElements) {
        if (iframe.contentDocument === ref.current.ownerDocument) {
          innerWindow = iframe.contentWindow;
          break;
        }
      }
    }
    const elements = ref.current.ownerDocument.querySelectorAll(
      `[data-id="${elementId}"]`
    );
    for (const element of elements) {
      if (innerWindow.getComputedStyle(element).display !== "none") {
        const top = element.getBoundingClientRect().top + innerWindow.pageYOffset - sectionMarginTop;
        innerWindow.scrollTo({
          top,
          behavior: "smooth"
        });
      }
    }
  };
  const computedTarget = () => {
    if (target === "_blank")
      return "_blank";
    if (target === "_self")
      return "_top";
  };
  if (linkType === "inPage") {
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      ref,
      style: { cursor: "pointer" },
      onClick: () => scrollToElement(href),
      children
    });
  }
  return /* @__PURE__ */ jsxRuntime.jsx("a", {
    style: { textDecoration: "none", color: "unset", cursor: "pointer" },
    href: convertHref(href, linkType),
    target: computedTarget(),
    className,
    rel: "noopener noreferrer",
    children
  });
};

exports.LinkV1 = LinkV1;


/***/ }),

/***/ 14781:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var coreRenderer = __webpack_require__(12060);

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LinkV2 = (_a) => {
  var _b = _a, {
    eventType,
    children,
    className,
    sectionMarginTop = 0,
    trackingEventName,
    conversionGGAdsId,
    conversionGGAdsLabel,
    scriptCustom
  } = _b, rest = __objRest(_b, [
    "eventType",
    "children",
    "className",
    "sectionMarginTop",
    "trackingEventName",
    "conversionGGAdsId",
    "conversionGGAdsLabel",
    "scriptCustom"
  ]);
  var _a2, _b2, _c, _d, _e, _f, _g, _h;
  const ref = React.useRef();
  const openPopup = (popupId) => {
    var _a3;
    (_a3 = ref.current.ownerDocument.querySelector(
      `[data-uniq-id="${popupId}"]`
    )) == null ? void 0 : _a3.click();
  };
  const closePopup = (popupId) => {
    const popup = ref.current.ownerDocument.querySelector(
      `[data-uniq-id="${popupId}"]`
    );
    const maskPopup = popup == null ? void 0 : popup.parentElement;
    maskPopup.classList.remove("show");
    maskPopup.classList.add("hide-from-btn");
    popup == null ? void 0 : popup.click();
  };
  const closePopupList = (popupIds) => {
    const getAllElement = ref.current.ownerDocument.querySelectorAll(
      `[data-uniq-id]`
    );
    const popupList = [];
    getAllElement.forEach((el) => {
      if (popupIds.includes(el.getAttribute("data-uniq-id")))
        popupList.push(el);
    });
    popupList.forEach((popup) => {
      const maskPopup = popup == null ? void 0 : popup.parentElement;
      maskPopup.classList.remove("show");
      maskPopup.classList.add("hide-from-btn");
      popup == null ? void 0 : popup.click();
    });
  };
  const scrollToElement = (elementId) => {
    const isInIframe = ref.current.ownerDocument !== document;
    let innerWindow = window;
    if (isInIframe) {
      const iframeElements = window.document.getElementsByTagName("iframe");
      for (const iframe of iframeElements) {
        if (iframe.contentDocument === ref.current.ownerDocument) {
          innerWindow = iframe.contentWindow;
          break;
        }
      }
    }
    const elements = ref.current.ownerDocument.querySelectorAll(
      `[data-id="${elementId}"]`
    );
    for (const element of elements) {
      if (innerWindow.getComputedStyle(element).display !== "none") {
        const top = element.getBoundingClientRect().top + innerWindow.pageYOffset - sectionMarginTop;
        innerWindow.scrollTo({
          top,
          behavior: "smooth"
        });
      }
    }
  };
  const trackEventClick = () => {
    var _a3, _b3, _c2, _d2;
    if (trackingEventName) {
      (_a3 = window == null ? void 0 : window.gtag) == null ? void 0 : _a3.call(window, "event", trackingEventName);
      (_b3 = window == null ? void 0 : window.fbq) == null ? void 0 : _b3.call(window, "trackCustom", trackingEventName);
      (_c2 = window == null ? void 0 : window.track) == null ? void 0 : _c2.call(window, "customEvent", trackingEventName);
    }
    if (conversionGGAdsId && conversionGGAdsLabel) {
      (_d2 = window == null ? void 0 : window.gtag) == null ? void 0 : _d2.call(window, "event", "conversion", {
        send_to: `AW-${conversionGGAdsId}/${conversionGGAdsLabel}`
      });
    }
    runStringFunc(scriptCustom);
  };
  const runStringFunc = (script) => {
    if (script == null ? void 0 : script.trim()) {
      try {
        const excuteScript = new Function(coreRenderer.unescapeString(script));
        excuteScript();
      } catch (err) {
        console.error(err);
      }
    }
  };
  if (eventType === "openPageOfWebsite" && ((_a2 = rest["openPageOfWebsite"]) == null ? void 0 : _a2.href))
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: rest["openPageOfWebsite"].href,
      onClick: trackEventClick,
      target: ((_b2 = rest[eventType]) == null ? void 0 : _b2.openNewTab) ? "_blank" : "_top",
      className,
      children
    });
  if (eventType === "link" && ((_c = rest["link"]) == null ? void 0 : _c.href))
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: rest["link"].href,
      onClick: trackEventClick,
      target: ((_d = rest[eventType]) == null ? void 0 : _d.openNewTab) ? "_blank" : "_top",
      className,
      rel: ((_e = rest[eventType]) == null ? void 0 : _e.nofollow) ? "nofollow" : "noopener noreferrer",
      children
    });
  if (eventType === "inPage" && rest["inPage"])
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      style: { cursor: "pointer" },
      onClick: () => {
        scrollToElement(rest["inPage"]);
        trackEventClick();
      },
      ref,
      children
    });
  if (eventType === "internal" && ((_f = rest["internal"]) == null ? void 0 : _f.href))
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: `/${rest["internal"].href}`,
      onClick: trackEventClick,
      target: ((_g = rest["internal"]) == null ? void 0 : _g.openNewTab) ? "_blank" : "_top",
      className,
      rel: "noopener noreferrer",
      children
    });
  if (eventType === "email" && rest["email"])
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: `mailto:${rest["email"]}`,
      onClick: trackEventClick,
      className,
      rel: "noopener noreferrer",
      target: "_top",
      children
    });
  if (eventType === "phone" && rest["phone"])
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: `tel:${rest["phone"]}`,
      onClick: trackEventClick,
      className,
      rel: "noopener noreferrer",
      target: "_top",
      children
    });
  if (eventType === "openPopup" && rest["togglePopup"]) {
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      ref,
      onClick: () => {
        openPopup(rest["togglePopup"]);
        trackEventClick();
      },
      children
    });
  }
  if (eventType === "closePopupList" && ((_h = rest["togglePopupList"]) == null ? void 0 : _h.length)) {
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      ref,
      onClick: () => {
        closePopupList(rest["togglePopupList"]);
        trackEventClick();
      },
      children
    });
  }
  if (eventType === "closePopup" && rest["togglePopup"]) {
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      ref,
      onClick: () => {
        closePopup(rest["togglePopup"]);
        trackEventClick();
      },
      children
    });
  }
  return /* @__PURE__ */ jsxRuntime.jsx("div", {
    onClick: trackEventClick,
    children
  });
};

exports.LinkV2 = LinkV2;


/***/ }),

/***/ 43866:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var LinkV1 = __webpack_require__(69632);
var LinkV2 = __webpack_require__(14781);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Link = (props) => {
  if (props.eventType)
    return /* @__PURE__ */ jsxRuntime.jsx(LinkV2.LinkV2, __spreadValues({}, props));
  return /* @__PURE__ */ jsxRuntime.jsx(LinkV1.LinkV1, __spreadValues({}, props));
};

exports.Link = Link;


/***/ }),

/***/ 66507:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var Rate = __webpack_require__(21088);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Rate__default = /*#__PURE__*/_interopDefaultLegacy(Rate);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Rating = (props) => {
  return /* @__PURE__ */ jsxRuntime.jsx(StyledRate, __spreadValues({
    prefixCls: "tempi-rate",
    allowHalf: true
  }, props));
};
const StyledRate = styled__default["default"](Rate__default["default"])`
  &.tempi-rate {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 18px;
    display: inline-block;
    vertical-align: middle;
    font-weight: normal;
    font-style: normal;
    outline: none;
  }

  &.tempi-rate-rtl {
    direction: rtl;
    .tempi-rate-star {
      margin-right: 0;
      margin-left: 2px;
      float: right;
    }
    .tempi-rate-star-first {
      right: 0;
      left: auto;
    }
  }

  &.tempi-rate-disabled {
    .tempi-rate-star {
      cursor: default;
    }
    .tempi-rate-star:before,
    .tempi-rate-star-content:before {
      cursor: default;
    }
    .tempi-rate-star:hover {
      transform: scale(1);
    }
  }

  .tempi-rate-star {
    margin: 0;
    padding: 0;
    display: inline-block;
    margin-right: 2px;
    position: relative;
    transition: all 0.3s;
    color: #e9e9e9;
    cursor: pointer;
    line-height: 1.5;
    &:last-child {
      margin-right: 0;
    }
  }

  .tempi-rate-star-first,
  .tempi-rate-star-second {
    transition: all 0.3s;
  }
  .tempi-rate-star-focused,
  .tempi-rate-star:hover {
    transform: scale(1.1);
  }
  .tempi-rate-star-first {
    position: absolute;
    left: 0;
    top: 0;
    width: 50%;
    height: 100%;
    overflow: hidden;
    opacity: 0;
  }

  .tempi-rate-star-half .tempi-rate-star-first,
  .tempi-rate-star-half .tempi-rate-star-second {
    opacity: 1;
  }
  .tempi-rate-star-half .tempi-rate-star-first,
  .tempi-rate-star-full .tempi-rate-star-second {
    color: #fadb14;
  }
`;

exports.Rating = Rating;


/***/ }),

/***/ 2078:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var React = __webpack_require__(91987);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Wrapper = styled__default["default"].div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: 0;
  border-radius: inherit;
  span {
    transform: scale(0);
    border-radius: 100%;
    position: absolute;
    opacity: 0.75;
    background-color: rgba(255, 255, 255, 0.6);
    animation: ripple;
    animation-duration: 696ms;
  }
  @keyframes ripple {
    to {
      opacity: 0;
      transform: scale(2);
    }
  }
`;
const useDebouncedRippleCleanUp = (rippleCount, duration, cleanUpFunction) => {
  const useIsomorphicLayoutEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
  useIsomorphicLayoutEffect(() => {
    let bounce = null;
    if (rippleCount > 0) {
      clearTimeout(bounce);
      bounce = setTimeout(() => {
        cleanUpFunction();
        clearTimeout(bounce);
      }, duration * 4);
    }
    return () => clearTimeout(bounce);
  }, [rippleCount, duration, cleanUpFunction]);
};
const Ripple = ({
  duration = 600,
  color = "rgba(255,255,255,0.6)"
}) => {
  const [rippleArray, setRippleArray] = React.useState([]);
  useDebouncedRippleCleanUp(rippleArray.length, duration, () => {
    setRippleArray([]);
  });
  const addRipple = (event) => {
    const rippleContainer = event.currentTarget.getBoundingClientRect();
    const size = rippleContainer.width > rippleContainer.height ? rippleContainer.width : rippleContainer.height;
    const x = event.clientX - rippleContainer.x - size / 2;
    const y = event.clientY - rippleContainer.y - size / 2;
    const newRipple = {
      x,
      y,
      size
    };
    setRippleArray([...rippleArray, newRipple]);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    onMouseDown: addRipple,
    children: rippleArray.map((ripple, index) => {
      return /* @__PURE__ */ jsxRuntime.jsx("span", {
        style: {
          top: ripple.y,
          left: ripple.x,
          width: ripple.size,
          height: ripple.size,
          backgroundColor: color,
          animationDuration: `${duration}ms`
        }
      }, "span" + index);
    })
  });
};

exports.Ripple = Ripple;


/***/ }),

/***/ 48183:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var SpinningInner = __webpack_require__(70411);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Spin = ({
  spinning = true,
  children,
  style
}) => {
  if (!spinning)
    return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children
    });
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(NestedSpinning, {
        children: /* @__PURE__ */ jsxRuntime.jsx(StyledSpinning, {
          children: /* @__PURE__ */ jsxRuntime.jsx(SpinningInner.StyledSpinningInner, {})
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsx(StyledContainer, {
        style,
        children
      })
    ]
  });
};
const NestedSpinning = styled__default["default"].div`
  position: relative;
`;
const StyledSpinning = styled__default["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  display: block;
  width: 100%;
  height: 100%;
  max-height: 400px;
  top: 40px;
  left: calc(50% - 40px);
`;
const StyledContainer = styled__default["default"].div`
  clear: both;
  opacity: 0.5;
  user-select: none;
  pointer-events: none;
`;

exports.Spin = Spin;


/***/ }),

/***/ 70411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const StyledSpinningInner = styled__default["default"].div(
  ({
    size,
    transform,
    time,
    color = "#3f747e"
  }) => `
  @keyframes ldio-1ga5p6b2g17 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  width: ${size || 80}px;
  height: ${size || 80}px;
  box-shadow: 0 1.9px 0 0 ${color};
  transform-origin: ${transform || 40}px ${transform || 40}px;
  animation: ldio-1ga5p6b2g17 ${time || 1.27}s linear infinite;
  border-radius: 50%;
`
);

exports.StyledSpinningInner = StyledSpinningInner;


/***/ }),

/***/ 28887:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var jsxRuntime = __webpack_require__(61261);
var ui = __webpack_require__(96453);
var ui$9 = __webpack_require__(49730);
var ui$a = __webpack_require__(51986);
var ui$b = __webpack_require__(1326);
var ui$c = __webpack_require__(95648);
var ui$d = __webpack_require__(72457);
var ui$f = __webpack_require__(20024);
var ui$g = __webpack_require__(53590);
var ui$h = __webpack_require__(49322);
var ui$i = __webpack_require__(81812);
var ui$j = __webpack_require__(21424);
var ui$k = __webpack_require__(58783);
var ui$l = __webpack_require__(88494);
var ui$m = __webpack_require__(92163);
var ui$p = __webpack_require__(65188);
var ui$q = __webpack_require__(92022);
var ui$r = __webpack_require__(82404);
var ui$s = __webpack_require__(96985);
var ui$t = __webpack_require__(82026);
var ui$u = __webpack_require__(42263);
var ui$v = __webpack_require__(24190);
var ui$w = __webpack_require__(5553);
var ui$x = __webpack_require__(68944);
var ui$y = __webpack_require__(57901);
var ui$z = __webpack_require__(71209);
var ui$A = __webpack_require__(43874);
var ui$B = __webpack_require__(48081);
var ui$C = __webpack_require__(42413);
var ui$1 = __webpack_require__(80768);
var ui$2 = __webpack_require__(69447);
var ui$3 = __webpack_require__(68882);
var ui$4 = __webpack_require__(82398);
var ui$5 = __webpack_require__(67610);
var ui$6 = __webpack_require__(61349);
var ui$7 = __webpack_require__(89223);
var ui$8 = __webpack_require__(81171);
var ui$e = __webpack_require__(49864);
var Accordion = __webpack_require__(62160);
var AccordionContent = __webpack_require__(22735);
var AccordionItem = __webpack_require__(62906);
var ListItemV2 = __webpack_require__(46530);
var ListItemContentV2 = __webpack_require__(97863);
var ListItemIconV2 = __webpack_require__(68248);
var ui$n = __webpack_require__(62575);
var ui$o = __webpack_require__(89666);
var Header = __webpack_require__(54501);
var Menu = __webpack_require__(30655);
var MenuItem = __webpack_require__(7286);
var Logo = __webpack_require__(51195);
var MenuCol = __webpack_require__(22945);
var Tab = __webpack_require__(12770);
var TabItem = __webpack_require__(10348);
var TestimonialV2 = __webpack_require__(32588);
var TestimonialItemV2 = __webpack_require__(36852);
var ContentSlider = __webpack_require__(11970);
var ContentSliderItem = __webpack_require__(49051);
var ProductList = __webpack_require__(83217);
var ProductListContent = __webpack_require__(18620);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SubscriptionFormV2 = (props) => {
  return /* @__PURE__ */ jsxRuntime.jsx(ui$n.FormV4, __spreadValues({}, props));
};
SubscriptionFormV2.displayName = "SubscriptionFormV2";
const components = {
  Root: ui.Root,
  PbIcon: ui$1.PbIcon,
  Section: ui$2.PbSection,
  Container: ui$3.PbContainer,
  Row: ui$4.PbRow,
  Col: ui$5.PbCol,
  ButtonV2: ui$6.ButtonV2,
  Paragraph: ui$7.Paragraph,
  Heading: ui$8.Heading,
  Divider: ui$9.PbDivider,
  Spacer: ui$a.Spacer,
  Youtube: ui$b.Youtube,
  Countdown: ui$c.Countdown,
  Map: ui$d.Map,
  Image: ui$e.Image,
  Gallery: ui$f.Gallery,
  HtmlCode: ui$g.HtmlCode,
  PageFlip: ui$h.PageFlip,
  NumberCounter: ui$i.NumberCounter,
  SocialIcon: ui$j.SocialIcon,
  StoreList: ui$k.StoreList,
  Slider: ui$l.Slider,
  Table: ui$m.Table,
  Accordion: Accordion.Accordion,
  AccordionContent: AccordionContent.AccordionContent,
  AccordionItem: AccordionItem.AccordionItem,
  ListItemV2: ListItemV2.ListItemV2,
  ListItemContentV2: ListItemContentV2.ListItemContentV2,
  ListItemIconV2: ListItemIconV2.ListItemIconV2,
  FormV4: ui$n.FormV4,
  SubscriptionFormV2,
  PopupV1: ui$o.PopupV1,
  Header: Header.Header,
  Menu: Menu.Menu,
  MenuItem: MenuItem.MenuItem,
  Logo: Logo.Logo,
  MenuCol: MenuCol.MenuCol,
  LuckyDrawV2: ui$p.LuckyDrawV2,
  Tab: Tab.Tab,
  TabItem: TabItem.TabItem,
  TestimonialCarousel: ui$q.TestimonialCarousel,
  TestimonialV2: TestimonialV2.TestimonialV2,
  TestimonialV2Item: TestimonialItemV2.TestimonialV2Item,
  ContentSlider: ContentSlider.ContentSlider,
  ContentSliderItem: ContentSliderItem.ContentSliderItem,
  ProductList: ProductList.ProductList,
  ProductListContent: ProductListContent.ProductListContent,
  WebsiteFooter: ui$r.WebsiteFooter,
  GlobalBlock: ui$s.GlobalBlock,
  WebsiteHeader: ui$t.WebsiteHeader,
  PopupRoot: ui$u.PopupRoot,
  ContactBubble: ui$v.ContactBubble,
  Page404: ui$w.Page404,
  TempiProductList: ui$x.TempiProductList,
  QRCode: ui$y.QRCode,
  ExamScore: ui$z.ExamScore,
  Video: ui$A.Video,
  ArticleList: ui$B.ArticleList,
  ArticleHeader: ui$C.ArticleHeader
};

exports.w = components;


/***/ }),

/***/ 5502:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var WidthTypeEnum = /* @__PURE__ */ ((WidthTypeEnum2) => {
  WidthTypeEnum2["auto"] = "auto";
  WidthTypeEnum2["full"] = "full";
  WidthTypeEnum2["fixed"] = "fixed";
  return WidthTypeEnum2;
})(WidthTypeEnum || {});
var HeightTypeEnum = /* @__PURE__ */ ((HeightTypeEnum2) => {
  HeightTypeEnum2["default"] = "default";
  HeightTypeEnum2["fixed"] = "fixed";
  HeightTypeEnum2["fullHeight"] = "fullHeight";
  return HeightTypeEnum2;
})(HeightTypeEnum || {});
var Position = /* @__PURE__ */ ((Position2) => {
  Position2["front"] = "front";
  Position2["behind"] = "behind";
  return Position2;
})(Position || {});

exports.HeightTypeEnum = HeightTypeEnum;
exports.Position = Position;
exports.WidthTypeEnum = WidthTypeEnum;


/***/ }),

/***/ 14437:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const addPaddingNumber = (number) => isNaN(number) ? "" : number == null ? void 0 : number.toString().padStart(2, "0");

exports.addPaddingNumber = addPaddingNumber;


/***/ }),

/***/ 20951:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const capitalize = (text) => text[0].toUpperCase() + text.substr(1, text.length);

exports.capitalize = capitalize;


/***/ }),

/***/ 11340:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);

class FormUtil {
  constructor() {
    this.insertDataToGoogleSheetV2 = async (config, formData, url) => {
      try {
        const res = this.api.post(url, {
          merchantId: config == null ? void 0 : config.merchantId,
          formAccountId: config == null ? void 0 : config.formAccountId,
          spreadSheetId: config == null ? void 0 : config.spreadSheetId,
          sheetId: config == null ? void 0 : config.sheetId,
          formData
        });
        return res;
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    };
    this.submitFormData = async (formId, formData, url) => {
      try {
        const res = this.api.post(url, {
          formId,
          formData
        });
        return res;
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    };
    this.api = new coreRenderer.Api("");
  }
}
const formUtils = new FormUtil();

exports.FormUtil = FormUtil;
exports.formUtils = formUtils;


/***/ }),

/***/ 35010:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var icons = __webpack_require__(94556);
var getPropsIcon = __webpack_require__(26321);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const getIconCompoment = (icon) => {
  return /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, __spreadValues({}, __spreadValues({
    name: icon == null ? void 0 : icon.name
  }, getPropsIcon.getPropsIcon({
    color: icon == null ? void 0 : icon.color,
    size: icon == null ? void 0 : icon.size
  }))));
};

exports.getIconCompoment = getIconCompoment;


/***/ }),

/***/ 81700:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const getPartialDateTimeTimeZone7 = (date) => {
  const year = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    year: "numeric"
  }).format(date);
  const month = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    month: "2-digit"
  }).format(date);
  const day = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    day: "2-digit"
  }).format(date);
  const hour = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    hour: "2-digit",
    hour12: false
  }).format(date);
  const minute = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    minute: "2-digit"
  }).format(date);
  const second = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    second: "2-digit"
  }).format(date);
  return {
    year,
    month,
    day,
    hour,
    minute,
    second
  };
};

exports.getPartialDateTimeTimeZone7 = getPartialDateTimeTimeZone7;


/***/ }),

/***/ 26321:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const getPropsIcon = (icon) => {
  const style = {};
  if (icon == null ? void 0 : icon.color) {
    style.color = icon.color;
  }
  if (icon == null ? void 0 : icon.size) {
    style.fontSize = icon.size;
  }
  return { style };
};

exports.getPropsIcon = getPropsIcon;


/***/ }),

/***/ 97612:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const getResponsiveAttrKey = (key, device) => {
  return key + device.charAt(0).toUpperCase() + device.slice(1);
};

exports.getResponsiveAttrKey = getResponsiveAttrKey;


/***/ }),

/***/ 80808:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);

const getSizeWithUnit = (value) => {
  if (typeof (value == null ? void 0 : value.size) === "number") {
    return `${value == null ? void 0 : value.size}${(value == null ? void 0 : value.unit) || coreRenderer.UnitEnum.pixel}`;
  }
};

exports.getSizeWithUnit = getSizeWithUnit;


/***/ }),

/***/ 58983:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const isUrlValid = (userInput) => {
  const res = userInput.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );
  if (!res)
    return false;
  else
    return true;
};

exports.isUrlValid = isUrlValid;


/***/ }),

/***/ 51004:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const flattenToTree = (originMenu) => {
  const getChildren = (menu, parentId) => {
    const result = menu.filter((item) => item.parentId === parentId).map((item) => {
      const children = getChildren(menu, item.id);
      return __spreadProps(__spreadValues({}, item), {
        children
      });
    });
    return result;
  };
  const tree = originMenu.filter((item) => !item.parentId).map((item) => __spreadProps(__spreadValues({}, item), { children: getChildren(originMenu, item.id) }));
  return tree;
};
const getUrlOfMenuItem = (item, isEditingMode = false) => {
  var _a, _b;
  if (isEditingMode)
    return null;
  if ((item == null ? void 0 : item.linkType) === "LINK")
    return item.href;
  if ((_a = item == null ? void 0 : item.page) == null ? void 0 : _a.isHomepage)
    return "/";
  return "/" + ((_b = item == null ? void 0 : item.page) == null ? void 0 : _b.slug);
};
const getTargetUrl = (target) => {
  if (target === "BLANK")
    return "_blank";
  return "_self";
};

exports.flattenToTree = flattenToTree;
exports.getTargetUrl = getTargetUrl;
exports.getUrlOfMenuItem = getUrlOfMenuItem;


/***/ }),

/***/ 39217:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const queryStringToObject = (search, arrayKey = []) => {
  const urlParams = new URLSearchParams(search);
  const result = {};
  for (const [key, value] of urlParams) {
    if (typeof value === "string") {
      if (arrayKey.includes(key)) {
        result[key] = value.split(",");
      } else {
        result[key] = value.trim();
      }
    } else
      result[key] = value;
  }
  return result;
};

exports.queryStringToObject = queryStringToObject;


/***/ }),

/***/ 73416:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var getPartialDateTimeTimeZone7 = __webpack_require__(81700);

const transformValuesGGSheet = (values, inputs) => {
  const formData = [];
  inputs.forEach((item) => {
    let value = values[item.name];
    if (item.type === "date" && !!values[item.name]) {
      const { year, month, day } = getPartialDateTimeTimeZone7.getPartialDateTimeTimeZone7(
        new Date(values[item.name])
      );
      value = `${day}-${month}-${year}`;
    }
    if (item.type === "datetime-local" && !!values[item.name]) {
      const { year, month, day, hour, minute, second } = getPartialDateTimeTimeZone7.getPartialDateTimeTimeZone7(new Date(values[item.name]));
      value = `${day}-${month}-${year} ${parseInt(hour) > 23 ? `00` : hour}:${minute}:${second}`;
    }
    if (item.type === "checkbox-group" && value === false || item.type === "radio-group" && value === null) {
      value = "";
    }
    formData.push({
      name: item.name,
      value: typeof value === "object" ? JSON.stringify(value) : value,
      type: item.type === "number" ? "number" : "string"
    });
    delete values[item.name];
  });
  Object.keys(values).forEach((el) => {
    if (values[el] != null && values[el] != void 0) {
      formData.push({
        name: el,
        value: values[el],
        type: "string"
      });
    }
  });
  return formData;
};

exports.transformValuesGGSheet = transformValuesGGSheet;


/***/ }),

/***/ 94345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ animationCss; }
/* harmony export */ });
const animationCss = `
    .animation-hidden {
        visibility: hidden!important;
        opacity: 0!important;
    }
`;




/***/ }),

/***/ 70516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a$": function() { return /* binding */ pbFontWeight; },
/* harmony export */   "tC": function() { return /* binding */ pbFontFamily; },
/* harmony export */   "wc": function() { return /* binding */ fontQueryParams; }
/* harmony export */ });
const pbFontFamily = [
  "Alfa Slab One",
  "Anton",
  "Arima Madurai",
  "Arimo",
  "Athiti",
  "Bahianita",
  "Baloo Bhaina",
  "Barlow",
  "Barlow Condensed",
  "Bungee",
  "Bungee Inline",
  "Bungee Outline",
  "Bungee Shade",
  "Cabin",
  "Chonburi",
  "Cormorant Upright",
  "Crimson Pro",
  "Dancing Script",
  "Dosis",
  "EB Garamond",
  "Exo",
  "Fira Sans",
  "Hepta Slab",
  "Inconsolata",
  "Inter",
  "Itim",
  "Josefin Sans",
  "Judson",
  "Jura",
  "K2D",
  "Literata",
  "Lobster",
  "Lora",
  "Maven Pro",
  "Merriweather",
  "Montserrat",
  "Mulish",
  "Niramit",
  "Noto Serif",
  "Open Sans",
  "Oswald",
  "Pattaya",
  "Paytone One",
  "Philosopher",
  "Play",
  "Playfair Display",
  "Prata",
  "Quicksand",
  "Raleway",
  "Roboto",
  "Roboto Slab",
  "Rokkit",
  "Source Sans Pro",
  "Sriracha",
  "Taviraj",
  "Thasadith",
  "Tinos",
  "Trirong",
  "VT323",
  "Work Sans",
  "Yeseva One"
];
const pbFontWeight = {
  regular: 400,
  medium: 500,
  bold: 700
};
const fontWeightQueryParams = Object.values(pbFontWeight).join(";");
const fontQueryParams = pbFontFamily.map((font) => {
  return `family=${encodeURIComponent(font)}:wght@${fontWeightQueryParams}`;
}).join("&");




/***/ }),

/***/ 70403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fd": function() { return /* binding */ publicBffUrl; },
/* harmony export */   "Zq": function() { return /* binding */ landingLinks; },
/* harmony export */   "d1": function() { return /* binding */ LandingLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _fonts_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70516);
/* harmony import */ var react_helmet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71188);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const landingLinks = [
  {
    rel: "preconnect",
    href: "https://fonts.googleapis.com"
  },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous"
  },
  {
    rel: "stylesheet",
    href: `https://fonts.googleapis.com/css2?${_fonts_es_js__WEBPACK_IMPORTED_MODULE_3__/* .fontQueryParams */ .wc}&display=swap`
  },
  {
    rel: "stylesheet",
    href: "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
  }
];
const LandingLinks = () => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_helmet__WEBPACK_IMPORTED_MODULE_2__/* .Helmet */ .q, {
  children: landingLinks.map((link, index) => /* @__PURE__ */ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)("link", __spreadProps(__spreadValues({}, link), {
    key: index
  })))
});
const publicBffUrl = {
  local: "http://localhost:8081",
  dev: "https://public-builder-bff.dev.tekoapis.net",
  stag: "https://public-builder-bff.stag.tekoapis.net",
  production: "https://public-bff.tempi.vn",
  "test-1": "https://public-builder-bff.test-1.tekoapis.net",
  internal: "http://public-bff-api.page-management"
};




/***/ }),

/***/ 67084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ rcCascaderCss; }
/* harmony export */ });
const rcCascaderCss = `
.rc-cascader {
  font-size: 12px;
}
.rc-cascader-menus {
  font-size: 12px;
  overflow: hidden;
  background: #fff;
  position: absolute;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  box-shadow: 0 0 4px rgba(0,0,0,0.17);
  white-space: nowrap;
}
.rc-cascader-menus-hidden {
  display: none;
}
.rc-cascader-menus.slide-up-enter, .rc-cascader-menus.slide-up-appear {
  animation-duration: .3s;
  animation-fill-mode: both;
  transform-origin: 0 0;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08,0.82,0.17,1);
  animation-play-state: paused;
}
.rc-cascader-menus.slide-up-leave {
  animation-duration: .3s;
  animation-fill-mode: both;
  transform-origin: 0 0;
  opacity: 1;
  animation-timing-function: cubic-bezier(0.6,0.04,0.98,0.34);
  animation-play-state: paused;
}
.rc-cascader-menus.slide-up-enter.slide-up-enter-active.rc-cascader-menus-placement-bottomLeft, .rc-cascader-menus.slide-up-appear.slide-up-appear-active.rc-cascader-menus-placement-bottomLeft {
  animation-name: SlideUpIn;
  animation-play-state: running;
}
.rc-cascader-menus.slide-up-enter.slide-up-enter-active.rc-cascader-menus-placement-topLeft, .rc-cascader-menus.slide-up-appear.slide-up-appear-active.rc-cascader-menus-placement-topLeft {
  animation-name: SlideDownIn;
  animation-play-state: running;
}
.rc-cascader-menus.slide-up-leave.slide-up-leave-active.rc-cascader-menus-placement-bottomLeft {
  animation-name: SlideUpOut;
  animation-play-state: running;
}
.rc-cascader-menus.slide-up-leave.slide-up-leave-active.rc-cascader-menus-placement-topLeft {
  animation-name: SlideDownOut;
  animation-play-state: running;
}
.rc-cascader-menu {
  display: inline-block;
  height: 192px;
  list-style: none;
  margin: 0;
  padding: 0;
  padding-right:1em
  border-right: 1px solid #e9e9e9;
  overflow: auto;
}
.rc-cascader-menu:last-child {
  border-right: 0;
}
.rc-cascader-menu-item {
  height: 32px;
  line-height: 32px;
  padding: 0 16px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.3s ease;
  position: relative;
}
.rc-cascader-menu-item:hover {
  background: #2db6f5e7;
}
.rc-cascader-menu-item-disabled {
  cursor: not-allowed;
  color: #ccc;
}
.rc-cascader-menu-item-disabled:hover {
  background: transparent;
}
.rc-cascader-menu-item-loading:after {
  position: absolute;
  right: 12px;
  content: 'loading';
  color: #aaa;
  font-style: italic;
}
.rc-cascader-menu-item-active {
  background:  #2db6f5dd;
}
.rc-cascader-menu-item-active:hover {
  background:  #2db6f5e7;
}
.rc-cascader-menu-item-expand {
  position: relative;
}
.rc-cascader-menu-item-expand-icon {
  font-size: 12px;
  color: #999;
  position: absolute;
  right: 16px;
  line-height: 32px;
}
@keyframes SlideUpIn {
  0% {
    opacity: 0;
    transform-origin: 0% 0%;
    transform: scaleY(.8);
 }
  100% {
    opacity: 1;
    transform-origin: 0% 0%;
    transform: scaleY(1);
 }
}
@keyframes SlideUpOut {
  0% {
    opacity: 1;
    transform-origin: 0% 0%;
    transform: scaleY(1);
 }
  100% {
    opacity: 0;
    transform-origin: 0% 0%;
    transform: scaleY(0.8);
 }
}
@keyframes SlideDownIn {
  0% {
    opacity: 0;
    transform-origin: 0% 100%;
    transform: scaleY(0.8);
 }
  100% {
    opacity: 1;
    transform-origin: 0% 100%;
    transform: scaleY(1);
 }
}
@keyframes SlideDownOut {
  0% {
    opacity: 1;
    transform-origin: 0% 100%;
    transform: scaleY(1);
 }
  100% {
    opacity: 0;
    transform-origin: 0% 100%;
    transform: scaleY(0.8);
 }
}

`;




/***/ }),

/***/ 69614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ reset; }
/* harmony export */ });
const reset = `
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }
  
  [tabindex='-1']:focus:not(:focus-visible) {
    outline: 0 !important;
  }

  hr {
    margin: 1rem 0;
    color: inherit;
    background-color: currentColor;
    border: 0;
    opacity: 0.25;
  }

  hr:not([size]) {
    height: 1px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.3;
    color: unset;
  }

  h1 {
    font-size: calc(1.375rem + 1.5vw);
  }

  @media (min-width: 1200px) {
    h1 {
      font-size: 2.5rem;
    }
  }

  h2 {
    font-size: calc(1.325rem + 0.9vw);
  }

  @media (min-width: 1200px) {
    h2 {
      font-size: 2rem;
    }
  }

  h3 {
    font-size: calc(1.3rem + 0.6vw);
  }

  @media (min-width: 1200px) {
    h3 {
      font-size: 1.75rem;
    }
  }

  h4 {
    font-size: calc(1.275rem + 0.3vw);
  }

  @media (min-width: 1200px) {
    h4 {
      font-size: 1.5rem;
    }
  }

  h5 {
    font-size: 1.25rem;
  }

  h6 {
    font-size: 1rem;
  }

  p {
    margin-top: 0;
    margin-bottom: 0;
  }

  abbr[title],
  abbr[data-original-title] {
    text-decoration: underline;
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
    cursor: help;
    -webkit-text-decoration-skip-ink: none;
    text-decoration-skip-ink: none;
  }

  address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit;
  }

  ol,
  ul {
    padding-left: 2rem;
  }

  ol,
  ul,
  dl {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  ol ol,
  ul ul,
  ol ul,
  ul ol {
    margin-bottom: 0;
  }

  dt {
    font-weight: 700;
  }

  dd {
    margin-bottom: 0.5rem;
    margin-left: 0;
  }

  blockquote {
    margin: 0 0 1rem;
  }

  b,
  strong {
    font-weight: bolder;
  }

  small {
    font-size: 0.875em;
  }

  mark {
    padding: 0.2em;
    background-color: #fcf8e3;
  }

  sub,
  sup {
    position: relative;
    font-size: 0.75em;
    line-height: 0;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  a {
    color: #0d6efd;
    text-decoration: none;
  }

  a:hover {
    color: #024dbc;
  }

  a:not([href]),
  a:not([href]):hover {
    text-decoration: none;
  }

  pre,
  code,
  kbd,
  samp {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
      'Courier New', monospace;
    font-size: 1em;
  }

  pre {
    display: block;
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    font-size: 0.875em;
  }

  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal;
  }

  code {
    font-size: 0.875em;
    color: #d63384;
    word-wrap: break-word;
  }

  a > code {
    color: inherit;
  }

  kbd {
    padding: 0.2rem 0.4rem;
    font-size: 0.875em;
    color: #fff;
    background-color: #212529;
    border-radius: 0.2rem;
  }

  kbd kbd {
    padding: 0;
    font-size: 1em;
    font-weight: 700;
  }

  figure {
    margin: 0 0 1rem;
  }

  img,
  svg {
    vertical-align: middle;
  }

  table {
    caption-side: bottom;
    border-collapse: collapse;
  }

  caption {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    color: #6c757d;
    text-align: left;
  }

  th {
    text-align: inherit;
    text-align: -webkit-match-parent;
  }

  label {
    display: inline-block;
    margin-bottom: 0.5rem;
  }

  button {
    border-radius: 0;
  }

  button:focus {
    outline: none;
  }

  input,
  button,
  select,
  optgroup,
  textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  button,
  input {
    overflow: visible;
  }

  button,
  select {
    text-transform: none;
  }

  select {
    word-wrap: normal;
  }

  [list]::-webkit-calendar-picker-indicator {
    display: none;
  }

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }

  button:not(:disabled),
  [type='button']:not(:disabled),
  [type='reset']:not(:disabled),
  [type='submit']:not(:disabled) {
    cursor: pointer;
  }

  ::-moz-focus-inner {
    padding: 0;
    border-style: none;
  }

  input[type='date'],
  input[type='time'],
  input[type='datetime-local'],
  input[type='month'] {
    -webkit-appearance: textfield;
  }

  textarea {
    resize: vertical;
  }

  fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
  }

  legend {
    float: left;
    width: 100%;
    padding: 0;
    margin-bottom: 0.5rem;
    font-size: calc(1.275rem + 0.3vw);
    line-height: inherit;
    white-space: normal;
  }

  @media (min-width: 1200px) {
    legend {
      font-size: 1.5rem;
    }
  }

  legend + * {
    clear: left;
  }

  ::-webkit-datetime-edit-fields-wrapper,
  ::-webkit-datetime-edit-text,
  ::-webkit-datetime-edit-minute,
  ::-webkit-datetime-edit-hour-field,
  ::-webkit-datetime-edit-day-field,
  ::-webkit-datetime-edit-month-field,
  ::-webkit-datetime-edit-year-field {
    padding: 0;
  }

  ::-webkit-inner-spin-button {
    height: auto;
  }

  [type='search'] {
    outline-offset: -2px;
    -webkit-appearance: textfield;
  }

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  ::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button;
  }

  output {
    display: inline-block;
  }

  summary {
    display: list-item;
    cursor: pointer;
  }

  progress {
    vertical-align: baseline;
  }

  [hidden] {
    display: none !important;
  }

  html,
  body,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  a,
  p,
  span,
  em,
  small,
  strong,
  sub,
  sup,
  mark,
  del,
  ins,
  strike,
  abbr,
  dfn,
  blockquote,
  q,
  cite,
  code,
  pre,
  ol,
  ul,
  li,
  dl,
  dt,
  dd,
  div,
  section,
  article,
  main,
  aside,
  nav,
  header,
  hgroup,
  footer,
  img,
  figure,
  figcaption,
  address,
  time,
  audio,
  video,
  canvas,
  iframe,
  details,
  summary,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td {
    margin: 0;
    padding: 0;
    border: 0;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0px;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }

  @media (max-width: 767px) {
    .hidden-xs {
      display: none !important;
    }
  }

  @media (min-width: 768px) {
    .hidden-md {
      display: none !important;
    }
  }
`;




/***/ }),

/***/ 67141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ StoreProvider; },
/* harmony export */   "o": function() { return /* binding */ useStore; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StoreStateContext = react__WEBPACK_IMPORTED_MODULE_1__.createContext(
  {}
);
const StoreProvider = (_a) => {
  var _b = _a, {
    children,
    device = "desktop"
  } = _b, rest = __objRest(_b, [
    "children",
    "device"
  ]);
  var _a2;
  const menu = (_a2 = rest.globalData) == null ? void 0 : _a2.menu;
  const mappingWebsiteMenuHref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    const getHref = (item) => {
      if (!item)
        return;
      if (item.linkType === "LINK")
        return item.href;
      const { slug, isHomepage } = item.page || {};
      if (!slug && !isHomepage)
        return;
      return "/" + (slug || "");
    };
    return menu == null ? void 0 : menu.reduce(
      (acc, curr) => __spreadProps(__spreadValues({}, acc), {
        [curr == null ? void 0 : curr.id]: getHref(curr)
      }),
      {}
    );
  }, [JSON.stringify(menu)]);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StoreStateContext.Provider, {
    value: __spreadValues({ device, mappingWebsiteMenuHref }, rest),
    children
  });
};
function useStore() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(
    StoreStateContext
  );
  if (!context) {
    throw new Error(
      "useStore must be inside a StoreStateContext with a state value"
    );
  }
  return context;
}




/***/ }),

/***/ 12060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ARTICLE_HEADER": function() { return /* reexport */ ARTICLE_HEADER; },
  "Alignment": function() { return /* reexport */ Alignment; },
  "Api": function() { return /* reexport */ Api; },
  "ApiError": function() { return /* reexport */ ApiError; },
  "BG_LAZY_CLASS_NAME": function() { return /* reexport */ BG_LAZY_CLASS_NAME; },
  "BG_VISIBLE_LAZY_CLASS_NAME": function() { return /* reexport */ BG_VISIBLE_LAZY_CLASS_NAME; },
  "BUBBLE": function() { return /* reexport */ BUBBLE; },
  "BackgroundVideo": function() { return /* reexport */ BackgroundVideo; },
  "BreakpointWidthProvider": function() { return /* reexport */ BreakpointWidthProvider; },
  "BuilderComponent": function() { return /* reexport */ render_es/* BuilderComponent */.V; },
  "COMPONENT_TAG": function() { return /* reexport */ COMPONENT_TAG; },
  "ColorType": function() { return /* reexport */ ColorType; },
  "FOOTER": function() { return /* reexport */ FOOTER; },
  "GradientType": function() { return /* reexport */ GradientType; },
  "HEADER": function() { return /* reexport */ HEADER; },
  "ImageBase": function() { return /* reexport */ ImageBase; },
  "ImageOptimize": function() { return /* reexport */ ImageOptimize; },
  "LandingLinks": function() { return /* reexport */ index_es/* LandingLinks */.d1; },
  "Link": function() { return /* reexport */ Link; },
  "MAX_DPR": function() { return /* reexport */ MAX_DPR; },
  "MINESTONE_M_WIDTH": function() { return /* reexport */ MINESTONE_M_WIDTH; },
  "OverlayType": function() { return /* reexport */ OverlayType; },
  "PATTERN_VALIDATION": function() { return /* reexport */ PATTERN_VALIDATION; },
  "ROOT": function() { return /* reexport */ ROOT; },
  "ROOT_SELECTOR_NAME": function() { return /* reexport */ ROOT_SELECTOR_NAME; },
  "RepeatTypeEnum": function() { return /* reexport */ common_es/* RepeatTypeEnum */.gj; },
  "RuleRepeatEnum": function() { return /* reexport */ common_es/* RuleRepeatEnum */.Ew; },
  "StoreProvider": function() { return /* reexport */ StoreContext_es/* StoreProvider */.g; },
  "UnitEnum": function() { return /* reexport */ UnitEnum; },
  "UnitRepeatEnum": function() { return /* reexport */ common_es/* UnitRepeatEnum */.Ql; },
  "VerticalAlignment": function() { return /* reexport */ VerticalAlignment; },
  "animationCss": function() { return /* reexport */ animation_es/* animationCss */.W; },
  "buildComponentDict": function() { return /* reexport */ utils_render_es/* buildComponentDict */.Oq; },
  "buildSizes": function() { return /* reexport */ buildSizes; },
  "buildSrcset": function() { return /* reexport */ buildSrcset; },
  "buildSrcsetDPR": function() { return /* reexport */ buildSrcsetDPR; },
  "builder": function() { return /* reexport */ builder; },
  "calculateTimeDelta": function() { return /* reexport */ date_time_es/* calculateTimeDelta */.mE; },
  "computeStringHandleBarsExpression": function() { return /* reexport */ computeStringHandleBarsExpression; },
  "constructGoogleImageParams": function() { return /* reexport */ constructGoogleImageParams; },
  "debounce": function() { return /* reexport */ debounce; },
  "escapeString": function() { return /* reexport */ escapeString; },
  "fontQueryParams": function() { return /* reexport */ fonts_es/* fontQueryParams */.wc; },
  "formatCurrencyVND": function() { return /* reexport */ formatCurrencyVND; },
  "formatImageUrlQuality": function() { return /* reexport */ formatImageUrlQuality; },
  "generate": function() { return /* reexport */ generate; },
  "generateRandomId": function() { return /* reexport */ generateRandomId; },
  "getAllHandleBarsVariables": function() { return /* reexport */ getAllHandleBarsVariables; },
  "getAnimation": function() { return /* reexport */ getAnimation; },
  "getBackgroundOverlay": function() { return /* reexport */ getBackgroundOverlay; },
  "getBoxShadow": function() { return /* reexport */ getBoxShadow; },
  "getBreakpointWidthFromStyle": function() { return /* reexport */ getBreakpointWidthFromStyle; },
  "getCommonCss": function() { return /* reexport */ getCommonCss; },
  "getImageUrlFromGoogleUserContent": function() { return /* reexport */ getImageUrlFromGoogleUserContent; },
  "getOffset": function() { return /* reexport */ getOffset; },
  "getPropsByDevice": function() { return /* reexport */ utils_render_es/* getPropsByDevice */.vv; },
  "getRgbaFromHex": function() { return /* reexport */ getRgbaFromHex; },
  "getScrollbarWidth": function() { return /* reexport */ getScrollbarWidth; },
  "getSrcSetImageWidth": function() { return /* reexport */ getSrcSetImageWidth; },
  "getStyle": function() { return /* reexport */ getStyle; },
  "getTargetOfTrackingFromEvent": function() { return /* reexport */ utils_render_es/* getTargetOfTrackingFromEvent */.d0; },
  "getTrackingData": function() { return /* reexport */ utils_render_es/* getTrackingData */.O5; },
  "isAbsoluteWidth": function() { return /* reexport */ isAbsoluteWidth; },
  "isGCSUrl": function() { return /* reexport */ isGCSUrl; },
  "landingLinks": function() { return /* reexport */ index_es/* landingLinks */.Zq; },
  "mappingAssets": function() { return /* reexport */ mappingAssets; },
  "parseColor": function() { return /* reexport */ transform_es_parseColor; },
  "parseRuleRepeat": function() { return /* reexport */ date_time_es/* parseRuleRepeat */.gV; },
  "pbFontFamily": function() { return /* reexport */ fonts_es/* pbFontFamily */.tC; },
  "pbFontWeight": function() { return /* reexport */ fonts_es/* pbFontWeight */.a$; },
  "pixelParse": function() { return /* reexport */ pixelParse; },
  "publicBffUrl": function() { return /* reexport */ index_es/* publicBffUrl */.Fd; },
  "rcCascaderCss": function() { return /* reexport */ rc_cascader_es/* rcCascaderCss */.J; },
  "reset": function() { return /* reexport */ reset_es/* reset */.m; },
  "stringifyColor": function() { return /* reexport */ stringifyColor; },
  "unescapeString": function() { return /* reexport */ unescapeString; },
  "unitParse": function() { return /* reexport */ unitParse; },
  "useAnimation": function() { return /* reexport */ useAnimation; },
  "useBreakpointWidth": function() { return /* reexport */ useBreakpointWidth; },
  "useEndpointHandler": function() { return /* reexport */ useEndpointHandler; },
  "useInjectDynamicLinks": function() { return /* reexport */ useInjectDynamicLinks; },
  "useInjectLinksToHTML": function() { return /* reexport */ useInjectLinksToHTML; },
  "useIntersectionObserver": function() { return /* reexport */ useIntersectionObserver; },
  "useLocationChange": function() { return /* reexport */ useLocationChange; },
  "useStore": function() { return /* reexport */ StoreContext_es/* useStore */.o; },
  "useTimeVisibility": function() { return /* reexport */ useTimeVisibility; },
  "useTimer": function() { return /* reexport */ useTimer; },
  "validateIsVisibleComponent": function() { return /* reexport */ date_time_es/* validateIsVisibleComponent */.U0; },
  "youtubeParser": function() { return /* reexport */ youtubeParser; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/constants/index.es.js
var index_es = __webpack_require__(70403);
// EXTERNAL MODULE: ../../.yarn/cache/opentracing-npm-0.14.7-a8451c5ee8-5f7e444390.zip/node_modules/opentracing/lib/index.js
var lib = __webpack_require__(83492);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/api/error.es.js
class ApiError {
  constructor(message, code, response) {
    this.message = message;
    this.response = response;
    this.code = code;
  }
  get reason() {
    return this.response;
  }
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/api/index.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const normalizeSlashUrl = (baseURL = "", url) => {
  const normalizedBaseUrl = baseURL.endsWith("/") ? baseURL.slice(0, baseURL.length - 1) : baseURL;
  const normalizedPath = url.startsWith("/") ? url.slice(1) : url;
  return `${normalizedBaseUrl}/${normalizedPath}`;
};
const DEFAULT_ERROR_MESSAGE = "\u0110\xE3 c\xF3 l\u1ED7i x\u1EA3y ra, vui l\xF2ng th\u1EED l\u1EA1i sau!";
class Api {
  constructor(url, getError, defaultConfig = {}) {
    this.baseURL = url;
    this.interceptors = [];
    this.getError = getError;
    this.defaultConfig = defaultConfig;
  }
  _parseJson(response) {
    return response.text().then((text) => text ? JSON.parse(text) : null);
  }
  addInterceptor(interceptFn) {
    this.interceptors.push(interceptFn);
  }
  appendParamsToURL(url, params = {}) {
    if (params) {
      const paramsArr = [];
      for (const k of Object.keys(params)) {
        if (params[k] !== null && params[k] !== void 0) {
          paramsArr.push(`${k}=${encodeURIComponent(params[k])}`);
        }
      }
      if (paramsArr.length > 0)
        url = `${url}?${paramsArr.join("&")}`;
    }
    return url;
  }
  async request(path, body, method, config = {}) {
    var _a;
    const { params: configParams } = config;
    let headers = config.headers || {};
    const url = this.appendParamsToURL(path, configParams || {});
    let serializedBody = null;
    const isFormData = body && typeof body !== "string" && "append" in body;
    if (body) {
      if (typeof body !== "string") {
        if (isFormData) {
          serializedBody = new URLSearchParams(body).toString();
        } else {
          serializedBody = JSON.stringify(body);
          headers = __spreadValues({
            "Content-Type": "application/json"
          }, headers);
        }
      }
    }
    let serializedParams = null;
    if (configParams) {
      serializedParams = JSON.stringify(configParams);
    }
    const tracer = (0,lib.globalTracer)();
    const spanName = `[${method}] ${normalizeSlashUrl(this.baseURL, path)}`;
    const span = tracer.startSpan(spanName);
    tracer.inject(span, lib.FORMAT_HTTP_HEADERS, headers);
    span.setTag("http.method", method);
    span.setTag("http.baseurl", this.baseURL);
    span.log({
      body: serializedBody,
      params: serializedParams
    });
    const requestObj = __spreadProps(__spreadValues({}, this.defaultConfig), {
      method,
      headers: new Headers(headers),
      body: isFormData ? body : serializedBody
    });
    this.interceptors.forEach((fn) => fn(requestObj));
    const res = await fetch(
      url.startsWith("http") ? url : normalizeSlashUrl(this.baseURL, url),
      requestObj
    );
    if (res.status >= 400) {
      const resp = await res.json();
      const error = ((_a = this.getError) == null ? void 0 : _a.call(this, resp)) || new ApiError(DEFAULT_ERROR_MESSAGE, -1, resp);
      span.setTag("status", "error");
      span.log({
        error: JSON.stringify(error)
      });
      span.finish();
      return Promise.reject(error);
    }
    const respHeaders = {};
    res.headers.forEach((val, key) => respHeaders[key] = val);
    const data = await this._parseJson(res);
    span.setTag("status", "success");
    span.finish();
    return { code: res.status, data, headers: respHeaders };
  }
  async get(url, config = {}) {
    return await this.request(url, null, "GET", config);
  }
  async post(url, body, config = {}) {
    return await this.request(url, body, "POST", config);
  }
  async patch(url, body, config = {}) {
    return await this.request(url, body, "PATCH", config);
  }
  async put(url, body, config = {}) {
    return await this.request(url, body, "PUT", config);
  }
  async delete(url, body = {}, config = {}) {
    return await this.request(url, body, "DELETE", config);
  }
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/builder.es.js



var builder_es_defProp = Object.defineProperty;
var builder_es_defProps = Object.defineProperties;
var builder_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var builder_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var builder_es_hasOwnProp = Object.prototype.hasOwnProperty;
var builder_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var builder_es_defNormalProp = (obj, key, value) => key in obj ? builder_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var builder_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (builder_es_hasOwnProp.call(b, prop))
      builder_es_defNormalProp(a, prop, b[prop]);
  if (builder_es_getOwnPropSymbols)
    for (var prop of builder_es_getOwnPropSymbols(b)) {
      if (builder_es_propIsEnum.call(b, prop))
        builder_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var builder_es_spreadProps = (a, b) => builder_es_defProps(a, builder_es_getOwnPropDescs(b));
class Builder {
  init(domain, config) {
    this.domain = domain;
    if (!config.env) {
      config.env = "production";
    }
    this.pageManagementClient = new Api(index_es/* publicBffUrl */.Fd[config.env]);
    this.internalClient = new Api(index_es/* publicBffUrl.internal */.Fd.internal);
  }
  async getPublicPage(params, internal = false) {
    const client = internal ? this.internalClient : this.pageManagementClient;
    const { data } = await client.get("/v1/page", {
      params: builder_es_spreadProps(builder_es_spreadValues({}, params), {
        domain: this.domain
      })
    });
    return data == null ? void 0 : data.data;
  }
  async getPublicPageV2(params, internal = false) {
    var _a, _b, _c;
    const client = internal ? this.internalClient : this.pageManagementClient;
    const { data } = await client.get("/v1/page", {
      params: builder_es_spreadProps(builder_es_spreadValues({}, params), {
        domain: this.domain
      })
    });
    return builder_es_spreadProps(builder_es_spreadValues({}, (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.page), {
      pbConfig: (_c = (_b = data == null ? void 0 : data.data) == null ? void 0 : _b.page) == null ? void 0 : _c.content
    });
  }
  async getPrivatePageV2(params, headers) {
    var _a, _b, _c;
    const client = this.pageManagementClient;
    const { data } = await client.get("/v1/page", {
      params: builder_es_spreadProps(builder_es_spreadValues({}, params), {
        domain: this.domain
      }),
      headers
    });
    return builder_es_spreadProps(builder_es_spreadValues({}, (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.page), {
      pbConfig: (_c = (_b = data == null ? void 0 : data.data) == null ? void 0 : _b.page) == null ? void 0 : _c.content
    });
  }
  getSSRInputs(pbConfig, option) {
    const { device = "desktop", ssrComponentTags, getSlotDataFunc } = option;
    return Object.keys(pbConfig).filter((k) => {
      return ssrComponentTags.includes(pbConfig[k].tag);
    }).map((k) => ({
      key: k,
      data: getSlotDataFunc(pbConfig[k], device)
    })).reduce(
      (acc, curr) => builder_es_spreadProps(builder_es_spreadValues({}, acc), {
        [curr.key]: curr.data
      }),
      {}
    );
  }
}
Builder.ITEMS_PER_PAGE = 18;
const builder = new Builder();



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/render.es.js
var render_es = __webpack_require__(21108);
// EXTERNAL MODULE: ../../.yarn/cache/color-name-npm-1.1.4-025792b0ea-b044585952.zip/node_modules/color-name/index.js
var color_name = __webpack_require__(35410);
var color_name_default = /*#__PURE__*/__webpack_require__.n(color_name);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/parse-css-color/regexes/index.es.js
const index_es_float = "-?\\d*(?:\\.\\d+)";
const number = `(${index_es_float}?)`;
const percentage = `(${index_es_float}?%)`;
const numberOrPercentage = `(${index_es_float}?%?)`;
const pattern1 = /^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/;
const hexRe = new RegExp(pattern1, "i");
const pattern2 = `^
  hsla?\\(
    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*,
    \\s*${percentage}\\s*,
    \\s*${percentage}\\s*
    (?:,\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, "");
const hsl3Re = new RegExp(pattern2);
const pattern3 = `^
  hsla?\\(
    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*
    \\s+${percentage}
    \\s+${percentage}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, "");
const hsl4Re = new RegExp(pattern3);
const pattern4 = `^
  rgba?\\(
    \\s*${number}\\s*,
    \\s*${number}\\s*,
    \\s*${number}\\s*
    (?:,\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, "");
const rgb3NumberRe = new RegExp(pattern4);
const pattern5 = `^
  rgba?\\(
    \\s*${percentage}\\s*,
    \\s*${percentage}\\s*,
    \\s*${percentage}\\s*
    (?:,\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, "");
const rgb3PercentageRe = new RegExp(pattern5);
const pattern6 = `^
  rgba?\\(
    \\s*${number}
    \\s+${number}
    \\s+${number}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage}\\s*)?
  \\)
$
`.replace(/\n|\s/g, "");
const rgb4NumberRe = new RegExp(pattern6);
const pattern7 = `^
  rgba?\\(
    \\s*${percentage}
    \\s+${percentage}
    \\s+${percentage}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage}\\s*)?
  \\)
$
`.replace(/\n|\s/g, "");
const rgb4PercentageRe = new RegExp(pattern7);
const pattern8 = /^transparent$/;
const transparentRe = new RegExp(pattern8, "i");



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/parse-css-color/utils/hex-rgb.es.js
const hexCharacters = "a-f\\d";
const match3or4Hex = `#?[${hexCharacters}]{3}[${hexCharacters}]?`;
const match6or8Hex = `#?[${hexCharacters}]{6}([${hexCharacters}]{2})?`;
const nonHexChars = new RegExp(`[^#${hexCharacters}]`, "gi");
const validHexSize = new RegExp(`^${match3or4Hex}$|^${match6or8Hex}$`, "i");
function hex2Rgb(hex, options = { format: void 0 }) {
  if (typeof hex !== "string" || nonHexChars.test(hex) || !validHexSize.test(hex)) {
    throw new TypeError("Expected a valid hex string");
  }
  hex = hex.replace(/^#/, "");
  let alpha = 1;
  if (hex.length === 8) {
    alpha = Math.floor(Number.parseInt(hex.slice(6, 8), 16) / 255 * 100) / 100;
    hex = hex.slice(0, 6);
  }
  if (hex.length === 4) {
    alpha = Math.floor(Number.parseInt(hex.slice(3, 4).repeat(2), 16) / 255 * 100) / 100;
    hex = hex.slice(0, 3);
  }
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  const number = Number.parseInt(hex, 16);
  const red = number >> 16;
  const green = number >> 8 & 255;
  const blue = number & 255;
  if (options.format === "array") {
    return [red, green, blue, alpha];
  }
  if (options.format === "css") {
    const alphaString = alpha === 1 ? "" : ` / ${Number((alpha * 100).toFixed(2))}%`;
    return `rgb(${red} ${green} ${blue}${alphaString})`;
  }
  return { red, green, blue, alpha };
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/parse-css-color/utils/index.es.js


const clamp = (num, min, max) => Math.min(Math.max(min, num), max);
const parseRGB = (num) => {
  let n = num;
  if (typeof n !== "number")
    n = n.endsWith("%") ? parseFloat(n) * 255 / 100 : parseFloat(n);
  return clamp(Math.round(n), 0, 255);
};
const parsePercentage = (percentage) => clamp(parseFloat(percentage), 0, 100);
function parseAlpha(alpha) {
  let a = alpha;
  if (typeof a !== "number")
    a = a.endsWith("%") ? parseFloat(a) / 100 : parseFloat(a);
  return clamp(a, 0, 1);
}
function getHEX(hex) {
  const [r, g, b, a] = hex2Rgb(hex, { format: "array" });
  return getRGB([null, ...[r, g, b, a]]);
}
function getHSL([, h, s, l, a = 1]) {
  let hh = h;
  if (hh.endsWith("turn")) {
    hh = parseFloat(hh) * 360 / 1;
  } else if (hh.endsWith("rad")) {
    hh = Math.round(parseFloat(hh) * 180 / Math.PI);
  } else {
    hh = parseFloat(hh);
  }
  return {
    type: "hsl",
    values: [hh, parsePercentage(s), parsePercentage(l)],
    alpha: parseAlpha(a === null ? 1 : a)
  };
}
function getRGB([, r, g, b, a = 1]) {
  return {
    type: "rgb",
    values: [r, g, b].map(parseRGB),
    alpha: parseAlpha(a === null ? 1 : a)
  };
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/parse-css-color/index.es.js




const parseCSSColor = (str) => {
  if (typeof str !== "string")
    return null;
  const hex = hexRe.exec(str);
  if (hex)
    return getHEX(hex[0]);
  const hsl = hsl4Re.exec(str) || hsl3Re.exec(str);
  if (hsl)
    return getHSL(hsl);
  const rgb = rgb4NumberRe.exec(str) || rgb4PercentageRe.exec(str) || rgb3NumberRe.exec(str) || rgb3PercentageRe.exec(str);
  if (rgb)
    return getRGB(rgb);
  if (transparentRe.exec(str))
    return getRGB([null, 0, 0, 0, 0]);
  const cn = (color_name_default())[str.toLowerCase()];
  if (cn)
    return getRGB([null, cn[0], cn[1], cn[2], 1]);
  return null;
};
var parse = parseCSSColor;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/pure-color/index.es.js
function index_es_clamp(val, min, max) {
  return Math.min(Math.max(val, min), max);
}
function hsl2rgb(hsl) {
  const h = hsl[0] / 360, s = hsl[1] / 100, l = hsl[2] / 100;
  let t2, t3, val;
  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }
  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  const t1 = 2 * l - t2;
  const rgb = [0, 0, 0];
  for (let i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * -(i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;
    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;
    rgb[i] = val * 255;
  }
  return rgb;
}
function componentToHex(c) {
  const value = Math.round(index_es_clamp(c, 0, 255));
  const hex = value.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}
function rgb2hex(rgb) {
  const alpha = rgb.length === 4 ? componentToHex(rgb[3] * 255) : "";
  return "#" + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]) + alpha;
}
function rgb2hsl(rgb) {
  const r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), delta = max - min;
  let h, s;
  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g) / delta;
  h = Math.min(h * 60, 360);
  if (h < 0)
    h += 360;
  const l = (min + max) / 2;
  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);
  return [h, s * 100, l * 100];
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/mix-css-color/index.es.js



function parseColor(color) {
  const res = parse(color);
  if (res === null)
    return null;
  if (res.type === "hsl")
    res.values = hsl2rgb(res.values);
  return res;
}
function mix(color1, color2, percentage = 50) {
  const c1 = parseColor(color1);
  const c2 = parseColor(color2);
  if (!c1 || !c2)
    return null;
  const p = Math.min(Math.max(0, percentage), 100) / 100;
  const w = p * 2 - 1;
  const a = c1.alpha - c2.alpha;
  const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
  const w2 = 1 - w1;
  const [r, g, b] = c1.values.map(
    (c, i) => Math.round(c1.values[i] * w1 + c2.values[i] * w2)
  );
  const alpha = parseFloat((c1.alpha * p + c2.alpha * (1 - p)).toFixed(8));
  return {
    hex: rgb2hex([r, g, b]),
    hexa: rgb2hex([r, g, b, alpha]),
    rgba: [r, g, b, alpha],
    hsla: [...rgb2hsl([r, g, b]).map(Math.round), alpha]
  };
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/colors/core/index.es.js




const defaultNumberParam = (v, d) => v === null || isNaN(v) || typeof v === "string" ? d : v;
class ColorCore {
  constructor(color = "#000", type = "base", weight = 0) {
    [this.rgb, this.alpha, this.type, this.weight] = [
      [0, 0, 0],
      1,
      type,
      weight
    ];
    const c = color === null ? "#000" : color;
    if (typeof c !== "string")
      throw new TypeError(`Input should be a string: ${c}`);
    const parsed = parse(c);
    if (!parsed)
      throw new Error(`Unable to parse color from string: ${c}`);
    return this[`_setFrom${parsed.type.toUpperCase()}`]([
      ...parsed.values,
      parsed.alpha
    ]);
  }
  get hex() {
    return this.hexString().replace(/^#/, "");
  }
  setColor(color) {
    const parsed = parse(color);
    if (!parsed)
      return null;
    return this[`_setFrom${parsed.type.toUpperCase()}`]([
      ...parsed.values,
      parsed.alpha
    ]);
  }
  tint(weight, w = defaultNumberParam(weight, 50)) {
    return new ColorCore(
      `rgb(${mix("#fff", this.rgbString(), w).rgba})`,
      "tint",
      w
    );
  }
  shade(weight, w = defaultNumberParam(weight, 50)) {
    return new ColorCore(
      `rgb(${mix("#000", this.rgbString(), w).rgba})`,
      "shade",
      w
    );
  }
  tints(weight, w = defaultNumberParam(weight, 10)) {
    return Array.from({ length: 100 / w }, (_, i) => this.tint((i + 1) * w));
  }
  shades(weight, w = defaultNumberParam(weight, 10)) {
    return Array.from({ length: 100 / w }, (_, i) => this.shade((i + 1) * w));
  }
  all(weight = 10) {
    return [
      ...this.tints(weight).reverse(),
      Object.assign(this),
      ...this.shades(weight)
    ];
  }
  hexString() {
    return rgb2hex(this.alpha >= 1 ? this.rgb : [...this.rgb, this.alpha]);
  }
  rgbString() {
    const channels = (this.alpha >= 1 ? this.rgb : [...this.rgb, this.alpha]).join(", ");
    return `${this.alpha >= 1 ? "rgb" : "rgba"}(${channels})`;
  }
  getBrightness() {
    return Math.round(this.rgb.reduce((a, b) => a + b) / (255 * 3) * 100);
  }
  _setFromRGB([r, g, b, a]) {
    [this.rgb, this.alpha] = [[r, g, b], a];
    return this;
  }
  _setFromHSL([h, s, l, a]) {
    [this.rgb, this.alpha] = [hsl2rgb([h, s, l]).map(Math.round), a];
    return this;
  }
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/colors/generate.es.js


const DEFAULT_WEIGHT = 5;
const valueOptions = {
  50: 1,
  100: 2,
  200: 4,
  500: 20,
  600: 22,
  700: 24
};
function generate(color, type = "") {
  const patterns = {};
  const pColors = new ColorCore(color).all(DEFAULT_WEIGHT);
  Object.keys(valueOptions).forEach((key) => {
    patterns[`${type}${key}`] = pColors[valueOptions[key]].hexString();
  });
  return patterns;
}



// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/hooks/useIntersectionObserver.es.js


const useIntersectionObserver = (elementRef, {
  threshold = 0,
  root = null,
  rootMargin = "0%",
  freezeOnceVisible = false
}) => {
  const [entry, setEntry] = (0,react.useState)();
  const frozen = (entry == null ? void 0 : entry.isIntersecting) && freezeOnceVisible;
  const updateEntry = ([entry2]) => {
    setEntry(entry2);
  };
  (0,react.useEffect)(() => {
    const node = elementRef == null ? void 0 : elementRef.current;
    const hasIOSupport = !!window.IntersectionObserver;
    if (!hasIOSupport || frozen || !node)
      return;
    const observerParams = { threshold, root, rootMargin };
    const observer = new IntersectionObserver(updateEntry, observerParams);
    observer.observe(node);
    return () => observer.disconnect();
  }, [elementRef == null ? void 0 : elementRef.current, threshold, root, rootMargin, frozen]);
  return entry;
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/hooks/useAnimation.es.js



const useAnimation = (animation, animationRef) => {
  var _a;
  const entry = useIntersectionObserver(animationRef, {});
  const isVisible = !!(entry == null ? void 0 : entry.isIntersecting);
  const [isFirstRender, setFirstRender] = (0,react.useState)(true);
  const [animationClassName, setClassName] = (0,react.useState)("animation-hidden");
  (0,react.useEffect)(() => {
    if (!(animation == null ? void 0 : animation.name) || !isFirstRender || !(animationRef == null ? void 0 : animationRef.current))
      return;
    if (isVisible && isFirstRender) {
      const timeout = setTimeout(() => {
        setClassName("");
        setFirstRender(false);
      }, ((animation == null ? void 0 : animation.delay) || 0) * 1e3 + 20);
      return () => clearTimeout(timeout);
    }
  }, [isVisible, animation, isFirstRender, animationRef]);
  if (!(animation == null ? void 0 : animation.name))
    return { style: {}, animationClassName: "" };
  if (isVisible && isFirstRender || !isFirstRender) {
    const style = {
      animationName: animation == null ? void 0 : animation.name,
      animationDelay: `${(animation == null ? void 0 : animation.delay) || 0}s`,
      animationDuration: `${(animation == null ? void 0 : animation.duration) || 0}s`,
      animationIterationCount: (animation == null ? void 0 : animation.repeatType) === "infinite" ? "infinite" : ((_a = animation == null ? void 0 : animation.repeatNumber) == null ? void 0 : _a.toString()) || "1"
    };
    return { style, animationClassName };
  }
  return { style: {}, animationClassName };
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/react-dom-virtual-d2a5f90a4a/0/cache/react-dom-npm-18.2.0-dd675bca1c-7d323310be.zip/node_modules/react-dom/index.js
var react_dom = __webpack_require__(26759);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@react-spring-web-virtual-3070b8fc7a/0/cache/@react-spring-web-npm-9.7.3-95390d075a-7f5cd05b23.zip/node_modules/@react-spring/web/dist/react-spring_web.modern.mjs + 3 modules
var react_spring_web_modern = __webpack_require__(18904);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/getOffset.es.js
const getOffset = (node) => {
  const parentWindow = node && node.ownerDocument.defaultView || window;
  const parentDocument = node && node.ownerDocument || document;
  const box = node.getBoundingClientRect();
  const docElem = parentDocument.documentElement;
  return {
    left: box.left + (parentWindow.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
    top: box.top + (parentWindow.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
  };
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/components/Image/Preview.es.js







var Preview_es_defProp = Object.defineProperty;
var Preview_es_defProps = Object.defineProperties;
var Preview_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Preview_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Preview_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Preview_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Preview_es_defNormalProp = (obj, key, value) => key in obj ? Preview_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Preview_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Preview_es_hasOwnProp.call(b, prop))
      Preview_es_defNormalProp(a, prop, b[prop]);
  if (Preview_es_getOwnPropSymbols)
    for (var prop of Preview_es_getOwnPropSymbols(b)) {
      if (Preview_es_propIsEnum.call(b, prop))
        Preview_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Preview_es_spreadProps = (a, b) => Preview_es_defProps(a, Preview_es_getOwnPropDescs(b));
const Preview = ({
  open,
  onClose,
  mousePosition,
  src
}) => {
  const ref = (0,react.useRef)();
  const [rendered, setRendered] = (0,react.useState)(open);
  const [showMask, setShowMask] = (0,react.useState)(open);
  const [showContent, setShowContent] = (0,react.useState)(open);
  const [previewPosition, setPreviewPosition] = (0,react.useState)();
  const [prevBodyAttrs, setPrevBodyAttrs] = (0,react.useState)({});
  const [props, api] = (0,react_spring_web_modern/* useSpring */.q_)(
    () => ({
      from: { opacity: open ? 0 : 1 },
      to: { opacity: open ? 1 : 0 },
      config: {
        duration: 100
      },
      onResolve: () => {
        if (!open)
          setShowMask(false);
      }
    }),
    [open]
  );
  const [imgProps, imgApi] = (0,react_spring_web_modern/* useSpring */.q_)(() => {
    const baseScale = typeof (previewPosition == null ? void 0 : previewPosition.width) === "number" ? mousePosition.width / (previewPosition == null ? void 0 : previewPosition.width) : 1;
    const baseTranslateX = typeof (previewPosition == null ? void 0 : previewPosition.left) === "number" ? mousePosition.left - (previewPosition == null ? void 0 : previewPosition.left) : 0;
    const baseTranslateY = typeof (previewPosition == null ? void 0 : previewPosition.top) === "number" ? mousePosition.top - (previewPosition == null ? void 0 : previewPosition.top) : 0;
    const scaleFrom = open ? baseScale : 1;
    const translateFrom = open ? `translate(${baseTranslateX}px, ${baseTranslateY}px)` : `translate(0px, 0px)`;
    const scaleTo = open ? 1 : baseScale;
    const translateTo = open ? `translate(0px, 0px)` : `translate(${baseTranslateX}px, ${baseTranslateY}px)`;
    return {
      from: { transform: translateFrom, scale: scaleFrom },
      to: { transform: translateTo, scale: scaleTo },
      config: {
        duration: 100
      },
      onResolve: () => {
        if (!open)
          setShowContent(false);
      }
    };
  }, [open, previewPosition]);
  const getParentWindow = () => {
    var _a, _b;
    return ((_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) == null ? void 0 : _b.defaultView) || window;
  };
  const getParentDocument = () => {
    var _a;
    return ((_a = ref.current) == null ? void 0 : _a.ownerDocument) || document;
  };
  const bodyScrollDisable = () => {
    setPrevBodyAttrs({
      overflow: getParentDocument().body.style.overflow,
      width: getParentDocument().body.style.width
    });
    const clientWidth = getParentDocument().body.clientWidth;
    getParentDocument().body.style.overflow = "hidden";
    getParentDocument().body.style.width = `${clientWidth}px`;
  };
  const bodyScrollEnable = () => {
    getParentDocument().body.style.width = prevBodyAttrs.width;
    getParentDocument().body.style.overflow = prevBodyAttrs.overflow;
    setPrevBodyAttrs({});
  };
  const handleClosePreview = () => {
    onClose == null ? void 0 : onClose();
  };
  (0,react.useEffect)(() => {
    api.start();
    imgApi.start();
  }, [open]);
  (0,react.useEffect)(() => {
    if (open) {
      setShowMask(true);
      setShowContent(true);
    }
  }, [open]);
  (0,react.useEffect)(() => {
    if (open && !rendered) {
      setRendered(true);
    }
  }, [open, rendered]);
  (0,react.useEffect)(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" || e.keyCode === 27) {
        e.preventDefault();
        e.stopPropagation();
        handleClosePreview();
      }
    };
    if (open && rendered) {
      bodyScrollDisable();
      getParentWindow().addEventListener("wheel", handleClosePreview);
      getParentWindow().addEventListener("touchstart", handleClosePreview);
      getParentDocument().addEventListener("keydown", handleKeyDown, false);
    } else {
      bodyScrollEnable();
      getParentWindow().removeEventListener("wheel", handleClosePreview);
      getParentWindow().removeEventListener("touchstart", handleClosePreview);
      getParentDocument().removeEventListener("keydown", handleKeyDown, false);
    }
    return () => {
      getParentWindow().removeEventListener("wheel", handleClosePreview);
      getParentWindow().removeEventListener("touchstart", handleClosePreview);
      getParentDocument().removeEventListener("keydown", handleKeyDown, false);
    };
  }, [open, rendered]);
  return rendered ? /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0,jsx_runtime.jsx)("div", {
        ref,
        style: { display: "none" }
      }),
      (0,react_dom.createPortal)(
        /* @__PURE__ */ (0,jsx_runtime.jsxs)("div", {
          children: [
            showMask && /* @__PURE__ */ (0,jsx_runtime.jsx)(MaskSpring, {
              style: props
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(Content, {
              onClick: onClose,
              style: showContent ? {} : { display: "none" },
              children: [
                /* @__PURE__ */ (0,jsx_runtime.jsx)(StyledButtonUnzoom, {
                  type: "button",
                  children: /* @__PURE__ */ (0,jsx_runtime.jsx)("svg", {
                    "aria-hidden": "true",
                    "data-rmiz-btn-unzoom-icon": true,
                    fill: "currentColor",
                    focusable: "false",
                    viewBox: "0 0 16 16",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /* @__PURE__ */ (0,jsx_runtime.jsx)("path", {
                      d: "M 14.144531 1.148438 L 9 6.292969 L 9 3 L 8 3 L 8 8 L 13 8 L 13 7 L 9.707031 7 L 14.855469 1.851563 Z M 8 8 L 3 8 L 3 9 L 6.292969 9 L 1.148438 14.144531 L 1.851563 14.855469 L 7 9.707031 L 7 13 L 8 13 Z"
                    })
                  })
                }),
                /* @__PURE__ */ (0,jsx_runtime.jsx)(ImageSpring, {
                  style: Preview_es_spreadProps(Preview_es_spreadValues({}, imgProps), { transformOrigin: "top left" }),
                  src,
                  onLoad: (e) => {
                    setPreviewPosition(Preview_es_spreadValues({
                      width: e.currentTarget.offsetWidth
                    }, getOffset(e.currentTarget)));
                  }
                })
              ]
            })
          ]
        }),
        getParentDocument().body
      )
    ]
  }) : null;
};
const Mask = emotion_styled_browser_esm["default"].div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  pointer-events: none;
`;
const MaskSpring = (0,react_spring_web_modern/* animated */.q)(Mask);
const Content = emotion_styled_browser_esm["default"].div`
  position: fixed;
  inset: 0;
  z-index: 10001;
  overflow: auto;
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Image = emotion_styled_browser_esm["default"].img`
  max-width: 100vw;
  max-height: 100vh;
  cursor: zoom-out;
`;
const ImageSpring = (0,react_spring_web_modern/* animated */.q)(Image);
const StyledButtonUnzoom = emotion_styled_browser_esm["default"].button`
  position: absolute;
  cursor: pointer;
  inset: 20px 20px auto auto;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  border: none;
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  color: #fff;
  height: 40px;
  margin: 0;
  outline-offset: 2px;
  padding: 9px;
  touch-action: manipulation;
  width: 40px;
`;



// EXTERNAL MODULE: ../../.yarn/cache/clsx-npm-1.1.1-362bec0598-ff05265032.zip/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(77084);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/image.es.js
var image_es_defProp = Object.defineProperty;
var image_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var image_es_hasOwnProp = Object.prototype.hasOwnProperty;
var image_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var image_es_defNormalProp = (obj, key, value) => key in obj ? image_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var image_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (image_es_hasOwnProp.call(b, prop))
      image_es_defNormalProp(a, prop, b[prop]);
  if (image_es_getOwnPropSymbols)
    for (var prop of image_es_getOwnPropSymbols(b)) {
      if (image_es_propIsEnum.call(b, prop))
        image_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const imgAttributeMapping = {
  width: "w",
  height: "h",
  webp: "rw",
  png: "rp",
  jpg: "rj",
  stretch: "s",
  crop: "c"
};
const formatGoogleParams = (config) => {
  const newConfig = image_es_spreadValues({}, config);
  const { width, percent } = newConfig || {};
  if (width && percent) {
    newConfig.width = Math.round(width * percent / 100);
  }
  return newConfig;
};
const constructGoogleImageParams = (url, config) => {
  const baseUrl = url.indexOf("=") >= 0 ? url.substring(0, url.indexOf("=")) : url;
  const params = [];
  const newConfig = formatGoogleParams(config);
  Object.entries(newConfig).forEach(([key, value]) => {
    if (value !== 0 && !value)
      return;
    if (key === "format") {
      params.push(imgAttributeMapping[value]);
      return;
    }
    if (key === "size" && value) {
      params.push(`${imgAttributeMapping[key]}0`);
      return;
    }
    if (imgAttributeMapping[key]) {
      if (typeof value === "boolean") {
        if (value) {
          params.push(`${imgAttributeMapping[key]}`);
          return;
        }
        return;
      }
      params.push(`${imgAttributeMapping[key]}${value}`);
    }
  });
  return params.length > 0 ? `${baseUrl}=${params.join("-")}` : url;
};
const getImageUrlFromGoogleUserContent = (imageUrl, config) => {
  if (imageUrl && imageUrl.includes("googleusercontent.com") && !imageUrl.includes("="))
    return constructGoogleImageParams(imageUrl, config);
  return imageUrl;
};
const formatImageUrlQuality = (url, resolution = 800) => {
  if (!(url == null ? void 0 : url.startsWith("https://lh3.googleusercontent.com/")))
    return url;
  const resizedImageReg = /\S*=(rw(-w\d+)?|w\d+)/g;
  return resizedImageReg.test(url) ? url.replace(/=(rw(-w\d+)?|w\d+)/, `=rw-w${resolution}`) : url + `=w${resolution}`;
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/isAbsoluteWidth.es.js
const isAbsoluteWidth = (w) => w.unit === "px";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/contexts/BreakpointWidthContext.es.js




const BreakpointWidthContext = (0,react.createContext)({
  sWidth: {
    value: 100,
    unit: "%"
  },
  mWidth: {
    value: 100,
    unit: "%"
  }
});
const getAggregateWidth = (currWidth, aggWidth) => {
  if (isAbsoluteWidth(currWidth))
    return currWidth;
  return {
    value: aggWidth.value * currWidth.value / 100,
    unit: isAbsoluteWidth(aggWidth) ? "px" : "%"
  };
};
const BreakpointWidthProvider = ({ children, sWidth, mWidth }) => {
  const { sWidth: aggregateSWidth, mWidth: aggregateMWidth } = useBreakpointWidth();
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(BreakpointWidthContext.Provider, {
    value: {
      sWidth: getAggregateWidth(sWidth, aggregateSWidth),
      mWidth: getAggregateWidth(mWidth, aggregateMWidth)
    },
    children
  });
};
const useBreakpointWidth = () => {
  return (0,react.useContext)(BreakpointWidthContext);
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/getBreakpointWidthFromStyle.es.js
const getBreakpointWidthFromStyle = (style) => {
  const defaultValue = {
    value: 100,
    unit: "%"
  };
  const width = style == null ? void 0 : style.width;
  const widthUnit = style == null ? void 0 : style.widthUnit;
  if (widthUnit) {
    if (isNaN(+width))
      return defaultValue;
    return {
      value: +width,
      unit: widthUnit
    };
  }
  if (typeof width === "number")
    return {
      value: width,
      unit: "px"
    };
  return defaultValue;
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/types/style.es.js
var UnitEnum = /* @__PURE__ */ ((UnitEnum2) => {
  UnitEnum2["percent"] = "%";
  UnitEnum2["pixel"] = "px";
  return UnitEnum2;
})(UnitEnum || {});
var OverlayType = /* @__PURE__ */ ((OverlayType2) => {
  OverlayType2["color"] = "color";
  OverlayType2["gradient"] = "gradient";
  return OverlayType2;
})(OverlayType || {});
var ColorType = /* @__PURE__ */ ((ColorType2) => {
  ColorType2["solid"] = "solid";
  ColorType2["gradient"] = "gradient";
  return ColorType2;
})(ColorType || {});
var GradientType = /* @__PURE__ */ ((GradientType2) => {
  GradientType2["linear"] = "linear";
  GradientType2["radial"] = "radial";
  return GradientType2;
})(GradientType || {});
var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["left"] = "left";
  Alignment2["center"] = "center";
  Alignment2["right"] = "right";
  Alignment2["justify"] = "justify";
  return Alignment2;
})(Alignment || {});
var VerticalAlignment = /* @__PURE__ */ ((VerticalAlignment2) => {
  VerticalAlignment2["top"] = "top";
  VerticalAlignment2["center"] = "center";
  VerticalAlignment2["bottom"] = "bottom";
  return VerticalAlignment2;
})(VerticalAlignment || {});



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/colors/util.es.js


function getRgbaFromHex(hex, alpha = 1) {
  var _a;
  const rgb = hex2Rgb(hex);
  if (!rgb) {
    return null;
  }
  return `rgba(${rgb.red},${rgb.green},${rgb.blue},${(_a = rgb == null ? void 0 : rgb.alpha) != null ? _a : alpha})`;
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/constants/common.es.js
const BG_VISIBLE_LAZY_CLASS_NAME = "bg-visible-lazy";
const BG_LAZY_CLASS_NAME = "bg-lazy";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/transform.es.js





var transform_es_defProp = Object.defineProperty;
var transform_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var transform_es_hasOwnProp = Object.prototype.hasOwnProperty;
var transform_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var transform_es_defNormalProp = (obj, key, value) => key in obj ? transform_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var transform_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (transform_es_hasOwnProp.call(b, prop))
      transform_es_defNormalProp(a, prop, b[prop]);
  if (transform_es_getOwnPropSymbols)
    for (var prop of transform_es_getOwnPropSymbols(b)) {
      if (transform_es_propIsEnum.call(b, prop))
        transform_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (transform_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && transform_es_getOwnPropSymbols)
    for (var prop of transform_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && transform_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const isNumeric = (str) => {
  if (typeof str === "number")
    return true;
  if (typeof str !== "string")
    return false;
  return !isNaN(str) && !isNaN(parseFloat(str));
};
const jsToCss = (str) => str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
const getCommonCss = (attribute) => {
  return attribute && Object.entries(attribute).reduce((acc, curr) => {
    const [key, value] = curr;
    if ([null, void 0, false].some((el) => el === value) || /Unit$/.test(key))
      return acc;
    return `${acc}
${jsToCss(key)}: ${unitParse(
      value,
      attribute[`${key}Unit`]
    )};`;
  }, "");
};
const getFourSideCss = (props) => {
  const sidesOrder = ["top", "right", "bottom", "left"];
  const corderOrder = ["topLeft", "topRight", "bottomRight", "bottomLeft"];
  return Object.entries(props).reduce((acc, curr) => {
    const [key, value = {}] = curr;
    const _a = value, { unit = UnitEnum.pixel } = _a, restValue = __objRest(_a, ["unit"]);
    return acc + "\n" + Object.keys(restValue).filter(
      (attr) => (sidesOrder.includes(attr) || corderOrder.includes(attr)) && value[attr] !== null && value[attr] !== void 0
    ).map((attr) => {
      let childValue;
      if (isNumeric(value[attr])) {
        childValue = value[attr] + unit;
      } else {
        childValue = value[attr];
      }
      return `${jsToCss(`${key}-${attr}`)}: ${childValue};`;
    }).join("\n");
  }, "");
};
const getBackgroundOverlay = (type, value) => {
  if (type === OverlayType.color && value) {
    return `
      & {
        position: relative;

        &:before {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          content: '';
          background: ${value};
          border-radius: inherit;
          z-index: -1;
        }
      }
    `;
  }
  return "";
};
const getBoxShadow = (shadow) => {
  let boxShadow = "";
  if (shadow == null ? void 0 : shadow.color) {
    boxShadow = "box-shadow: ";
    boxShadow += (shadow == null ? void 0 : shadow.x) ? `${shadow.x}px ` : "0 ";
    boxShadow += (shadow == null ? void 0 : shadow.y) ? `${shadow.y}px ` : "0 ";
    boxShadow += (shadow == null ? void 0 : shadow.blur) ? `${shadow.blur}px ` : "0 ";
    boxShadow += (shadow == null ? void 0 : shadow.spread) ? `${shadow.spread}px ` : "0 ";
    boxShadow += `${shadow.color};`;
  }
  if (shadow == null ? void 0 : shadow.on) {
    boxShadow = "box-shadow: ";
    boxShadow += (shadow == null ? void 0 : shadow.x) ? `${shadow.x}px ` : "0 ";
    boxShadow += (shadow == null ? void 0 : shadow.y) ? `${shadow.y}px ` : "0 ";
    boxShadow += (shadow == null ? void 0 : shadow.blur) ? `${shadow.blur}px ` : "0 ";
    boxShadow += (shadow == null ? void 0 : shadow.spread) ? `${shadow.spread}px ` : "0 ";
    boxShadow += `rgba(0,0,0,${shadow == null ? void 0 : shadow.opacity});`;
  }
  return boxShadow;
};
const getTextShadow = (shadow) => {
  let textShadow = "";
  if (shadow == null ? void 0 : shadow.color) {
    textShadow = "text-shadow: ";
    textShadow += (shadow == null ? void 0 : shadow.x) ? `${shadow.x}px ` : "0 ";
    textShadow += (shadow == null ? void 0 : shadow.y) ? `${shadow.y}px ` : "0 ";
    textShadow += (shadow == null ? void 0 : shadow.blur) ? `${shadow.blur}px ` : "0 ";
    textShadow += `${shadow.color};`;
  }
  return textShadow;
};
const getHoverStyle = (hover) => {
  return `
    &:hover {
      ${getCommonCss(transform_es_spreadValues(transform_es_spreadValues(transform_es_spreadValues(transform_es_spreadValues({}, (hover == null ? void 0 : hover.color) && { color: hover.color }), (hover == null ? void 0 : hover.backgroundColor) && {
    backgroundColor: hover.backgroundColor
  }), (hover == null ? void 0 : hover.background) && {
    background: hover.background
  }), (hover == null ? void 0 : hover.borderColor) && { borderColor: hover.borderColor }))}
      ${(hover == null ? void 0 : hover.transparent) ? `opacity: ${hover.transparent / 100};` : ""}
      ${(hover == null ? void 0 : hover.zoom) ? `transform: scale(${hover.zoom / 100})` : ""}
    }
    `;
};
const getAnimation = (animation) => {
  return `
    ${(animation == null ? void 0 : animation.name) ? `animation-name: ${animation.name};` : ""}
    ${isNumeric(animation == null ? void 0 : animation.delay) ? `animation-delay: ${animation.delay}s;` : ""}
    ${isNumeric(animation == null ? void 0 : animation.duration) ? `animation-duration: ${animation.duration}s;` : ""}
    ${(animation == null ? void 0 : animation.repeatType) === "infinite" ? `animation-iteration-count: infinite;` : isNumeric(animation == null ? void 0 : animation.repeatNumber) ? `animation-iteration-count: ${animation.repeatNumber};` : ""}
    `;
};
const getBackgroundImageUrl = (bgImage, bgImageWidth, bgImagePercent) => {
  const isUrlPrefix = /^url\((.*)\)$/.test(bgImage);
  if (!isUrlPrefix && bgImage) {
    return `url(${getImageUrlFromGoogleUserContent(bgImage, {
      width: bgImageWidth,
      percent: bgImagePercent
    })})`;
  }
  return bgImage;
};
const getBackgroundImagePlaceholderUrl = (bgImage) => {
  return getBackgroundImageUrl(bgImage, 200, 100);
};
const getDefaultOverlay = (value) => {
  if (value)
    return `
      & {
        position: relative;
        z-index: 0;

        &:before {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          content: '';
          background: #000;
          border-radius: inherit;
          z-index: -1;
          opacity: ${value};
        }
      }`;
  return "";
};
const getStyle = (props, opts = { lazyBgImage: false }) => {
  const { lazyBgImage } = opts;
  if (!props)
    return "";
  const _a = props, {
    margin = {},
    padding = {},
    border = {},
    shadow,
    textShadow,
    backgroundVideo,
    backgroundOverlay,
    backgroundOverlayType,
    bgImageWidth,
    bgImagePercent,
    backgroundImage,
    hover = {},
    animation = {},
    defaultOverlay,
    background,
    backgroundColor,
    backgroundPosition,
    backgroundRepeat,
    backgroundSize
  } = _a, rest = __objRest(_a, [
    "margin",
    "padding",
    "border",
    "shadow",
    "textShadow",
    "backgroundVideo",
    "backgroundOverlay",
    "backgroundOverlayType",
    "bgImageWidth",
    "bgImagePercent",
    "backgroundImage",
    "hover",
    "animation",
    "defaultOverlay",
    "background",
    "backgroundColor",
    "backgroundPosition",
    "backgroundRepeat",
    "backgroundSize"
  ]);
  let bgCss = ``;
  if (!(backgroundVideo == null ? void 0 : backgroundVideo.src) && !(backgroundVideo == null ? void 0 : backgroundVideo.uploadSrc)) {
    if (backgroundImage) {
      const bgImage = getBackgroundImageUrl(
        backgroundImage,
        bgImageWidth,
        bgImagePercent
      );
      const bgImagePlaceHolder = getBackgroundImagePlaceholderUrl(backgroundImage);
      bgCss = bgImage !== bgImagePlaceHolder && lazyBgImage ? `
        background-image: ${bgImagePlaceHolder};
        &.${BG_VISIBLE_LAZY_CLASS_NAME} {
          background-image: ${bgImage};
        }
      ` : `
        background-image: ${bgImage};
      `;
    }
    bgCss += `
      ${getBackgroundOverlay(backgroundOverlayType, backgroundOverlay)}
      ${getCommonCss({
      background,
      backgroundColor,
      backgroundPosition,
      backgroundRepeat,
      backgroundSize
    })}
    `;
  } else {
    bgCss += `
      position: relative;
    `;
  }
  return `
    & {
      ${getBoxShadow(shadow)}
      ${getTextShadow(textShadow)}
      ${getCommonCss(transform_es_spreadValues(transform_es_spreadValues({}, border), rest))}
      ${bgCss}
      ${getFourSideCss({ margin, padding })}
      ${getHoverStyle(hover)}
      ${getDefaultOverlay(defaultOverlay)}
    }
    `;
};
const getScrollbarWidth = () => {
  let width = 0;
  if (typeof window !== "undefined") {
    if (document.body.scrollHeight <= window.innerHeight)
      return 0;
    if (window.scrollbarWidth && document.body.scrollHeight > window.innerHeight) {
      return window.scrollbarWidth;
    }
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    width = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);
  }
  return width;
};
const pixelParse = (value) => {
  if (typeof value === "number")
    return `${value}px`;
  return value;
};
const unitParse = (value, unit = UnitEnum.pixel) => {
  if (typeof value === "number")
    return `${value}${unit}`;
  return value;
};
const debounce = (fn, delay = 200) => {
  let timerId;
  return function(...args) {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, delay);
  };
};
const stringifyColor = (color) => {
  if (color.colorType === ColorType.solid)
    return color.colorValue;
  const gradientColor = color.colorValue;
  if (!gradientColor)
    return "";
  const cloneArr = [...gradientColor.colors];
  const gradientType = `${gradientColor.gradientType}-gradient`;
  const gradientRadius = gradientColor.gradientType === GradientType.radial ? "circle" : `${gradientColor.radius}deg`;
  const gradientList = cloneArr.sort((color1, color2) => color1.stop - color2.stop).map((color2) => `${color2.color} ${color2.stop}%`).join(",");
  return `${gradientType}(${gradientRadius}, ${gradientList})`;
};
const transform_es_parseColor = (color) => {
  if (!color || typeof color !== "string")
    return;
  if (!color.includes("-gradient"))
    return {
      colorType: ColorType.solid,
      colorValue: color.includes("#") ? getRgbaFromHex(color) : color
    };
  const gradientType = color.slice(0, color.indexOf("-gradient"));
  const content = color.substring(
    color.indexOf("(") + 1,
    color.lastIndexOf(")")
  );
  const arr = content.split(
    /,(?![^(]*\))(?![^"']*["'](?:[^"']*["'][^"']*["'])*[^"']*$)/
  );
  const radius = arr.shift();
  const colorList = arr.map((colorString) => {
    const colorArray = colorString.trim().split(" ");
    return { color: colorArray[0], stop: parseInt(colorArray[1]) };
  });
  return {
    colorType: ColorType.gradient,
    colorValue: {
      colors: [...colorList],
      radius: parseInt(radius) || void 0,
      gradientType: gradientType === GradientType.linear ? GradientType.linear : GradientType.radial
    }
  };
};
const generateRandomId = (length = 7) => Math.random().toString(36).substring(1, length);
const escapeString = (text) => {
  if (!text)
    return "";
  const map = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;"
  };
  return text.replace(/[&<>"']/g, function(m) {
    return map[m];
  });
};
const unescapeString = (text) => {
  if (!text)
    return "";
  const map = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#039;": "'"
  };
  return text.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g, function(m) {
    return map[m];
  });
};
const formatCurrencyVND = (value, includeUnit = true) => {
  if (typeof value !== "number")
    return null;
  let currencyFormat;
  if (includeUnit)
    currencyFormat = new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND"
    });
  else
    currencyFormat = new Intl.NumberFormat("vi-VN");
  return currencyFormat.format(value);
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/components/Link/Link.es.js




var Link_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Link_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Link_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Link_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Link_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Link_es_getOwnPropSymbols)
    for (var prop of Link_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Link_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Link = (_a) => {
  var _b = _a, {
    eventType,
    children,
    className,
    sectionMarginTop = 0,
    trackingEventName,
    conversionGGAdsId,
    conversionGGAdsLabel,
    scriptCustom
  } = _b, rest = Link_es_objRest(_b, [
    "eventType",
    "children",
    "className",
    "sectionMarginTop",
    "trackingEventName",
    "conversionGGAdsId",
    "conversionGGAdsLabel",
    "scriptCustom"
  ]);
  var _a2, _b2, _c, _d, _e, _f, _g, _h;
  const ref = (0,react.useRef)();
  const openPopup = (popupId) => {
    var _a3;
    (_a3 = ref.current.ownerDocument.querySelector(
      `[data-uniq-id="${popupId}"]`
    )) == null ? void 0 : _a3.click();
  };
  const closePopup = (popupId) => {
    const popup = ref.current.ownerDocument.querySelector(
      `[data-uniq-id="${popupId}"]`
    );
    const maskPopup = popup == null ? void 0 : popup.parentElement;
    maskPopup.classList.remove("show");
    maskPopup.classList.add("hide-from-btn");
    popup == null ? void 0 : popup.click();
  };
  const closePopupList = (popupIds) => {
    const getAllElement = ref.current.ownerDocument.querySelectorAll(
      `[data-uniq-id]`
    );
    const popupList = [];
    getAllElement.forEach((el) => {
      if (popupIds.includes(el.getAttribute("data-uniq-id")))
        popupList.push(el);
    });
    popupList.forEach((popup) => {
      const maskPopup = popup == null ? void 0 : popup.parentElement;
      maskPopup.classList.remove("show");
      maskPopup.classList.add("hide-from-btn");
      popup == null ? void 0 : popup.click();
    });
  };
  const scrollToElement = (elementId) => {
    const isInIframe = ref.current.ownerDocument !== document;
    let innerWindow = window;
    if (isInIframe) {
      const iframeElements = window.document.getElementsByTagName("iframe");
      for (const iframe of iframeElements) {
        if (iframe.contentDocument === ref.current.ownerDocument) {
          innerWindow = iframe.contentWindow;
          break;
        }
      }
    }
    const elements = ref.current.ownerDocument.querySelectorAll(
      `[data-id="${elementId}"]`
    );
    for (const element of elements) {
      if (innerWindow.getComputedStyle(element).display !== "none") {
        const top = element.getBoundingClientRect().top + innerWindow.pageYOffset - sectionMarginTop;
        innerWindow.scrollTo({
          top,
          behavior: "smooth"
        });
      }
    }
  };
  const trackEventClick = () => {
    var _a3, _b3, _c2, _d2;
    if (trackingEventName) {
      (_a3 = window == null ? void 0 : window.gtag) == null ? void 0 : _a3.call(window, "event", trackingEventName);
      (_b3 = window == null ? void 0 : window.fbq) == null ? void 0 : _b3.call(window, "trackCustom", trackingEventName);
      (_c2 = window == null ? void 0 : window.track) == null ? void 0 : _c2.call(window, "customEvent", trackingEventName);
    }
    if (conversionGGAdsId && conversionGGAdsLabel) {
      (_d2 = window == null ? void 0 : window.gtag) == null ? void 0 : _d2.call(window, "event", "conversion", {
        send_to: `AW-${conversionGGAdsId}/${conversionGGAdsLabel}`
      });
    }
    runStringFunc(scriptCustom);
  };
  const runStringFunc = (script) => {
    if (script == null ? void 0 : script.trim()) {
      try {
        const excuteScript = new Function(unescapeString(script));
        excuteScript();
      } catch (err) {
        console.error(err);
      }
    }
  };
  if (eventType === "openPageOfWebsite" && ((_a2 = rest["openPageOfWebsite"]) == null ? void 0 : _a2.href))
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: rest["openPageOfWebsite"].href,
      onClick: trackEventClick,
      target: ((_b2 = rest[eventType]) == null ? void 0 : _b2.openNewTab) ? "_blank" : "_top",
      className,
      children
    });
  if (eventType === "link" && ((_c = rest["link"]) == null ? void 0 : _c.href))
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: rest["link"].href,
      onClick: trackEventClick,
      target: ((_d = rest[eventType]) == null ? void 0 : _d.openNewTab) ? "_blank" : "_top",
      className,
      rel: ((_e = rest[eventType]) == null ? void 0 : _e.nofollow) ? "nofollow" : "noopener noreferrer",
      children
    });
  if (eventType === "inPage" && rest["inPage"])
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("div", {
      style: { cursor: "pointer" },
      onClick: () => {
        scrollToElement(rest["inPage"]);
        trackEventClick();
      },
      ref,
      children
    });
  if (eventType === "internal" && ((_f = rest["internal"]) == null ? void 0 : _f.href))
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: `/${rest["internal"].href}`,
      onClick: trackEventClick,
      target: ((_g = rest["internal"]) == null ? void 0 : _g.openNewTab) ? "_blank" : "_top",
      className,
      rel: "noopener noreferrer",
      children
    });
  if (eventType === "email" && rest["email"])
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: `mailto:${rest["email"]}`,
      onClick: trackEventClick,
      className,
      rel: "noopener noreferrer",
      target: "_top",
      children
    });
  if (eventType === "phone" && rest["phone"])
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: `tel:${rest["phone"]}`,
      onClick: trackEventClick,
      className,
      rel: "noopener noreferrer",
      target: "_top",
      children
    });
  if (eventType === "openPopup" && rest["togglePopup"]) {
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("div", {
      ref,
      onClick: () => {
        openPopup(rest["togglePopup"]);
        trackEventClick();
      },
      children
    });
  }
  if (eventType === "closePopupList" && ((_h = rest["togglePopupList"]) == null ? void 0 : _h.length)) {
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("div", {
      ref,
      onClick: () => {
        closePopupList(rest["togglePopupList"]);
        trackEventClick();
      },
      children
    });
  }
  if (eventType === "closePopup" && rest["togglePopup"]) {
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("div", {
      ref,
      onClick: () => {
        closePopup(rest["togglePopup"]);
        trackEventClick();
      },
      children
    });
  }
  return /* @__PURE__ */ (0,jsx_runtime.jsx)("div", {
    onClick: trackEventClick,
    children
  });
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/constants/root.es.js
const ROOT = "ROOT";
const ROOT_SELECTOR_NAME = "RootEditor";
const HEADER = "HEADER";
const FOOTER = "FOOTER";
const BUBBLE = "BUBBLE";
const ARTICLE_HEADER = "ARTICLE_HEADER";
const MINESTONE_M_WIDTH = 768;
const MAX_DPR = 5;
const COMPONENT_TAG = {
  SECTION: "section",
  ROW: "row"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/getSrcSetImageWidth.es.js



const generateArraySrcSet = (min, max) => {
  const arr = [];
  let i = 1;
  while (min * i < max) {
    if (i > 100)
      return arr;
    arr.push(min * i);
    i++;
  }
  arr.push(max);
  return arr;
};
const getSrcSetImageWidth = (maxWidthImage, breakpointWidth) => {
  const breakpointWidthS = breakpointWidth.sWidth;
  let sWidth;
  if (isAbsoluteWidth(breakpointWidthS)) {
    const minSrcSetWidth = breakpointWidthS.value;
    const maxSrcSetWidth = Math.min(maxWidthImage, minSrcSetWidth * MAX_DPR);
    sWidth = generateArraySrcSet(minSrcSetWidth, maxSrcSetWidth);
  } else {
    const minSrcSetWidth = Math.floor(
      breakpointWidthS.value * MINESTONE_M_WIDTH / 100
    );
    const maxSrcSetWidth = Math.min(maxWidthImage, minSrcSetWidth * MAX_DPR);
    sWidth = generateArraySrcSet(minSrcSetWidth, maxSrcSetWidth);
  }
  let mWidth;
  const breakpointWidthM = breakpointWidth.mWidth;
  if (isAbsoluteWidth(breakpointWidthM)) {
    const minSrcSetWidth = breakpointWidthM.value;
    const maxSrcSetWidth = Math.min(maxWidthImage, minSrcSetWidth * MAX_DPR);
    mWidth = generateArraySrcSet(minSrcSetWidth, maxSrcSetWidth);
  } else {
    const minSrcSetWidth = Math.floor(
      breakpointWidthM.value * MINESTONE_M_WIDTH / 100
    );
    const maxSrcSetWidth = maxWidthImage;
    mWidth = generateArraySrcSet(minSrcSetWidth, maxSrcSetWidth);
  }
  return {
    sWidth,
    mWidth
  };
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/buildSrcset.es.js


const buildSrcset = (src, listWidth) => {
  return listWidth.map((w) => `${formatImageUrlQuality(src, w)} ${w}w`).join(",");
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/buildSizes.es.js


const buildSizes = (w) => {
  if (isAbsoluteWidth(w))
    return `${w.value}${w.unit}`;
  return `${w.value}vw`;
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/components/ImageOptimize/ImageOptimize.es.js







const ImageOptimize = ({
  src,
  googleImageParams
}) => {
  const breakpointWidth = useBreakpointWidth();
  const { sWidth, mWidth } = getSrcSetImageWidth(
    googleImageParams.width,
    breakpointWidth
  );
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0,jsx_runtime.jsx)("source", {
        media: `(max-width: ${MINESTONE_M_WIDTH}px)`,
        srcSet: buildSrcset(src, sWidth),
        sizes: buildSizes(breakpointWidth.sWidth),
        type: "image/webp"
      }),
      /* @__PURE__ */ (0,jsx_runtime.jsx)("source", {
        srcSet: buildSrcset(src, mWidth),
        sizes: buildSizes(breakpointWidth.mWidth),
        type: "image/webp"
      })
    ]
  });
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/constants/mapping-assets.es.js
const mappingAssets = {
  cardDefaultImage: "https://lh3.googleusercontent.com/XkvvC_Xpbpatsq8nf_NUjQgAdyB2wD7qbBQO1omzrUoa3eAV7WZuKGkBHHQzDP134RfgK5TFH1tiszH11ptSXQUr5RuvkGgw",
  defaultImage: "https://lh3.googleusercontent.com/Av6FDtBu9SniovENlthB014sqhpxhMSolIBzF9NCXcs1Ky1zelW1DlQ6UHaNxDRJRoJdY-AxjQJAbnKug8WKdHhpCqGu1iJabA",
  defaultImageSvg: "https://landingbuilder-cdn.tekoapis.com/static-assets/images/default_image.svg",
  rouletteImage: "https://lh3.googleusercontent.com/E66gFfiSLjcORXrWIS91o5DKUEPVKqjYN4cc2gn-ORBa12J-2B64bYQ-y938L_ggJbxnUkfkchtlfbFxUd5fT2im6F6ONGm4tw",
  spinTriggerImage: "https://lh3.googleusercontent.com/1ZxAxoPeshezR3ZevusxeAtmn8PHtf-yK4_SMMYUsvpTdz1l0M_LWWtIo9eDNMxy3Vdssy_QLSwUSK-KpyGUlF32h7eutKA",
  checkedInputGroupImageBkg: "https://lh3.googleusercontent.com/gb3xmoWfyljDOoCzs17NowaMtKFZllc4UHeBRtAuJWxinFDRJtfmzWnZUd1Sih83LKlP1lPNFdusQVOGyn2iEs13Vra5S74",
  noProductFoundImage: "https://lh3.googleusercontent.com/aCaLPZj5x231b37or78je16Gtd7e1mOvkpPkFH_pCvr6byaFgc9rw8lOfrClBFH6RRFHP2aZTpT9eN9RuVV743YtQgKV8jG4",
  VN: "https://landingbuilder-cdn.tekoapis.com/static-assets/json/VN.json"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/components/Image/Image.es.js















var Image_es_defProp = Object.defineProperty;
var Image_es_defProps = Object.defineProperties;
var Image_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Image_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Image_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Image_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Image_es_defNormalProp = (obj, key, value) => key in obj ? Image_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Image_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Image_es_hasOwnProp.call(b, prop))
      Image_es_defNormalProp(a, prop, b[prop]);
  if (Image_es_getOwnPropSymbols)
    for (var prop of Image_es_getOwnPropSymbols(b)) {
      if (Image_es_propIsEnum.call(b, prop))
        Image_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Image_es_spreadProps = (a, b) => Image_es_defProps(a, Image_es_getOwnPropDescs(b));
var Image_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Image_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Image_es_getOwnPropSymbols)
    for (var prop of Image_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Image_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { defaultImage } = mappingAssets;
const ImageWrapper = emotion_styled_browser_esm["default"].div(
  ({ alignment }) => `
    text-align: ${alignment};
  `
);
const funcWrapperImage = ({ commonStyle }) => `
    max-width: 100%;
    display: inline-block;
    transition: transform 0.3s;
    overflow: hidden;
    position: relative;
    object-fit: cover;

    ${getStyle(commonStyle)}
    &:before {
      z-index: 1;
    }
  `;
const StyledImageWrapperDiv = emotion_styled_browser_esm["default"].div(funcWrapperImage);
const StyledImageWrapperPicture = emotion_styled_browser_esm["default"].picture(funcWrapperImage);
const StyledImage = emotion_styled_browser_esm["default"].img`
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: inherit;
  &.preview {
    cursor: zoom-in;
  }
`;
const PlaceholderImage = emotion_styled_browser_esm["default"].img`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  object-fit: inherit;
`;
const ImageBase = react.forwardRef(
  (props, ref) => {
    var _b, _c;
    const _a = props, {
      src,
      alt = "",
      commonStyle,
      alignment = "center",
      event,
      googleImageParams,
      isEditingMode = false,
      zoomPreview = false,
      fetchPriority = "auto",
      showPlaceholder = true,
      autoOptimize = true
    } = _a, rest = Image_es_objRest(_a, [
      "src",
      "alt",
      "commonStyle",
      "alignment",
      "event",
      "googleImageParams",
      "isEditingMode",
      "zoomPreview",
      "fetchPriority",
      "showPlaceholder",
      "autoOptimize"
    ]);
    const imageRef = (0,react.useRef)(null);
    const [showPreview, setShowPreview] = (0,react.useState)(false);
    const [mousePosition, setMousePosition] = (0,react.useState)();
    const handleOpenPreview = (e) => {
      if (!zoomPreview)
        return;
      const { left, top } = getOffset(e.target);
      setMousePosition({
        left,
        top,
        width: e.target.clientWidth
      });
      setShowPreview(true);
    };
    const preProcesssorGoogleImageParams = (googleParams, config) => {
      return Image_es_spreadProps(Image_es_spreadValues(Image_es_spreadValues({}, config), googleParams), {
        width: (googleParams == null ? void 0 : googleParams.percent) ? Math.round((googleParams == null ? void 0 : googleParams.width) * (googleParams == null ? void 0 : googleParams.percent) / 100) : googleParams == null ? void 0 : googleParams.width
      });
    };
    const imageWrapperRef = (0,react.useRef)(null);
    const mergedWrapperRef = ref || imageWrapperRef;
    const { style: animationStyle, animationClassName } = useAnimation(
      commonStyle == null ? void 0 : commonStyle.animation,
      mergedWrapperRef
    );
    const [fullLoaded, setFullLoaded] = (0,react.useState)(false);
    const newSrc = getImageUrlFromGoogleUserContent(
      src,
      preProcesssorGoogleImageParams(googleImageParams, { format: "webp" })
    );
    const pngSrc = getImageUrlFromGoogleUserContent(
      src,
      preProcesssorGoogleImageParams(googleImageParams, { format: "png" })
    );
    const imgError = (image2) => {
      image2.target.src = defaultImage;
      return;
    };
    const placeholderSrc = showPlaceholder ? formatImageUrlQuality(newSrc, 200) : "";
    const allowOptimzeImage = autoOptimize && (googleImageParams == null ? void 0 : googleImageParams.width);
    const visiblePlaceholder = showPlaceholder && !fullLoaded && placeholderSrc !== newSrc;
    const fallbackImage = /* @__PURE__ */ (0,jsx_runtime.jsx)(StyledImage, {
      ref: imageRef,
      src: newSrc,
      alt,
      onError: imgError,
      decoding: "async",
      className: (0,clsx_m["default"])("lazyload", { preview: zoomPreview }),
      loading: fetchPriority === "high" ? "eager" : "lazy",
      fetchpriority: fetchPriority,
      onLoad: () => {
        setFullLoaded(true);
      },
      onClick: handleOpenPreview
    });
    const image = allowOptimzeImage ? /* @__PURE__ */ (0,jsx_runtime.jsxs)(StyledImageWrapperPicture, {
      ref: mergedWrapperRef,
      commonStyle,
      style: animationStyle,
      className: animationClassName,
      children: [
        /* @__PURE__ */ (0,jsx_runtime.jsx)(ImageOptimize, {
          src: newSrc,
          googleImageParams
        }),
        pngSrc && /* @__PURE__ */ (0,jsx_runtime.jsx)("source", {
          srcSet: pngSrc,
          type: "image/png"
        }),
        fallbackImage
      ]
    }) : /* @__PURE__ */ (0,jsx_runtime.jsxs)(StyledImageWrapperDiv, {
      ref: mergedWrapperRef,
      commonStyle,
      style: animationStyle,
      className: animationClassName,
      children: [
        fallbackImage,
        visiblePlaceholder && /* @__PURE__ */ (0,jsx_runtime.jsx)(PlaceholderImage, {
          src: placeholderSrc,
          alt,
          onError: imgError,
          fetchpriority: "high"
        })
      ]
    });
    (0,react.useEffect)(() => {
      if ((imageRef == null ? void 0 : imageRef.current) !== void 0 && imageRef.current.complete !== fullLoaded)
        setFullLoaded(imageRef.current.complete);
    }, [(_b = imageRef == null ? void 0 : imageRef.current) == null ? void 0 : _b.complete, fullLoaded]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(BreakpointWidthProvider, {
      sWidth: getBreakpointWidthFromStyle(commonStyle),
      mWidth: getBreakpointWidthFromStyle(commonStyle),
      children: isEditingMode ? image : /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
          /* @__PURE__ */ (0,jsx_runtime.jsx)(Link, Image_es_spreadProps(Image_es_spreadValues({}, event), {
            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(ImageWrapper, Image_es_spreadProps(Image_es_spreadValues({
              alignment
            }, rest), {
              children: image
            }))
          })),
          /* @__PURE__ */ (0,jsx_runtime.jsx)(Preview, {
            src: ((_c = imageRef.current) == null ? void 0 : _c.currentSrc) || newSrc,
            open: showPreview,
            onClose: () => {
              setShowPreview(false);
            },
            mousePosition
          })
        ]
      })
    });
  }
);



// EXTERNAL MODULE: ../../.yarn/__virtual__/react-youtube-virtual-608ea16416/0/cache/react-youtube-npm-10.1.0-57507894ba-514678c2a2.zip/node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(67818);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/isGCSUrl.es.js
const isGCSUrl = (url) => {
  if (!!url) {
    const regExp = /^(?:https?:\/\/)?(?:www\.)?storage\.googleapis\.com/i;
    const match = new RegExp(regExp).test(url);
    if (match) {
      return true;
    }
  }
  return false;
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/youtubeParser.es.js
const youtubeParser = (url) => {
  var _a;
  const formattedUrl = url == null ? void 0 : url.trim();
  if (!formattedUrl)
    return "";
  const regExp = new RegExp("^(https?:\\/\\/)?(www\\.)?(youtu\\.be\\/|youtube\\.com\\/(embed\\/|v\\/|watch\\?(.+&)*v=))(?<videoId>(\\w|-)+)");
  const { videoId } = ((_a = regExp.exec(formattedUrl)) == null ? void 0 : _a.groups) || {};
  return (videoId == null ? void 0 : videoId.length) === 11 ? videoId : "";
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/components/BackgroundVideo/BackgroundVideo.es.js









var BackgroundVideo_es_defProp = Object.defineProperty;
var BackgroundVideo_es_defProps = Object.defineProperties;
var BackgroundVideo_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var BackgroundVideo_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var BackgroundVideo_es_hasOwnProp = Object.prototype.hasOwnProperty;
var BackgroundVideo_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var BackgroundVideo_es_defNormalProp = (obj, key, value) => key in obj ? BackgroundVideo_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var BackgroundVideo_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (BackgroundVideo_es_hasOwnProp.call(b, prop))
      BackgroundVideo_es_defNormalProp(a, prop, b[prop]);
  if (BackgroundVideo_es_getOwnPropSymbols)
    for (var prop of BackgroundVideo_es_getOwnPropSymbols(b)) {
      if (BackgroundVideo_es_propIsEnum.call(b, prop))
        BackgroundVideo_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var BackgroundVideo_es_spreadProps = (a, b) => BackgroundVideo_es_defProps(a, BackgroundVideo_es_getOwnPropDescs(b));
const BackgroundVideo = ({
  src,
  uploadSrc,
  defaultOverlay
}) => {
  const wrapperRef = (0,react.useRef)();
  const intervalRef = (0,react.useRef)();
  (0,react.useEffect)(() => {
    return () => clearTimeout(intervalRef.current);
  }, []);
  const entry = useIntersectionObserver(wrapperRef, {
    freezeOnceVisible: true
  });
  if (!src && !uploadSrc && !defaultOverlay)
    return null;
  const renderVideo = () => {
    if (!(entry == null ? void 0 : entry.isIntersecting) || !wrapperRef.current)
      return null;
    const getWidthHeightOfYtb = () => {
      let { clientWidth: width, clientHeight: height } = wrapperRef.current;
      const displayRatio = 16 / 9;
      const containerRatio = width / height;
      if (containerRatio < displayRatio) {
        width = height * displayRatio;
      } else if (containerRatio > displayRatio) {
        height = width / displayRatio;
      }
      return {
        width,
        height
      };
    };
    if (isGCSUrl(uploadSrc)) {
      return /* @__PURE__ */ (0,jsx_runtime.jsx)("video", BackgroundVideo_es_spreadProps(BackgroundVideo_es_spreadValues({}, getWidthHeightOfYtb()), {
        style: videoStyle,
        playsInline: true,
        loop: true,
        autoPlay: true,
        muted: true,
        src: uploadSrc
      }));
    }
    const videoId = youtubeParser(src);
    if (!videoId)
      return null;
    let videoPlayer;
    let totalVideoTime;
    const OVERHEAD = 10;
    const RESTART_BEFORE = 1e3;
    function checkVideoPos() {
      let currentTime = videoPlayer.getCurrentTime();
      currentTime = currentTime * 1e3;
      if (currentTime >= totalVideoTime) {
        videoPlayer.seekTo(0);
        intervalRef.current = setTimeout(checkVideoPos, totalVideoTime);
      } else {
        const newTime = totalVideoTime - currentTime - OVERHEAD;
        intervalRef.current = setTimeout(checkVideoPos, newTime);
      }
    }
    const onReady = (event) => {
      videoPlayer = event.target;
      totalVideoTime = videoPlayer.getDuration() * 1e3 - RESTART_BEFORE;
      intervalRef.current = setTimeout(checkVideoPos, totalVideoTime);
    };
    const onEnd = () => {
      clearTimeout(intervalRef.current);
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(StyledYtb, {
      videoId,
      opts: BackgroundVideo_es_spreadProps(BackgroundVideo_es_spreadValues({}, getWidthHeightOfYtb()), {
        playerVars: {
          playlist: videoId,
          playsInLine: 1,
          mute: 1,
          controls: 0,
          allowFullScreen: 1,
          autoplay: 1
        }
      }),
      onReady,
      onEnd
    });
  };
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(Wrapper, {
    ref: wrapperRef,
    commonStyle: {
      defaultOverlay
    },
    children: renderVideo()
  });
};
const Wrapper = emotion_styled_browser_esm["default"].div(
  ({ commonStyle }) => `
  ${getStyle(commonStyle)}

  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
`
);
const StyledYtb = (0,emotion_styled_browser_esm["default"])(YouTube_esm/* default */.Z)`
  iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -2; // z-index of overlay: -1
  }
`;
const videoStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: "-2",
  objectFit: "fill"
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/constants/reset.es.js
var reset_es = __webpack_require__(69614);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/constants/fonts.es.js
var fonts_es = __webpack_require__(70516);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/constants/regex.es.js
const PATTERN_VALIDATION = {
  email: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
  phone: /^(0|84|\+84)[1-9]([0-9]{8,9})$/
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/constants/rc-cascader.es.js
var rc_cascader_es = __webpack_require__(67084);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/constants/animation.es.js
var animation_es = __webpack_require__(94345);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/contexts/StoreContext.es.js
var StoreContext_es = __webpack_require__(67141);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/hooks/useInjectLinksToHTML.es.js


var useInjectLinksToHTML_es_defProp = Object.defineProperty;
var useInjectLinksToHTML_es_defProps = Object.defineProperties;
var useInjectLinksToHTML_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var useInjectLinksToHTML_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var useInjectLinksToHTML_es_hasOwnProp = Object.prototype.hasOwnProperty;
var useInjectLinksToHTML_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var useInjectLinksToHTML_es_defNormalProp = (obj, key, value) => key in obj ? useInjectLinksToHTML_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var useInjectLinksToHTML_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (useInjectLinksToHTML_es_hasOwnProp.call(b, prop))
      useInjectLinksToHTML_es_defNormalProp(a, prop, b[prop]);
  if (useInjectLinksToHTML_es_getOwnPropSymbols)
    for (var prop of useInjectLinksToHTML_es_getOwnPropSymbols(b)) {
      if (useInjectLinksToHTML_es_propIsEnum.call(b, prop))
        useInjectLinksToHTML_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var useInjectLinksToHTML_es_spreadProps = (a, b) => useInjectLinksToHTML_es_defProps(a, useInjectLinksToHTML_es_getOwnPropDescs(b));
const useInjectLinksToHTML = (links, customDocument) => {
  (0,react.useEffect)(() => {
    if (!(links == null ? void 0 : links.length))
      return;
    const injectedDocument = customDocument || document;
    const mappingExistedLinks = [
      ...injectedDocument.getElementsByTagName("link")
    ].reduce((acc, cur) => useInjectLinksToHTML_es_spreadProps(useInjectLinksToHTML_es_spreadValues({}, acc), { [cur.href]: true }), {});
    links.forEach(({ type, rel, href }) => {
      if (!mappingExistedLinks[href]) {
        const link = injectedDocument.createElement("link");
        if (type)
          link.type = type;
        if (rel)
          link.rel = rel;
        link.href = href;
        injectedDocument.head.appendChild(link);
        mappingExistedLinks[href] = true;
      }
    });
  }, [customDocument]);
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/date-time.es.js
var date_time_es = __webpack_require__(78781);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/hooks/useTimer.es.js



const useTimer = (endAt) => {
  const [time, setTime] = (0,react.useState)(() => {
    return endAt ? (0,date_time_es/* calculateTimeDelta */.mE)(new Date(), endAt) : null;
  });
  (0,react.useEffect)(() => {
    const timer = setInterval(
      () => setTime((0,date_time_es/* calculateTimeDelta */.mE)(new Date(), endAt)),
      1e3
    );
    return () => {
      clearInterval(timer);
    };
  }, [endAt]);
  return time;
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/hooks/useTimeVisibility.es.js



const useTimeVisibility = (items, isEditingMode = false) => {
  const displayItems = (0,react.useMemo)(() => {
    return items == null ? void 0 : items.filter((item) => {
      return !isEditingMode ? (0,date_time_es/* validateIsVisibleComponent */.U0)((item == null ? void 0 : item.timeVisibility) || {}) : true;
    });
  }, [isEditingMode, items]);
  return {
    displayItems
  };
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/hooks/useInjectDynamicLinks.es.js


const useInjectDynamicLinks = (text) => {
  const { mappingWebsiteMenuHref } = (0,StoreContext_es/* useStore */.o)();
  const formatText = () => {
    if (!text)
      return;
    return text.replace(
      new RegExp('(?<start><a[^>]+data-page-id=)"(?<pageId>[a-zA-Z0-9]+)"(?<end>[^>]*>)', "g"),
      (string, start, pageId, end) => {
        const href = mappingWebsiteMenuHref[pageId];
        if (!href)
          return string;
        return `${start}"${pageId}" href="${href}"${end}`;
      }
    );
  };
  return {
    text: formatText()
  };
};



// EXTERNAL MODULE: ../../.yarn/cache/lodash.get-npm-4.4.2-7bda64ed87-e403047ddb.zip/node_modules/lodash.get/index.js
var lodash_get = __webpack_require__(47248);
var lodash_get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/hooks/useLocationChange.es.js


const useLocationChange = (callback, runWhenInit = false) => {
  (0,react.useEffect)(() => {
    if (runWhenInit) {
      callback();
    }
    const oldPushState = window.history.pushState;
    const oldReplaceState = window.history.replaceState;
    const dispatchEventLocationChange = () => {
      window.dispatchEvent(new Event("locationchange"));
    };
    (() => {
      window.history.pushState = function pushState(...args) {
        const ret = oldPushState.apply(this, args);
        dispatchEventLocationChange();
        return ret;
      };
      window.history.replaceState = function replaceState(...args) {
        const ret = oldReplaceState.apply(this, args);
        dispatchEventLocationChange();
        return ret;
      };
      window.addEventListener("popstate", dispatchEventLocationChange, false);
    })();
    window.addEventListener("locationchange", callback, false);
    return () => {
      window.removeEventListener("locationchange", callback, false);
      window.history.pushState = oldPushState;
      window.history.replaceState = oldReplaceState;
      window.removeEventListener(
        "popstate",
        dispatchEventLocationChange,
        false
      );
    };
  }, []);
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/computeStringHandleBarsExpression.es.js


const computeStringHandleBarsExpression = (str, inputs) => {
  const returnStr = str.replaceAll(/"{{([\w,.]*)}}"/g, (i) => {
    const value = lodash_get_default()(inputs, i.replace(/"{{/, "").replace(/}}"/, ""));
    return JSON.stringify(value);
  });
  return returnStr.replaceAll(/{{([\w,.]*)}}/g, (i) => {
    const value = lodash_get_default()(inputs, i.replace(/{{/, "").replace(/}}/, ""));
    return typeof value === "string" ? value : i;
  });
};
const getAllHandleBarsVariables = (str) => {
  return (str.match(/{{([\w,.]*)}}/g) || []).map(
    (el) => el.replace(/{{/, "").replace(/}}/, "")
  );
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/hooks/useEndpointHandler.es.js







var useEndpointHandler_es_defProp = Object.defineProperty;
var useEndpointHandler_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var useEndpointHandler_es_hasOwnProp = Object.prototype.hasOwnProperty;
var useEndpointHandler_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var useEndpointHandler_es_defNormalProp = (obj, key, value) => key in obj ? useEndpointHandler_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var useEndpointHandler_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (useEndpointHandler_es_hasOwnProp.call(b, prop))
      useEndpointHandler_es_defNormalProp(a, prop, b[prop]);
  if (useEndpointHandler_es_getOwnPropSymbols)
    for (var prop of useEndpointHandler_es_getOwnPropSymbols(b)) {
      if (useEndpointHandler_es_propIsEnum.call(b, prop))
        useEndpointHandler_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const useEndpointHandler = (endpointId) => {
  const [queryParams, setQueryParams] = (0,react.useState)();
  const [loading, setLoading] = (0,react.useState)(false);
  const [data, setData] = (0,react.useState)();
  const [error, setError] = (0,react.useState)();
  const {
    auth: { getAccessToken, user = {} } = {},
    globalData: { endpoints = [] } = {}
  } = (0,StoreContext_es/* useStore */.o)();
  const checkCanFetchData = (endpoint) => {
    const urlVars = getAllHandleBarsVariables(endpoint.url || "");
    const bodyVars = getAllHandleBarsVariables(endpoint.body || "");
    const headerVars = getAllHandleBarsVariables(endpoint.headers || "");
    return [...urlVars, ...bodyVars, ...headerVars].every((variable) => {
      const value = lodash_get_default()({ queryParams, user }, variable);
      return typeof value !== "undefined";
    });
  };
  const fetchData = async () => {
    const endpoint = endpoints.find((e) => e.id === endpointId);
    if (!endpoint || !checkCanFetchData(endpoint) || !queryParams)
      return;
    const api = new Api("");
    const url = computeStringHandleBarsExpression(endpoint.url, {
      queryParams,
      user
    });
    let body, headers = {};
    if (endpoint.method !== "GET" && endpoint.body) {
      try {
        body = JSON.parse(
          computeStringHandleBarsExpression(endpoint.body, {
            queryParams,
            user
          })
        );
      } catch (e) {
        console.error(e);
        body = {};
      }
    }
    if (endpoint.headers) {
      try {
        headers = JSON.parse(
          computeStringHandleBarsExpression(endpoint.headers, {
            queryParams,
            user
          })
        );
      } catch (e) {
        console.error(e);
        headers = {};
      }
    }
    const accessToken = getAccessToken == null ? void 0 : getAccessToken();
    try {
      setLoading(true);
      const res = await api.request(url, body, endpoint.method, {
        headers: useEndpointHandler_es_spreadValues(useEndpointHandler_es_spreadValues({}, headers), accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
      });
      setError(void 0);
      setData(res.data);
    } catch (e) {
      setError(e);
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  useLocationChange(() => {
    const search = window.location.search;
    setQueryParams(Object.fromEntries(new URLSearchParams(search)));
  }, true);
  (0,react.useEffect)(() => {
    const revalidateDataOnFocus = () => {
      if (document.visibilityState === "visible") {
        fetchData();
      }
    };
    fetchData();
    document.addEventListener("visibilitychange", revalidateDataOnFocus);
    return () => {
      document.removeEventListener("visibilitychange", revalidateDataOnFocus);
    };
  }, [endpointId, JSON.stringify(endpoints), JSON.stringify(queryParams)]);
  return {
    result: data,
    loading: data == void 0 && loading,
    error,
    queryParams
  };
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/types/common.es.js
var common_es = __webpack_require__(54627);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/buildSrcsetDPR.es.js



const buildSrcsetDPR = (imageUrl, absolutedWidth) => {
  if (!imageUrl)
    return "";
  if (!imageUrl.startsWith("https://lh3.googleusercontent.com/"))
    return imageUrl;
  return Array.from({ length: MAX_DPR }, (_, i) => i + 1).map(
    (dpr) => `${constructGoogleImageParams(imageUrl, {
      width: absolutedWidth * dpr,
      format: "webp"
    })} ${dpr}x`
  ).join(", ");
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/utils/render.es.js
var utils_render_es = __webpack_require__(45710);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-feb15f89f5/0/cache/@tempi-core-renderer-npm-1.0.22-2ce0eea0c1-05a6727b94.zip/node_modules/@tempi/core-renderer/dist/index.es.js















































/***/ }),

/***/ 21108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ BuilderComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77084);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70403);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75537);
/* harmony import */ var _contexts_StoreContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67141);
/* harmony import */ var _constants_reset_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69614);
/* harmony import */ var _constants_rc_cascader_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67084);
/* harmony import */ var _constants_animation_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94345);
/* harmony import */ var _utils_date_time_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78781);










var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const BuilderComponent = (props) => {
  const {
    content,
    configs,
    ssrData = {},
    mappingDynamicSlots,
    rootId = "ROOT",
    componentDict,
    addGlobalStyle = true
  } = props;
  const renderComponent = (id, apiResponse, restProps, ssrData2) => {
    const compData = apiResponse[id];
    const { tag, startTime, endTime, ruleRepeat, date, duration } = compData;
    const Comp = componentDict[tag];
    if (!Comp) {
      console.warn("Cannot found component: " + tag.toString());
      return null;
    }
    const props2 = __spreadValues(__spreadProps(__spreadValues({}, compData.customAttributes[tag] || {}), {
      commonStyle: compData.style || {},
      id: compData.elementId,
      "data-id": compData.elementId,
      "data-uniq-id": compData.id
    }), restProps);
    const getClassName = () => {
      var _a, _b;
      return (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])({
        "hidden-xs": (_a = props2 == null ? void 0 : props2.responsive) == null ? void 0 : _a.hiddenXs,
        "hidden-md": (_b = props2 == null ? void 0 : props2.responsive) == null ? void 0 : _b.hiddenMd
      });
    };
    const isVisible = (0,_utils_date_time_es_js__WEBPACK_IMPORTED_MODULE_2__/* .validateIsVisibleComponent */ .U0)({
      startTime,
      endTime,
      ruleRepeat,
      date,
      duration
    });
    if (!isVisible)
      return null;
    if (compData.children.length) {
      const currentSSRData2 = ssrData2[compData.id];
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, __spreadProps(__spreadValues({
        className: getClassName()
      }, props2), {
        ssrData: currentSSRData2,
        children: compData.children.map(
          (childId) => renderComponent(childId, apiResponse, restProps, ssrData2)
        )
      }), compData.id);
    }
    const currentSSRData = ssrData2[compData.id];
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, __spreadProps(__spreadValues({
      className: getClassName()
    }, props2), {
      ssrData: currentSSRData
    }), compData.id);
  };
  if (!(content == null ? void 0 : content[rootId]))
    return null;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_StoreContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .StoreProvider */ .g, __spreadProps(__spreadValues({
    mappingDynamicSlots
  }, configs), {
    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      children: [
        addGlobalStyle && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
          children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .LandingLinks */ .d1, {}),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_5__.Global, {
              styles: _constants_reset_es_js__WEBPACK_IMPORTED_MODULE_6__/* .reset */ .m
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_5__.Global, {
              styles: _constants_rc_cascader_es_js__WEBPACK_IMPORTED_MODULE_7__/* .rcCascaderCss */ .J
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_5__.Global, {
              styles: _constants_animation_es_js__WEBPACK_IMPORTED_MODULE_8__/* .animationCss */ .W
            })
          ]
        }),
        renderComponent(rootId, content, configs, ssrData)
      ]
    })
  }));
};




/***/ }),

/***/ 54627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ew": function() { return /* binding */ RuleRepeatEnum; },
/* harmony export */   "Ql": function() { return /* binding */ UnitRepeatEnum; },
/* harmony export */   "gj": function() { return /* binding */ RepeatTypeEnum; }
/* harmony export */ });
var RepeatTypeEnum = /* @__PURE__ */ ((RepeatTypeEnum2) => {
  RepeatTypeEnum2["DAILY"] = "DAILY";
  RepeatTypeEnum2["DAY_IN_WEEK"] = "DAY_IN_WEEK";
  RepeatTypeEnum2["CUSTOM"] = "CUSTOM";
  RepeatTypeEnum2["NO_REPEAT"] = "NO_REPEAT";
  return RepeatTypeEnum2;
})(RepeatTypeEnum || {});
var UnitRepeatEnum = /* @__PURE__ */ ((UnitRepeatEnum2) => {
  UnitRepeatEnum2["DAY"] = "DAILY";
  UnitRepeatEnum2["WEEK"] = "WEEKLY";
  UnitRepeatEnum2["MONTH"] = "MONTH";
  UnitRepeatEnum2["YEAR"] = "YEAR";
  UnitRepeatEnum2["DURATION"] = "DURATION";
  return UnitRepeatEnum2;
})(UnitRepeatEnum || {});
var RuleRepeatEnum = /* @__PURE__ */ ((RuleRepeatEnum2) => {
  RuleRepeatEnum2["FREQ"] = "FREQ";
  RuleRepeatEnum2["INTERVAL"] = "INTERVAL";
  RuleRepeatEnum2["BYDAY"] = "BYDAY";
  RuleRepeatEnum2["UNTIL"] = "UNTIL";
  return RuleRepeatEnum2;
})(RuleRepeatEnum || {});




/***/ }),

/***/ 78781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U0": function() { return /* binding */ validateIsVisibleComponent; },
/* harmony export */   "gV": function() { return /* binding */ parseRuleRepeat; },
/* harmony export */   "mE": function() { return /* binding */ calculateTimeDelta; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87268);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _types_common_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54627);



const formatDate = (date) => {
  if (!date)
    return void 0;
  return new Date(date).toISOString();
};
const parseRuleRepeat = (field, ruleRepeat) => {
  var _a;
  const regex = new RegExp(`(${field}:)[^;]+(?=;)`, "g");
  const result = ruleRepeat.match(regex);
  return (result == null ? void 0 : result.length) > 0 ? (_a = result[0]) == null ? void 0 : _a.replaceAll(`${field}:`, "") : void 0;
};
const validateIsVisibleComponent = ({
  startTime,
  endTime,
  ruleRepeat,
  date,
  duration
}) => {
  var _a;
  const now = new Date().toISOString();
  const formattedStartTime = formatDate(startTime);
  const formattedEndTime = formatDate(endTime);
  if (formattedStartTime && now < formattedStartTime) {
    return false;
  }
  if (formattedEndTime && now >= formattedEndTime) {
    return false;
  }
  if (ruleRepeat) {
    const interval = parseRuleRepeat(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.INTERVAL */ .Ew.INTERVAL, ruleRepeat) ? parseInt(parseRuleRepeat(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.INTERVAL */ .Ew.INTERVAL, ruleRepeat)) : 1;
    const freq = parseRuleRepeat(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.FREQ */ .Ew.FREQ, ruleRepeat);
    const until = parseRuleRepeat(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.UNTIL */ .Ew.UNTIL, ruleRepeat);
    const byDay = parseRuleRepeat(_types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .RuleRepeatEnum.BYDAY */ .Ew.BYDAY, ruleRepeat);
    if (date && now < dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).hour(0).minute(0).second(0).toISOString())
      return false;
    if (until && now > formatDate(until))
      return false;
    let isDateVisible = true;
    const isValidTime = (unit) => {
      if (interval === 1 && (unit === "day" || unit === "week"))
        return true;
      const dateDiff = date ? dayjs__WEBPACK_IMPORTED_MODULE_0___default()(now).diff(date, unit) : -1;
      return dateDiff >= 0 && dateDiff % interval === 0;
    };
    switch (freq) {
      case _types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .UnitRepeatEnum.DAY */ .Ql.DAY:
        isDateVisible = isValidTime("day");
        break;
      case _types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .UnitRepeatEnum.WEEK */ .Ql.WEEK:
        isDateVisible = isValidTime("week") && ((_a = byDay == null ? void 0 : byDay.split(",")) == null ? void 0 : _a.includes(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(now).day().toString()));
        break;
      case _types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .UnitRepeatEnum.MONTH */ .Ql.MONTH:
        isDateVisible = isValidTime("month") && dayjs__WEBPACK_IMPORTED_MODULE_0___default()(now).get("date") === dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).get("date");
        break;
      case _types_common_es_js__WEBPACK_IMPORTED_MODULE_1__/* .UnitRepeatEnum.YEAR */ .Ql.YEAR:
        isDateVisible = isValidTime("year") && dayjs__WEBPACK_IMPORTED_MODULE_0___default()(now).get("date") === dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).get("date") && dayjs__WEBPACK_IMPORTED_MODULE_0___default()(now).get("month") === dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).get("month");
        break;
    }
    if (!isDateVisible)
      return false;
    if (duration && (duration[0] && dayjs__WEBPACK_IMPORTED_MODULE_0___default()(now).hour() * 60 + dayjs__WEBPACK_IMPORTED_MODULE_0___default()(now).minute() < duration[0] || duration[1] && dayjs__WEBPACK_IMPORTED_MODULE_0___default()(now).hour() * 60 + dayjs__WEBPACK_IMPORTED_MODULE_0___default()(now).minute() >= duration[1]))
      return false;
  }
  return true;
};
const calculateTimeDelta = (startTime, endTime) => {
  const fromTimestamp = startTime.getTime();
  const endTimestamp = endTime.getTime();
  const durationInSecond = Math.max(
    0,
    Math.round((endTimestamp - fromTimestamp) / 1e3)
  );
  return {
    durationInSecond,
    days: Math.floor(durationInSecond / (3600 * 24)),
    hours: Math.floor(durationInSecond / 3600 % 24),
    minutes: Math.floor(durationInSecond / 60 % 60),
    seconds: Math.floor(durationInSecond % 60)
  };
};




/***/ }),

/***/ 45710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O5": function() { return /* binding */ getTrackingData; },
/* harmony export */   "Oq": function() { return /* binding */ buildComponentDict; },
/* harmony export */   "d0": function() { return /* binding */ getTargetOfTrackingFromEvent; },
/* harmony export */   "vv": function() { return /* binding */ getPropsByDevice; }
/* harmony export */ });
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15477);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getTrackingData = ({
  isTrackContent,
  contentName,
  index,
  regionName,
  target,
  payload
}) => {
  return __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, regionName && { "data-content-region-name": regionName }), isTrackContent && { "data-track-content": true }), contentName && { "data-content-name": contentName }), (index || index === 0) && { "data-content-index": index }), target && { "data-content-target": target }), payload && { "data-content-payload": payload });
};
const getPropsByDevice = (props, device = "desktop") => {
  const _a = props, { syncDeviceStyle, desktop, mobile, commonStyle } = _a, rest = __objRest(_a, ["syncDeviceStyle", "desktop", "mobile", "commonStyle"]);
  const _b = commonStyle || {}, {
    desktop: desktopStyle,
    mobile: mobileStyle
  } = _b, restStyle = __objRest(_b, [
    "desktop",
    "mobile"
  ]);
  if (device === "mobile") {
    const inheritDesktopProps = syncDeviceStyle === void 0;
    const newCommonStyle2 = lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(
      {},
      restStyle,
      inheritDesktopProps ? desktopStyle : {},
      mobileStyle
    );
    return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(
      { commonStyle: newCommonStyle2 },
      rest,
      inheritDesktopProps ? desktop : {},
      mobile
    );
  }
  const newCommonStyle = lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(
    {},
    restStyle,
    desktopStyle
  );
  return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(
    { commonStyle: newCommonStyle },
    rest,
    desktop
  );
};
const getTargetOfTrackingFromEvent = (event) => {
  var _a;
  const key = event == null ? void 0 : event.eventType;
  switch (key) {
    case "openPageOfWebsite":
    case "link":
    case "internal":
      return (_a = event[key]) == null ? void 0 : _a.href;
    case "email":
    case "phone":
    case "inPage":
      return event[key];
    case "openPopup":
    case "closePopup":
      return event.togglePopup;
    default:
      return void 0;
  }
};
const buildComponentDict = (objComponent) => {
  const components = Object.values(objComponent);
  return components.reduce((acc, cur) => {
    const name = cur.displayName || cur.name;
    const key = name.toLowerCase();
    return __spreadProps(__spreadValues({}, acc), { [key]: cur });
  }, {});
};




/***/ }),

/***/ 14529:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);
var coreRenderer = __webpack_require__(12060);
var Container = __webpack_require__(61703);
var renderDynamicSlot = __webpack_require__(64915);
var EmptyProduct = __webpack_require__(36838);
var grid = __webpack_require__(29297);
var getStyles = __webpack_require__(82016);
var BlockHeader = __webpack_require__(59941);
var renderLink = __webpack_require__(45292);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CarouselSkuList = (_a) => {
  var _b = _a, {
    isEditingMode = false,
    ssrData
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData"
  ]);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    collectionSlug,
    viewMoreUrl,
    title,
    commonStyle,
    titleStyle,
    viewMoreStyle
  } = _a2, rest = __objRest(_a2, [
    "collectionSlug",
    "viewMoreUrl",
    "title",
    "commonStyle",
    "titleStyle",
    "viewMoreStyle"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const renderViewAllLink = () => {
    if (!viewMoreUrl)
      return null;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(viewMoreUrl, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({
      commonStyle: __spreadValues({ backgroundSize: "cover" }, restStyle)
    }, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: `${title}HorizontalBlock`
    })), {
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsxs(Header, {
          device,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(Label, {
              commonStyle: titleStyle,
              children: title
            }),
            renderViewAllLink()
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx(ProductListWrapper, {
          children: collectionSlug || isEditingMode ? renderDynamicSlot.renderDynamicSlot(
            `product_carousel_${device}`,
            mappingDynamicSlots,
            ssrData,
            {
              collectionSlug
            }
          ) : /* @__PURE__ */ jsxRuntime.jsx(EmptyProduct.EmptyProduct, {})
        })
      ]
    }))
  }));
};
CarouselSkuList.displayName = "Omni_ProductSlider";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${getStyles.getStyle(commonStyle)}
`
);
const Header = styled__default["default"](BlockHeader.BlockHeader)(
  `
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  color: #ffffff;
`
);
const Label = styled__default["default"].div(
  ({ commonStyle }) => `
    flex: 1;
    margin-right: 8px;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;

    ${getStyles.getStyle(commonStyle)}
  `
);
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
    display: flex;
    align-items: center;
    ${getStyles.getStyle(commonStyle)}
  `
);
const ProductListWrapper = styled__default["default"].div`
  padding: 1rem;
`;

exports.CarouselSkuList = CarouselSkuList;


/***/ }),

/***/ 80228:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var MenuItems = __webpack_require__(80320);
var Container = __webpack_require__(61703);
var BlockHeader = __webpack_require__(59941);
var grid = __webpack_require__(29297);
var getStyles = __webpack_require__(82016);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CategoryMenu = (_a) => {
  var _b = _a, {
    isEditingMode
  } = _b, restProps = __objRest(_b, [
    "isEditingMode"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), { commonStyle, title, titleStyle, altStyle, items } = _a2, rest = __objRest(_a2, ["commonStyle", "title", "titleStyle", "altStyle", "items"]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const isDesktop = device === "desktop";
  const getSlidesPerView = () => {
    const numberOfItem = items == null ? void 0 : items.length;
    if (isDesktop) {
      return numberOfItem <= 10 ? numberOfItem : 9.5;
    }
    if (numberOfItem <= 5)
      return numberOfItem;
    return numberOfItem <= 10 ? 5 : 4.5;
  };
  const getMenuItemsStyle = () => {
    if (isDesktop) {
      return {
        slidesPerView: getSlidesPerView(),
        slidesPerGroup: 1,
        categoryMenuItems: items,
        imageSize: { height: 56, width: 56 },
        isEditingMode,
        altStyle,
        style: {
          padding: "24px 0",
          margin: "0 16px"
        }
      };
    }
    return {
      slidesPerView: getSlidesPerView(),
      slidesPerGroup: 1,
      slidesPerColumn: (items == null ? void 0 : items.length) <= 5 ? 1 : 2,
      categoryMenuItems: items,
      imageSize: { height: 42, width: 42 },
      isEditingMode,
      altStyle,
      style: {
        padding: "12px 0",
        margin: "0 16px"
      }
    };
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: {
      maxWidth: grid.DEFAULT_MAX_WIDTH,
      padding,
      margin
    }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
            commonStyle: titleStyle,
            children: title
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(MenuItems.MenuItems, __spreadValues({}, getMenuItemsStyle()))
      ]
    })
  }));
};
CategoryMenu.displayName = "Omni_BlockMenu";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${getStyles.getStyle(commonStyle)}
`
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 700;
  font-size: 20px;
  ${getStyles.getStyle(commonStyle)}; 
`
);

exports.CategoryMenu = CategoryMenu;


/***/ }),

/***/ 80320:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var Slider = __webpack_require__(29062);
var renderLink = __webpack_require__(45292);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const MenuItems = (_a) => {
  var _b = _a, {
    categoryMenuItems = [],
    imageSize,
    isEditingMode = false,
    altStyle
  } = _b, sliderProps = __objRest(_b, [
    "categoryMenuItems",
    "imageSize",
    "isEditingMode",
    "altStyle"
  ]);
  const { displayItems } = coreRenderer.useTimeVisibility(categoryMenuItems, isEditingMode);
  const renderMenuItem = (item) => {
    const { src, alt, googleImageParams, event } = item;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
          commonStyle: {
            height: imageSize.height,
            width: imageSize.width,
            objectFit: "cover",
            marginLeft: "auto",
            marginRight: "auto"
          },
          src: src || defaultImage,
          alt,
          googleImageParams
        }),
        /* @__PURE__ */ jsxRuntime.jsx(StyledSubTitle, {
          commonStyle: altStyle,
          children: alt
        })
      ]
    });
    return renderLink.renderLink(event, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, __spreadProps(__spreadValues({
    allowTouchMove: !isEditingMode
  }, sliderProps), {
    children: displayItems == null ? void 0 : displayItems.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: "categoryList",
      contentName: item.alt,
      target: coreRenderer.getTargetOfTrackingFromEvent(item == null ? void 0 : item.event),
      index
    })), {
      children: renderMenuItem(item)
    }), index))
  }));
};
const StyledSubTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-align: center;
  word-wrap: break-word;
  /* Mobile */
  @media only screen and (max-width: 460px) {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 4px;
  }

  ${coreRenderer.getStyle(commonStyle)}
`
);

exports.MenuItems = MenuItems;


/***/ }),

/***/ 87981:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const bannerTemplate = [
  {
    bannerPerView: 1,
    width: 1200,
    height: 108,
    label: "M\xF4\u0323t banner (1200x108)"
  },
  {
    bannerPerView: 2,
    width: 594,
    height: 108,
    label: "Hai banner (594x108)"
  },
  {
    bannerPerView: 3,
    width: 392,
    height: 108,
    label: "Ba banner (392x108)"
  }
];

exports.bannerTemplate = bannerTemplate;


/***/ }),

/***/ 28785:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var addPaddingNumber = __webpack_require__(27440);
var Countdown = __webpack_require__(58361);
var Row = __webpack_require__(83042);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const BlockCountdown = ({ endTime, isMobile }) => {
  const timer = coreRenderer.useTimer(new Date(endTime || ""));
  if (!endTime) {
    return null;
  }
  const digitStyle = {
    width: isMobile ? "1.5rem" : "2.2rem",
    height: isMobile ? "1.5rem" : "2.2rem",
    fontSize: isMobile ? "12px" : "1rem",
    fontWeight: "bold",
    textAlign: "center",
    alignItems: "center",
    lineHeight: isMobile ? "1.5rem" : "2.2rem",
    color: "white",
    background: "linear-gradient(rgb(74, 74, 74),rgb(35, 34, 34))",
    borderRadius: 5
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(CountdownWrapper, {
    isMobile,
    children: [
      "K\u1EBFt th\xFAc sau",
      !!(timer == null ? void 0 : timer.days) ? /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(RemainingDay, {
            style: digitStyle,
            children: addPaddingNumber.addPaddingNumber(timer.days)
          }),
          " ",
          "Nga\u0300y"
        ]
      }) : /* @__PURE__ */ jsxRuntime.jsx(Countdown.Countdown, {
        due: endTime,
        showDays: false,
        showLabel: false,
        showHours: true,
        showMinutes: true,
        showSeconds: true,
        countdownType: "due",
        splitTimeUnit: /* @__PURE__ */ jsxRuntime.jsx(Row.Row, {
          align: "middle",
          children: ":"
        }),
        countdownStyle: {
          elementGap: 4,
          align: coreRenderer.Alignment.center,
          digitStyle
        }
      })
    ]
  });
};
const CountdownWrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  color: white;
  column-gap: 0.5rem;
  font-size: ${({ isMobile }) => isMobile ? "13px" : "18px"};
  font-weight: 500;
`;
const RemainingDay = styled__default["default"].div`
  font-size: 1rem;
  color: white;
  text-align: center;
`;

exports.BlockCountdown = BlockCountdown;


/***/ }),

/***/ 68501:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var icons = __webpack_require__(94556);
var Countdown = __webpack_require__(28785);
var useTabs = __webpack_require__(8917);
var renderLink = __webpack_require__(45292);
var banner = __webpack_require__(87981);
var renderDynamicSlot = __webpack_require__(64915);
var EmptyProduct = __webpack_require__(36838);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CountdownSkuListDesktop = (_a) => {
  var _b = _a, {
    tabs,
    commonStyle,
    isEditingMode,
    activeTabStyle,
    ssrData,
    viewMoreStyle,
    titleStyle
  } = _b, props = __objRest(_b, [
    "tabs",
    "commonStyle",
    "isEditingMode",
    "activeTabStyle",
    "ssrData",
    "viewMoreStyle",
    "titleStyle"
  ]);
  var _a2, _b2;
  const { displayItem, validItems, setActiveTab, activeTab } = useTabs.useTabs(
    tabs,
    isEditingMode
  );
  const { mappingDynamicSlots } = coreRenderer.useStore();
  const { id, viewMoreUrl, timeVisibility, collectionSlug, banners } = displayItem || {};
  const blockCountdownEndTime = timeVisibility == null ? void 0 : timeVisibility.endTime;
  const viewMoreContent = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
    viewMoreStyle,
    children: [
      "Xem t\u1EA5t c\u1EA3 ",
      /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
        name: "RightOutlined",
        style: { fontSize: 18 }
      })
    ]
  });
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({}, props), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(TabHeaderWapper, {
        children: validItems.slice(0, 6).map((tab, index) => {
          return /* @__PURE__ */ jsxRuntime.jsxs(TabItem, {
            active: tab.id === activeTab,
            commonStyle,
            activeTabStyle,
            titleStyle,
            onClick: () => setActiveTab(tab.id),
            children: [
              /* @__PURE__ */ jsxRuntime.jsx("div", {
                className: "tab-title inline",
                children: tab.title
              }),
              /* @__PURE__ */ jsxRuntime.jsxs("div", {
                className: "tab-description inline",
                children: [
                  " ",
                  tab.description
                ]
              })
            ]
          }, index);
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(TabContentWrapper, {
        commonStyle,
        children: [
          (commonStyle == null ? void 0 : commonStyle.backgroundImage) && /* @__PURE__ */ jsxRuntime.jsx(BackgroundImage, {
            src: commonStyle.backgroundImage
          }),
          /* @__PURE__ */ jsxRuntime.jsxs(TabContent, {
            children: [
              /* @__PURE__ */ jsxRuntime.jsxs(StyledRow, {
                justify: !!blockCountdownEndTime ? "space-between" : "flex-end",
                children: [
                  !!blockCountdownEndTime && /* @__PURE__ */ jsxRuntime.jsx(Countdown.BlockCountdown, {
                    endTime: blockCountdownEndTime
                  }),
                  viewMoreUrl ? renderLink.renderLink(viewMoreUrl, viewMoreContent, isEditingMode) : null
                ]
              }),
              !!((_a2 = banners == null ? void 0 : banners.desktop) == null ? void 0 : _a2.length) && !!(banners == null ? void 0 : banners.bannerPerView) && /* @__PURE__ */ jsxRuntime.jsx(TabBanner, {
                children: (_b2 = [...Array(banners == null ? void 0 : banners.bannerPerView).fill(null)]) == null ? void 0 : _b2.map(
                  (_, index) => {
                    var _a3;
                    const banner$1 = (_a3 = banners == null ? void 0 : banners.desktop) == null ? void 0 : _a3[index];
                    const template = banner.bannerTemplate.find(
                      (tem) => tem.bannerPerView === ((banners == null ? void 0 : banners.bannerPerView) || 1)
                    );
                    return (banner$1 == null ? void 0 : banner$1.src) ? /* @__PURE__ */ jsxRuntime.jsx(Banner, {
                      src: banner$1.src,
                      ratio: `${template.width}/${template.height}`
                    }, index) : /* @__PURE__ */ jsxRuntime.jsx("div", {
                      style: { flex: 1 }
                    }, index);
                  }
                )
              }),
              /* @__PURE__ */ jsxRuntime.jsx(ProductListWrapper, {
                style: { minHeight: 300 },
                children: collectionSlug || isEditingMode ? renderDynamicSlot.renderDynamicSlot(
                  "product_carousel_desktop",
                  mappingDynamicSlots,
                  validItems.findIndex((el) => el.id === activeTab) === 0 ? ssrData : void 0,
                  {
                    collectionSlug,
                    config: {
                      regionName: "hotDeal"
                    }
                  }
                ) : /* @__PURE__ */ jsxRuntime.jsx(EmptyProduct.EmptyProduct, {})
              }, activeTab)
            ]
          }, id)
        ]
      })
    ]
  }));
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
  position: relative;
  overflow: hidden;
  width: 100%;
  border-radius: 8px;
`
);
const TabHeaderWapper = styled__default["default"].div`
  display: flex;
  wrap: no-wrap;
  background-color: #fff;
  padding: 0.5rem 0 0 0;
`;
const TabContent = styled__default["default"].div`
  padding: 1rem;
  position: relative;
`;
const TabItem = styled__default["default"].div`
  /* title max length =  */
  color: ${({ commonStyle, active, titleStyle }) => active ? "#fff" : (titleStyle == null ? void 0 : titleStyle.color) || (commonStyle == null ? void 0 : commonStyle.color) || "gray"};
  background-color: ${({ active, commonStyle, activeTabStyle }) => active ? (activeTabStyle == null ? void 0 : activeTabStyle.backgroundColor) || (commonStyle == null ? void 0 : commonStyle.backgroundColor) || "gray" : "#fff"};
  flex: 1 1 0%;
  text-align: center;
  padding: 0.5rem 0.5rem 0.75rem 0.5rem;
  border-radius: 8px 8px 0 0;
  max-width: 50%;
  cursor: pointer;
  .inline {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    max-width: 100%;
  }
  .tab-title {
    font-size: 13px;
    font-weight: 550;
    line-height: 20px;
    margin-bottom: 2px;
  }
  .tab-description {
    font-size: 10px;
    color: ${({ commonStyle, active }) => active ? "#fff" : (commonStyle == null ? void 0 : commonStyle.color) || "gray"};
  }
`;
const ViewMore = styled__default["default"].a(
  ({ viewMoreStyle }) => `
  color: ${(viewMoreStyle == null ? void 0 : viewMoreStyle.color) || "#fff"}!important;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  :hover {
    color: #fff;
  }
  text-decoration: none;
`
);
const StyledRow = styled__default["default"].div`
  display: flex;
  justify-content: ${({ justify }) => justify || "flex-end"};
  align-items: center;
  padding: 0 !important;
  margin: 0 !important;
  min-height: 36px;
  flex-wrap: nowrap;
`;
const TabBanner = styled__default["default"].div`
  display: flex;
  column-gap: 1rem;
  flex-wrap: nowrap;
  margin-top: 1rem;
  min-height: 108px;
`;
const Banner = styled__default["default"].img`
  border-radius: 4px;
  flex: 1 1 0%;
  overflow: hidden;
  object-fit: cover;
  width: 100%;
  object-position: top;
  aspect-ratio: ${({ ratio }) => ratio};
`;
const ProductListWrapper = styled__default["default"].div`
  margin-top: 1rem;
`;
const BackgroundImage = styled__default["default"].img`
  position: absolute;
  width: 100%;
  object-fit: cover;
`;
const TabContentWrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
  background-color: ${({ commonStyle: commonStyle2 }) => (commonStyle2 == null ? void 0 : commonStyle2.backgroundColor) || "gray"};
  position: relative;
`
);

exports.CountdownSkuListDesktop = CountdownSkuListDesktop;


/***/ }),

/***/ 77594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var icons = __webpack_require__(94556);
var useTabs = __webpack_require__(8917);
var Countdown = __webpack_require__(28785);
var Slider = __webpack_require__(29062);
var renderDynamicSlot = __webpack_require__(64915);
var EmptyProduct = __webpack_require__(36838);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CountdownSkuListMobile = (_a) => {
  var _b = _a, {
    tabs,
    isEditingMode,
    commonStyle,
    activeTabStyle,
    viewMoreStyle,
    ssrData,
    titleStyle
  } = _b, props = __objRest(_b, [
    "tabs",
    "isEditingMode",
    "commonStyle",
    "activeTabStyle",
    "viewMoreStyle",
    "ssrData",
    "titleStyle"
  ]);
  var _a2, _b2, _c, _d, _e, _f, _g;
  const { validItems, activeTab, setActiveTab, displayItem } = useTabs.useTabs(
    tabs || [],
    isEditingMode
  );
  const { mappingDynamicSlots } = coreRenderer.useStore();
  const blockCountdownEndTime = (_a2 = displayItem == null ? void 0 : displayItem.timeVisibility) == null ? void 0 : _a2.endTime;
  const onClickTabId = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    }
    setActiveTab(id);
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({}, props), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(BlockHeader, {
        children: /* @__PURE__ */ jsxRuntime.jsx(TabHeaderWapper, {
          children: validItems.map((tab) => {
            return /* @__PURE__ */ jsxRuntime.jsxs(TabItem, {
              id: tab.id,
              active: tab.id === activeTab,
              commonStyle,
              activeTabStyle,
              titleStyle,
              onClick: () => onClickTabId(tab.id),
              children: [
                /* @__PURE__ */ jsxRuntime.jsx("div", {
                  className: "tab-title-wrapper",
                  children: /* @__PURE__ */ jsxRuntime.jsx("div", {
                    className: "tab-title inline",
                    children: tab.title
                  })
                }),
                /* @__PURE__ */ jsxRuntime.jsxs("div", {
                  className: "tab-description inline",
                  children: [
                    " ",
                    tab.description
                  ]
                })
              ]
            }, tab.id);
          })
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(BlockContainer, {
        commonStyle,
        children: [
          /* @__PURE__ */ jsxRuntime.jsxs(StyledRow, {
            justify: !!blockCountdownEndTime ? "space-between" : "end",
            children: [
              !!blockCountdownEndTime && /* @__PURE__ */ jsxRuntime.jsx(Countdown.BlockCountdown, {
                isMobile: true,
                endTime: blockCountdownEndTime
              }),
              /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
                href: displayItem.viewMoreUrl,
                target: "_self",
                viewMoreStyle,
                children: [
                  "Xem t\xE2\u0301t ca\u0309",
                  /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                    name: "RightOutlined",
                    style: { fontSize: 18 }
                  })
                ]
              })
            ]
          }),
          ((_c = (_b2 = displayItem.banners) == null ? void 0 : _b2.mobile) == null ? void 0 : _c.length) && /* @__PURE__ */ jsxRuntime.jsx(SliderWrapper, {
            children: ((_e = (_d = displayItem.banners) == null ? void 0 : _d.mobile) == null ? void 0 : _e.length) === 1 ? /* @__PURE__ */ jsxRuntime.jsx(Banner, {
              src: (_f = displayItem.banners) == null ? void 0 : _f.mobile[0].src,
              ratio: `359/108`
            }) : /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, {
              spaceBetween: 8,
              loop: true,
              allowTouchMove: !isEditingMode,
              autoplay: true,
              children: (_g = displayItem.banners) == null ? void 0 : _g.mobile.map((banner, index) => /* @__PURE__ */ jsxRuntime.jsx(Banner, {
                src: banner.src,
                ratio: `359/108`
              }, index))
            })
          }),
          /* @__PURE__ */ jsxRuntime.jsx(ProductListWrapper, {
            style: { minHeight: 250 },
            children: displayItem.collectionSlug || isEditingMode ? renderDynamicSlot.renderDynamicSlot(
              "product_carousel_desktop",
              mappingDynamicSlots,
              validItems.findIndex((el) => el.id === activeTab) === 0 ? ssrData : void 0,
              {
                collectionSlug: displayItem.collectionSlug,
                config: {
                  regionName: "hotDeal"
                }
              }
            ) : /* @__PURE__ */ jsxRuntime.jsx(EmptyProduct.EmptyProduct, {})
          }, activeTab)
        ]
      }, activeTab)
    ]
  }));
};
const Wrapper = styled__default["default"].div`
  position: relative;
  width: 100%;
  padding-top: 40px;
`;
const TabHeaderWapper = styled__default["default"].div`
  display: flex;
  wrap: nowrap;
  padding: 0 0.5rem;
  column-gap: 6px;
  user-select: none;
`;
const TabItem = styled__default["default"].div`
  cursor: pointer;
  color: ${({ commonStyle, active, titleStyle }) => active ? "#fff" : (titleStyle == null ? void 0 : titleStyle.color) || (commonStyle == null ? void 0 : commonStyle.color) || "gray"};
  background-color: ${({ active, commonStyle, activeTabStyle }) => active ? (activeTabStyle == null ? void 0 : activeTabStyle.backgroundColor) || (commonStyle == null ? void 0 : commonStyle.backgroundColor) || "gray" : "#fff"};
  padding: 0.5rem;
  justify-content: center;
  height: 80px;
  min-width: 96px;
  max-width: 110px;
  flex: 1;
  border-radius: 8px;
  border: 1px solid ${({ active }) => active ? "#fff" : "#E4E5F0"};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .inline {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    max-width: 100%;
  }
  .tab-title {
    font-size: 13px;
    font-weight: 550;
    line-height: 20px;
    margin-bottom: 2px;
    -webkit-line-clamp: 2;
    text-align: center;
  }
  .tab-description {
    font-size: 10px;
    -webkit-line-clamp: 1;
    text-align: center;
  }
  .tab-title-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
  }
`;
const BlockHeader = styled__default["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow-x: auto;
  /* hide scrollbar*/
  ::-webkit-scrollbar {
    display: none;
  }
`;
const BlockContainer = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
  padding: 1rem 0.5rem;
  padding-top: 48px;
`
);
const StyledRow = styled__default["default"].div`
  display: flex;
  justify-content: ${({ justify }) => justify || "flex-end"};
  align-items: center;
  padding: 0 !important;
  margin: 0 !important;
  min-height: 36px;
  flex-wrap: nowrap !important;
`;
const ViewMore = styled__default["default"].a(
  ({ viewMoreStyle }) => `
  color: ${(viewMoreStyle == null ? void 0 : viewMoreStyle.color) || "#fff"}!important;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  :hover {
    color: #fff;
  }
  text-decoration: none;
`
);
const Banner = styled__default["default"].img`
  border-radius: 4px;
  flex: 1 1 0%;
  overflow: hidden;
  object-fit: cover;
  object-position: top;
  width: 100%;
  aspect-ratio: ${({ ratio }) => ratio};
`;
const SliderWrapper = styled__default["default"].div`
  border-radius: 4px;
  overflow: hidden;
  margin-top: 0.25rem;
`;
const ProductListWrapper = styled__default["default"].div`
  margin-top: 1rem;
`;

exports.CountdownSkuListMobile = CountdownSkuListMobile;


/***/ }),

/***/ 70776:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var CountdownSkuListDesktop = __webpack_require__(68501);
var CountdownSkuListMobile = __webpack_require__(77594);
var grid = __webpack_require__(29297);
var Container = __webpack_require__(61703);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CountdownSkuListV2 = (_a) => {
  var _b = _a, {
    isEditingMode,
    ssrData
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(
    restProps,
    device
  ), { tabs, commonStyle } = _a2, restStyle = __objRest(_a2, ["tabs", "commonStyle"]);
  const _b2 = commonStyle || {}, { padding, margin, borderRadius } = _b2, restCommonStyle = __objRest(_b2, ["padding", "margin", "borderRadius"]);
  const ContainerStyle = {
    padding,
    margin,
    borderRadius,
    maxWidth: grid.DEFAULT_MAX_WIDTH
  };
  if (!(tabs == null ? void 0 : tabs.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, {
    commonStyle: ContainerStyle,
    children: device === "desktop" ? /* @__PURE__ */ jsxRuntime.jsx(CountdownSkuListDesktop.CountdownSkuListDesktop, __spreadValues({
      tabs: (tabs || []).map((el) => __spreadProps(__spreadValues({}, el), {
        id: el.id || coreRenderer.generateRandomId()
      })),
      ssrData,
      commonStyle: restCommonStyle,
      isEditingMode
    }, restStyle)) : /* @__PURE__ */ jsxRuntime.jsx(CountdownSkuListMobile.CountdownSkuListMobile, __spreadValues({
      tabs: (tabs || []).map((el) => __spreadProps(__spreadValues({}, el), {
        id: el.id || coreRenderer.generateRandomId()
      })),
      ssrData,
      commonStyle: restCommonStyle,
      isEditingMode
    }, restStyle))
  });
};
CountdownSkuListV2.displayName = "Omni_CountdownSkuList_v2";

exports.CountdownSkuListV2 = CountdownSkuListV2;


/***/ }),

/***/ 8917:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);

const useTabs = (items, isEditingMode = false) => {
  var _a;
  const { displayItems: validItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const [activeTab, setActiveTab] = React.useState((_a = validItems == null ? void 0 : validItems[0]) == null ? void 0 : _a.id);
  const displayItem = React.useMemo(() => {
    return validItems == null ? void 0 : validItems.find((el) => el.id === activeTab);
  }, [validItems, activeTab]);
  React.useEffect(() => {
    var _a2;
    if (isEditingMode) {
      setActiveTab((_a2 = validItems == null ? void 0 : validItems[0]) == null ? void 0 : _a2.id);
    }
  }, [items == null ? void 0 : items.length, isEditingMode]);
  return {
    activeTab,
    setActiveTab,
    validItems,
    displayItem
  };
};

exports.useTabs = useTabs;


/***/ }),

/***/ 13220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var getISODateBackward = __webpack_require__(48180);
var Countdown = __webpack_require__(58361);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const CountdownDesktop = ({
  endTime
}) => {
  const finalDue = getISODateBackward.getISODateBackward(endTime);
  const timer = coreRenderer.useTimer(new Date(finalDue));
  return /* @__PURE__ */ jsxRuntime.jsxs(CountdownWrapper, {
    children: [
      !!(timer == null ? void 0 : timer.days) && /* @__PURE__ */ jsxRuntime.jsxs(RemainingDay, {
        children: [
          "K\u1EBFt th\xFAc sau",
          " ",
          /* @__PURE__ */ jsxRuntime.jsx("span", {
            style: { fontSize: "1.3rem", fontWeight: "600" },
            children: timer.days
          }),
          " ",
          "ng\xE0y"
        ]
      }),
      /* @__PURE__ */ jsxRuntime.jsx(Countdown.Countdown, {
        due: endTime,
        showDays: false,
        showLabel: false,
        showHours: true,
        showMinutes: true,
        showSeconds: true,
        countdownType: "due",
        countdownStyle: {
          elementGap: 16,
          align: coreRenderer.Alignment.center,
          digitStyle: {
            width: 45,
            height: 45,
            fontSize: "20px",
            fontWeight: "bold",
            textAlign: "center",
            alignItems: "center",
            lineHeight: 45,
            color: "white",
            background: "linear-gradient(rgb(74, 74, 74),rgb(35, 34, 34))",
            borderRadius: 5
          }
        }
      })
    ]
  });
};
const CountdownWrapper = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  flex: 16.66%;
`;
const RemainingDay = styled__default["default"].p`
  font-size: 1rem;
  color: white;
  text-align: center;
`;

exports.CountdownDesktop = CountdownDesktop;


/***/ }),

/***/ 66432:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var getISODateBackward = __webpack_require__(48180);
var Countdown = __webpack_require__(58361);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const CountdownMobile = ({
  endTime
}) => {
  const finalDue = getISODateBackward.getISODateBackward(endTime);
  const timer = coreRenderer.useTimer(new Date(finalDue));
  return /* @__PURE__ */ jsxRuntime.jsx(CountdownWrapper, {
    children: !!timer && /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: (timer == null ? void 0 : timer.days) > 1 ? /* @__PURE__ */ jsxRuntime.jsxs(StyledText, {
        children: [
          "C\xF2n ",
          timer.days,
          " ng\xE0y"
        ]
      }) : /* @__PURE__ */ jsxRuntime.jsx(Countdown.Countdown, {
        due: endTime,
        showDays: false,
        showLabel: false,
        showHours: true,
        showMinutes: true,
        showSeconds: true,
        countdownType: "due",
        countdownStyle: {
          elementGap: 3,
          align: coreRenderer.Alignment.center,
          timeUnitStyle: { fontSize: "10px" }
        },
        splitTimeUnit: /* @__PURE__ */ jsxRuntime.jsx("span", {
          style: { fontSize: "10px" },
          children: " : "
        }),
        commonStyle: {
          backgroundColor: "white",
          color: "rgb(20, 115, 204)",
          borderRadius: "4px",
          padding: {
            top: 2,
            bottom: 2,
            left: 8,
            right: 8,
            unit: coreRenderer.UnitEnum.pixel
          }
        }
      })
    })
  });
};
const CountdownWrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
`;
const StyledText = styled__default["default"].div`
  color: rgb(20, 115, 204);
  background-color: white;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 10px;
`;

exports.CountdownMobile = CountdownMobile;


/***/ }),

/***/ 26712:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var CountdownSkuListDesktop = __webpack_require__(15582);
var CountdownSkuListMobile = __webpack_require__(24943);
var grid = __webpack_require__(29297);
var Container = __webpack_require__(61703);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CountdownSkuList = (_a) => {
  var _b = _a, {
    isEditingMode,
    ssrData
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(
    restProps,
    device
  ), { items, commonStyle } = _a2, restStyle = __objRest(_a2, ["items", "commonStyle"]);
  const _b2 = commonStyle, { padding, margin, borderRadius } = _b2, restCommonStyle = __objRest(_b2, ["padding", "margin", "borderRadius"]);
  const ContainerStyle = {
    padding,
    margin,
    borderRadius,
    maxWidth: grid.DEFAULT_MAX_WIDTH
  };
  if (!isEditingMode && !(items == null ? void 0 : items.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, {
    commonStyle: ContainerStyle,
    children: device === "desktop" ? /* @__PURE__ */ jsxRuntime.jsx(CountdownSkuListDesktop.CountdownSkuListDesktop, __spreadValues({
      items: (items || []).map((el) => __spreadProps(__spreadValues({}, el), {
        id: el.id || coreRenderer.generateRandomId()
      })),
      ssrData,
      commonStyle: restCommonStyle,
      isEditingMode
    }, restStyle)) : /* @__PURE__ */ jsxRuntime.jsx(CountdownSkuListMobile.CountdownSkuListMobile, __spreadValues({
      items: (items || []).map((el) => __spreadProps(__spreadValues({}, el), {
        id: el.id || coreRenderer.generateRandomId()
      })),
      ssrData,
      isEditingMode,
      commonStyle
    }, restStyle))
  });
};
CountdownSkuList.displayName = "Omni_CountdownSkuList";

exports.CountdownSkuList = CountdownSkuList;


/***/ }),

/***/ 15582:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);
var coreRenderer = __webpack_require__(12060);
var helper = __webpack_require__(50907);
var hooks = __webpack_require__(88102);
var CountdownDesktop = __webpack_require__(13220);
var renderDynamicSlot = __webpack_require__(64915);
var getStyles = __webpack_require__(82016);
var renderLink = __webpack_require__(45292);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CountdownSkuListDesktop = ({
  items,
  ssrData,
  isEditingMode,
  commonStyle,
  titleStyle,
  viewMoreStyle,
  activeTabStyle
}) => {
  const { activeTab, setActiveTab, validItems, displayItem } = hooks.useCountdownSkuList(items, isEditingMode);
  const renderViewAllLink = () => {
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(displayItem == null ? void 0 : displayItem.collectionSlug, content, isEditingMode);
  };
  const { mappingDynamicSlots } = coreRenderer.useStore();
  if (!isEditingMode && !(validItems == null ? void 0 : validItems.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Container, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(HeaderWrapper, {
          children: validItems.map((tab, index) => {
            return /* @__PURE__ */ jsxRuntime.jsxs(TabHeader, __spreadProps(__spreadValues({
              onClick: () => setActiveTab(tab.id),
              className: `${activeTab === tab.id ? "active " : ""}`
            }, coreRenderer.getTrackingData({
              isTrackContent: true,
              regionName: "hotDealTab",
              contentName: tab.title
            })), {
              commonStyle: __spreadValues(__spreadValues({}, activeTabStyle), titleStyle),
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(TabTitle, {
                  children: tab.title
                }),
                /* @__PURE__ */ jsxRuntime.jsx(TabDescription, {
                  children: tab.description
                })
              ]
            }), index);
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(TabContainer, {
          commonStyle: __spreadProps(__spreadValues({}, commonStyle), { backgroundColor: "#cecece" }),
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(ViewAllLinkWrapper, {
              children: renderViewAllLink()
            }),
            /* @__PURE__ */ jsxRuntime.jsxs(TabContent, {
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(CountdownDesktop.CountdownDesktop, {
                  endTime: helper.getEndTimeByTimeVisibility(displayItem == null ? void 0 : displayItem.timeVisibility)
                }),
                /* @__PURE__ */ jsxRuntime.jsx(ProductWrapper, {
                  style: { minHeight: 300 },
                  children: renderDynamicSlot.renderDynamicSlot(
                    "product_carousel_desktop",
                    mappingDynamicSlots,
                    validItems.findIndex((el) => el.id === activeTab) === 0 ? ssrData : void 0,
                    {
                      collectionSlug: displayItem == null ? void 0 : displayItem.collectionSlug,
                      config: {
                        regionName: "hotDeal"
                      }
                    }
                  )
                }, activeTab)
              ]
            })
          ]
        })
      ]
    })
  });
};
const Wrapper = styled__default["default"].div`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
`;
const Container = styled__default["default"].div`
  z-index: 1;
  background: none;
  position: relative;
`;
const HeaderWrapper = styled__default["default"].div`
  display: flex;
  flex-direction: row;
  flex-wrap: no-wrap;
  border-radius: 8px 8px 0 0;
`;
const TabHeader = styled__default["default"].div(
  ({ commonStyle }) => `
color: ${commonStyle == null ? void 0 : commonStyle.color};
flex: 1 1 0%;
padding: 0.25rem 0;
position: relative;
overflow: hidden;
background: white;
text-align: center;
&:hover {
  cursor: pointer;
}
&.active {
  color: #fff;
  background: ${commonStyle == null ? void 0 : commonStyle.backgroundColor};
  &:before {
    content: '';
    width: 0px;
    height: 0px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid white;
    position: absolute;
    left: -5px;
    top: 0px;
  }
  &:after {
    content: '';
    width: 0px;
    height: 0px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid white;
    position: absolute;
    right: -5px;
    top: 0px;
    z-index: 0;
  }
}
`
);
const TabTitle = styled__default["default"].div`
  color: inherit;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  text-transform: uppercase;
  &:hover {
    cursor: pointer;
  }
`;
const TabDescription = styled__default["default"].div`
  color: inherit;
  font-weight: 500;
  text-decoration: unset;
  font-size: 13px;
  line-height: 24px;
  &:hover {
    cursor: pointer;
  }
`;
const TabContainer = styled__default["default"].div(
  ({ commonStyle }) => `
position: relative;
${getStyles.getStyle(commonStyle)}
`
);
const TabContent = styled__default["default"].div(
  ({ commonStyle }) => `
display: flex;
flex: row nowrap;
${getStyles.getStyle(commonStyle)}
`
);
const ProductWrapper = styled__default["default"].div`
  flex: 83.33%;
  max-width: 83.33%;
  padding: 16px 8px;
`;
const ViewAllLinkWrapper = styled__default["default"].div`
  color: white;
  display: flex;
  justify-content: flex-end;
  padding: 1rem 1rem 0 0;
`;
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
  display: flex;
  align-items: center;
  ${getStyles.getStyle(commonStyle)}
`
);

exports.CountdownSkuListDesktop = CountdownSkuListDesktop;


/***/ }),

/***/ 24943:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);
var coreRenderer = __webpack_require__(12060);
var helper = __webpack_require__(50907);
var hooks = __webpack_require__(88102);
var CountdownMobile = __webpack_require__(66432);
var renderDynamicSlot = __webpack_require__(64915);
var getStyles = __webpack_require__(82016);
var renderLink = __webpack_require__(45292);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CountdownSkuListMobile = ({
  items,
  ssrData,
  isEditingMode,
  commonStyle,
  titleStyle,
  viewMoreStyle,
  activeTabStyle
}) => {
  const { activeTab, setActiveTab, validItems, displayItem } = hooks.useCountdownSkuList(items, isEditingMode);
  const { mappingDynamicSlots } = coreRenderer.useStore();
  const renderViewAllLink = () => {
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(displayItem == null ? void 0 : displayItem.collectionSlug, content, isEditingMode);
  };
  if (!isEditingMode && !(validItems == null ? void 0 : validItems.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Container, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(HeaderWrapper, {
          children: validItems.map((tab, index) => {
            const isActive = activeTab === tab.id;
            return /* @__PURE__ */ jsxRuntime.jsxs(TabHeader, __spreadProps(__spreadValues({
              onClick: () => setActiveTab(tab.id),
              className: `${isActive ? "active" : ""}`
            }, coreRenderer.getTrackingData({
              isTrackContent: true,
              regionName: "hotDealTab",
              contentName: tab.title
            })), {
              commonStyle: __spreadValues(__spreadValues({}, activeTabStyle), titleStyle),
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(TabTitle, {
                  className: `${isActive ? "active" : ""}`,
                  children: tab.title
                }),
                /* @__PURE__ */ jsxRuntime.jsx(TabDescription, {
                  className: `${isActive ? "active" : ""}`,
                  children: tab.description
                }),
                isActive && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
                  children: [
                    /* @__PURE__ */ jsxRuntime.jsx(CountdownMobile.CountdownMobile, {
                      endTime: helper.getEndTimeByTimeVisibility(
                        displayItem == null ? void 0 : displayItem.timeVisibility
                      )
                    }),
                    /* @__PURE__ */ jsxRuntime.jsx(ActiveArrow, {
                      commonStyle: activeTabStyle
                    })
                  ]
                })
              ]
            }), index);
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(TabContent, {
          commonStyle: __spreadProps(__spreadValues({}, commonStyle), { backgroundColor: "#cecece" }),
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(ViewAllLinkWrapper, {
              children: renderViewAllLink()
            }),
            /* @__PURE__ */ jsxRuntime.jsx(ProductWrapper, {
              children: renderDynamicSlot.renderDynamicSlot(
                "product_carousel_mobile",
                mappingDynamicSlots,
                validItems.findIndex((el) => el.id === activeTab) === 0 ? ssrData : void 0,
                {
                  collectionSlug: displayItem == null ? void 0 : displayItem.collectionSlug,
                  config: {
                    regionName: "hotDeal"
                  }
                }
              )
            }, activeTab)
          ]
        })
      ]
    })
  });
};
const Wrapper = styled__default["default"].div`
  position: relative;
  margin-bottom: 0.5rem;
`;
const Container = styled__default["default"].div(
  ({ commonStyle }) => `
  position: relative;
  ${getStyles.getStyle(commonStyle)}
`
);
const HeaderWrapper = styled__default["default"].div`
  display: flex;
  flex-direction: row;
  flex-wrap: no-wrap;
  justify-content: flex-start;
  column-gap: 0.5rem;
  height: 96px;
  position: relative;
  z-index: 2;
  margin-left: 1rem;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;
const TabHeader = styled__default["default"].div(
  ({ commonStyle }) => `
  color: ${commonStyle == null ? void 0 : commonStyle.color};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 84px;
  min-width: 84px;
  padding: 0.25rem;
  position: relative;
  background: white;
  text-align: center;
  border-radius: 8px;
  border: 1px solid rgb(228, 229, 240);
  &:hover {
    cursor: pointer;
  }
  &.active {
    color: #fff;
    background: ${commonStyle == null ? void 0 : commonStyle.backgroundColor};
    color: white;
    transition: all 0.2s ease-in-out 0s;
    border-style: none;
  }
`
);
const TabTitle = styled__default["default"].div`
  color: inherit;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  &:hover {
    cursor: pointer;
  }
  &.active {
    transition: color 0.3s ease 0s;
  }
`;
const TabDescription = styled__default["default"].div`
  color: inherit;
  text-decoration: unset;
  font-size: 10px;
  line-height: 16px;
  margin-bottom: 0.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

  &:hover {
    cursor: pointer;
  }
  &.active {
    transition: color 0.3s ease 0s;
  }
`;
const TabContent = styled__default["default"].div(
  ({ commonStyle }) => `
  margin-top: -36px;
  margin-bottom: 8px;
  padding: 16px 8px;
  position: relative;
  ${getStyles.getStyle(commonStyle)}
`
);
const ProductWrapper = styled__default["default"].div`
  flex-grow: 1;
  width: 100%;
`;
const ViewAllLinkWrapper = styled__default["default"].div`
  color: white;
  display: flex;
  justify-content: flex-end;
  padding: 32px 16px;
`;
const ActiveArrow = styled__default["default"].div(
  ({ commonStyle }) => `
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  position: absolute;
  bottom: -5px;
  background: ${commonStyle == null ? void 0 : commonStyle.backgroundColor};
  transition: all 0.2s ease-in-out 0s;
`
);
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
  display: flex;
  align-items: center;
  ${getStyles.getStyle(commonStyle)}
`
);

exports.Container = Container;
exports.CountdownSkuListMobile = CountdownSkuListMobile;
exports.HeaderWrapper = HeaderWrapper;
exports.Wrapper = Wrapper;


/***/ }),

/***/ 50907:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);

const getEndTimeByTimeVisibility = (timeVisibility) => {
  var _a, _b;
  if (!timeVisibility)
    return "";
  const { endTime, ruleRepeat, duration } = timeVisibility;
  if (!ruleRepeat)
    return "";
  try {
    const frequently = coreRenderer.parseRuleRepeat(coreRenderer.RuleRepeatEnum.FREQ, ruleRepeat);
    const currentDate = new Date();
    if (frequently === coreRenderer.UnitRepeatEnum.DURATION)
      return endTime;
    const [, endMinute] = duration;
    const hour = Math.floor(endMinute / 60);
    const minute = endMinute % 60;
    if (frequently === coreRenderer.UnitRepeatEnum.DAY) {
      currentDate.setHours(hour);
      currentDate.setMinutes(minute);
      return currentDate.toISOString();
    }
    if (frequently === coreRenderer.UnitRepeatEnum.WEEK) {
      const availableDays = (_b = (_a = coreRenderer.parseRuleRepeat(coreRenderer.RuleRepeatEnum.BYDAY, ruleRepeat)) == null ? void 0 : _a.split) == null ? void 0 : _b.call(_a, ",").map((i) => parseInt(i));
      const nextWeekAvailableDays = availableDays.map((i) => i + 7);
      const checkArr = [...availableDays, ...nextWeekAvailableDays].sort(
        (a, b) => a - b
      );
      const dayOfWeek = currentDate.getDay();
      const day = checkArr.find((d) => d >= dayOfWeek);
      const interval = day - dayOfWeek;
      const newDate = new Date();
      newDate.setDate(currentDate.getDate() + interval);
      newDate.setHours(hour);
      newDate.setMinutes(minute);
      return newDate.toISOString();
    }
  } catch (e) {
    return "";
  }
};

exports.getEndTimeByTimeVisibility = getEndTimeByTimeVisibility;


/***/ }),

/***/ 88102:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);

const useCountdownSkuList = (items, isEditingMode = false) => {
  var _a;
  const { displayItems: validItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const [activeTab, setActiveTab] = React.useState((_a = validItems == null ? void 0 : validItems[0]) == null ? void 0 : _a.id);
  const displayItem = React.useMemo(() => {
    return validItems == null ? void 0 : validItems.find((el) => el.id === activeTab);
  }, [validItems, activeTab]);
  React.useEffect(() => {
    var _a2;
    if (isEditingMode) {
      setActiveTab((_a2 = validItems == null ? void 0 : validItems[0]) == null ? void 0 : _a2.id);
    }
  }, [items == null ? void 0 : items.length, isEditingMode]);
  return {
    activeTab,
    setActiveTab,
    validItems,
    displayItem
  };
};

exports.useCountdownSkuList = useCountdownSkuList;


/***/ }),

/***/ 36182:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var Section = __webpack_require__(57338);
var Col = __webpack_require__(50366);
var MegaMenu = __webpack_require__(95711);
var grid = __webpack_require__(29297);
var Slider = __webpack_require__(29062);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const HeroBanner = (_a) => {
  var _b = _a, {
    isEditingMode,
    ssrData,
    menu: menuProps
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData",
    "menu"
  ]);
  var _b2;
  const { device, globalData } = coreRenderer.useStore();
  const menu = isEditingMode ? menuProps : globalData.menu || [];
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    autoSwipeTimeMilliseconds = 3e3,
    items = [],
    rightItems = [],
    showMegaMenu,
    menuZone,
    commonStyle,
    primaryColor
  } = _a2, rest = __objRest(_a2, [
    "autoSwipeTimeMilliseconds",
    "items",
    "rightItems",
    "showMegaMenu",
    "menuZone",
    "commonStyle",
    "primaryColor"
  ]);
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const [showNavBtns, setShowNavBtns] = React.useState(false);
  const { displayItems: validItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const { displayItems: validRightItems } = coreRenderer.useTimeVisibility(
    rightItems,
    isEditingMode
  );
  if (!isEditingMode && !(items == null ? void 0 : items.length))
    return null;
  const renderValidItem = (item, index) => {
    return /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues({
      isEditingMode,
      event: item.event,
      googleImageParams: item.googleImageParams || { width: 1920 },
      src: item.src || defaultImage,
      alt: item.alt || "Image",
      commonStyle: {
        objectFit: "cover",
        width: "100%",
        height: 566
      }
    }, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: "topSliderBannerHomepage",
      contentName: "heroBannerSlide",
      target: coreRenderer.getTargetOfTrackingFromEvent(item.event),
      index
    })), index);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(StyledHeroBanner, __spreadProps(__spreadValues({
    commonStyle,
    onMouseEnter: () => setShowNavBtns(true),
    onMouseLeave: () => setShowNavBtns(false)
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Section.Section, {
      commonStyle: {
        maxWidth: grid.DEFAULT_MAX_WIDTH,
        padding: { left: 16, right: 16 }
      },
      row: {
        commonStyle: {
          height: 556,
          alignItems: "stretch"
        }
      },
      children: [
        /* @__PURE__ */ jsxRuntime.jsxs(Col.Col, {
          span: 2,
          style: { paddingTop: "1rem", zIndex: 980 },
          children: [
            /* @__PURE__ */ jsxRuntime.jsx("div", {
              style: { position: "relative" },
              children: /* @__PURE__ */ jsxRuntime.jsx(MegaMenu.MegaMenu, {
                menu,
                isEditingMode,
                primaryColor
              })
            }),
            (validItems == null ? void 0 : validItems.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(StyledLeftNav, {
              style: { opacity: showNavBtns ? 1 : 0 },
              ref: navigationPrevRef
            })
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx("div", {
          style: { flex: "1 1 0%" },
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledFullWidthSlider, {
            children: validItems.length !== 1 ? /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, {
              pagination: true,
              paginationStyle: 1,
              navigation: {
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current
              },
              navigationStyle: 1,
              virtual: true,
              paginationColor: "#ffffff",
              loop: true,
              autoplay: !!autoSwipeTimeMilliseconds,
              speed: autoSwipeTimeMilliseconds,
              allowTouchMove: !isEditingMode,
              onBeforeInit: (swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
              },
              children: validItems.map((item, index) => renderValidItem(item, index))
            }) : renderValidItem(validItems[0], 0)
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(Col.Col, {
          span: 2,
          style: { paddingTop: "1rem" },
          children: [
            (validItems == null ? void 0 : validItems.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(StyledRightNav, {
              style: { opacity: showNavBtns ? 1 : 0 },
              ref: navigationNextRef
            }),
            !!(validRightItems == null ? void 0 : validRightItems.length) && /* @__PURE__ */ jsxRuntime.jsx(StyledRightBanner, {
              children: (_b2 = validRightItems == null ? void 0 : validRightItems.slice) == null ? void 0 : _b2.call(validRightItems, 0, 2).map((item, index) => /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues({
                isEditingMode,
                event: item.event,
                googleImageParams: item.googleImageParams || { width: 300 },
                src: item.src || defaultImage,
                alt: item.alt || "Image",
                commonStyle: {
                  objectFit: "cover",
                  width: "100%",
                  height: 220,
                  borderRadius: 8,
                  hover: {
                    zoom: 105
                  }
                }
              }, !isEditingMode && coreRenderer.getTrackingData({
                isTrackContent: true,
                regionName: "topRightBannerHomepage",
                contentName: "heroBannerRight",
                index,
                target: coreRenderer.getTargetOfTrackingFromEvent(item.event)
              })), index))
            })
          ]
        })
      ]
    })
  }));
};
const StyledHeroBanner = styled__default["default"].div(
  ({ commonStyle }) => `
  position: relative;
  content-visibility: auto;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const StyledFullWidthSlider = styled__default["default"].div`
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  z-index: 0;

  .swiper-pagination {
    bottom: 7rem !important;
  }
`;
const StyledRightBanner = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const StyledLeftNav = styled__default["default"].div`
  top: 39.5%;
  right: -46px;

  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;

  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
  background-color: rgba(168, 168, 168, 0.46);

  &:after {
    mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
`;
const StyledRightNav = styled__default["default"].div`
  top: 39.5%;
  left: -48px;

  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;

  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  background-color: rgba(168, 168, 168, 0.46);

  &:after {
    mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
`;
HeroBanner.displayName = "Omni_HeroBanner";

exports.HeroBanner = HeroBanner;


/***/ }),

/***/ 18111:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var Container = __webpack_require__(61703);
var BlockHeader = __webpack_require__(59941);
var renderDynamicSlot = __webpack_require__(64915);
var EmptyProduct = __webpack_require__(36838);
var grid = __webpack_require__(29297);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListingTab = (_a) => {
  var _b = _a, {
    isEditingMode = false,
    ssrData
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData"
  ]);
  var _c, _d;
  const [activeTab, setActiveTab] = React.useState(0);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    items = [],
    commonStyle,
    title,
    activeTabStyle
  } = _a2, rest = __objRest(_a2, [
    "items",
    "commonStyle",
    "title",
    "activeTabStyle"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const tabHeadRef = React.useRef();
  const tabHead = tabHeadRef == null ? void 0 : tabHeadRef.current;
  const isDesktop = device === "desktop";
  React.useEffect(() => {
    if (tabHead && tabHead.scroll) {
      const activeDom = tabHead.childNodes[activeTab];
      tabHead.scroll({
        left: activeDom.offsetLeft - (tabHead.offsetWidth - activeDom.offsetWidth) / 2,
        behavior: "smooth"
      });
    }
  }, [activeTab, tabHead]);
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(Title, {
            children: title
          })
        }),
        !!(items == null ? void 0 : items.length) && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(HeaderWrapper, {
              ref: tabHeadRef,
              children: items.map(({ src, title: title2 }, index) => /* @__PURE__ */ jsxRuntime.jsxs(TabItem, __spreadProps(__spreadValues({
                className: activeTab === index ? "active" : "",
                onClick: () => setActiveTab(index)
              }, !isEditingMode && coreRenderer.getTrackingData({
                isTrackContent: true,
                regionName: "forYouTabCategory",
                contentName: title2,
                index
              })), {
                isDesktop,
                hasImage: !!src,
                activeTabStyle,
                children: [
                  !!src && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
                    src,
                    alt: title2 || "Image",
                    commonStyle: {
                      objectFit: "cover",
                      position: "relative",
                      display: "inline-block",
                      margin: {
                        bottom: 4
                      },
                      height: 44,
                      width: 44
                    }
                  }),
                  /* @__PURE__ */ jsxRuntime.jsx(TabTitle, {
                    isDesktop,
                    children: title2
                  })
                ]
              }), index))
            }),
            /* @__PURE__ */ jsxRuntime.jsx("div", {
              children: ((_c = items == null ? void 0 : items[activeTab]) == null ? void 0 : _c.collectionSlug) || isEditingMode ? renderDynamicSlot.renderDynamicSlot(
                `product_grid_${device}`,
                mappingDynamicSlots,
                activeTab === 0 ? ssrData : void 0,
                {
                  collectionSlug: (_d = items == null ? void 0 : items[activeTab]) == null ? void 0 : _d.collectionSlug,
                  config: { regionName: "productCard" }
                }
              ) : /* @__PURE__ */ jsxRuntime.jsx(EmptyProduct.EmptyProduct, {})
            })
          ]
        })
      ]
    })
  }));
};
ListingTab.displayName = "Omni_ListingTab";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  border-radius: 8px;
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
  `
);
const Title = styled__default["default"].div`
  color: rgb(51, 51, 51);
  font-weight: 700;
  font-size: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  background-color: #ffffff;
`;
const HeaderWrapper = styled__default["default"].div`
  overflow-x: scroll;
  position: sticky;
  width: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  scroll-snap-type: x mandatory;
  display: flex;
  align-items: stretch;
  background-color: #ffffff;
`;
const TabItem = styled__default["default"].div(
  ({ isDesktop, hasImage, activeTabStyle }) => `
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  flex-direction: column;
  position: relative;
  background: rgb(255, 255, 255);
  display: inline-flex;
  scroll-snap-align: start;
  justify-content: ${hasImage ? `flex-start` : `center`};
  height: auto;
  ${isDesktop ? `min-width: 120px; width: 120px; padding: 12px 0;` : `min-width: 90px; width: 90px; padding: 8px 0;`}
  &.active {
    color: rgb(51, 51, 51);
    ${coreRenderer.getStyle(activeTabStyle)}
  }
  &:hover {
    cursor: pointer;
  }
`
);
const TabTitle = styled__default["default"].span(
  ({ isDesktop }) => `
  color: rgb(51, 51, 51);
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  text-align: center;
  
  ${isDesktop ? `font-size: 14px; padding: 0 12px;` : `font-size: 12px; padding: 0 8px;`}
`
);

exports.ListingTab = ListingTab;


/***/ }),

/***/ 95711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var styled = __webpack_require__(21483);
var clsx = __webpack_require__(81892);
var MegaMenuContent = __webpack_require__(24573);
var menu = __webpack_require__(4637);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const MegaMenu = ({ menu: menu$1 = [], primaryColor, isEditingMode }) => {
  const [activeMenu, setActiveMenu] = React.useState();
  const MAX_LENGTH_MENU = 14;
  const tree = menu.flattenToTree((menu$1 || []).filter((el) => !el.isHidden)).slice(
    0,
    MAX_LENGTH_MENU
  );
  return /* @__PURE__ */ jsxRuntime.jsxs("div", {
    onMouseLeave: () => setActiveMenu(null),
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
        className: clsx__default["default"]((activeMenu == null ? void 0 : activeMenu.children.length) > 0 ? ["active"] : null),
        children: tree == null ? void 0 : tree.map((item, index) => /* @__PURE__ */ jsxRuntime.jsxs(MenuItemWrapper, {
          href: menu.getUrlOfMenuItem(item, isEditingMode),
          primaryColor,
          onMouseEnter: () => {
            setActiveMenu(item);
          },
          children: [
            (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx(IconImg, {
              src: item == null ? void 0 : item.iconUrl,
              alt: item == null ? void 0 : item.name
            }),
            /* @__PURE__ */ jsxRuntime.jsx(Caption, {
              children: item == null ? void 0 : item.name
            })
          ]
        }, index))
      }),
      /* @__PURE__ */ jsxRuntime.jsx(VerticalMenuPanel, {
        className: clsx__default["default"]((activeMenu == null ? void 0 : activeMenu.children.length) > 0 ? ["active"] : null),
        children: activeMenu && /* @__PURE__ */ jsxRuntime.jsx(MegaMenuContent.MegaMenuContent, {
          menu: activeMenu,
          primaryColor,
          isEditingMode,
          type: "vertical"
        })
      })
    ]
  });
};
const verticalMenuWidth = "12.375rem";
const megaMenuHeight = "28.5rem";
const Wrapper = styled__default["default"].div`
  border-radius: 0.5rem;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
  z-index: 980;
  height: ${megaMenuHeight};
  width: ${verticalMenuWidth};

  &.active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;
const MenuItemWrapper = styled__default["default"].a(
  ({ primaryColor = "#1435c3" }) => `
  cursor: pointer;
  color: black;
  text-decoration: none;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
  padding: 0 0.5rem;
  border-radius: 0.5rem;
  overflow: hidden;

  &:hover {
    background-color: #ababab20;
    color: ${primaryColor} !important;
  }
`
);
const Caption = styled__default["default"].div`
  flex: 1 1 0%;
  margin: 0px;
  padding: 0px;
  border-style: none;
  border-width: 1px;
  border-color: unset;
  opacity: 1;
  color: inherit;
  font-weight: 500;
  text-decoration: unset;
  font-size: 12px;
  line-height: 16px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  max-width: unset;
  min-width: unset;
  transition: color 0.3s ease 0s;
`;
const VerticalMenuPanel = styled__default["default"].div`
  position: absolute;
  top: 0;
  width: calc(75rem - 12.375rem);
  left: 12.375rem;
  min-height: 100%;
  z-index: 980;
  overflow: hidden;
  transition: all 0.1s;
  visibility: hidden;
  opacity: 0;
  border-radius: 0.5rem;
  &.active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    visibility: visible;
    opacity: 1;
  }
`;
const IconImg = styled__default["default"].img`
  width: 22px;
  height: 22px;
`;

exports.MegaMenu = MegaMenu;


/***/ }),

/***/ 24573:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var utils = __webpack_require__(47461);
var menu = __webpack_require__(4637);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const MegaMenuContent = ({
  menu: menu$1,
  primaryColor = "#434657",
  isEditingMode = false,
  type = "vertical"
}) => {
  const getMenuColumns = () => {
    let totalCols = 6;
    if (type === "vertical")
      totalCols--;
    return totalCols;
  };
  const newMenu = utils.convertMegaMenu(menu$1, getMenuColumns());
  return /* @__PURE__ */ jsxRuntime.jsx(StyledContentPanel, {
    children: newMenu == null ? void 0 : newMenu.map((col) => /* @__PURE__ */ jsxRuntime.jsx(MegaMenuColumn, {
      children: col.items.map((item, index) => {
        var _a;
        return /* @__PURE__ */ jsxRuntime.jsxs(MegaMenuSubColumn, {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
            marginBottom: "1.5rem"
          },
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(StyledLink, {
              href: menu.getUrlOfMenuItem(item, isEditingMode),
              primaryColor,
              children: item == null ? void 0 : item.name
            }),
            (_a = item == null ? void 0 : item.children) == null ? void 0 : _a.map((child) => /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
              children: (child == null ? void 0 : child.name) && /* @__PURE__ */ jsxRuntime.jsx(StyledChildLink, {
                href: menu.getUrlOfMenuItem(child, isEditingMode),
                children: child.name
              })
            }))
          ]
        }, index);
      })
    }))
  });
};
const StyledContentPanel = styled__default["default"].div`
  background-color: #ffffff;
  display: flex;
  flex: 1 1 0%;
  min-height: 28.5rem;
  padding: 0.75rem;
`;
const StyledLink = styled__default["default"].a(
  ({ primaryColor }) => `
color: ${primaryColor};
text-decoration: none;
font-size: 14px;
font-weight: bold;

&:hover {
  color: ${primaryColor};
}
`
);
const StyledChildLink = styled__default["default"].a`
  color: rgb(67, 70, 87);
  text-decoration: none;
  font-size: 14px;

  &:hover {
    color: rgb(20, 53, 195);
  }
`;
const MegaMenuColumn = styled__default["default"].div`
  width: 25%;
  padding: 0px 8px;
  font-size: 20;
`;
const MegaMenuSubColumn = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

exports.MegaMenuContent = MegaMenuContent;


/***/ }),

/***/ 47461:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const convertMegaMenu = (menu, numberCol) => {
  if (numberCol < 1)
    return [];
  const newArr = menu.children.map((m) => {
    return {
      len: m.children.length + 1,
      items: [__spreadValues({}, m)]
    };
  });
  if (newArr.length <= numberCol)
    return newArr;
  newArr.sort((a, b) => b.len - a.len);
  const result = [...newArr.slice(0, numberCol)];
  let min;
  let k;
  for (let i = numberCol; i < newArr.length; i++) {
    min = result[0].len;
    k = 0;
    for (let j = 0; j < numberCol; j++) {
      if (min > result[j].len) {
        min = result[j].len;
        k = j;
      }
    }
    result[k] = {
      len: result[k].len + newArr[i].len,
      items: [...result[k].items, ...newArr[i].items]
    };
  }
  return result;
};

exports.convertMegaMenu = convertMegaMenu;


/***/ }),

/***/ 97841:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var MixBannerSide = __webpack_require__(85859);
var Container = __webpack_require__(61703);
var grid = __webpack_require__(29297);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MixBanner = (_a) => {
  var _b = _a, {
    isEditingMode
  } = _b, restProps = __objRest(_b, [
    "isEditingMode"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), { left, right, commonStyle, titleStyle, viewMoreStyle } = _a2, rest = __objRest(_a2, ["left", "right", "commonStyle", "titleStyle", "viewMoreStyle"]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  return /* @__PURE__ */ jsxRuntime.jsxs(Container.Container, __spreadProps(__spreadValues({
    commonStyle: {
      maxWidth: grid.DEFAULT_MAX_WIDTH,
      padding,
      margin,
      display: "flex",
      gap: 16
    }
  }, rest), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(MixBannerSide.MixBannerSide, __spreadProps(__spreadValues({}, left), {
        commonStyle: __spreadValues(__spreadValues({}, restStyle), left == null ? void 0 : left.commonStyle),
        isEditingMode,
        titleStyle,
        viewMoreStyle
      })),
      /* @__PURE__ */ jsxRuntime.jsx(MixBannerSide.MixBannerSide, __spreadProps(__spreadValues({}, right), {
        commonStyle: __spreadValues(__spreadValues({}, restStyle), right == null ? void 0 : right.commonStyle),
        isEditingMode,
        titleStyle,
        viewMoreStyle
      }))
    ]
  }));
};
MixBanner.displayName = "Omni_MixBanner";

exports.MixBanner = MixBanner;


/***/ }),

/***/ 85859:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);
var coreRenderer = __webpack_require__(12060);
var Row = __webpack_require__(83042);
var Col = __webpack_require__(50366);
var renderLink = __webpack_require__(45292);
var BlockHeader = __webpack_require__(59941);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const MixBannerSide = ({
  isEditingMode,
  title,
  redirectUrl,
  mainBanner,
  rightBanners,
  bottomBanners,
  commonStyle,
  titleStyle,
  viewMoreStyle
}) => {
  var _a, _b, _c;
  const { device } = coreRenderer.useStore();
  const { displayItems: displayRightBanners } = coreRenderer.useTimeVisibility(
    rightBanners,
    isEditingMode
  );
  const { displayItems: displayBottomBanners } = coreRenderer.useTimeVisibility(
    bottomBanners,
    isEditingMode
  );
  const renderViewAllLink = () => {
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(redirectUrl, content, isEditingMode);
  };
  const renderMainBanner = () => {
    if (!mainBanner)
      return null;
    const { googleImageParams, src, alt, event } = mainBanner;
    const content = /* @__PURE__ */ jsxRuntime.jsx(StyleMainBanner, __spreadValues({
      googleImageParams: googleImageParams || {
        width: 400
      },
      src: src || defaultImage,
      alt: alt || "Image",
      commonStyle: {
        hover: { zoom: 105 },
        objectFit: "cover",
        width: "100%",
        height: "100%"
      }
    }, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: "categoriesBlockBrand",
      contentName: title,
      target: coreRenderer.getTargetOfTrackingFromEvent(event)
    })));
    return renderLink.renderLink(event, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    commonStyle,
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(Header, {
        device,
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Label, {
            commonStyle: titleStyle,
            children: title
          }),
          renderViewAllLink()
        ]
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(Row.Row, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Col.Col, {
            span: 4,
            children: renderMainBanner()
          }),
          /* @__PURE__ */ jsxRuntime.jsx(Col.Col, {
            span: 8,
            children: /* @__PURE__ */ jsxRuntime.jsx(ContentItemsWrapper, {
              children: (_c = (_a = displayRightBanners == null ? void 0 : displayRightBanners.slice) == null ? void 0 : (_b = _a.call(displayRightBanners, 0, 4)).map) == null ? void 0 : _c.call(_b, (banner, index) => {
                const content = /* @__PURE__ */ jsxRuntime.jsxs(ContentItem, {
                  children: [
                    /* @__PURE__ */ jsxRuntime.jsx(StyledRightTitle, {
                      children: banner == null ? void 0 : banner.alt
                    }),
                    /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
                      googleImageParams: banner.googleImageParams || { width: 300 },
                      src: banner.src || defaultImage,
                      alt: banner.alt || banner.title || "Image",
                      commonStyle: {
                        hover: { zoom: 105 },
                        objectFit: "contain",
                        height: 120
                      }
                    })
                  ]
                });
                return renderLink.renderLink(banner == null ? void 0 : banner.event, content, isEditingMode, index);
              })
            })
          })
        ]
      }),
      !!(displayBottomBanners == null ? void 0 : displayBottomBanners.length) && /* @__PURE__ */ jsxRuntime.jsx(Footer, {
        children: displayBottomBanners.map((banner, index) => {
          const content = /* @__PURE__ */ jsxRuntime.jsx(StyledBottomImage, __spreadValues({
            googleImageParams: banner.googleImageParams || { width: 200 },
            src: banner.src || defaultImage,
            alt: banner.alt || "Image",
            commonStyle: {
              hover: { zoom: 105 },
              objectFit: "contain",
              height: 68
            }
          }, !isEditingMode && coreRenderer.getTrackingData({
            isTrackContent: true,
            regionName: "categoriesBlockBrand",
            contentName: "bottomCategoriesBlockBrand",
            index,
            target: coreRenderer.getTargetOfTrackingFromEvent(banner.event)
          })));
          return renderLink.renderLink(banner.event, content, isEditingMode, index);
        })
      })
    ]
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  overflow: hidden;
  flex: 50%;
  ${coreRenderer.getStyle(commonStyle)}
  `
);
const Header = styled__default["default"](BlockHeader.BlockHeader)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Label = styled__default["default"].div(
  ({ commonStyle }) => `
  flex: 1;
  margin-right: 8px;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const StyleMainBanner = styled__default["default"](coreRenderer.ImageBase)`
  display: inline-block;
  overflow: hidden;
  height: 100%;
  width: 100%;
  transition: transform 0.3s ease 0s;
`;
const ContentItemsWrapper = styled__default["default"].div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0;

  & > :nth-child(odd) {
    border-right: 1px solid rgb(224, 224, 224);
  }
  & > :nth-child(-n + 2) {
    border-bottom: 1px solid rgb(224, 224, 224);
  }
`;
const ContentItem = styled__default["default"].div`
  text-align: center;
  padding: 1rem;
  height: 100%;
`;
const StyledRightTitle = styled__default["default"].div`
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;
const Footer = styled__default["default"].div`
  display: flex;
  justify-content: space-between;

  & > * {
    flex: 1;
  }
`;
const StyledBottomImage = styled__default["default"](coreRenderer.ImageBase)`
  width: 100%;
`;
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
    display: flex;
    align-items: center;
    ${coreRenderer.getStyle(commonStyle)}
  `
);

exports.MixBannerSide = MixBannerSide;


/***/ }),

/***/ 33715:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var Container = __webpack_require__(61703);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniFooter = (_a) => {
  var _b = _a, {
    children,
    commonStyle
  } = _b, other = __objRest(_b, [
    "children",
    "commonStyle"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    fluid: true,
    commonStyle
  }, other), {
    children
  }));
};
OmniFooter.displayName = "Omni_Footer";

exports.OmniFooter = OmniFooter;


/***/ }),

/***/ 91799:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(91987);

const OmniHeaderContext = React.createContext({});
const OmniHeaderProvider = OmniHeaderContext.Provider;
const useOmniHeader = () => React.useContext(OmniHeaderContext);

exports.OmniHeaderContext = OmniHeaderContext;
exports.OmniHeaderProvider = OmniHeaderProvider;
exports.useOmniHeader = useOmniHeader;


/***/ }),

/***/ 68992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var HorizontalCategories = __webpack_require__(93073);
var VerticalCategories = __webpack_require__(12945);
var context = __webpack_require__(91799);
var coreRenderer = __webpack_require__(12060);
var Row = __webpack_require__(83042);
var Col = __webpack_require__(50366);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MainNavigationBar = ({
  logo,
  searchSlot,
  rightItemsSlot,
  layout,
  showMenu,
  setShowMenu,
  primaryColor
}) => {
  const isVertical = layout === "vertical";
  const isHorizontal = layout === "horizontal";
  const { isEditingMode = false } = context.useOmniHeader();
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Content, {
        children: /* @__PURE__ */ jsxRuntime.jsxs(StyledRow, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(StyledCol, {
              children: /* @__PURE__ */ jsxRuntime.jsxs(LogoWrapper, {
                children: [
                  /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadProps(__spreadValues({}, logo), {
                    event: {
                      eventType: "link",
                      link: { href: isEditingMode ? null : "/" }
                    }
                  })),
                  isVertical && /* @__PURE__ */ jsxRuntime.jsx(VerticalCategories.VerticalCategories, {
                    showMenu,
                    setShowMenu,
                    primaryColor
                  })
                ]
              })
            }),
            /* @__PURE__ */ jsxRuntime.jsx(StyledCol, {
              style: {
                flex: "1 1 auto"
              },
              children: searchSlot
            }),
            /* @__PURE__ */ jsxRuntime.jsx(StyledCol, {
              children: rightItemsSlot
            })
          ]
        })
      }),
      isHorizontal && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Divider, {}),
          /* @__PURE__ */ jsxRuntime.jsx(Content, {
            children: /* @__PURE__ */ jsxRuntime.jsx(Row.Row, {
              children: /* @__PURE__ */ jsxRuntime.jsx(Col.Col, {
                span: 12,
                children: /* @__PURE__ */ jsxRuntime.jsx(HorizontalCategories.HorizontalCategories, {
                  primaryColor
                })
              })
            })
          })
        ]
      })
    ]
  });
};
const Wrapper = styled__default["default"].nav`
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
`;
const Content = styled__default["default"].div`
  max-width: 1232px;
  margin: 0 auto;
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
`;
const StyledRow = styled__default["default"](Row.Row)`
  margin-left: -8px;
  margin-right: -8px;
  row-gap: 16px;
  min-height: 88px;
  align-items: center;

  @media (min-width: 1024px) {
    justify-content: center;
  }
`;
const StyledCol = styled__default["default"](Col.Col)`
  padding-left: 8px;
  padding-right: 8px;
`;
const Divider = styled__default["default"].div`
  display: flex;
  width: 100%;
  border-top: 1px solid #e4e5f0;
`;
const LogoWrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

exports.MainNavigationBar = MainNavigationBar;


/***/ }),

/***/ 84956:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var TopBarMenu = __webpack_require__(56349);
var MainNavigationBar = __webpack_require__(68992);
var TopBanner = __webpack_require__(29971);
var context = __webpack_require__(91799);
var renderDynamicSlot = __webpack_require__(64915);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniDesktopHeader = (_a) => {
  var _b = _a, {
    ssrData
  } = _b, rest = __objRest(_b, [
    "ssrData"
  ]);
  const { isEditingMode = false } = context.useOmniHeader();
  const { topBarMenu = [], logoDesktop, topBanner, layout } = rest || {};
  const _a2 = coreRenderer.getPropsByDevice(
    rest,
    "desktop"
  ), { primaryColor, commonStyle } = _a2, others = __objRest(_a2, ["primaryColor", "commonStyle"]);
  const { mappingDynamicSlots } = coreRenderer.useStore();
  const [showMenu, setShowMenu] = React__default["default"].useState(false);
  const searchSlot = renderDynamicSlot.renderDynamicSlot(
    `header_search_desktop`,
    mappingDynamicSlots,
    ssrData,
    {
      primaryColor
    }
  );
  const rightItemsSlot = renderDynamicSlot.renderDynamicSlot(
    `header_right_items_desktop`,
    mappingDynamicSlots,
    ssrData
  );
  const isShowTopBanner = isEditingMode || coreRenderer.validateIsVisibleComponent((topBanner == null ? void 0 : topBanner.timeVisibility) || {});
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      showMenu && /* @__PURE__ */ jsxRuntime.jsx(Backdrop, {
        onClick: () => setShowMenu(false)
      }),
      isShowTopBanner && /* @__PURE__ */ jsxRuntime.jsx(TopBanner.TopBanner, __spreadValues(__spreadValues({}, topBanner), others)),
      /* @__PURE__ */ jsxRuntime.jsx(TopBarMenu.TopBarMenu, __spreadValues({
        items: topBarMenu,
        backgroundColor: primaryColor
      }, others)),
      /* @__PURE__ */ jsxRuntime.jsx(Header, __spreadProps(__spreadValues({
        commonStyle,
        isEditingMode
      }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx(MainNavigationBar.MainNavigationBar, {
          logo: logoDesktop,
          layout,
          searchSlot,
          rightItemsSlot,
          showMenu,
          setShowMenu,
          primaryColor
        })
      }))
    ]
  });
};
const Header = styled__default["default"].header(
  ({ commonStyle, isEditingMode }) => `
    background-color: #fff;
    position: sticky;
    top: 0;
    z-index: ${isEditingMode ? "550" : "1040"};
    margin-bottom: 24px;
    ${coreRenderer.getStyle(commonStyle)}
    `
);
const Backdrop = styled__default["default"].div`
  position: fixed;
  inset: 0px;
  background: rgba(0, 0, 0, 0.5);
  transition-delay: 0.1s;
  z-index: 550;
`;

exports.OmniDesktopHeader = OmniDesktopHeader;


/***/ }),

/***/ 29971:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TopBanner = (_a) => {
  var _b = _a, {
    timeVisibility,
    commonStyle
  } = _b, props = __objRest(_b, [
    "timeVisibility",
    "commonStyle"
  ]);
  if (!props.src)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadProps(__spreadValues({}, props), {
      commonStyle: __spreadProps(__spreadValues({}, commonStyle), { display: "block" })
    }))
  });
};
const Wrapper = styled__default["default"].div`
  position: relative;
  z-index: 550;
`;

exports.TopBanner = TopBanner;


/***/ }),

/***/ 56349:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var styled = __webpack_require__(21483);
var Link = __webpack_require__(9231);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TopBarMenu = (_a) => {
  var _b = _a, { items, backgroundColor } = _b, rest = __objRest(_b, ["items", "backgroundColor"]);
  if (!(items == null ? void 0 : items.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
    backgroundColor
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsx(ContentWrapper, {
      children: /* @__PURE__ */ jsxRuntime.jsx(Content, {
        children: items == null ? void 0 : items.map(({ event, icon, title }, index) => /* @__PURE__ */ React.createElement(Link.Link, __spreadProps(__spreadValues({}, event), {
          key: index
        }), /* @__PURE__ */ jsxRuntime.jsxs(MenuItem, {
          children: [
            (icon == null ? void 0 : icon.src) && /* @__PURE__ */ jsxRuntime.jsx("img", {
              src: icon.src,
              style: {
                width: 18,
                height: 18
              },
              alt: title
            }),
            title
          ]
        })))
      })
    })
  }));
};
const Wrapper = styled__default["default"].nav(
  ({ backgroundColor }) => `
  position: relative;
  min-height: 42px;
  ${backgroundColor && `background-color: ${backgroundColor};`}
  z-index: 550;
`
);
const ContentWrapper = styled__default["default"].div`
  max-width: 1232px;
  margin: 0 auto;
  text-align: right;
`;
const Content = styled__default["default"].div`
  display: inline-flex;
  color: white;
  white-space: pre;
  max-width: 100%;
  overflow: hidden;
`;
const MenuItem = styled__default["default"].div`
  display: flex;
  align-items: center;
  padding: 0 1.25rem;
  cursor: pointer;
  height: 42px;
  gap: 0.5rem;
`;

exports.TopBarMenu = TopBarMenu;


/***/ }),

/***/ 93073:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var React = __webpack_require__(91987);
var clsx = __webpack_require__(81892);
var context = __webpack_require__(91799);
var MegaMenuContent = __webpack_require__(24573);
var menu = __webpack_require__(4637);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const HorizontalCategories = ({ primaryColor }) => {
  const { isEditingMode = false, menu: menu$1 = [] } = context.useOmniHeader();
  const [activeMenu, setActiveMenu] = React.useState();
  if (!(menu$1 == null ? void 0 : menu$1.length))
    return null;
  const tree = menu.flattenToTree(menu$1.filter((el) => !el.isHidden));
  return /* @__PURE__ */ jsxRuntime.jsxs("div", {
    onMouseLeave: () => setActiveMenu(null),
    style: { position: "relative" },
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
        children: tree == null ? void 0 : tree.map((item, index) => /* @__PURE__ */ jsxRuntime.jsxs(CategoryItem, {
          href: menu.getUrlOfMenuItem(item, isEditingMode),
          primaryColor,
          onMouseEnter: () => {
            setActiveMenu(item);
          },
          children: [
            (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx(StyledImage, {
              src: item == null ? void 0 : item.iconUrl,
              alt: item == null ? void 0 : item.name
            }),
            item == null ? void 0 : item.name
          ]
        }, index))
      }),
      activeMenu && /* @__PURE__ */ jsxRuntime.jsx(HorizontalMenuPanel, {
        className: clsx__default["default"]((activeMenu == null ? void 0 : activeMenu.children.length) > 0 ? ["active"] : null),
        children: /* @__PURE__ */ jsxRuntime.jsx(MegaMenuContent.MegaMenuContent, {
          menu: activeMenu,
          primaryColor,
          isEditingMode,
          type: "horizontal"
        })
      })
    ]
  });
};
const Wrapper = styled__default["default"].div`
  position: relative;
  height: 3rem;
  background-color: #ffffff;
  width: 100%;
  overflow: hidden;
`;
const HorizontalMenuPanel = styled__default["default"].div`
  background-color: rgb(255, 255, 255);
  display: flex;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 3rem;
  z-index: 980;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s ease 0s;
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;

  &.active {
    visibility: visible;
    opacity: 1;
    filter: drop-shadow(rgba(0, 0, 0, 0.05) 0px 2px 4px);
  }
`;
const CategoryItem = styled__default["default"].a(
  ({ primaryColor }) => `
  cursor: pointer;
  padding: 0 0.75rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  float: left;
  position: relative;
  transition: all 0.3s ease;
  color: #434657;
  font-weight: 500;
  text-decoration: unset;
  font-size: 13px;
  line-height: 20px;
  
  &:hover {
    color: ${primaryColor};
  }

  &:hover::after {
    opacity: 1;
  }

  &::after {
    content: '';
    height: 2px;
    background-color: ${primaryColor};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
}
`
);
const StyledImage = styled__default["default"].img`
  width: 22px;
  height: 22px;
  margin-right: 0.5rem;
`;

exports.HorizontalCategories = HorizontalCategories;


/***/ }),

/***/ 12945:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var ListIcon = __webpack_require__(56591);
var context = __webpack_require__(91799);
var MegaMenu = __webpack_require__(95711);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const VerticalCategories = ({ showMenu = false, setShowMenu, primaryColor }) => {
  const { isEditingMode = false, menu = [] } = context.useOmniHeader();
  if (!(menu == null ? void 0 : menu.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
        onClick: () => setShowMenu(!showMenu),
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(ListIcon.ListIcon, {}),
          /* @__PURE__ */ jsxRuntime.jsx("span", {
            style: { marginLeft: "0.5rem" },
            children: "Danh m\u1EE5c s\u1EA3n ph\u1EA9m"
          })
        ]
      }),
      showMenu && /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: /* @__PURE__ */ jsxRuntime.jsx(MenuWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(MegaMenu.MegaMenu, {
            menu,
            primaryColor,
            isEditingMode
          })
        })
      })
    ]
  });
};
const Wrapper = styled__default["default"].div`
  border: 1px solid rgb(224, 224, 224);
  cursor: pointer;
  border-radius: 4px;
  line-height: 1rem;
  padding: 0.4rem 0.75rem;
  text-align: center;
  color: rgb(130, 134, 158);
  margin: 0 0.5rem;
  user-select: none;
`;
const MenuWrapper = styled__default["default"].div`
  position: absolute;
  inset: 0px auto auto 0px;
  visibility: visible;
  z-index: 999;
  transform: translate(16px, 72px) !important;
`;

exports.VerticalCategories = VerticalCategories;


/***/ }),

/***/ 34765:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);

const CloseIcon = () => {
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "m4.21 4.387.083-.094a1 1 0 0 1 1.32-.083l.094.083L12 10.585l6.293-6.292a1 1 0 1 1 1.414 1.414L13.415 12l6.292 6.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083L12 13.415l-6.293 6.292a1 1 0 0 1-1.414-1.414L10.585 12 4.293 5.707a1 1 0 0 1-.083-1.32l.083-.094-.083.094Z",
      fill: "currentColor"
    })
  });
};

exports.CloseIcon = CloseIcon;


/***/ }),

/***/ 31826:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);

const DownIcon = () => {
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M4.293 8.293a1 1 0 0 1 1.414 0L12 14.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Z",
      fill: "#212121"
    })
  });
};

exports.DownIcon = DownIcon;


/***/ }),

/***/ 56591:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);

const ListIcon = () => {
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M3 17h18a1 1 0 0 1 .117 1.993L21 19H3a1 1 0 0 1-.117-1.993L3 17h18H3Zm0-6 18-.002a1 1 0 0 1 .117 1.993l-.117.007L3 13a1 1 0 0 1-.117-1.993L3 11l18-.002L3 11Zm0-6h18a1 1 0 0 1 .117 1.993L21 7H3a1 1 0 0 1-.117-1.993L3 5h18H3Z",
      fill: "currentColor"
    })
  });
};

exports.ListIcon = ListIcon;


/***/ }),

/***/ 27744:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);

const UpIcon = () => {
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M4.293 15.707a1 1 0 0 0 1.414 0L12 9.414l6.293 6.293a1 1 0 0 0 1.414-1.414l-7-7a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 0 1.414Z",
      fill: "#212121"
    })
  });
};

exports.UpIcon = UpIcon;


/***/ }),

/***/ 52096:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var React = __webpack_require__(91987);
var context = __webpack_require__(91799);
var UpIcon = __webpack_require__(27744);
var DownIcon = __webpack_require__(31826);
var menu = __webpack_require__(4637);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const MenuItemTile = ({ item }) => {
  var _a, _b;
  const { isEditingMode = false } = context.useOmniHeader();
  const [open, setOpen] = React.useState(false);
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(MenuItemWrapper, {
        onClick: () => setOpen(!open),
        children: [
          /* @__PURE__ */ jsxRuntime.jsxs(TitleWrapper, {
            href: menu.getUrlOfMenuItem(item, isEditingMode),
            children: [
              (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx("img", {
                src: item == null ? void 0 : item.iconUrl,
                width: 18,
                height: 18,
                alt: item == null ? void 0 : item.name
              }),
              item == null ? void 0 : item.name
            ]
          }),
          ((_a = item == null ? void 0 : item.children) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */ jsxRuntime.jsx("div", {
            children: open ? /* @__PURE__ */ jsxRuntime.jsx(UpIcon.UpIcon, {}) : /* @__PURE__ */ jsxRuntime.jsx(DownIcon.DownIcon, {})
          })
        ]
      }),
      open && /* @__PURE__ */ jsxRuntime.jsx("div", {
        style: { paddingLeft: "2em" },
        children: (_b = item == null ? void 0 : item.children) == null ? void 0 : _b.map((item2) => /* @__PURE__ */ jsxRuntime.jsx(MenuItemTile, {
          item: item2
        }))
      })
    ]
  });
};
const MenuItemWrapper = styled__default["default"].div`
  cursor: pointer;
  color: black;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0 0.5rem;
  overflow: hidden;
  padding: 10px 16px;
  border-top: 1px solid #eeeeee;

  a {
    color: black;
  }
`;
const TitleWrapper = styled__default["default"].a`
  display: flex;
  align-items: center;
  gap: 0.5em;
`;

exports.MenuItemTile = MenuItemTile;
exports.MenuItemWrapper = MenuItemWrapper;


/***/ }),

/***/ 67134:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var styled = __webpack_require__(21483);
var context = __webpack_require__(91799);
var CloseIcon = __webpack_require__(34765);
var MenuItemTile = __webpack_require__(52096);
var menu = __webpack_require__(4637);
var coreRenderer = __webpack_require__(12060);
var Link = __webpack_require__(9231);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MobileDrawer = ({ setMenuOpen, topBarMenu = [] }) => {
  const { menu: menu$1 = [] } = context.useOmniHeader();
  const tree = menu.flattenToTree((menu$1 || []).filter((el) => !el.isHidden));
  return /* @__PURE__ */ jsxRuntime.jsxs(Drawer, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(Menu, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx("div", {
            style: {
              display: "flex",
              padding: "1em"
            },
            children: /* @__PURE__ */ jsxRuntime.jsx(CloseDrawer, {
              onClick: () => setMenuOpen(false),
              children: /* @__PURE__ */ jsxRuntime.jsx(CloseIcon.CloseIcon, {})
            })
          }),
          tree == null ? void 0 : tree.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx(MenuItemTile.MenuItemTile, {
            item
          }, index))
        ]
      }),
      /* @__PURE__ */ jsxRuntime.jsx(TopBarMenu, {
        children: topBarMenu == null ? void 0 : topBarMenu.map(({ event, icon, title }, index) => /* @__PURE__ */ React.createElement(StyledLink, __spreadProps(__spreadValues({}, event), {
          key: index
        }), /* @__PURE__ */ jsxRuntime.jsxs(TopBarItem, {
          children: [
            (icon == null ? void 0 : icon.src) && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadProps(__spreadValues({}, icon), {
              commonStyle: {
                width: 18,
                height: 18
              }
            })),
            title
          ]
        })))
      })
    ]
  });
};
const Menu = styled__default["default"].div`
  background-color: white;
`;
const TopBarMenu = styled__default["default"].div`
  background-color: white;
  margin-top: 1em;
`;
const Drawer = styled__default["default"].div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f8f8fc;
  z-index: 1060;
`;
const CloseDrawer = styled__default["default"].div`
  display: inline-block;
  cursor: pointer;
  margin-left: auto;
`;
const StyledLink = styled__default["default"](Link.Link)`
  display: flex;
`;
const TopBarItem = styled__default["default"].div`
  cursor: pointer;
  color: black;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;
  overflow: hidden;
  padding: 10px 16px;
  border-top: 1px solid #eeeeee;

  a {
    color: black;
  }
`;

exports.MobileDrawer = MobileDrawer;


/***/ }),

/***/ 31280:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const MobileSearchBar = ({ searchSlot, rightItemsSlot, isRightItemsVisible }) => {
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    children: [
      searchSlot,
      isRightItemsVisible && rightItemsSlot
    ]
  });
};
const Wrapper = styled__default["default"].div`
  margin: 0 1rem;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  & > *:not(:first-child) {
    margin-left: 1rem;
  }
`;

exports.MobileSearchBar = MobileSearchBar;


/***/ }),

/***/ 12951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var React = __webpack_require__(91987);
var useIntersectionObserver = __webpack_require__(65380);
var coreRenderer = __webpack_require__(12060);
var context = __webpack_require__(91799);
var MobileDrawer = __webpack_require__(67134);
var MobileSearchBar = __webpack_require__(31280);
var renderDynamicSlot = __webpack_require__(64915);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniMobileHeader = (_a) => {
  var _b = _a, {
    ssrData
  } = _b, rest = __objRest(_b, [
    "ssrData"
  ]);
  const { isEditingMode = false } = context.useOmniHeader();
  const { topBarMenu = [], logoMobile } = rest || {};
  const { mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(
    rest,
    "mobile"
  ), { primaryColor, commonStyle } = _a2, others = __objRest(_a2, ["primaryColor", "commonStyle"]);
  const [isMenuOpen, setMenuOpen] = React__default["default"].useState(false);
  const headerRef = React.useRef(null);
  const [isVisible] = useIntersectionObserver.useIntersectionObserver({
    elementRef: headerRef,
    threshold: 0
  });
  const searchSlot = renderDynamicSlot.renderDynamicSlot(
    `header_search_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  const searchBarRightItemsSlot = renderDynamicSlot.renderDynamicSlot(
    `search_bar_right_items_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  const headerRightItemsSlot = renderDynamicSlot.renderDynamicSlot(
    `header_right_items_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      isMenuOpen && /* @__PURE__ */ jsxRuntime.jsx(MobileDrawer.MobileDrawer, {
        setMenuOpen,
        topBarMenu
      }),
      /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
        ref: headerRef,
        primaryColor,
        commonStyle
      }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsxs(NavigationBar, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(LogoWrapper, {
              children: [
                false,
                (logoMobile == null ? void 0 : logoMobile.src) && /* @__PURE__ */ jsxRuntime.jsx(Logo, {
                  href: isEditingMode ? null : "/",
                  children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadProps(__spreadValues({}, logoMobile), {
                    alt: "logo"
                  }))
                })
              ]
            }),
            headerRightItemsSlot
          ]
        })
      })),
      /* @__PURE__ */ jsxRuntime.jsx(SearchBarWrapper, __spreadProps(__spreadValues({
        primaryColor,
        isEditingMode
      }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx(MobileSearchBar.MobileSearchBar, {
          searchSlot,
          rightItemsSlot: searchBarRightItemsSlot,
          isRightItemsVisible: !isVisible
        })
      }))
    ]
  });
};
const Wrapper = styled__default["default"].header(
  ({ commonStyle, primaryColor }) => `
  position: relative; 
  background-color: ${primaryColor};
  ${coreRenderer.getStyle(commonStyle)}
        `
);
const NavigationBar = styled__default["default"].nav`
  display: flex;
  padding: 8px 16px 0 16px;
  color: white;
  justify-content: space-between;
  align-items: center;
`;
const SearchBarWrapper = styled__default["default"].div(
  ({ primaryColor, isEditingMode }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.5rem;
  background: ${primaryColor};
  position: sticky;
  top: 0;
  margin-bottom: 8px;
  ${isEditingMode ? "" : "z-index: 1040;"}
`
);
styled__default["default"].div`
  margin-right: 0.5em;
  cursor: pointer;
`;
const Logo = styled__default["default"].a`
  user-select: none;
`;
const LogoWrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

exports.OmniMobileHeader = OmniMobileHeader;


/***/ }),

/***/ 31294:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var useMediaQuery = __webpack_require__(27116);
var context = __webpack_require__(91799);
var OmniMobileHeader = __webpack_require__(12951);
var OmniDesktopHeader = __webpack_require__(84956);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const OmniHeader = (props) => {
  const { isEditingMode } = props;
  const { device, globalData } = coreRenderer.useStore();
  const menu = isEditingMode ? props == null ? void 0 : props.menu : (globalData == null ? void 0 : globalData.menu) || [];
  const isMobile = useMediaQuery.useMediaQuery("(max-width: 768px)");
  const renderByDevice = () => {
    if (device === "mobile" || isMobile)
      return /* @__PURE__ */ jsxRuntime.jsx(OmniMobileHeader.OmniMobileHeader, __spreadProps(__spreadValues({}, props), {
        menu
      }));
    return /* @__PURE__ */ jsxRuntime.jsx(OmniDesktopHeader.OmniDesktopHeader, __spreadProps(__spreadValues({}, props), {
      menu
    }));
  };
  return /* @__PURE__ */ jsxRuntime.jsx(context.OmniHeaderProvider, {
    value: { menu, isEditingMode },
    children: renderByDevice()
  });
};
OmniHeader.displayName = "Omni_Header";

exports.OmniHeader = OmniHeader;


/***/ }),

/***/ 11140:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var icons = __webpack_require__(94556);
var coreRenderer = __webpack_require__(12060);
var Container = __webpack_require__(61703);
var renderDynamicSlot = __webpack_require__(64915);
var grid = __webpack_require__(29297);
var BlockHeader = __webpack_require__(59941);
var renderLink = __webpack_require__(45292);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniProductList = (_a) => {
  var _b = _a, {
    ssrData,
    isEditingMode
  } = _b, restProps = __objRest(_b, [
    "ssrData",
    "isEditingMode"
  ]);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    collectionSlug,
    commonStyle,
    title,
    titleStyle,
    viewMoreUrl,
    viewMoreStyle
  } = _a2, rest = __objRest(_a2, [
    "collectionSlug",
    "commonStyle",
    "title",
    "titleStyle",
    "viewMoreUrl",
    "viewMoreStyle"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const renderViewAllLink = () => {
    if (!viewMoreUrl)
      return null;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewAll, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(viewMoreUrl, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsxs(Header, {
          device,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
              commonStyle: titleStyle,
              children: title
            }),
            renderViewAllLink()
          ]
        }),
        renderDynamicSlot.renderDynamicSlot(
          `product_grid_${device}`,
          mappingDynamicSlots,
          ssrData,
          {
            collectionSlug,
            config: {
              regionName: "forYouListProduct"
            }
          }
        )
      ]
    })
  }));
};
OmniProductList.displayName = "Omni_ProductList";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  border-radius: 0.5rem;
  background: #ffffff;
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const Header = styled__default["default"](BlockHeader.BlockHeader)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  flex: 1;
  margin-right: 8px;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const ViewAll = styled__default["default"].div(
  ({ commonStyle }) => `
  display: flex;
  align-items: center;
  ${coreRenderer.getStyle(commonStyle)}
`
);

exports.OmniProductList = OmniProductList;


/***/ }),

/***/ 95713:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var Container = __webpack_require__(61703);
var BlockHeader = __webpack_require__(59941);
var Slider = __webpack_require__(29062);
var grid = __webpack_require__(29297);
var getStyles = __webpack_require__(82016);
var renderLink = __webpack_require__(45292);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const RecommendBrand = (_a) => {
  var _b = _a, {
    isEditingMode
  } = _b, restProps = __objRest(_b, [
    "isEditingMode"
  ]);
  var _c;
  const { device } = coreRenderer.useStore();
  const isDesktop = device === "desktop";
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    title,
    titleStyle,
    altStyle,
    showAlt = true,
    items
  } = _a2, rest = __objRest(_a2, [
    "commonStyle",
    "title",
    "titleStyle",
    "altStyle",
    "showAlt",
    "items"
  ]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const renderBrandItem = (item, index) => {
    const { event, googleImageParams, src, alt } = item;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(BrandItem, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(ImageWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues({
            googleImageParams,
            src: src || defaultImage,
            alt: alt || "Brand",
            isEditingMode,
            commonStyle: __spreadValues({
              width: "100%",
              borderRadius: 8,
              objectFit: "cover"
            }, isDesktop ? {
              height: "140px",
              hover: { zoom: 103 }
            } : {
              height: "120px"
            })
          }, !isEditingMode && coreRenderer.getTrackingData({
            isTrackContent: true,
            regionName: "topBrands",
            contentName: alt,
            index,
            target: coreRenderer.getTargetOfTrackingFromEvent(event)
          })))
        }),
        showAlt && /* @__PURE__ */ jsxRuntime.jsx(BrandTitle, {
          commonStyle: altStyle,
          children: alt
        })
      ]
    });
    return renderLink.renderLink(event, content, isEditingMode, index);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
            commonStyle: titleStyle,
            children: title
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(RecommendBrandWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, __spreadProps(__spreadValues({
            allowTouchMove: !isEditingMode
          }, isDesktop ? { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 8 } : { slidesPerView: 1.5, spaceBetween: 16 }), {
            children: (_c = displayItems == null ? void 0 : displayItems.map) == null ? void 0 : _c.call(displayItems, (item, index) => renderBrandItem(item, index))
          }))
        })
      ]
    })
  }));
};
RecommendBrand.displayName = "Omni_BannerSlider_2";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => getStyles.getStyle(commonStyle)
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    ${getStyles.getStyle(commonStyle)}
  `
);
const RecommendBrandWrapper = styled__default["default"].div`
  width: 100%;
  padding: 12px 16px;
`;
const ImageWrapper = styled__default["default"].div`
  width: 100%;
  height: 100%;
`;
const BrandItem = styled__default["default"].div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
`;
const BrandTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  margin-top: 0.5rem;
  font-size: 15px;
  line-height: 24px;
  font-weight: 500;
  ${getStyles.getStyle(commonStyle)}
`
);

exports.RecommendBrand = RecommendBrand;


/***/ }),

/***/ 98610:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var Container = __webpack_require__(61703);
var BlockHeader = __webpack_require__(59941);
var Slider = __webpack_require__(29062);
var renderLink = __webpack_require__(45292);
var grid = __webpack_require__(29297);
var getStyles = __webpack_require__(82016);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const RecommendCategory = (_a) => {
  var _b = _a, {
    isEditingMode = false
  } = _b, restProps = __objRest(_b, [
    "isEditingMode"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), { title, items, commonStyle, altStyle, titleStyle } = _a2, rest = __objRest(_a2, ["title", "items", "commonStyle", "altStyle", "titleStyle"]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  if (!(displayItems == null ? void 0 : displayItems.length) && !isEditingMode)
    return null;
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
            commonStyle: titleStyle,
            children: title
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(CategoryWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, __spreadProps(__spreadValues({
            allowTouchMove: !isEditingMode
          }, device === "desktop" ? { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 24 } : {
            slidesPerView: 2.5,
            slidesPerColumn: 2,
            spaceBetween: 16,
            isMultipleRows: true
          }), {
            children: displayItems == null ? void 0 : displayItems.map(({ src, event, alt }, index) => {
              const content = /* @__PURE__ */ jsxRuntime.jsxs(CategoryItem, __spreadProps(__spreadValues({}, !isEditingMode && coreRenderer.getTrackingData({
                isTrackContent: true,
                regionName: "topCategories",
                contentName: title,
                target: coreRenderer.getTargetOfTrackingFromEvent(event),
                index
              })), {
                children: [
                  /* @__PURE__ */ jsxRuntime.jsx(StyledImage, {
                    src: src || defaultImage,
                    alt: alt || "Image",
                    commonStyle: {
                      borderRadius: 12,
                      objectFit: "contain",
                      width: "100%"
                    }
                  }),
                  !!alt && /* @__PURE__ */ jsxRuntime.jsx(CategoryTitle, {
                    commonStyle: altStyle,
                    children: alt
                  })
                ]
              }), index);
              return renderLink.renderLink(event, content, isEditingMode, index);
            })
          }))
        })
      ]
    })
  }));
};
RecommendCategory.displayName = "Omni_RecommendCategory";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => getStyles.getStyle(commonStyle)
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  transition: color 0.3s ease 0s;
  ${getStyles.getStyle(commonStyle)}
`
);
const CategoryWrapper = styled__default["default"].div`
  padding: 12px 16px;
`;
const CategoryItem = styled__default["default"].div`
  flex-direction: column;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;
const StyledImage = styled__default["default"](coreRenderer.ImageBase)`
  border-radius: 12px;
  box-shadow: rgb(217 217 217) 0px 4px 8px 0px;
`;
const CategoryTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  transition: color 0.3s ease 0s;
  z-index: 1;
  background-color: white;
  padding: 3px 10px;
  border-radius: 12px;
  max-width: 90%;
  box-shadow: rgb(217 217 217) 0px 4px 8px 0px;
  position: absolute;
  bottom: 0;
  transform: translateY(50%);
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  font-weight: 400;
  ${getStyles.getStyle(commonStyle)}
`
);

exports.RecommendCategory = RecommendCategory;


/***/ }),

/***/ 97108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var Container = __webpack_require__(61703);
var Slider = __webpack_require__(29062);
var grid = __webpack_require__(29297);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const SlideBanner = (_a) => {
  var _b = _a, {
    isEditingMode = false
  } = _b, restProps = __objRest(_b, [
    "isEditingMode"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    autoSwipeTimeMilliseconds,
    items = []
  } = _a2, rest = __objRest(_a2, [
    "commonStyle",
    "autoSwipeTimeMilliseconds",
    "items"
  ]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: __spreadValues({ maxWidth: grid.DEFAULT_MAX_WIDTH }, commonStyle)
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, {
      pagination: true,
      paginationStyle: 1,
      virtual: true,
      paginationColor: "#ffffff",
      loop: true,
      allowTouchMove: !isEditingMode,
      autoplay: !!autoSwipeTimeMilliseconds,
      speed: autoSwipeTimeMilliseconds,
      children: displayItems.map((el, index) => {
        return /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues({
          event: el.event,
          isEditingMode,
          googleImageParams: el.googleImageParams || { width: 1e3 },
          src: el.src || defaultImage,
          alt: el.alt || "Image",
          commonStyle: {
            objectFit: "cover",
            width: "100%",
            borderRadius: 10
          }
        }, !isEditingMode && coreRenderer.getTrackingData({
          isTrackContent: true,
          regionName: "topBannerHomepage",
          contentName: "slideBanner",
          target: coreRenderer.getTargetOfTrackingFromEvent(el.event),
          index
        })), index);
      })
    })
  }));
};
SlideBanner.displayName = "Omni_BannerSlider";

exports.SlideBanner = SlideBanner;


/***/ }),

/***/ 14135:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var Container = __webpack_require__(61703);
var renderDynamicSlot = __webpack_require__(64915);
var grid = __webpack_require__(29297);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const VisualizeBlock = React__default["default"].forwardRef((props, ref) => {
  const { mappingDynamicSlots } = coreRenderer.useStore();
  const _a = props, { commonStyle, isEditingMode, type } = _a, rest = __objRest(_a, ["commonStyle", "isEditingMode", "type"]);
  if (!(mappingDynamicSlots == null ? void 0 : mappingDynamicSlots[type]))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    ref,
    commonStyle: __spreadProps(__spreadValues({}, commonStyle), { maxWidth: grid.DEFAULT_MAX_WIDTH })
  }, rest), {
    children: renderDynamicSlot.renderDynamicSlot(type, mappingDynamicSlots)
  }));
});

exports.VisualizeBlock = VisualizeBlock;


/***/ }),

/***/ 93990:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var visualizeBlock = __webpack_require__(14135);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const PendingPayment = React__default["default"].forwardRef((props, ref) => {
  return /* @__PURE__ */ jsxRuntime.jsx(visualizeBlock.VisualizeBlock, __spreadValues({
    type: "pending_payment",
    ref
  }, props));
});
PendingPayment.displayName = "Omni_PendingPayment";

exports.PendingPayment = PendingPayment;


/***/ }),

/***/ 88240:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var visualizeBlock = __webpack_require__(14135);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const RecentProduct = React__default["default"].forwardRef((props, ref) => {
  return /* @__PURE__ */ jsxRuntime.jsx(visualizeBlock.VisualizeBlock, __spreadValues({
    type: "recent_product",
    ref
  }, props));
});
RecentProduct.displayName = "Omni_RecentProduct";

exports.RecentProduct = RecentProduct;


/***/ }),

/***/ 9702:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var visualizeBlock = __webpack_require__(14135);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const RecentSearch = React__default["default"].forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsxRuntime.jsx(visualizeBlock.VisualizeBlock, __spreadValues({
      type: "recent_search",
      ref
    }, props));
  }
);
RecentSearch.displayName = "Omni_RecentSearch";

exports.RecentSearch = RecentSearch;


/***/ }),

/***/ 22572:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var ui$4 = __webpack_require__(14529);
var ui = __webpack_require__(9702);
var ui$1 = __webpack_require__(88240);
var ui$2 = __webpack_require__(93990);
var ui$3 = __webpack_require__(11140);
var index = __webpack_require__(70776);
var ui$5 = __webpack_require__(18111);
var ui$6 = __webpack_require__(98610);
var ui$7 = __webpack_require__(95713);
var ui$8 = __webpack_require__(36182);
var ui$9 = __webpack_require__(97108);
var CountdownSkuList = __webpack_require__(26712);
var CategoryMenu = __webpack_require__(80228);
var MixBanner = __webpack_require__(97841);

const ECOMERCE_COMPONENT_TAG = {
  RECENT_SEARCH: ui.RecentSearch.displayName.toLowerCase(),
  RECENT_PRODUCT: ui$1.RecentProduct.displayName.toLowerCase(),
  PENDING_PAYMENT: ui$2.PendingPayment.displayName.toLowerCase(),
  PRODUCT_LIST: ui$3.OmniProductList.displayName.toLowerCase(),
  COUNT_DOWN_SKU_LIST: CountdownSkuList.CountdownSkuList.displayName.toLowerCase(),
  COUNT_DOWN_SKU_LIST_V2: index.CountdownSkuListV2.displayName.toLowerCase(),
  CAROUSEL_SKU_LIST: ui$4.CarouselSkuList.displayName.toLowerCase(),
  LISTING_TAB: ui$5.ListingTab.displayName.toLowerCase(),
  PROMOTE_CATEGORY_MENU: CategoryMenu.CategoryMenu.displayName.toLowerCase(),
  RECOMMENDED_CATEGORY: ui$6.RecommendCategory.displayName.toLowerCase(),
  RECOMMENDED_BRAND: ui$7.RecommendBrand.displayName.toLowerCase(),
  HERO_BANNER: ui$8.HeroBanner.displayName.toLowerCase(),
  MIX_BANNER: MixBanner.MixBanner.displayName.toLowerCase(),
  SLIDE_BANNER: ui$9.SlideBanner.displayName.toLowerCase()
};
const SSR_COMPONENT_TAGS = [
  ECOMERCE_COMPONENT_TAG.PRODUCT_LIST,
  ECOMERCE_COMPONENT_TAG.COUNT_DOWN_SKU_LIST,
  ECOMERCE_COMPONENT_TAG.CAROUSEL_SKU_LIST,
  ECOMERCE_COMPONENT_TAG.LISTING_TAB,
  ECOMERCE_COMPONENT_TAG.HERO_BANNER,
  ECOMERCE_COMPONENT_TAG.COUNT_DOWN_SKU_LIST_V2
];

exports.ECOMERCE_COMPONENT_TAG = ECOMERCE_COMPONENT_TAG;
exports.SSR_COMPONENT_TAGS = SSR_COMPONENT_TAGS;


/***/ }),

/***/ 29297:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);
var grid = __webpack_require__(99761);

const DEFAULT_MAX_WIDTH = 1232;
const BREAK_POINTS = {
  xs: "480px",
  sm: "576px",
  md: "768px",
  lg: "1024px",
  xl: "1440px",
  xxl: "1600px"
};
const GRID_COLUMNS = 12;
({
  [coreRenderer.VerticalAlignment.top]: "flex-start",
  [coreRenderer.VerticalAlignment.center]: "center",
  [coreRenderer.VerticalAlignment.bottom]: "flex-end"
});
const MAPPING_ALIGNMENT_FLEX = {
  [coreRenderer.Alignment.center]: "center",
  [coreRenderer.Alignment.left]: "flex-start",
  [coreRenderer.Alignment.right]: "flex-end",
  [coreRenderer.Alignment.justify]: "space-between"
};
const DEFAULT_GUTTER = [0, 0];
const DEFAULT_WIDTH = 1232;
const DEFAULT_HEIGHT = 400;
const WIDTH_TYPE_OPTIONS = [
  { label: "To\xE0n b\u1ED9 chi\u1EC1u r\u1ED9ng", value: grid.WidthTypeEnum.full },
  { label: "T\xF9y ch\u1EC9nh", value: grid.WidthTypeEnum.fixed }
];

exports.BREAK_POINTS = BREAK_POINTS;
exports.DEFAULT_GUTTER = DEFAULT_GUTTER;
exports.DEFAULT_HEIGHT = DEFAULT_HEIGHT;
exports.DEFAULT_MAX_WIDTH = DEFAULT_MAX_WIDTH;
exports.DEFAULT_WIDTH = DEFAULT_WIDTH;
exports.GRID_COLUMNS = GRID_COLUMNS;
exports.MAPPING_ALIGNMENT_FLEX = MAPPING_ALIGNMENT_FLEX;
exports.WIDTH_TYPE_OPTIONS = WIDTH_TYPE_OPTIONS;


/***/ }),

/***/ 59941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const BlockHeader = styled__default["default"].div(
  ({ device }) => `
    padding: ${device === "desktop" ? "1rem" : "0.5rem"} 1rem;
  `
);

exports.BlockHeader = BlockHeader;


/***/ }),

/***/ 61703:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var grid = __webpack_require__(29297);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Container = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
    return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
      ref,
      fluid,
      maxWidth
    }, others), {
      children
    }));
  }
);
const Wrapper = styled__default["default"].div(
  ({ fluid, maxWidth, commonStyle }) => `
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    ${coreRenderer.getStyle(commonStyle)}
    
    @media (min-width: ${grid.BREAK_POINTS.xl}) {
      max-width: ${fluid ? "100%" : coreRenderer.unitParse(maxWidth)};
    }
  `
);

exports.Container = Container;


/***/ }),

/***/ 58361:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var grid = __webpack_require__(29297);
var getISODateBackward = __webpack_require__(48180);
var addPaddingNumber = __webpack_require__(27440);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Countdown = ({
  countdownType: _countdownType = "due",
  due,
  showDays = true,
  showHours = true,
  showMinutes = true,
  showSeconds = true,
  showLabel = false,
  labelDays,
  labelHours,
  labelMinutes,
  labelSeconds,
  countdownStyle,
  commonStyle,
  splitTimeUnit
}) => {
  const {
    elementGap,
    labelGap,
    digitStyle,
    labelStyle,
    timeUnitStyle,
    layout,
    labelPosition,
    align
  } = countdownStyle || {};
  const finalDue = getISODateBackward.getISODateBackward(due);
  const dueDate = new Date(finalDue);
  const [duration, setDuration] = React.useState(
    coreRenderer.calculateTimeDelta(new Date(), dueDate)
  );
  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setDuration(coreRenderer.calculateTimeDelta(new Date(), dueDate));
    }, 1e3);
    return () => {
      clearInterval(intervalId);
    };
  }, [finalDue]);
  if (dueDate.toString() === "Invalid Date")
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    align,
    children: /* @__PURE__ */ jsxRuntime.jsxs(TimeWrapper, {
      commonStyle: __spreadProps(__spreadValues({}, commonStyle), { gap: elementGap }),
      children: [
        showDays && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(TimeUnit, {
              layout,
              labelPosition,
              labelGap,
              timeUnitStyle,
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(Digit, {
                  digitStyle,
                  children: addPaddingNumber.addPaddingNumber(duration.days)
                }),
                showLabel && /* @__PURE__ */ jsxRuntime.jsx(Label, {
                  labelStyle,
                  children: labelDays
                })
              ]
            }),
            !!splitTimeUnit && splitTimeUnit
          ]
        }),
        showHours && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(TimeUnit, {
              layout,
              labelPosition,
              labelGap,
              timeUnitStyle,
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(Digit, {
                  digitStyle,
                  children: addPaddingNumber.addPaddingNumber(duration.hours)
                }),
                showLabel && /* @__PURE__ */ jsxRuntime.jsx(Label, {
                  labelStyle,
                  children: labelHours
                })
              ]
            }),
            !!splitTimeUnit && splitTimeUnit
          ]
        }),
        showMinutes && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(TimeUnit, {
              layout,
              labelPosition,
              labelGap,
              timeUnitStyle,
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(Digit, {
                  digitStyle,
                  children: addPaddingNumber.addPaddingNumber(duration.minutes)
                }),
                showLabel && /* @__PURE__ */ jsxRuntime.jsx(Label, {
                  labelStyle,
                  children: labelMinutes
                })
              ]
            }),
            !!splitTimeUnit && splitTimeUnit
          ]
        }),
        showSeconds && /* @__PURE__ */ jsxRuntime.jsxs(TimeUnit, {
          layout,
          labelPosition,
          labelGap,
          timeUnitStyle,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(Digit, {
              digitStyle,
              children: addPaddingNumber.addPaddingNumber(duration.seconds)
            }),
            showLabel && /* @__PURE__ */ jsxRuntime.jsx(Label, {
              labelStyle,
              children: labelSeconds
            })
          ]
        })
      ]
    })
  });
};
const Wrapper = styled__default["default"].div(
  ({ align }) => `
  display: flex;
  justify-content: ${grid.MAPPING_ALIGNMENT_FLEX[align]};
`
);
const TimeWrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)};
  display: flex;
`
);
const Digit = styled__default["default"].div(
  ({ digitStyle }) => `
  ${coreRenderer.getStyle(digitStyle)}
  @media only screen and (max-width: 480px){
    font-size: min(${digitStyle == null ? void 0 : digitStyle.fontSize}px, 30px);
  }
`
);
const Label = styled__default["default"].div(
  ({ labelStyle }) => `
  ${coreRenderer.getStyle(labelStyle)}
  @media only screen and (max-width: 480px){
    font-size: min(${labelStyle == null ? void 0 : labelStyle.fontSize}px, 30px);
  }
`
);
const TimeUnit = styled__default["default"].div(
  ({ layout, labelPosition, labelGap, timeUnitStyle }) => `
  ${coreRenderer.getStyle(timeUnitStyle)}
  display: flex;
  ${labelGap ? `gap: ${labelGap}px;` : ""}
  ${layout === "horizontal" ? `align-items: ${labelPosition};` : `flex-direction: column;`};
`
);
Countdown.displayName = "Countdown";

exports.Countdown = Countdown;


/***/ }),

/***/ 36838:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const EmptyProduct = () => {
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: "Danh s\xE1ch s\u1EA3n ph\u1EA9m tr\u1ED1ng"
  });
};
const Wrapper = styled__default["default"].div`
  height: 200px;
  line-height: 200px;
  text-align: center;
`;

exports.EmptyProduct = EmptyProduct;


/***/ }),

/***/ 50366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var react = __webpack_require__(75537);
var styled = __webpack_require__(21483);
var clsx = __webpack_require__(81892);
var React = __webpack_require__(91987);
var RowContext = __webpack_require__(24529);
var grid = __webpack_require__(29297);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function parseFlex(flex) {
  if (typeof flex === "number") {
    return `${flex} ${flex} auto`;
  }
  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return `0 0 ${flex}`;
  }
  return flex;
}
const sizes = ["xs", "sm", "md", "lg", "xl", "xxl"];
const Col = React__default["default"].forwardRef(
  (props, ref) => {
    const { gutter, wrap } = React__default["default"].useContext(RowContext);
    const _a = props, {
      span,
      order,
      offset,
      push,
      pull,
      className,
      children,
      flex,
      style
    } = _a, others = __objRest(_a, [
      "span",
      "order",
      "offset",
      "push",
      "pull",
      "className",
      "children",
      "flex",
      "style"
    ]);
    const prefixCls = "teko-col";
    let sizeClassObj = {};
    sizes.forEach((size) => {
      let sizeProps = {};
      const propSize = props[size];
      if (typeof propSize === "number") {
        sizeProps.span = propSize;
      } else if (typeof propSize === "object") {
        sizeProps = propSize || {};
      }
      sizeClassObj = __spreadProps(__spreadValues({}, sizeClassObj), {
        [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== void 0,
        [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
        [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
        [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
        [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0
      });
    });
    const classes = clsx__default["default"](
      prefixCls,
      {
        [`${prefixCls}-${span}`]: span !== void 0,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull
      },
      className,
      sizeClassObj
    );
    let mergedStyle = __spreadValues({}, style);
    if (gutter) {
      mergedStyle = __spreadValues(__spreadValues({}, gutter[0] && gutter[0] > 0 ? {
        paddingLeft: gutter[0] / 2,
        paddingRight: gutter[0] / 2
      } : {}), mergedStyle);
    }
    if (flex) {
      mergedStyle.flex = parseFlex(flex);
      if (flex === "auto" && wrap === false && !mergedStyle.minWidth) {
        mergedStyle.minWidth = 0;
      }
    }
    return /* @__PURE__ */ jsxRuntime.jsx(StyledCol, __spreadProps(__spreadValues({}, others), {
      style: mergedStyle,
      className: classes,
      ref,
      children
    }));
  }
);
const floorPercentage = (percent) => {
  return Math.floor(percent * 100) / 100;
};
const percentage = (x, y) => {
  return floorPercentage(x / y * 100) + "%";
};
const loopGridColumn = (_class = "") => {
  let _css = `
    &.teko-col${_class}-0 {
      display: none;
    }
    &.teko-col-push-0 {
      left: auto;
    }
    &.teko-col-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-push-0 {
      left: auto;
    }
    &.teko-col${_class}-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-offset-0 {
      margin-left: 0;
    }
    &.teko-col${_class}-order-0 {
      order: 0;
    }
  `;
  for (let i = 1; i <= 24; i++) {
    _css += `
      &.teko-col${_class}-${i} {
        display: block;
        flex: 0 0 ${percentage(i, grid.GRID_COLUMNS)};
        max-width: ${_class === "-lg" ? "84px" : ["-xl", "-xxl"].includes(_class) ? "104px" : percentage(i, grid.GRID_COLUMNS)};
      }
      &.teko-col${_class}-push-${i} {
        left: ${percentage(i, grid.GRID_COLUMNS)};
      }
      &.teko-col${_class}-pull-${i} {
        right: ${percentage(i, grid.GRID_COLUMNS)};
      }
      &.teko-col${_class}-offset-${i} {
        margin-left: ${percentage(i, grid.GRID_COLUMNS)};
      }
      &.teko-col${_class}-order-${i} {
        order: ${i};
      }
    `;
  }
  return _css;
};
const makeGrid = react.css`
  ${loopGridColumn()}
  ${loopGridColumn("-xs")}
  ${Object.keys(grid.BREAK_POINTS).map(
  (label) => label !== "xs" ? `
    @media (min-width: ${grid.BREAK_POINTS[label]}) {
      ${loopGridColumn(`-${label}`)}
    }
  ` : ""
).join("")}
`;
const flexStyle = (flex) => {
  if (!flex)
    return;
  return `
    flex: ${parseFlex(flex)};
    ${typeof flex === "string" ? `max-width: ${flex} !important;` : ""}
  `;
};
const makeFlexStyles = (props) => {
  var _a;
  return react.css`
    ${typeof props.xs === "object" && ((_a = props.xs) == null ? void 0 : _a.flex) !== void 0 ? flexStyle(props.xs.flex) : ""}
    ${Object.keys(grid.BREAK_POINTS).map(
    (label) => {
      var _a2, _b;
      return ((_a2 = props[label]) == null ? void 0 : _a2.flex) && label !== "xs" ? `
      @media (min-width: ${grid.BREAK_POINTS[label]}) {
        ${flexStyle((_b = props[label]) == null ? void 0 : _b.flex)};
      }
    ` : "";
    }
  ).join("")}
  `;
};
const StyledCol = styled__default["default"].div(
  `
  &.teko-col {
    position: relative;
    max-width: 100%;
    // Prevent columns from collapsing when empty
    min-height: 1px;
  }`,
  makeGrid,
  makeFlexStyles
);

exports.Col = Col;
exports.floorPercentage = floorPercentage;
exports.percentage = percentage;


/***/ }),

/***/ 83042:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var clsx = __webpack_require__(81892);
var React = __webpack_require__(91987);
var RowContext = __webpack_require__(24529);
var util = __webpack_require__(35340);
var grid = __webpack_require__(29297);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Row = React__default["default"].forwardRef((props, ref) => {
  const _a = props, {
    justify,
    align,
    className,
    style,
    children,
    gutter = 0,
    wrap
  } = _a, others = __objRest(_a, [
    "justify",
    "align",
    "className",
    "style",
    "children",
    "gutter",
    "wrap"
  ]);
  const [screens, setScreens] = React__default["default"].useState({
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true
  });
  const gutterRef = React__default["default"].useRef(gutter);
  React__default["default"].useEffect(() => {
    const token = util["default"].subscribe((screen) => {
      const currentGutter = gutterRef.current || 0;
      if (!Array.isArray(currentGutter) && typeof currentGutter === "object" || Array.isArray(currentGutter) && (typeof currentGutter[0] === "object" || typeof currentGutter[1] === "object")) {
        setScreens(screen);
      }
    });
    return () => util["default"].unsubscribe(token);
  }, []);
  const getGutter = () => {
    const results = [0, 0];
    const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
    normalizedGutter.forEach((g, index) => {
      if (typeof g === "object") {
        for (let i = 0; i < util.responsiveArray.length; i++) {
          const breakpoint = util.responsiveArray[i];
          if (screens[breakpoint] && g[breakpoint] !== void 0) {
            results[index] = g[breakpoint];
            break;
          }
        }
      } else {
        results[index] = g || 0;
      }
    });
    return results;
  };
  const prefixCls = "teko-row";
  const gutters = getGutter();
  const classes = clsx__default["default"](
    prefixCls,
    {
      [`${prefixCls}-no-wrap`]: wrap === false,
      [`${prefixCls}-${justify}`]: justify,
      [`${prefixCls}-${align}`]: align
    },
    className
  );
  const rowStyle = __spreadValues(__spreadValues(__spreadValues({}, gutters[0] && gutters[0] > 0 ? {
    marginLeft: gutters[0] / -2,
    marginRight: gutters[0] / -2
  } : {}), gutters[1] && gutter[1] > 0 ? {
    rowGap: gutters[1]
  } : {}), style);
  return /* @__PURE__ */ jsxRuntime.jsx(RowContext.Provider, {
    value: { gutter: gutters, wrap },
    children: /* @__PURE__ */ jsxRuntime.jsx(StyledRow, __spreadProps(__spreadValues({}, others), {
      className: classes,
      commonStyle: rowStyle,
      ref,
      children
    }))
  });
});
const StyledRow = styled__default["default"].div(
  `
    &.teko-row {
      display: flex;
      flex-flow: row wrap;
    }
    @media (min-width: ${grid.BREAK_POINTS.lg}) {
      &.teko-row {
        justify-content: center;
      }
    }
    &.teko-row:before,
    &.teko-row:after {
      display: flex;
    }

    // No wrap of flex
    &.teko-row-no-wrap {
      flex-wrap: nowrap;
    }

    &.teko-row-start {
      justify-content: flex-start;
    }

    &.teko-row-center {
      justify-content: center;
    }

    &.teko-row-end {
      justify-content: flex-end;
    }

    &.teko-row-space-between {
      justify-content: space-between;
    }

    &.teko-row-space-around {
      justify-content: space-around;
    }

    &.teko-row-top {
      align-items: flex-start;
    }

    &.teko-row-middle {
      align-items: center;
    }

    &.teko-row-bottom {
      align-items: flex-end;
    }
  `,
  ({ commonStyle }) => coreRenderer.getStyle(commonStyle)
);

exports.Row = Row;


/***/ }),

/***/ 24529:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



var React = __webpack_require__(91987);

const RowContext = React.createContext({});
var RowContext$1 = RowContext;

module.exports = RowContext$1;


/***/ }),

/***/ 57338:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var Row = __webpack_require__(83042);
var Container = __webpack_require__(61703);
var grid = __webpack_require__(99761);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Section = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, { children, commonStyle, widthType, row } = _a, other = __objRest(_a, ["children", "commonStyle", "widthType", "row"]);
    const { maxWidth } = commonStyle;
    let rowStyle = row == null ? void 0 : row.style;
    rowStyle = __spreadValues({ minHeight: "inherit", height: "100%" }, rowStyle);
    if (rowStyle == null ? void 0 : rowStyle.maxWidth) {
      rowStyle = __spreadValues({
        marginLeft: "auto !important",
        marginRight: "auto !important"
      }, rowStyle);
    }
    return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
      maxWidth,
      fluid: widthType === grid.WidthTypeEnum.full,
      ref,
      commonStyle
    }, other), {
      children: /* @__PURE__ */ jsxRuntime.jsx(Row.Row, __spreadProps(__spreadValues({}, row), {
        style: rowStyle,
        children
      }))
    }));
  }
);

exports.Section = Section;


/***/ }),

/***/ 35340:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const responsiveArray = [
  "xxl",
  "xl",
  "lg",
  "md",
  "sm",
  "xs"
];
const responsiveMap = {
  xs: "(max-width: 575px)",
  sm: "(min-width: 576px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 1024px)",
  xl: "(min-width: 1440px)",
  xxl: "(min-width: 1600px)"
};
const subscribers = /* @__PURE__ */ new Map();
let subUid = -1;
let screens = {};
const responsiveObserve = {
  matchHandlers: {},
  dispatch(pointMap) {
    screens = pointMap;
    subscribers.forEach((func) => func(screens));
    return subscribers.size >= 1;
  },
  subscribe(func) {
    if (!subscribers.size)
      this.register();
    subUid += 1;
    subscribers.set(subUid, func);
    func(screens);
    return subUid;
  },
  unsubscribe(token) {
    subscribers.delete(token);
    if (!subscribers.size)
      this.unregister();
  },
  unregister() {
    Object.keys(responsiveMap).forEach((screen) => {
      const matchMediaQuery = responsiveMap[screen];
      const handler = this.matchHandlers[matchMediaQuery];
      handler == null ? void 0 : handler.mql.removeListener(handler == null ? void 0 : handler.listener);
    });
    subscribers.clear();
  },
  register() {
    Object.keys(responsiveMap).forEach((screen) => {
      const matchMediaQuery = responsiveMap[screen];
      const listener = ({ matches }) => {
        this.dispatch(__spreadProps(__spreadValues({}, screens), {
          [screen]: matches
        }));
      };
      const mql = window.matchMedia(matchMediaQuery);
      mql.addListener(listener);
      this.matchHandlers[matchMediaQuery] = {
        mql,
        listener
      };
      listener(mql);
    });
  }
};
var ResponsiveObserve = responsiveObserve;

exports["default"] = ResponsiveObserve;
exports.responsiveArray = responsiveArray;
exports.responsiveMap = responsiveMap;


/***/ }),

/***/ 9231:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var React = __webpack_require__(91987);
var coreRenderer = __webpack_require__(12060);

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Link = (_a) => {
  var _b = _a, {
    eventType,
    children,
    className,
    sectionMarginTop = 0,
    trackingEventName,
    conversionGGAdsId,
    conversionGGAdsLabel,
    scriptCustom
  } = _b, rest = __objRest(_b, [
    "eventType",
    "children",
    "className",
    "sectionMarginTop",
    "trackingEventName",
    "conversionGGAdsId",
    "conversionGGAdsLabel",
    "scriptCustom"
  ]);
  var _a2, _b2, _c, _d, _e, _f, _g, _h;
  const ref = React.useRef();
  const openPopup = (popupId) => {
    var _a3;
    (_a3 = ref.current.ownerDocument.querySelector(
      `[data-uniq-id="${popupId}"]`
    )) == null ? void 0 : _a3.click();
  };
  const closePopup = (popupId) => {
    const popup = ref.current.ownerDocument.querySelector(
      `[data-uniq-id="${popupId}"]`
    );
    const maskPopup = popup == null ? void 0 : popup.parentElement;
    maskPopup.classList.remove("show");
    maskPopup.classList.add("hide-from-btn");
    popup == null ? void 0 : popup.click();
  };
  const closePopupList = (popupIds) => {
    const getAllElement = ref.current.ownerDocument.querySelectorAll(
      `[data-uniq-id]`
    );
    const popupList = [];
    getAllElement.forEach((el) => {
      if (popupIds.includes(el.getAttribute("data-uniq-id")))
        popupList.push(el);
    });
    popupList.forEach((popup) => {
      const maskPopup = popup == null ? void 0 : popup.parentElement;
      maskPopup.classList.remove("show");
      maskPopup.classList.add("hide-from-btn");
      popup == null ? void 0 : popup.click();
    });
  };
  const scrollToElement = (elementId) => {
    const isInIframe = ref.current.ownerDocument !== document;
    let innerWindow = window;
    if (isInIframe) {
      const iframeElements = window.document.getElementsByTagName("iframe");
      for (const iframe of iframeElements) {
        if (iframe.contentDocument === ref.current.ownerDocument) {
          innerWindow = iframe.contentWindow;
          break;
        }
      }
    }
    const elements = ref.current.ownerDocument.querySelectorAll(
      `[data-id="${elementId}"]`
    );
    for (const element of elements) {
      if (innerWindow.getComputedStyle(element).display !== "none") {
        const top = element.getBoundingClientRect().top + innerWindow.pageYOffset - sectionMarginTop;
        innerWindow.scrollTo({
          top,
          behavior: "smooth"
        });
      }
    }
  };
  const trackEventClick = () => {
    var _a3, _b3, _c2, _d2;
    if (trackingEventName) {
      (_a3 = window == null ? void 0 : window.gtag) == null ? void 0 : _a3.call(window, "event", trackingEventName);
      (_b3 = window == null ? void 0 : window.fbq) == null ? void 0 : _b3.call(window, "trackCustom", trackingEventName);
      (_c2 = window == null ? void 0 : window.track) == null ? void 0 : _c2.call(window, "customEvent", trackingEventName);
    }
    if (conversionGGAdsId && conversionGGAdsLabel) {
      (_d2 = window == null ? void 0 : window.gtag) == null ? void 0 : _d2.call(window, "event", "conversion", {
        send_to: `AW-${conversionGGAdsId}/${conversionGGAdsLabel}`
      });
    }
    runStringFunc(scriptCustom);
  };
  const runStringFunc = (script) => {
    if (script == null ? void 0 : script.trim()) {
      try {
        const excuteScript = new Function(coreRenderer.unescapeString(script));
        excuteScript();
      } catch (err) {
        console.error(err);
      }
    }
  };
  if (eventType === "openPageOfWebsite" && ((_a2 = rest["openPageOfWebsite"]) == null ? void 0 : _a2.href))
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: rest["openPageOfWebsite"].href,
      onClick: trackEventClick,
      target: ((_b2 = rest[eventType]) == null ? void 0 : _b2.openNewTab) ? "_blank" : "_top",
      className,
      children
    });
  if (eventType === "link" && ((_c = rest["link"]) == null ? void 0 : _c.href))
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: rest["link"].href,
      onClick: trackEventClick,
      target: ((_d = rest[eventType]) == null ? void 0 : _d.openNewTab) ? "_blank" : "_top",
      className,
      rel: ((_e = rest[eventType]) == null ? void 0 : _e.nofollow) ? "nofollow" : "noopener noreferrer",
      children
    });
  if (eventType === "inPage" && rest["inPage"])
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      style: { cursor: "pointer" },
      onClick: () => {
        scrollToElement(rest["inPage"]);
        trackEventClick();
      },
      ref,
      children
    });
  if (eventType === "internal" && ((_f = rest["internal"]) == null ? void 0 : _f.href))
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: `/${rest["internal"].href}`,
      onClick: trackEventClick,
      target: ((_g = rest["internal"]) == null ? void 0 : _g.openNewTab) ? "_blank" : "_top",
      className,
      rel: "noopener noreferrer",
      children
    });
  if (eventType === "email" && rest["email"])
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: `mailto:${rest["email"]}`,
      onClick: trackEventClick,
      className,
      rel: "noopener noreferrer",
      target: "_top",
      children
    });
  if (eventType === "phone" && rest["phone"])
    return /* @__PURE__ */ jsxRuntime.jsx("a", {
      style: { textDecoration: "none", color: "unset", cursor: "pointer" },
      href: `tel:${rest["phone"]}`,
      onClick: trackEventClick,
      className,
      rel: "noopener noreferrer",
      target: "_top",
      children
    });
  if (eventType === "openPopup" && rest["togglePopup"]) {
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      ref,
      onClick: () => {
        openPopup(rest["togglePopup"]);
        trackEventClick();
      },
      children
    });
  }
  if (eventType === "closePopupList" && ((_h = rest["togglePopupList"]) == null ? void 0 : _h.length)) {
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      ref,
      onClick: () => {
        closePopupList(rest["togglePopupList"]);
        trackEventClick();
      },
      children
    });
  }
  if (eventType === "closePopup" && rest["togglePopup"]) {
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
      ref,
      onClick: () => {
        closePopup(rest["togglePopup"]);
        trackEventClick();
      },
      children
    });
  }
  return /* @__PURE__ */ jsxRuntime.jsx("div", {
    onClick: trackEventClick,
    children
  });
};

exports.Link = Link;


/***/ }),

/***/ 29062:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var styled = __webpack_require__(21483);
var coreRenderer = __webpack_require__(12060);
var React = __webpack_require__(91987);
var SwiperCore = __webpack_require__(26438);
var react = __webpack_require__(6968);
var helper = __webpack_require__(58148);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var SwiperCore__default = /*#__PURE__*/_interopDefaultLegacy(SwiperCore);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
SwiperCore__default["default"].use([SwiperCore.Navigation, SwiperCore.Pagination, SwiperCore.Thumbs, SwiperCore.Autoplay, SwiperCore.Virtual]);
const Slider = (_a) => {
  var _b = _a, {
    className,
    children,
    paginationStyle,
    navigationStyle,
    speed = 3e3,
    pauseOnMouseEnter = true,
    paginationColor,
    virtual,
    paginationPosition = "inside",
    commonStyle,
    slidesPerViewMobile,
    navigationColor
  } = _b, swiperProps = __objRest(_b, [
    "className",
    "children",
    "paginationStyle",
    "navigationStyle",
    "speed",
    "pauseOnMouseEnter",
    "paginationColor",
    "virtual",
    "paginationPosition",
    "commonStyle",
    "slidesPerViewMobile",
    "navigationColor"
  ]);
  const {
    slidesPerView,
    slidesPerColumn,
    pagination,
    autoplay,
    loop,
    showThumbnail,
    alignThumbnail
  } = swiperProps;
  const [swiperKey, setSwiperKey] = React.useState(0);
  let breakpoints;
  const [thumbsSwiper, setThumbsSwiper] = React.useState(null);
  const isMultipleRows = slidesPerColumn && slidesPerColumn > 1;
  if (pagination) {
    swiperProps.pagination = {
      clickable: true
    };
  }
  if (isMultipleRows)
    swiperProps.loop = false;
  if (autoplay) {
    swiperProps.autoplay = {
      delay: speed,
      disableOnInteraction: false,
      pauseOnMouseEnter
    };
  }
  if (slidesPerViewMobile) {
    breakpoints = {
      320: { slidesPerView: slidesPerViewMobile },
      640: { slidesPerView }
    };
  }
  React.useEffect(() => {
    setSwiperKey((key) => key + 1);
  }, [
    showThumbnail,
    autoplay,
    loop,
    speed,
    pauseOnMouseEnter,
    virtual,
    slidesPerColumn
  ]);
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    className,
    paginationStyle,
    navigationStyle,
    isMultipleRows,
    paginationColor,
    navigationColor,
    paginationPosition,
    commonStyle,
    slidesPerView,
    slidesPerColumn,
    itemsCount: React.Children.toArray(children).length,
    spaceBetween: swiperProps == null ? void 0 : swiperProps.spaceBetween,
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(react.Swiper, __spreadProps(__spreadValues({
        breakpoints
      }, swiperProps), {
        thumbs: {
          swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
        },
        virtual: virtual && slidesPerView ? {
          addSlidesBefore: slidesPerView
        } : false,
        resizeObserver: true,
        slidesPerColumnFill: "row",
        children: React.Children.map(children, (child, index) => /* @__PURE__ */ jsxRuntime.jsx(react.SwiperSlide, {
          virtualIndex: index,
          children: child
        }, `slide-${index}`))
      }), `swiper-${swiperKey}`),
      showThumbnail && /* @__PURE__ */ jsxRuntime.jsx(react.Swiper, {
        className: `swiper-thumbnail ${alignThumbnail ? `swiper-thumbnail__${alignThumbnail}` : ""}`,
        onSwiper: setThumbsSwiper,
        spaceBetween: 10,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        children: React.Children.map(children, (child, index) => /* @__PURE__ */ jsxRuntime.jsx(react.SwiperSlide, {
          virtualIndex: index,
          children: child
        }, `thumb-${index}`))
      })
    ]
  });
};
const Wrapper = styled__default["default"].div(
  ({
    isMultipleRows,
    paginationStyle,
    paginationColor,
    paginationPosition,
    navigationStyle,
    navigationColor,
    commonStyle,
    slidesPerView = 1,
    slidesPerColumn = 1,
    itemsCount,
    spaceBetween = 10
  }) => {
    const isServerless = typeof window === "undefined";
    let totalItemPerRow, serverWidthWrapper, serverWidthItem;
    if (isServerless) {
      totalItemPerRow = Math.ceil(itemsCount / slidesPerColumn);
      serverWidthWrapper = `${totalItemPerRow / slidesPerView * 100}%`;
      serverWidthItem = `calc(100% / ${totalItemPerRow} - ${spaceBetween * (totalItemPerRow - 1) / totalItemPerRow}px)`;
    }
    return `
    .swiper-container {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      list-style: none;
      padding: 0;
      ${paginationStyle && paginationPosition === "outside" ? "padding-bottom: 3em;" : ""}
    }
    .swiper-wrapper {
      position: relative;
      height: 100%;
      display: flex;
      transition-property: transform;
      box-sizing: content-box;
      flex-wrap: ${isMultipleRows ? "wrap" : "nowrap"};
      // Ch\u1EC9 c\xF3 t\xE1c d\u1EE5ng \u1EDF SSR, khi v\u1EC1 CSR th\u01B0 vi\u1EC7n swiper s\u1EBD t\u1EF1 \u0111\u1ED9ng override css n\xE0y b\u1EB1ng pixel
      ${isServerless ? `width: ${serverWidthWrapper};` : ""}
    }
    .swiper-slide {
      flex-shrink: 0;
      height: 100%;
      position: relative;
      transition-property: transform;
      ${isMultipleRows ? `margin-top: 0px !important` : ""};
      // Ch\u1EC9 c\xF3 t\xE1c d\u1EE5ng \u1EDF SSR, khi v\u1EC1 CSR th\u01B0 vi\u1EC7n swiper s\u1EBD t\u1EF1 \u0111\u1ED9ng override css n\xE0y b\u1EB1ng pixel
      ${isServerless ? `width: ${serverWidthItem};
            margin-right: ${spaceBetween}px;` : ""}
    }
    &:hover {
      .swiper-button-next,
      .swiper-button-prev {
        opacity: 1;
        &.swiper-button-disabled {
          opacity: 0.35;
        }
      }
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-pagination-fraction {
      bottom: 0;
      left: 0;
      width: 100%;
    }
    .swiper-pagination-bullets {
      bottom: 10px;
      left: 0;
      width: 100%;
    }
    ${paginationStyle ? helper.renderPaginationStyle(paginationStyle, paginationColor) : ""}
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      top: 50%;
      z-index: 10;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      margin-top: -22px;
      opacity: 0;
      &.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
        pointer-events: auto;
      }
    }
    .swiper-thumbnail {
      padding-top: 10px;

      &.swiper-thumbnail__left {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }

      &.swiper-thumbnail__center {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &.swiper-thumbnail__right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .swiper-slide {
        width: 80px !important;
        height: 80px;
        cursor: pointer;

        img {
          width: 80px;
          height: 80px;
        }

        &.swiper-slide-thumb-active::after {
          background: transparent;
        }

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,.5);
        }
      }
    }
    ${coreRenderer.getStyle(commonStyle)}
    ${navigationStyle ? helper.renderSwipeButton(navigationStyle, navigationColor) : ""}
`;
  }
);

exports.Slider = Slider;


/***/ }),

/***/ 58148:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const renderPaginationStyle = (index, paginationColor) => {
  const styleArr = [
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: 0.75rem;
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: 0.75rem;
      width: 24px;
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #ddd;
      cursor: pointer;
      &:first-of-type {
        border-radius: 999px 0 0 999px;
      };
      &:last-of-type {
        border-radius: 0 999px 999px 0;
      }
    }
    .swiper-pagination-bullet-active {
      width: 24px;
      position: relative;
      &:after {
        content: "";
        border-radius: 999px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${paginationColor};
      }
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: 0.75rem;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      transform: translateY(2px);
    }`
  ];
  return index > 0 ? styleArr[index - 1] : null;
};
const renderSwipeButton = (index, color) => {
  const styleArr = [
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-right: 0.5rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-left: 1rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: ${color || "#333"};
      }
    }`
  ];
  return index > 0 ? styleArr[index - 1] : null;
};

exports.renderPaginationStyle = renderPaginationStyle;
exports.renderSwipeButton = renderSwipeButton;


/***/ }),

/***/ 65380:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(91987);

function useIntersectionObserver({
  elementRef,
  root = null,
  rootMargin = "0%",
  threshold,
  initialValue = true
}) {
  const [entry, setEntry] = React.useState();
  const observer = React.useRef(null);
  const IOCallback = ([entry2]) => {
    setEntry(entry2);
  };
  React.useEffect(() => {
    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = new IntersectionObserver(IOCallback, {
      root,
      rootMargin,
      threshold
    });
    const currentObserver = observer.current;
    const node = elementRef.current;
    if (node) {
      currentObserver.observe(node);
    }
    return () => {
      currentObserver.disconnect();
    };
  }, [elementRef, root, rootMargin, threshold]);
  return [entry ? entry.isIntersecting : initialValue, entry];
}

exports.useIntersectionObserver = useIntersectionObserver;


/***/ }),

/***/ 27116:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(91987);

function useMediaQuery(query) {
  const getMatches = (query2) => {
    if (typeof window !== "undefined") {
      return window.matchMedia(query2).matches;
    }
    return false;
  };
  const [matches, setMatches] = React.useState(getMatches(query));
  function handleChange() {
    setMatches(getMatches(query));
  }
  React.useEffect(() => {
    const matchMedia = window.matchMedia(query);
    handleChange();
    if (matchMedia.addListener) {
      matchMedia.addListener(handleChange);
    } else {
      matchMedia.addEventListener("change", handleChange);
    }
    return () => {
      if (matchMedia.removeListener) {
        matchMedia.removeListener(handleChange);
      } else {
        matchMedia.removeEventListener("change", handleChange);
      }
    };
  }, [query]);
  return matches;
}

exports.useMediaQuery = useMediaQuery;


/***/ }),

/***/ 82028:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var ui = __webpack_require__(14529);
var ui$a = __webpack_require__(33715);
var ui$b = __webpack_require__(31294);
var CategoryMenu = __webpack_require__(80228);
var ui$1 = __webpack_require__(36182);
var ui$2 = __webpack_require__(18111);
var MixBanner = __webpack_require__(97841);
var ui$3 = __webpack_require__(11140);
var ui$4 = __webpack_require__(95713);
var ui$5 = __webpack_require__(98610);
var ui$6 = __webpack_require__(97108);
var ui$7 = __webpack_require__(93990);
var ui$8 = __webpack_require__(88240);
var ui$9 = __webpack_require__(9702);
var CountdownSkuList = __webpack_require__(26712);
var index = __webpack_require__(70776);

const components = {
  CarouselSkuList: ui.CarouselSkuList,
  CategoryMenu: CategoryMenu.CategoryMenu,
  HeroBanner: ui$1.HeroBanner,
  ListingTab: ui$2.ListingTab,
  MixBanner: MixBanner.MixBanner,
  OmniProductList: ui$3.OmniProductList,
  RecommendBrand: ui$4.RecommendBrand,
  RecommendCategory: ui$5.RecommendCategory,
  SlideBanner: ui$6.SlideBanner,
  PendingPayment: ui$7.PendingPayment,
  RecentProduct: ui$8.RecentProduct,
  RecentSearch: ui$9.RecentSearch,
  OmniFooter: ui$a.OmniFooter,
  OmniHeader: ui$b.OmniHeader,
  CountdownSkuList: CountdownSkuList.CountdownSkuList,
  CountdownSkuListV2: index.CountdownSkuListV2
};

exports.w = components;


/***/ }),

/***/ 99761:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var WidthTypeEnum = /* @__PURE__ */ ((WidthTypeEnum2) => {
  WidthTypeEnum2["auto"] = "auto";
  WidthTypeEnum2["full"] = "full";
  WidthTypeEnum2["fixed"] = "fixed";
  return WidthTypeEnum2;
})(WidthTypeEnum || {});
var HeightTypeEnum = /* @__PURE__ */ ((HeightTypeEnum2) => {
  HeightTypeEnum2["default"] = "default";
  HeightTypeEnum2["fixed"] = "fixed";
  return HeightTypeEnum2;
})(HeightTypeEnum || {});

exports.HeightTypeEnum = HeightTypeEnum;
exports.WidthTypeEnum = WidthTypeEnum;


/***/ }),

/***/ 27440:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const addPaddingNumber = (number) => {
  return isNaN(number) ? "" : number == null ? void 0 : number.toString().padStart(2, "0");
};

exports.addPaddingNumber = addPaddingNumber;


/***/ }),

/***/ 48180:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const getISODateBackward = (dateString) => {
  if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/.test(dateString)) {
    const day = parseInt(dateString.substring(0, 2));
    const month = parseInt(dateString.substring(3, 5));
    const year = parseInt(dateString.substring(6, 10));
    const hour = parseInt(dateString.substring(11, 13));
    const minute = parseInt(dateString.substring(14, 16));
    return new Date(year, month - 1, day, hour, minute).toISOString();
  }
  return dateString;
};

exports.getISODateBackward = getISODateBackward;


/***/ }),

/***/ 10845:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var coreRenderer = __webpack_require__(12060);
var dynamicBlock = __webpack_require__(22572);

const getValidItemsByTimeVisibility = (items) => {
  var _a;
  return (_a = items == null ? void 0 : items.filter) == null ? void 0 : _a.call(
    items,
    (item) => coreRenderer.validateIsVisibleComponent((item == null ? void 0 : item.timeVisibility) || {})
  );
};
const getSlotData = (config, device) => {
  var _a, _b, _c, _d;
  const { tag } = config;
  const {
    omni_productlist: productlistecommerce,
    omni_productslider: carouselskulist,
    omni_herobanner: herobanner,
    omni_listingtab: listingtab,
    omni_countdownskulist: countdownskulist,
    omni_countdownskulist_v2: countdownskulistv2
  } = (config == null ? void 0 : config.customAttributes) || {};
  switch (tag) {
    case dynamicBlock.ECOMERCE_COMPONENT_TAG.PRODUCT_LIST:
      return [
        {
          slot: `product_grid_${device}`,
          collectionSlug: productlistecommerce == null ? void 0 : productlistecommerce.collectionSlug
        }
      ];
    case dynamicBlock.ECOMERCE_COMPONENT_TAG.COUNT_DOWN_SKU_LIST:
      const availableItems = getValidItemsByTimeVisibility(
        (countdownskulist == null ? void 0 : countdownskulist.items) || []
      );
      return [
        {
          slot: `product_carousel_${device}`,
          collectionSlug: (_a = availableItems == null ? void 0 : availableItems[0]) == null ? void 0 : _a.collectionSlug
        }
      ];
    case dynamicBlock.ECOMERCE_COMPONENT_TAG.COUNT_DOWN_SKU_LIST_V2:
      const availableTabs = getValidItemsByTimeVisibility(
        (countdownskulistv2 == null ? void 0 : countdownskulistv2.tabs) || []
      );
      return [
        {
          slot: `product_carousel_${device}`,
          collectionSlug: (_b = availableTabs == null ? void 0 : availableTabs[0]) == null ? void 0 : _b.collectionSlug
        }
      ];
    case dynamicBlock.ECOMERCE_COMPONENT_TAG.CAROUSEL_SKU_LIST:
      return [
        {
          slot: `product_carousel_${device}`,
          collectionSlug: carouselskulist == null ? void 0 : carouselskulist.collectionSlug
        }
      ];
    case dynamicBlock.ECOMERCE_COMPONENT_TAG.HERO_BANNER:
      return [
        {
          slot: "mega_menu",
          menuZone: (herobanner == null ? void 0 : herobanner.showMegaMenu) ? herobanner == null ? void 0 : herobanner.menuZone : null
        }
      ];
    case dynamicBlock.ECOMERCE_COMPONENT_TAG.LISTING_TAB:
      return [
        {
          slot: `product_grid_${device}`,
          collectionSlug: (_d = (_c = listingtab == null ? void 0 : listingtab.items) == null ? void 0 : _c[0]) == null ? void 0 : _d.collectionSlug
        }
      ];
    default:
      return [];
  }
};

exports.P = getSlotData;


/***/ }),

/***/ 82016:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var coreRenderer = __webpack_require__(12060);

const getStyle = (style) => {
  return `
    ${coreRenderer.getStyle(style)}
    ${(style == null ? void 0 : style.backgroundImage) ? `
      background-image: url(${style.backgroundImage}) !important;
    ` : ""}
    `;
};

exports.getStyle = getStyle;


/***/ }),

/***/ 4637:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const flattenToTree = (originMenu) => {
  const getChildren = (menu, parentId) => {
    const result = menu.filter((item) => item.parentId === parentId).map((item) => {
      const children = getChildren(menu, item.id);
      return __spreadProps(__spreadValues({}, item), {
        children
      });
    });
    return result;
  };
  const tree = originMenu.filter((item) => !item.parentId).map((item) => __spreadProps(__spreadValues({}, item), { children: getChildren(originMenu, item.id) }));
  return tree;
};
const getUrlOfMenuItem = (item, isEditingMode = false) => {
  var _a, _b;
  if (isEditingMode)
    return void 0;
  if ((item == null ? void 0 : item.linkType) === "LINK")
    return item.href;
  if ((_a = item == null ? void 0 : item.page) == null ? void 0 : _a.isHomepage)
    return "/";
  return "/" + ((_b = item == null ? void 0 : item.page) == null ? void 0 : _b.slug);
};

exports.flattenToTree = flattenToTree;
exports.getUrlOfMenuItem = getUrlOfMenuItem;


/***/ }),

/***/ 64915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(91987);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const renderDynamicSlot = (slot, mappingDynamicSlots, ssrData, restProps = {}, position = 0) => {
  const Comp = mappingDynamicSlots == null ? void 0 : mappingDynamicSlots[slot];
  if (!Comp)
    return null;
  const { serverData } = (ssrData == null ? void 0 : ssrData[position]) || {};
  return React.createElement(Comp, __spreadValues(__spreadValues({}, serverData ? { serverData } : {}), restProps));
};

exports.renderDynamicSlot = renderDynamicSlot;


/***/ }),

/***/ 45292:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(61261);
var Link = __webpack_require__(9231);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const renderLink = (event, children, isEditingMode = false, key) => {
  if (isEditingMode)
    return children;
  const eventProps = typeof event === "string" ? { eventType: "link", link: { href: event } } : event;
  return /* @__PURE__ */ jsxRuntime.jsx(Link.Link, __spreadProps(__spreadValues(__spreadValues({}, eventProps), typeof key !== "undefined" ? { key } : {}), {
    children
  }));
};

exports.renderLink = renderLink;


/***/ }),

/***/ 81892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clsx": function() { return /* binding */ clsx; }
/* harmony export */ });
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["default"] = (clsx);

/***/ })

}]);